import { protocolDisplayName, protocolCategory } from '@authe/fe-commons/metadata-analytics';
import { NODE_KIND_META, GRAPH_VIEW_MODES, GRAPH_VIEW_MODE_LABELS, isOffChainKind, GRAPH_DETAIL_TIERS, GRAPH_DETAIL_TIER_LABELS, AUTHORABLE_NODE_KINDS, displayChainText, GRAPH_PANEL_LABELS, badgeForKind, asString, safeTicker, domainKindForSceneKind, asTrimmedString, nodeKindLabel } from '@authe/fe-commons/display';
export { AUTHORABLE_NODE_KINDS, DEFAULT_GRAPH_DETAIL_TIER, GRAPH_DETAIL_TIERS, GRAPH_DETAIL_TIER_LABELS, GRAPH_NODE_KINDS, GRAPH_VIEW_MODES, GRAPH_VIEW_MODE_LABELS, NODE_KIND_META, badgeForKind, domainKindForSceneKind, isOffChainKind, labelForKind, nodeKindLabel } from '@authe/fe-commons/display';
import { FinalityState, chainDisplayName, normalizeAddress, resolveChain, shortenAddress, toCanonicalChainId, chainDecodeVocabulary, getChainGroupColors, shortenIdentifier, shortenHash, addressesEqual } from '@authe/fe-commons/chains';
import { formatUnits, formatPercentCell, parseUnits, nativeTokenMeta, isZeroText, formatUsd, formatGraphAmount, isStructuredTokenAmount, tokenAmountFace } from '@authe/fe-commons/value';
import * as React17 from 'react';
import { Position, MarkerType, ReactFlowProvider, useInternalNode, getBezierPath, BaseEdge, EdgeLabelRenderer, useNodesState, useEdgesState, useReactFlow, useNodesInitialized, useStore, ReactFlow, Background, Controls, Panel, MiniMap, Handle } from '@xyflow/react';
import { GRAPH_EDGE_VARIANT_COLOR, cn, Button, SearchIcon, Input, ChevronUpIcon, ChevronDownIcon, useReducedMotion, resolveTokenColor, graphEdgeColor, graphNodeColor, ViewModeToggle, notifyError, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuItem, rankedCounts, GRAPH_NODE_VARIANT_LABELS, GRAPH_NODE_VARIANT_COLOR, SettingsIcon, CheckIcon, DropdownMenuCheckboxItem, NativeSelect, ChainSelect, PlusIcon, LinkIcon, TooltipProvider, useGraphHeight, Card, CardContent, Badge, CopyButton, Tabs, TabsList, TabsTrigger, TabsContent, EmptyState, useInGraphFrame, GraphFrame, Slider, ChainAvatar, Spinner, ErrorState, GraphFrameMessage, FinalityPill, GraphNode, RichTooltip, Popover, PopoverAnchor, PopoverContent, NodeAssignMenu, Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, Tooltip, TooltipTrigger, TooltipContent, GRAPH_EDGE_VARIANTS, GRAPH_EDGE_VARIANT_LABELS, Label, TidyIcon, FlowIcon, BundleIcon, MinimizeIcon, MaximizeIcon, explainEvidence, AddressDisplay, MiddleEllipsis } from '@authe/ui-core';
import { HOLDER_VIEW_POLICY, HOLDER_BAND_LABELS, holderBand, titledSymbol } from '@authe/fe-commons/tokens';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { mergedTxRefs, MERGED_COUNT_ATTR, MERGED_TXS_ATTR, mergedTxRef, MERGED_TXS_LIMIT, parseGraphScene, groupSceneLegs, TX_COUNT_ATTR, isTxCountSublabel, txCountSublabel, mergedCount, AMOUNT_BASIS, txMembership } from '@authe/fe-commons/models';
import { edgeFlag, TRANSACTION_FLAG_KINDS, TRANSACTION_FLAG_META } from '@authe/fe-commons/spam';
import { NATIVE_COIN_FLOW_KINDS, toSceneView, filterSceneViewByDetailTier, nodesWithHiddenChildren, toGraphView, hasAssignmentActions, graphEdgeId } from '@authe/fe-commons/transpose';
import dagre from 'dagre';
import { createLogger } from '@authe/fe-commons/logging';
import { useOptionalTheme } from '@authe/ui-core/theme';
import { findingSentence, expectedLegs, annotateExpectedLegs, sagaIdLabel, correlationIdText, roleLabel, missingLegReason } from '@authe/fe-commons/grouping';
import { isReconstruction } from '@authe/fe-commons/graph-overlay';
import { exportDataset, useExportLedger, ExportLedgerStatus, buildExportFilename, ExportHistoryItem } from '@authe/export';
import { keys, parseNodeId } from '@authe/fe-commons/keys';
import { parseKeyAttributeGroups } from '@authe/fe-commons/storage';
import { useStream, createStreamingClient, createAppSyncClientPool, aliasEndpointResolver, createAppSyncTransport, selectAutheStreamPayload, useOptionalStreamingClient, subscribeDescriptor } from '@authe/streaming';
import { ReportPreview, ReportDownloadButton } from '@authe/reporting/preview';
import { formatUtcStamp, formatTimestamp, formatUtcDay, formatRelativeTime } from '@authe/fe-commons/time';
import { useDepsChanged } from '@authe/ui-core/api';
import { useResolveShare, AccessWarningBanner, ShareAccessBadge } from '@authe/saved-views';
import { parseReportSnapshot } from '@authe/fe-commons/reporting';
import { RELATED_ADDRESS_GRAPH_LIMITS, relationshipStrength, hasContractReferenceDirection, isMovementLink, RELATIONSHIP_CLAIM_LABELS, nodeId, evidenceLabel, contractObservations, contractPredicateLabel } from '@authe/fe-commons/related-addresses';
export { RELATED_ADDRESS_GRAPH_LIMITS } from '@authe/fe-commons/related-addresses';
import { DataTableFacetedFilter, serverFacetColumn } from '@authe/ui-core/table';

var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/grouping/clusterGroups.ts
function groupsWithinBands(bands, groups) {
  return bands.flatMap((band) => {
    const members = new Set(band.memberNodeIds);
    return [band, ...groups.flatMap((group) => {
      const memberNodeIds = group.memberNodeIds.filter((id) => members.has(id));
      return memberNodeIds.length ? [{ ...group, id: `${band.id}/${group.id}`, memberNodeIds }] : [];
    })];
  });
}
function clusterWithinGroups(groups, key) {
  const memberships = /* @__PURE__ */ new Map();
  for (const group of groups) {
    for (const id of group.memberNodeIds) {
      const path = memberships.get(id) ?? [];
      path.push(group.id);
      memberships.set(id, path);
    }
  }
  return (node) => {
    const base = key(node);
    const path = memberships.get(node.id);
    return base && path?.length ? { ...base, id: JSON.stringify([base.id, ...path]) } : base;
  };
}
function groupsForVisibleNodes(groups, nodes) {
  if (!groups) return void 0;
  return groups.flatMap((group) => {
    const members = new Set(group.memberNodeIds);
    const memberNodeIds = nodes.filter((node) => {
      if (members.has(node.id)) return true;
      const folded = node.data.memberIds;
      return node.data.cluster && folded?.length && folded.every((id) => members.has(id));
    }).map((node) => node.id);
    return memberNodeIds.length ? [{ ...group, memberNodeIds }] : [];
  });
}
var init_clusterGroups = __esm({
  "src/grouping/clusterGroups.ts"() {
  }
});
function receiptProtocolNames(ids = []) {
  const priority = (id) => {
    const category = protocolCategory(id);
    return category === "bridge" ? 0 : category === "erc20" || category === "other" || category === "nft" ? 2 : 1;
  };
  return [...new Set([...new Set(ids)].sort((a, b) => priority(a) - priority(b) || a.localeCompare(b)).map((id) => protocolDisplayName(id) ?? id))];
}
var init_receiptProtocols = __esm({
  "src/receiptProtocols.ts"() {
  }
});
function variantForKind(kind, fallback = "address") {
  return kind ? NODE_KIND_VARIANT[kind] : fallback;
}
var NODE_KIND_VARIANT, NODE_KIND_REGISTRY;
var init_nodeKinds = __esm({
  "src/nodeKinds.ts"() {
    NODE_KIND_VARIANT = {
      eoa: "address",
      contract: "contract",
      entity: "entity",
      cluster: "cluster",
      tx: "tx",
      exchange: "entity",
      defi: "contract",
      token: "contract",
      // On-chain (so it stays inside its chain rectangle) but reads as a structured
      // protocol artifact rather than a wallet.
      message: "contract",
      oracle: "oracle",
      bridge: "bridge",
      don: "don",
      mixer: "mixer",
      // Reuses the oracle visual: the design system has no dedicated verification
      // variant, and a verification step is off-chain infra like the DON it hangs
      // under.
      verification: "oracle",
      // The bridge visual family, since a relayer serves a bridge — its own badge is
      // what separates it from the hub.
      relayer: "bridge",
      // A DON rather than a bridge: like an oracle network it is a set of competing
      // agents the transaction hands work to, not a route value travels along.
      settlement: "don",
      situation: "entity"
    };
    NODE_KIND_REGISTRY = Object.fromEntries(
      Object.keys(NODE_KIND_META).map((kind) => [
        kind,
        { ...NODE_KIND_META[kind], variant: NODE_KIND_VARIANT[kind] }
      ])
    );
  }
});
function formatFactValue(value, kind) {
  if (value == null) return "";
  if (Array.isArray(value)) return value.length === 1 ? "1 item" : `${value.length} items`;
  if (kind === "token_amount" && (typeof value !== "object" || isStructuredTokenAmount(value))) {
    const face = tokenAmountFace(value);
    return [face.text, face.symbol, face.scaled || face.unlimited ? void 0 : "base units"].filter(Boolean).join(" ");
  }
  if (typeof value === "object") return "\u2026";
  if (kind === "chain" && typeof value === "string") return chainDisplayName(value) || value;
  return String(value);
}
function factRows(facts) {
  return (facts ?? []).map((f) => ({ label: f.label || f.key, value: formatFactValue(f.value, f.kind) })).filter((r) => r.value !== "");
}
function withContextRows(rows, extra) {
  const out = [...rows];
  const seen = new Set(out.map((r) => r.label.toLowerCase()));
  for (const [label, value] of extra) {
    if (!value || seen.has(label.toLowerCase())) continue;
    seen.add(label.toLowerCase());
    out.push({ label, value });
  }
  return out;
}
function contestedRow(claims) {
  if (!claims || claims.length < 2) return ["Disputed", void 0];
  const field = claims[0]?.field ?? "value";
  const rivals = claims.map((c) => c.by ? `${c.value} (${c.by})` : c.value).join(" vs ");
  return [`Disputed ${field}`, `${rivals} \u2014 same tier, no precedence between them`];
}
var ORIGIN_SUBTITLE;
var init_facts = __esm({
  "src/facts.ts"() {
    ORIGIN_SUBTITLE = {
      synthesized: "Expected \u2014 inferred, not observed in this transaction",
      user: "Added manually by an analyst"
    };
  }
});
var GraphAssignmentMenuContext;
var init_assignmentMenu = __esm({
  "src/engines/flow/assignmentMenu.ts"() {
    GraphAssignmentMenuContext = React17.createContext(null);
  }
});
var GraphExpandContext;
var init_expandControl = __esm({
  "src/engines/flow/expandControl.ts"() {
    GraphExpandContext = React17.createContext(null);
  }
});
function isPlainGraphClick(event) {
  return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
var GraphContextOpenerContext;
var init_contextOpener = __esm({
  "src/engines/flow/contextOpener.ts"() {
    GraphContextOpenerContext = React17.createContext(null);
  }
});
var GraphGroupBandContext;
var init_groupBandControl = __esm({
  "src/engines/flow/groupBandControl.ts"() {
    GraphGroupBandContext = React17.createContext(null);
  }
});
function useGraphRenderOptions() {
  return React17.useContext(GraphRenderContext);
}
var DEFAULT_GRAPH_RENDER_OPTIONS, GraphRenderContext;
var init_renderContext = __esm({
  "src/engines/flow/renderContext.ts"() {
    DEFAULT_GRAPH_RENDER_OPTIONS = {
      particles: false,
      direction: "LR"
    };
    GraphRenderContext = React17.createContext(DEFAULT_GRAPH_RENDER_OPTIONS);
  }
});
function ContextGlyph({ tone }) {
  const path = tone === "actor" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("circle", { cx: "9", cy: "7", r: "4" }),
    /* @__PURE__ */ jsx("path", { d: "M3 21v-2a4 4 0 0 1 4-4h4" }),
    /* @__PURE__ */ jsx("path", { d: "M19 13v4" }),
    /* @__PURE__ */ jsx("path", { d: "M19 21h.01" })
  ] }) : tone === "situation" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "5", r: "2.5" }),
    /* @__PURE__ */ jsx("circle", { cx: "5", cy: "18", r: "2.5" }),
    /* @__PURE__ */ jsx("circle", { cx: "19", cy: "18", r: "2.5" }),
    /* @__PURE__ */ jsx("path", { d: "M12 7.5 6.5 16M12 7.5l5.5 8.5M7.5 18h9" })
  ] }) : tone === "stop" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M7.9 2h8.2L22 7.9v8.2L16.1 22H7.9L2 16.1V7.9z" }),
    /* @__PURE__ */ jsx("path", { d: "M8 12h8" })
  ] }) : null;
  if (!path) return null;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox: "0 0 24 24",
      width: "10",
      height: "10",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": true,
      className: "shrink-0",
      children: path
    }
  );
}
function assetRows(assets) {
  return (assets ?? []).map((asset) => {
    const name = asset.symbol ? titledSymbol(safeTicker(asset.symbol).text, asset.impersonates) ?? safeTicker(asset.symbol).text : shortenAddress(asset.tokenAddress ?? "") ?? "Token";
    const label = asset.direction === "out" ? "Sold" : asset.direction === "in" ? "Bought" : "Moved";
    const floor = asset.basis === "quoted_minimum" ? " (min)" : "";
    return {
      label,
      value: asset.amount ? `${asset.amount} ${name}${floor}` : name
    };
  });
}
function nodeTooltipRows(node) {
  return withContextRows([...factRows(node.facts), ...assetRows(node.assets)], [
    ["Chain", node.chain],
    ...(node.contextBadges ?? []).map((badge) => [badge.label, badge.title]),
    ["Graph layers", node.sourceLayers?.map((layer) => `${layer.label}${layer.hop != null ? ` (hop ${layer.hop})` : ""}`).join(" \xB7 ")],
    ["Address", node.address],
    ["Receipt protocols", receiptProtocolNames(node.receiptProtocolIds).join(", ")],
    ["Protocol context", node.receiptProtocolIds?.length ? "Classified on supporting transactions; not proof of address ownership or a direct protocol call." : void 0],
    ["Value", node.value],
    ["Evidence", node.evidence?.flatMap(explainEvidence).join(" \xB7 ")],
    ["Sources", node.sourceRefs?.map((ref) => ref.logIndex != null ? `Log ${ref.logIndex}` : ref.internalTxIndex != null ? `Internal call ${ref.internalTxIndex}` : ref.refType).join(" \xB7 ")],
    // Only worth stating when attribution is actually uncertain.
    [
      "Confidence",
      node.confidence != null && node.confidence < 1 ? `${Math.round(node.confidence * 100)}%` : void 0
    ],
    contestedRow(node.contested)
  ]);
}
function txNode(id, data, position = { x: 0, y: 0 }) {
  return { id, type: "authe", position, data };
}
function AutheGraphNode({ id, data, selected, isConnectable }) {
  const node = data;
  const assignMenu = React17.useContext(GraphAssignmentMenuContext);
  const canAssign = Boolean(assignMenu?.enabled && node.address);
  const expand = React17.useContext(GraphExpandContext);
  const openContext = React17.useContext(GraphContextOpenerContext);
  const expandable = Boolean(expand?.enabled) && expand.isExpandable(id);
  const expanded = Boolean(expand?.enabled) && expand.isExpanded(id);
  const showExpand = expandable || expanded;
  const handleExpand = React17.useCallback(
    (event) => {
      event.stopPropagation();
      expand?.toggle(id);
    },
    [expand, id]
  );
  const handleAssign = React17.useCallback(
    (event) => {
      event.stopPropagation();
      assignMenu?.open(
        {
          id,
          label: node.label,
          address: node.address,
          chainId: node.chain,
          entityId: node.entityId
        },
        event.clientX,
        event.clientY
      );
    },
    [assignMenu, id, node.label, node.address, node.chain, node.entityId]
  );
  const rows = nodeTooltipRows(node);
  const receiptProtocols = receiptProtocolNames(node.receiptProtocolIds);
  const body = /* @__PURE__ */ jsx(
    GraphNode,
    {
      className: node.flowSelected ? "ring-2 ring-[hsl(var(--graph-selection))] ring-offset-2 ring-offset-background" : void 0,
      label: node.label,
      subtitle: [
        typeof node.hop === "number" && !node.cluster ? `${node.hop === 0 ? "Seed" : `Hop ${node.hop}`}${node.subtitle ? ` \xB7 ${node.subtitle}` : ""}` : node.subtitle,
        node.sourceLayers && node.sourceLayers.length > 1 ? `${node.sourceLayers.length} layers` : null,
        receiptProtocols.length ? `Receipt: ${receiptProtocols.slice(0, 2).join(", ")}${receiptProtocols.length > 2 ? ` +${receiptProtocols.length - 2}` : ""}` : null
      ].filter(Boolean).join(" \xB7 "),
      chain: node.chain,
      icon: node.icon,
      iconAlt: node.iconAlt,
      avatarColor: node.avatarColor,
      avatarEntity: node.avatarEntity,
      badge: node.badge ?? badgeForKind(node.kind),
      contested: Boolean(node.contested?.length),
      impersonates: node.impersonates,
      variant: node.variant ?? variantForKind(node.kind),
      accentClassName: node.accentClassName,
      riskLevel: node.riskLevel,
      riskScore: node.riskScore,
      tags: node.tags,
      value: node.value,
      confidence: node.confidence,
      confidenceLabel: node.confidenceLabel,
      dimmed: node.dimmed,
      highlighted: node.highlighted,
      failed: node.failed,
      virtual: node.virtual,
      selected,
      onAssign: canAssign ? handleAssign : void 0
    }
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ConnectionHandles, { type: "target", isConnectable }),
    rows.length > 0 && !node.dimmed ? /* @__PURE__ */ jsx(
      RichTooltip,
      {
        title: node.label,
        subtitle: (node.origin ? ORIGIN_SUBTITLE[node.origin] : void 0) ?? node.subtitle ?? void 0,
        rows,
        side: "top",
        align: "center",
        children: body
      }
    ) : body,
    node.contextBadges?.length ? /* @__PURE__ */ jsx("div", { "aria-label": "Investigation context", className: cn("flex max-w-72 flex-wrap gap-1 rounded-b border border-t-0 bg-background px-2 py-1 text-2xs", node.dimmed && "opacity-50"), children: node.contextBadges.map((badge) => {
      const chip = cn("inline-flex max-w-full items-center gap-1 rounded border px-1 leading-4", CONTEXT_TONE[badge.tone ?? "neutral"]);
      const content = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(ContextGlyph, { tone: badge.tone }),
        /* @__PURE__ */ jsx("span", { className: "truncate", children: badge.label })
      ] });
      const linked = cn(chip, "nodrag nopan underline underline-offset-2 focus-visible:outline focus-visible:outline-2");
      if (badge.href) return /* @__PURE__ */ jsx(
        "a",
        {
          href: badge.href,
          title: badge.title,
          "data-tone": badge.tone,
          className: linked,
          onClick: (event) => {
            event.stopPropagation();
            if (openContext && isPlainGraphClick(event) && openContext({ href: badge.href, opens: badge.opens })) event.preventDefault();
          },
          children: content
        },
        badge.id
      );
      if (badge.opens && openContext) return /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          title: badge.title,
          "data-tone": badge.tone,
          className: linked,
          onClick: (event) => {
            event.stopPropagation();
            openContext({ opens: badge.opens });
          },
          children: content
        },
        badge.id
      );
      return /* @__PURE__ */ jsx("span", { title: badge.title, "data-tone": badge.tone, className: chip, children: content }, badge.id);
    }) }) : null,
    node.actor ? /* @__PURE__ */ jsxs(
      "span",
      {
        "data-testid": "graph-node-actor",
        title: node.actor.title,
        style: { top: -10, left: 8, maxWidth: node.marker ? "calc(50% - 12px)" : "calc(100% - 16px)" },
        className: cn(
          "absolute z-10 inline-flex items-center gap-1 rounded-full border border-risk-critical bg-background px-1.5 py-0.5 text-3xs font-semibold leading-none text-risk-critical shadow-xs",
          node.dimmed && "opacity-50"
        ),
        children: [
          /* @__PURE__ */ jsx(ContextGlyph, { tone: "actor" }),
          /* @__PURE__ */ jsx("span", { className: "truncate", children: node.actor.label })
        ]
      }
    ) : null,
    node.liveChange && /* @__PURE__ */ jsx("span", { "data-testid": "graph-live-change", className: "absolute -bottom-4 left-0 rounded border bg-background px-1 text-3xs text-primary", children: node.liveChange === "added" ? "New" : "Updated" }),
    node.marker ? /* @__PURE__ */ jsxs(
      "span",
      {
        "data-testid": "graph-node-marker",
        "data-tone": node.marker.tone,
        title: node.marker.title,
        style: { top: -10, right: 8, maxWidth: node.actor ? "calc(50% - 12px)" : "calc(100% - 16px)" },
        className: cn(
          "absolute z-10 inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-3xs font-semibold leading-none shadow-xs",
          MARKER_TONE[node.marker.tone],
          // Faded with its node, never removed: a route highlight dims what
          // is off the route, and an alarm off the route is still an alarm.
          node.dimmed && "opacity-50"
        ),
        children: [
          /* @__PURE__ */ jsxs(
            "svg",
            {
              viewBox: "0 0 24 24",
              width: "10",
              height: "10",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2.5",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              "aria-hidden": true,
              className: "shrink-0",
              children: [
                /* @__PURE__ */ jsx("path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }),
                /* @__PURE__ */ jsx("path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "truncate", children: node.marker.label })
        ]
      }
    ) : null,
    showExpand ? /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: handleExpand,
        "aria-label": expanded ? "Hide node detail" : "Show node detail",
        "aria-expanded": expanded,
        title: expanded ? "Hide detail" : "Show detail",
        className: "nodrag absolute -bottom-2 left-1/2 z-10 flex size-5 -translate-x-1/2 items-center justify-center rounded-full border border-border bg-card text-muted-foreground shadow-xs transition-colors hover:text-foreground",
        children: /* @__PURE__ */ jsx(
          "svg",
          {
            viewBox: "0 0 24 24",
            width: "12",
            height: "12",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            "aria-hidden": true,
            style: { transform: expanded ? "rotate(180deg)" : void 0 },
            children: /* @__PURE__ */ jsx("path", { d: "M6 9l6 6 6-6" })
          }
        )
      }
    ) : null,
    /* @__PURE__ */ jsx(ConnectionHandles, { type: "source", isConnectable })
  ] });
}
function connectionAnchors(direction) {
  return ANCHOR[direction] ?? ANCHOR.LR;
}
function ConnectionHandles({
  type,
  isConnectable
}) {
  const { direction } = useGraphRenderOptions();
  const anchor = connectionAnchors(direction)[type];
  return /* @__PURE__ */ jsx(Fragment, { children: ALL_SIDES.map((position) => /* @__PURE__ */ jsx(
    Handle,
    {
      id: position === anchor ? void 0 : `${type}-${position}`,
      type,
      position,
      isConnectable,
      className: handleClass(isConnectable, position === anchor)
    },
    position
  )) });
}
function handleClass(connectable, drawn) {
  if (!connectable) return "h-2! w-2! border-0! bg-transparent! pointer-events-none! opacity-0";
  if (!drawn) return "h-3! w-3! border-0! bg-transparent!";
  return "h-2! w-2! border-0! bg-muted-foreground!";
}
function chainGroupNode(id, data, rect) {
  return {
    id,
    type: "chain-group",
    position: { x: rect.x, y: rect.y },
    data,
    // Behind the regular nodes, and inert: no drag/select/connect, and the DOM
    // ignores pointer events (set in the component) so the canvas stays pannable.
    zIndex: -1,
    selectable: false,
    draggable: false,
    connectable: false,
    focusable: false,
    style: { width: rect.width, height: rect.height, pointerEvents: "none" }
  };
}
function ChainGroupNodeView({ data }) {
  const group = data;
  const bands = React17.useContext(GraphGroupBandContext);
  const groupId = group.groupId;
  const openable = Boolean(bands?.enabled && groupId);
  const labelClass = "absolute left-2 top-1 rounded-sm px-1.5 py-0.5 text-2xs font-semibold uppercase tracking-wide";
  const labelStyle = {
    color: group.text,
    backgroundColor: "var(--card, rgba(255,255,255,0.7))"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "pointer-events-none size-full rounded-xl border-2 border-dashed transition-opacity",
      style: {
        backgroundColor: group.fill,
        borderColor: group.border,
        opacity: group.dimmed ? 0.25 : 1
      },
      children: openable ? /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: () => bands.open(groupId),
          title: `Show what is in ${group.label}`,
          className: `${labelClass} pointer-events-auto cursor-pointer underline-offset-2 transition-opacity hover:underline hover:opacity-80`,
          style: labelStyle,
          children: group.label
        }
      ) : /* @__PURE__ */ jsx("span", { className: `${labelClass} pointer-events-none`, style: labelStyle, children: group.label })
    }
  );
}
var CONTEXT_TONE, MARKER_TONE, ANCHOR, ALL_SIDES, nodeTypes;
var init_nodes = __esm({
  "src/engines/flow/nodes.tsx"() {
    init_receiptProtocols();
    init_nodeKinds();
    init_facts();
    init_assignmentMenu();
    init_expandControl();
    init_contextOpener();
    init_groupBandControl();
    init_renderContext();
    CONTEXT_TONE = {
      actor: "border-risk-critical/60 bg-risk-critical/10 text-risk-critical font-semibold",
      situation: "border-info/60 bg-info/10 text-info",
      stop: "border-border bg-muted text-muted-foreground",
      neutral: "border-border"
    };
    MARKER_TONE = {
      critical: "border-destructive bg-destructive text-destructive-foreground",
      brand: "border-primary bg-primary text-primary-foreground",
      muted: "border-border bg-muted text-muted-foreground"
    };
    ANCHOR = {
      TB: { source: Position.Bottom, target: Position.Top },
      BT: { source: Position.Top, target: Position.Bottom },
      LR: { source: Position.Right, target: Position.Left },
      RL: { source: Position.Left, target: Position.Right }
    };
    ALL_SIDES = [Position.Top, Position.Right, Position.Bottom, Position.Left];
    nodeTypes = { authe: AutheGraphNode, "chain-group": ChainGroupNodeView };
  }
});
function centre(box) {
  return { x: box.x + box.width / 2, y: box.y + box.height / 2 };
}
function boundaryPoint(box, toward) {
  const c = centre(box);
  const dx = toward.x - c.x;
  const dy = toward.y - c.y;
  const halfWidth = Math.max(box.width, 1) / 2;
  const halfHeight = Math.max(box.height, 1) / 2;
  if (dx === 0 && dy === 0) {
    return { x: c.x, y: c.y + halfHeight, position: Position.Bottom };
  }
  const scaleX = halfWidth / Math.abs(dx || Number.EPSILON);
  const scaleY = halfHeight / Math.abs(dy || Number.EPSILON);
  const scale = Math.min(scaleX, scaleY);
  const x = c.x + dx * scale;
  const y = c.y + dy * scale;
  const horizontal = scaleX < scaleY;
  const position = horizontal ? dx > 0 ? Position.Right : Position.Left : dy > 0 ? Position.Bottom : Position.Top;
  return { x, y, position };
}
function floatingEdgeGeometry(source, target) {
  if (!source || !target) return null;
  if (!source.width || !source.height || !target.width || !target.height) return null;
  const from = boundaryPoint(source, centre(target));
  const to = boundaryPoint(target, centre(source));
  return {
    sourceX: from.x,
    sourceY: from.y,
    sourcePosition: from.position,
    targetX: to.x,
    targetY: to.y,
    targetPosition: to.position
  };
}
function nodeBox(internal) {
  const node = internal;
  if (!node) return null;
  const position = node.internals?.positionAbsolute ?? node.position;
  const width = node.measured?.width ?? node.width;
  const height = node.measured?.height ?? node.height;
  if (!position || !width || !height) return null;
  return { x: position.x, y: position.y, width, height };
}
var init_floating = __esm({
  "src/engines/flow/floating.ts"() {
  }
});
function GraphEdgeQuickAction({ action, flowLabel }) {
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      "data-graph-export-exclude": true,
      disabled: action.disabled || action.busy,
      "aria-busy": action.busy || void 0,
      "aria-label": `${action.label}: ${flowLabel}`,
      title: action.hint ?? action.label,
      className: "nodrag nopan inline-flex min-h-6 items-center gap-1 whitespace-nowrap rounded border border-primary/30 bg-background px-1.5 text-xs font-medium text-primary shadow-xs hover:bg-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary disabled:opacity-50",
      onClick: (event) => {
        event.stopPropagation();
        action.onSelect();
      },
      children: [
        action.busy && /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "size-3 animate-spin rounded-full border border-current border-r-transparent motion-reduce:animate-none" }),
        action.label,
        !action.busy && /* @__PURE__ */ jsx("span", { "aria-hidden": true, children: "\u2192" })
      ]
    }
  );
}
var init_GraphEdgeQuickAction = __esm({
  "src/engines/GraphEdgeQuickAction.tsx"() {
  }
});
function originalEdgeIds(edge) {
  const members = edge.data?.aggregated ? edge.data.memberIds : void 0;
  return members && members.length > 0 ? [...members] : [edge.id];
}
function edgeColor(data, resolved = false) {
  if (data?.failed) return graphEdgeColor("failed", resolved);
  if (data?.flag?.mode === "alert") return resolved ? resolveTokenColor("--risk-critical") : FLAG_ALERT_STROKE;
  if (data?.flag?.mode === "demote" || data?.relation === "imitates") return resolved ? resolveTokenColor("--risk-high") : FLAG_DEMOTE_STROKE;
  return data?.assetColor ?? graphEdgeColor(data?.variant ?? "default", resolved);
}
function edgeStrokeWidth(data, selected = false) {
  if (data?.flag?.mode === "demote" || data?.relation === "imitates") return selected ? 2 : 1.25;
  let width = 1.5;
  const usd = data?.valueUsd;
  if (usd != null && usd > 0) {
    width = 1.5 + Math.min(6, Math.log10(usd + 1) * 0.9);
  } else {
    const amt = typeof data?.amount === "number" ? data.amount : Number.parseFloat(String(data?.amount ?? ""));
    if (Number.isFinite(amt) && amt > 0) width = 1.5 + Math.min(4, Math.log10(amt + 1) * 0.6);
  }
  if (data?.aggregated && data.count && data.count > 1) {
    width = Math.min(8, width + Math.log2(data.count));
  }
  if (data?.highlighted || data?.liveChange) width += 1.25;
  if (data?.flag?.mode === "alert") width = Math.max(width, 3.5);
  if (selected) width += 2;
  return Math.round(width * 10) / 10;
}
function txEdge(id, source, target, data = {}) {
  return {
    id,
    source,
    target,
    type: "authe",
    data,
    // Demixing/mixer-traced edges animate so heuristic links stand out.
    animated: data.demix === true,
    markerEnd: { type: MarkerType.ArrowClosed, color: edgeColor(data), width: 16, height: 16 }
  };
}
function edgeUsd(value) {
  return formatUsd(value, { compact: true });
}
function hasTokenFlow(data) {
  return data?.amount != null || data?.amountRaw != null || data?.ticker != null || data?.tokenLogo != null;
}
function EdgeLabelContent({ data, fallback = false }) {
  const content = EdgeLabelBody({ data }) ?? (fallback ? /* @__PURE__ */ jsx("span", { children: edgeKindLabel(data.kind) }) : null);
  if (!data.flag) return content;
  const meta = TRANSACTION_FLAG_META[data.flag.kind];
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        className: data.flag.mode === "alert" ? "rounded-sm bg-risk-critical px-1 font-medium text-status-foreground" : "rounded-sm border border-risk-high/40 px-1 text-risk-high",
        children: meta.label
      }
    ),
    content
  ] });
}
function crossingText(data) {
  if (!data.fromChain || !data.toChain || data.fromChain === data.toChain) return void 0;
  if (data.kind === "bridge_in") return `from ${chainDisplayName(data.fromChain)}`;
  if (data.kind === "bridge_out") return `to ${chainDisplayName(data.toChain)}`;
  return void 0;
}
function EdgeLabelBody({ data }) {
  if (data.displayName) return /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-col items-center", children: [
    /* @__PURE__ */ jsxs("span", { title: "Your display name", className: "font-medium", children: [
      data.displayName,
      " \xB7 note"
    ] }),
    /* @__PURE__ */ jsx(EdgeLabelBody, { data: { ...data, displayName: void 0 } })
  ] });
  if (hasTokenFlow(data)) {
    const rawOnly = data.amount == null && data.amountRaw != null;
    const rawMinimum = data.minAmount == null && data.minAmountRaw != null;
    const display = formatGraphAmount(data.amount ?? data.amountRaw, { maxChars: 14 });
    const minDisplay = formatGraphAmount(data.minAmount ?? data.minAmountRaw, { maxChars: 12 });
    const rawMaximum = data.maxAmount == null && data.maxAmountRaw != null;
    const maxDisplay = formatGraphAmount(data.maxAmount ?? data.maxAmountRaw, { maxChars: 12 });
    const named = data.ticker || (data.tokenAddress ? shortenAddress(data.tokenAddress) : void 0);
    const ticker = named ? safeTicker(named) : void 0;
    const isFloor = data.basis === AMOUNT_BASIS.QUOTED_MINIMUM;
    return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
      data.tokenLogo && /* @__PURE__ */ jsx(AssetLogo, { src: data.tokenLogo, hover: assetLogoHover(data) }),
      (display || named) && /* @__PURE__ */ jsxs(
        "span",
        {
          className: "font-mono tabular-nums",
          title: display?.abbreviated || ticker?.truncated || rawOnly ? `${display?.title ?? ""}${rawOnly ? " base units (token decimals unknown)" : ""}${ticker ? ` ${ticker.title}` : ""}`.trim() : void 0,
          children: [
            display?.text,
            rawOnly && " base units",
            display && named ? " " : "",
            ticker?.text,
            data.tokenId != null && /* @__PURE__ */ jsxs("span", { className: "ml-1", title: `NFT token ID ${data.tokenId}`, children: [
              "#",
              displayChainText(data.tokenId, { maxChars: 18 }).text
            ] }),
            isFloor && /* @__PURE__ */ jsx("span", { className: "ml-1 text-muted-foreground", children: "(min)" }),
            minDisplay && /* @__PURE__ */ jsxs(
              "span",
              {
                className: "ml-1 text-muted-foreground",
                title: rawMinimum ? `${minDisplay.title} base units (token decimals unknown)` : minDisplay.abbreviated ? minDisplay.title : void 0,
                children: [
                  "(min ",
                  minDisplay.text,
                  rawMinimum && " base units",
                  ticker ? ` ${ticker.text}` : "",
                  ")"
                ]
              }
            ),
            maxDisplay && /* @__PURE__ */ jsxs(
              "span",
              {
                className: "ml-1 text-muted-foreground",
                title: rawMaximum ? `${maxDisplay.title} base units (token decimals unknown)` : maxDisplay.abbreviated ? maxDisplay.title : void 0,
                children: [
                  "(max ",
                  maxDisplay.text,
                  rawMaximum && " base units",
                  ticker ? ` ${ticker.text}` : "",
                  ")"
                ]
              }
            )
          ]
        }
      ),
      data.valueUsd != null && /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: edgeUsd(data.valueUsd) }),
      crossingText(data) && /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
        "\xB7 ",
        crossingText(data)
      ] }),
      data.movementCount != null && data.movementCount > 1 && /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
        "\xB7 ",
        data.movementCount,
        " movements"
      ] }),
      data.aggregated && data.count && data.aggregateUnit ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
        "\xB7 ",
        data.count,
        " ",
        data.aggregateUnit
      ] }) : null
    ] });
  }
  if (data.label || data.assetLabel) {
    const shown = displayChainText(data.label ?? data.assetLabel, { maxChars: 80 });
    return /* @__PURE__ */ jsx("span", { className: "block truncate font-medium", title: shown.title, children: shown.text });
  }
  return null;
}
function assetLogoHover(data) {
  const named = (data.tokenLogoAlt ?? "").trim() || (data.ticker ?? "").trim();
  const name = named ? displayChainText(named).title : void 0;
  const address = data.tokenAddress ? shortenAddress(data.tokenAddress) : void 0;
  return [name, address].filter(Boolean).join(" \xB7 ") || void 0;
}
function AssetLogo({ src, hover }) {
  const [failed, setFailed] = React17.useState(false);
  React17.useEffect(() => setFailed(false), [src]);
  if (failed) return null;
  const image = /* @__PURE__ */ jsx(
    "img",
    {
      src,
      alt: "",
      "aria-hidden": true,
      onError: () => setFailed(true),
      className: "size-3 shrink-0 rounded-full object-cover"
    }
  );
  if (!hover) return image;
  return /* @__PURE__ */ jsx(TooltipProvider, { delayDuration: 250, children: /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: image }),
    /* @__PURE__ */ jsx(TooltipContent, { className: "max-w-xs break-words", children: hover })
  ] }) });
}
function edgeKindLabel(kind) {
  if (!kind) return "Flow";
  const spaced = kind.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
function transferSummary(data) {
  const transfers = data.transfers;
  if (!transfers || transfers.length === 0) return void 0;
  const total = Math.max(transfers.length, data.count ?? 0);
  const named = transfers.slice(0, TOOLTIP_TRANSFERS).map((t) => t.label);
  const rest = total - named.length;
  return rest > 0 ? `${named.join(", ")} +${rest} more` : named.join(", ");
}
function edgeTooltipRows(data) {
  const amount = [data.amount != null ? String(data.amount) : data.amountRaw != null ? `${data.amountRaw} base units (token decimals unknown)` : void 0, data.ticker || data.tokenAddress].filter(Boolean).join(" ");
  return withContextRows(factRows(data.facts), [
    ["Graph layer", data.sourceLayerLabel],
    ["Query scope", data.sourceLayerDescription],
    ["Flag", data.flag ? TRANSACTION_FLAG_META[data.flag.kind].label : void 0],
    ["Amount", amount || void 0],
    ["Recorded movements", data.movementCount != null && data.movementCount > 1 ? String(data.movementCount) : void 0],
    ["Amount basis", data.movementCount != null && data.movementCount > 1 ? "Sum of recorded movements; repeated transfers can count the same units again." : void 0],
    ["Value", data.valueUsd != null ? edgeUsd(data.valueUsd) : void 0],
    // Only meaningful when the endpoints actually differ.
    [
      "Route",
      data.fromChain && data.toChain && data.fromChain !== data.toChain ? `${chainDisplayName(data.fromChain)} \u2192 ${chainDisplayName(data.toChain)}` : void 0
    ],
    [
      "Bundled flows",
      data.aggregated && data.count && data.count > 1 ? String(data.count) : void 0
    ],
    // WHICH transactions, not only how many — the count on its own sent the
    // reader to the table to find them. The first few by hash; the rest are a
    // click away in the side panel.
    [data.transfers?.length === 1 ? "Transaction" : "Transactions", transferSummary(data)],
    // Named rather than implied: on the netted view an amount is what survived
    // the opposing movements, not a transfer anyone can point at on-chain.
    [
      "Netted",
      data.netZero ? "cancels out \u2014 equal value moved both ways" : data.netted ? "net of opposing movements" : void 0
    ],
    // An edge that hides a router has to say so, or the settlement view reads as
    // a direct payment between two addresses that never dealt with each other.
    [
      "Through",
      data.compressedVia?.length ? `${data.compressedVia.length} intermediar${data.compressedVia.length === 1 ? "y" : "ies"} (netted out)` : void 0
    ],
    contestedRow(data.contested)
  ]);
}
function FlowParticles({
  path,
  color,
  bidirectional,
  width
}) {
  const r = Math.max(2, Math.min(3.5, width));
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("circle", { r, fill: color, children: /* @__PURE__ */ jsx("animateMotion", { dur: "2.4s", repeatCount: "indefinite", path }) }),
    bidirectional ? /* @__PURE__ */ jsx("circle", { r, fill: color, opacity: 0.85, children: /* @__PURE__ */ jsx(
      "animateMotion",
      {
        dur: "2.4s",
        repeatCount: "indefinite",
        path,
        keyPoints: "1;0",
        keyTimes: "0;1",
        calcMode: "linear"
      }
    ) }) : null
  ] });
}
function quadraticPoint(p0, control, p2, t) {
  const mt = 1 - t;
  return mt * mt * p0 + 2 * mt * t * control + t * t * p2;
}
function parallelEdgeGeometry(sourceX, sourceY, targetX, targetY, index, count) {
  if (count <= 1) return null;
  const flip = sourceY > targetY || sourceY === targetY && sourceX > targetX;
  const ax = flip ? targetX : sourceX;
  const ay = flip ? targetY : sourceY;
  const bx = flip ? sourceX : targetX;
  const by = flip ? sourceY : targetY;
  const midX = (ax + bx) / 2;
  const midY = (ay + by) / 2;
  const dx = bx - ax;
  const dy = by - ay;
  const length = Math.hypot(dx, dy) || 1;
  const perpX = -dy / length;
  const perpY = dx / length;
  const centred = index - (count - 1) / 2;
  const spacing = Math.min(PARALLEL_ARC_SPACING, PARALLEL_FAN_HALF_WIDTH / ((count - 1) / 2));
  const offset = centred * spacing;
  const controlX = midX + perpX * offset * 2;
  const controlY = midY + perpY * offset * 2;
  const spread = Math.min(PARALLEL_LABEL_SPREAD, 0.24 * (count - 1));
  const t = 0.5 + centred / (count - 1) * spread;
  const labelX = quadraticPoint(ax, controlX, bx, t);
  const labelY = quadraticPoint(ay, controlY, by, t);
  return {
    path: `M ${sourceX},${sourceY} Q ${controlX},${controlY} ${targetX},${targetY}`,
    labelX,
    labelY
  };
}
function AutheGraphEdge(props) {
  const { selected } = props;
  const sourceNode = useInternalNode(props.source);
  const targetNode = useInternalNode(props.target);
  const floating = floatingEdgeGeometry(nodeBox(sourceNode), nodeBox(targetNode));
  const sourceX = floating?.sourceX ?? props.sourceX;
  const sourceY = floating?.sourceY ?? props.sourceY;
  const targetX = floating?.targetX ?? props.targetX;
  const targetY = floating?.targetY ?? props.targetY;
  const sourcePosition = floating?.sourcePosition ?? props.sourcePosition;
  const targetPosition = floating?.targetPosition ?? props.targetPosition;
  const data = props.data;
  const demix = data?.demix === true;
  const dimmed = !selected && data?.dimmed === true;
  const context = !selected && data?.context === true;
  const { particles, inspectEdge, edgeQuickAction, labelZoom = 1, visibleEdgeLabels } = useGraphRenderOptions();
  const quickAction = !dimmed && !context ? edgeQuickAction?.(props.id) : null;
  const Label2 = inspectEdge ? "button" : "div";
  const fan = parallelEdgeGeometry(
    sourceX,
    sourceY,
    targetX,
    targetY,
    data?.parallelIndex ?? 0,
    data?.parallelCount ?? 1
  );
  const [bezierPath, bezierLabelX, bezierLabelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });
  const edgePath = fan?.path ?? bezierPath;
  const labelX = fan?.labelX ?? bezierLabelX;
  const labelY = fan?.labelY ?? bezierLabelY;
  const horizontalLabel = Math.abs(targetX - sourceX) > Math.abs(targetY - sourceY);
  const color = edgeColor(data);
  const width = selected ? Math.max(edgeStrokeWidth(data, true), 3 / labelZoom) : edgeStrokeWidth(data);
  const hasLabel = Boolean(data && (data.label || data.assetLabel || data.displayName || hasTokenFlow(data) || data.flag || data.liveChange));
  const demoted = data?.flag?.mode === "demote" || data?.relation === "imitates";
  const showParticles = particles && data?.animated === true && !dimmed && !demoted && !context;
  const dash = demix ? "2 4" : data?.relation === "imitates" ? "1 4" : demoted ? "3 3" : data?.dashed || data?.provisional ? "5 4" : void 0;
  const rows = data ? edgeTooltipRows(data) : [];
  const hoverable = Boolean(data) && !dimmed && rows.length > 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    selected && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-flow-selection-halo": true,
          d: edgePath,
          fill: "none",
          "aria-hidden": "true",
          stroke: "hsl(var(--graph-selection))",
          strokeWidth: width + 8 / labelZoom,
          strokeDasharray: dash,
          style: { pointerEvents: "none" }
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: edgePath,
          fill: "none",
          "aria-hidden": "true",
          stroke: "hsl(var(--background))",
          strokeWidth: width + 3 / labelZoom,
          strokeDasharray: dash,
          style: { pointerEvents: "none" }
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      BaseEdge,
      {
        id: props.id,
        path: edgePath,
        markerEnd: props.markerEnd,
        style: {
          stroke: color,
          strokeWidth: width,
          opacity: selected ? 1 : dimmed ? 0.12 : context ? 0.3 : demoted ? 0.7 : 1,
          // Demixing edges always render as a traced (dashed) line; a demoted
          // flow and the lookalike relation get their own short dash.
          strokeDasharray: dash,
          strokeLinecap: demix ? "round" : void 0,
          transition: "opacity 120ms ease, stroke-width 120ms ease"
        }
      }
    ),
    showParticles ? /* @__PURE__ */ jsx(FlowParticles, { path: edgePath, color, bidirectional: data?.bidirectional === true, width }) : null,
    hoverable && data ? /* @__PURE__ */ jsx(
      RichTooltip,
      {
        title: data.label || edgeKindLabel(data.kind),
        subtitle: context ? "Outside the current filter \xB7 drawn to connect these flows to the seed" : data.origin ? ORIGIN_SUBTITLE[data.origin] : void 0,
        rows,
        side: "top",
        align: "center",
        children: /* @__PURE__ */ jsx(
          "path",
          {
            d: edgePath,
            fill: "none",
            stroke: "transparent",
            strokeWidth: Math.max(16, width + 12),
            style: { pointerEvents: "stroke", cursor: "help" }
          }
        )
      }
    ) : null,
    hasLabel && data && !dimmed && !context ? /* @__PURE__ */ jsx(EdgeLabelRenderer, { children: /* @__PURE__ */ jsxs(
      "div",
      {
        "data-graph-flow-label": props.id,
        "data-label-priority": selected ? 2 : data.highlighted ? 1 : 0,
        className: "group/flow-label nodrag nopan",
        style: {
          position: "absolute",
          transformOrigin: "0 0",
          transform: `translate(${labelX}px, ${labelY}px) scale(${1 / labelZoom}) translate(-50%, ${horizontalLabel ? "calc(-100% - 8px)" : "-50%"})`,
          visibility: !visibleEdgeLabels || visibleEdgeLabels.has(props.id) ? "visible" : "hidden",
          pointerEvents: "none"
        },
        children: [
          /* @__PURE__ */ jsxs(
            Label2,
            {
              ...inspectEdge ? {
                type: "button",
                "aria-label": `Inspect ${data.kind === "relationship" ? "connection" : "flow"}: ${data.displayName || data.label || data.assetLabel || edgeKindLabel(data.kind)}`,
                onClick: (event) => {
                  event.stopPropagation();
                  inspectEdge(props.id);
                }
              } : {},
              style: {
                pointerEvents: inspectEdge ? "all" : "none"
              },
              className: `nodrag nopan min-h-6 max-w-[16rem] rounded-sm bg-card px-1.5 py-0.5 text-xs text-foreground shadow-xs focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary ${selected ? "ring-2 ring-[hsl(var(--graph-selection))] font-semibold" : ""}`,
              children: [
                data.liveChange && /* @__PURE__ */ jsxs("span", { className: "mr-1 font-medium text-primary", children: [
                  data.liveChange === "added" ? "New" : "Updated",
                  " \xB7 "
                ] }),
                /* @__PURE__ */ jsx(EdgeLabelContent, { data })
              ]
            }
          ),
          quickAction && /* @__PURE__ */ jsx("span", { "data-graph-label-action": true, style: { pointerEvents: "all" }, className: `absolute left-1/2 top-full -translate-x-1/2 ${horizontalLabel ? "pt-4" : "pt-1"}`, children: /* @__PURE__ */ jsx(GraphEdgeQuickAction, { action: quickAction, flowLabel: [data.amount, data.ticker].filter(Boolean).join(" ") || data.label || edgeKindLabel(data.kind) }) })
        ]
      }
    ) }) : null
  ] });
}
var EDGE_STROKE, FLAG_ALERT_STROKE, FLAG_DEMOTE_STROKE, TOOLTIP_TRANSFERS, PARALLEL_ARC_SPACING, PARALLEL_FAN_HALF_WIDTH, PARALLEL_LABEL_SPREAD, edgeTypes;
var init_edges = __esm({
  "src/engines/flow/edges.tsx"() {
    init_floating();
    init_facts();
    init_renderContext();
    init_GraphEdgeQuickAction();
    EDGE_STROKE = GRAPH_EDGE_VARIANT_COLOR;
    FLAG_ALERT_STROKE = "hsl(var(--risk-critical))";
    FLAG_DEMOTE_STROKE = "hsl(var(--risk-high))";
    TOOLTIP_TRANSFERS = 3;
    PARALLEL_ARC_SPACING = 30;
    PARALLEL_FAN_HALF_WIDTH = 120;
    PARALLEL_LABEL_SPREAD = 0.6;
    edgeTypes = { authe: AutheGraphEdge };
  }
});

// src/engines/flow/keyboard.ts
function graphNodeAccessibleLabel(node) {
  return [...new Set([node.data.label, node.data.address, node.data.chain, node.data.subtitle].filter((value) => typeof value === "string" && Boolean(value)))].join(" \xB7 ") || node.id;
}
function graphKeyboardTarget(event) {
  if (!["Enter", " "].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.repeat) return null;
  const target = event.target;
  if (!(target instanceof Element)) return null;
  const kind = target.classList.contains("react-flow__node") ? "node" : target.classList.contains("react-flow__edge") ? "edge" : null;
  const id = target.getAttribute("data-id");
  return kind && id ? { kind, id } : null;
}
var init_keyboard = __esm({
  "src/engines/flow/keyboard.ts"() {
  }
});

// src/live/graphChanges.ts
function foldedLiveChange(changes) {
  if (!changes.some(Boolean)) return void 0;
  return changes.length > 0 && changes.every((change) => change === "added") ? "added" : "updated";
}
function stable(value) {
  if (Array.isArray(value)) return `[${value.map(stable).join(",")}]`;
  if (value && typeof value === "object") return JSON.stringify(Object.keys(value).sort().map((key) => [key, stable(value[key])]));
  return JSON.stringify(value) ?? "";
}
function graphEvidenceKey(graph) {
  return stable([
    graph.nodes.map((n) => [n.id, ...NODE_FIELDS.map((f) => n.data[f])]).sort(),
    graph.edges.map((e) => [e.id, e.source, e.target, ...EDGE_FIELDS.map((f) => e.data?.[f])]).sort()
  ]);
}
function diffGraphEvidence(before, after) {
  const changes = [];
  const nodeLabels = new Map([...before.nodes, ...after.nodes].map((node) => [node.id, String(node.data.label || node.id)]));
  const label = (item) => "source" in item ? `${nodeLabels.get(item.source) ?? item.source} \u2192 ${nodeLabels.get(item.target) ?? item.target}${item.data?.label ? ` \xB7 ${item.data.label}` : ""}` : String(item.data.label || item.id);
  for (const element of ["node", "edge"]) {
    const previous = new Map((element === "node" ? before.nodes : before.edges).map((item) => [item.id, item]));
    const next = element === "node" ? after.nodes : after.edges;
    const originalId = (item) => String(item.data?.sourceEdgeId ?? item.id);
    const oldByOriginal = /* @__PURE__ */ new Map();
    const nextCounts = /* @__PURE__ */ new Map();
    if (element === "edge") {
      for (const item of previous.values()) {
        const key = originalId(item);
        oldByOriginal.set(key, [...oldByOriginal.get(key) ?? [], item]);
      }
      for (const item of next) nextCounts.set(originalId(item), (nextCounts.get(originalId(item)) ?? 0) + 1);
    }
    const fields = element === "node" ? NODE_FIELDS : EDGE_FIELDS;
    for (const item of next) {
      const candidates = oldByOriginal.get(originalId(item));
      const candidate = candidates?.length === 1 && nextCounts.get(originalId(item)) === 1 ? candidates[0] : void 0;
      const old = previous.get(item.id) ?? (candidate && previous.has(candidate.id) && Boolean(candidate.data?.sourceLayerId) !== Boolean(item.data?.sourceLayerId) ? candidate : void 0);
      const changed = old ? fields.filter((field) => stable(old.data?.[field]) !== stable(item.data?.[field])) : [];
      if (old && "source" in old && "source" in item && (old.source !== item.source || old.target !== item.target)) changed.push("endpoints");
      if (!old || changed.length) changes.push({ id: item.id, element, kind: old ? "updated" : "added", label: label(item), fields: changed });
      previous.delete(old?.id ?? item.id);
    }
    for (const item of previous.values()) changes.push({ id: item.id, element, kind: "removed", label: label(item), fields: [] });
  }
  return changes;
}
var NODE_FIELDS, EDGE_FIELDS;
var init_graphChanges = __esm({
  "src/live/graphChanges.ts"() {
    NODE_FIELDS = ["label", "chain", "kind", "hop", "receiptProtocolIds", "riskLevel", "failed", "virtual"];
    EDGE_FIELDS = ["amountRaw", "amount", "movementCount", "count", "ticker", "provisional", "finality", "label", "failed", "facts"];
  }
});
function aggregateAmounts(edges) {
  const first = edges[0]?.data;
  if (!first) return {};
  if (new Set(edges.map((e) => e.data?.sourceLayerId)).size > 1) return {};
  const asset = (data) => {
    const chain = data.assetChain ?? data.fromChain;
    if (!chain) return null;
    if (data.kind === "transfer") {
      if (!data.tokenAddress) return null;
      return JSON.stringify([chain, data.tokenAddress === "native" ? "native" : normalizeAddress(data.tokenAddress, chain)]);
    }
    if (!["native", "internal", "closure", "erc20"].includes(data.kind ?? "")) return null;
    if (data.kind === "erc20" && !data.tokenAddress) return null;
    return JSON.stringify([chain, data.tokenAddress ? normalizeAddress(data.tokenAddress, chain) : "native"]);
  };
  const key = asset(first);
  if (!key || edges.some(({ data }) => !data || asset(data) !== key || data.failed || data.bidirectional || data.netted || data.basis === "quoted_minimum")) return {};
  const amounts = edges.map((edge) => String(edge.data?.amount ?? ""));
  if (amounts.some((value) => !/^\d+(?:\.\d+)?$/.test(value)) || edges.some((e) => typeof e.data?.amount === "number" && !Number.isSafeInteger(e.data.amount))) return {};
  const decimals = Math.max(...amounts.map((value) => value.split(".")[1]?.length ?? 0));
  const total = amounts.reduce((sum, value) => sum + parseUnits(value, decimals), 0n);
  return {
    ...first.sourceLayerId ? { sourceLayerId: first.sourceLayerId, sourceLayerLabel: first.sourceLayerLabel, sourceLayerHref: first.sourceLayerHref, sourceLayerDescription: first.sourceLayerDescription } : {},
    amount: formatUnits(total, decimals),
    assetChain: first.assetChain ?? first.fromChain,
    tokenAddress: first.tokenAddress,
    ticker: edges.every((edge) => edge.data?.ticker === first.ticker) ? first.ticker : void 0
  };
}
var init_aggregateAmounts = __esm({
  "src/engines/flow/aggregateAmounts.ts"() {
  }
});
function pairKey(a, b) {
  return a < b ? `${a}\0${b}` : `${b}\0${a}`;
}
function bundleParallelEdges(edges) {
  const groups = /* @__PURE__ */ new Map();
  const order = [];
  for (const edge of edges) {
    if (edge.source === edge.target) {
      const key2 = `self\0${edge.id}`;
      groups.set(key2, [edge]);
      order.push(key2);
      continue;
    }
    const key = pairKey(edge.source, edge.target) + (edge.data?.assetKey ? `\0asset:${edge.data.assetKey}\0${edge.source}->${edge.target}` : "") + (edge.data?.displayName ? `\0name:${edge.id}` : "") + (edge.data?.provisional ? "\0provisional" : "") + (edge.data?.context ? "\0context" : "");
    const list = groups.get(key);
    if (list) {
      list.push(edge);
    } else {
      groups.set(key, [edge]);
      order.push(key);
    }
  }
  const out = [];
  for (const key of order) {
    const list = groups.get(key);
    if (list.length === 1) {
      out.push(list[0]);
      continue;
    }
    const first = list[0];
    const orientations = new Set(list.map((e) => `${e.source}\0${e.target}`));
    const failed = list.some((e) => e.data?.failed === true);
    const animated = list.some((e) => e.data?.animated === true);
    const provisional = first.data?.provisional === true;
    let usd = 0;
    let hasUsd = false;
    for (const e of list) {
      if (e.data?.valueUsd != null) {
        usd += e.data.valueUsd;
        hasUsd = true;
      }
    }
    const movements = list.reduce((n, e) => n + (e.data?.aggregated && e.data.count ? e.data.count : 1), 0);
    const alert = list.find((e) => e.data?.flag?.mode === "alert")?.data?.flag;
    const flag = alert ?? (list.every((e) => e.data?.flag?.mode === "demote") ? list[0].data.flag : void 0);
    const variant = failed ? "failed" : list.find((e) => e.data?.variant && e.data.variant !== "default")?.data?.variant ?? first.data?.variant ?? "default";
    out.push(
      txEdge(`bundle:${first.source}->${first.target}:${list.length}${first.data?.assetKey ? `:asset:${first.data.assetKey}` : ""}${provisional ? ":provisional" : ""}${first.data?.context ? ":context" : ""}`, first.source, first.target, {
        variant,
        assetKey: first.data?.assetKey,
        assetColor: first.data?.assetColor,
        assetLabel: first.data?.assetLabel,
        kind: first.data?.kind,
        failed,
        ...provisional ? { provisional: true, dashed: true } : {},
        ...first.data?.context ? { context: true } : {},
        label: `${movements} transfers${first.data?.assetLabel ? ` \xB7 ${first.data.assetLabel}` : ""}`,
        ...orientations.size === 1 ? aggregateAmounts(list) : {},
        aggregateUnit: "transfers",
        valueUsd: hasUsd ? usd : void 0,
        animated: animated && !failed,
        liveChange: foldedLiveChange(list.map((edge) => edge.data?.liveChange)),
        bidirectional: orientations.size > 1,
        aggregated: true,
        count: movements,
        memberIds: list.flatMap(originalEdgeIds),
        ...flag ? { flag } : {}
      })
    );
  }
  return out;
}
function foldedEdgeId(id) {
  const at = id.indexOf(TRANSFER_ID_SEP);
  return at < 0 ? id : id.slice(0, at);
}
function transferAmountLabel(amount, raw, asset) {
  return [amount ?? (raw !== void 0 ? `${raw} base units (token decimals unknown)` : void 0), asset].filter((part) => part !== void 0 && part !== "").join(" ");
}
function expandFoldedEdges(edges, limit = EXPAND_TRANSFERS_LIMIT) {
  const out = [];
  for (const edge of edges) {
    const transfers = edge.data?.transfers;
    const count = edge.data?.count ?? transfers?.length ?? 0;
    const expandable = (
      // A quietened arrow stays one arrow: drawing eleven poisoning sends back
      // out as eleven labelled arcs undoes the point of quietening them.
      edge.data?.flag?.mode !== "demote" && transfers !== void 0 && transfers.length > 1 && transfers.length === count && transfers.length <= limit && transfers.every((t) => t.amount !== void 0 || t.amountRaw !== void 0)
    );
    if (!expandable) {
      out.push(edge);
      continue;
    }
    for (const transfer of transfers) {
      out.push({
        ...edge,
        id: `${edge.id}${TRANSFER_ID_SEP}${transfer.id}`,
        data: {
          ...edge.data,
          label: transferAmountLabel(transfer.amount, transfer.amountRaw, edge.data?.ticker || edge.data?.tokenAddress),
          amount: transfer.amount,
          amountRaw: transfer.amountRaw,
          // Per-transfer USD is not known; the folded total's would overstate.
          valueUsd: void 0,
          aggregated: void 0,
          count: void 0,
          memberIds: void 0,
          transfers: [transfer],
          transferOf: { edgeId: edge.id, txId: transfer.id }
        }
      });
    }
  }
  return out;
}
function emphasisLightsEdge(emphasis, edge) {
  const ids = originalEdgeIds(edge);
  const of = edge.data?.transferOf;
  if (of) ids.push(`${of.edgeId}${TRANSFER_ID_SEP}${of.txId}`);
  return ids.some((id) => {
    if (emphasis.edgeIds.has(id)) return true;
    const at = id.indexOf(TRANSFER_ID_SEP);
    if (at < 0) return false;
    const edgeId = foldedEdgeId(id);
    if (!emphasis.edgeIds.has(edgeId)) return false;
    const lit = emphasis.movements?.get(edgeId);
    return !lit || lit.has(id.slice(at + TRANSFER_ID_SEP.length));
  });
}
function sceneEdgeForClick(clicked, scene) {
  const of = clicked.data?.transferOf;
  const edge = scene.edges.find((e) => e.id === (of?.edgeId ?? clicked.id));
  if (!edge || !of) return edge;
  const ref = mergedTxRefs(edge.attributes).find((r) => r.id === of.txId);
  if (!ref) return edge;
  const { [MERGED_COUNT_ATTR]: _count, ...attributes } = edge.attributes ?? {};
  return {
    ...edge,
    asset: edge.asset && ref.amount_raw != null ? {
      ...edge.asset,
      amount_raw: ref.amount_raw,
      amount: edge.asset.decimals != null ? formatUnits(ref.amount_raw, edge.asset.decimals) : null,
      usd: null
    } : edge.asset,
    attributes: { ...attributes, [MERGED_TXS_ATTR]: [ref] }
  };
}
function annotatableEdgeId(clicked) {
  return clicked.data?.transferOf?.edgeId ?? clicked.id;
}
var EXPAND_TRANSFERS_LIMIT, TRANSFER_ID_SEP;
var init_edgeBundling = __esm({
  "src/engines/flow/edgeBundling.ts"() {
    init_graphChanges();
    init_edges();
    init_aggregateAmounts();
    EXPAND_TRANSFERS_LIMIT = 10;
    TRANSFER_ID_SEP = " tx:";
  }
});

// src/engines/emphasis.ts
function emphasisHas(ids, id, memberIds) {
  return ids.has(id) || (memberIds?.some((member) => ids.has(member)) ?? false);
}
var init_emphasis = __esm({
  "src/engines/emphasis.ts"() {
  }
});

// src/engines/flow/edgeLabelLayout.ts
function admitEdgeLabels(labels, obstacles, gap) {
  const grid = /* @__PURE__ */ new Map();
  const keys2 = (r) => {
    const result = [];
    for (let x = Math.floor(r.left / CELL); x <= Math.floor(r.right / CELL); x++)
      for (let y = Math.floor(r.top / CELL); y <= Math.floor(r.bottom / CELL); y++) result.push(`${x}:${y}`);
    return result;
  };
  const put = (r) => {
    for (const key of keys2(r)) {
      const cell = grid.get(key) ?? [];
      cell.push(r);
      grid.set(key, cell);
    }
  };
  for (const rect of obstacles) put(rect);
  const visible = /* @__PURE__ */ new Set();
  for (const box of [...labels].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0) || a.id.localeCompare(b.id))) {
    if (box.right <= box.left || box.bottom <= box.top) continue;
    const padded = { left: box.left - gap, top: box.top - gap, right: box.right + gap, bottom: box.bottom + gap };
    if (keys2(padded).some((key) => grid.get(key)?.some((rect) => overlaps(padded, rect)))) continue;
    visible.add(box.id);
    put(box);
  }
  return visible;
}
function flowHitIds(root, hits, invokedId) {
  const ids = /* @__PURE__ */ new Set([invokedId]);
  for (const hit2 of hits) {
    const edge = hit2.closest(".react-flow__edge[data-id]");
    const id = edge?.getAttribute("data-id");
    if (id && edge && root.contains(edge)) ids.add(id);
  }
  return [...ids];
}
var DEFAULT_EDGE_LABEL_POLICY, CELL, overlaps;
var init_edgeLabelLayout = __esm({
  "src/engines/flow/edgeLabelLayout.ts"() {
    DEFAULT_EDGE_LABEL_POLICY = { gap: 2 };
    CELL = 128;
    overlaps = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }
});
function useEdgeLabelLayout(rootRef, zoom, policy) {
  const gap = Math.max(0, policy?.gap ?? DEFAULT_EDGE_LABEL_POLICY.gap);
  const [state, setState] = React17.useState({ visible: /* @__PURE__ */ new Set(), hidden: 0 });
  React17.useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    let frame = 0;
    const measure = () => {
      frame = 0;
      const elements = [...root.querySelectorAll("[data-graph-flow-label]")];
      const boxes = [];
      const bounds = root.getBoundingClientRect();
      for (const el of elements) {
        const rects = [el.getBoundingClientRect(), ...[...el.querySelectorAll("[data-graph-label-action]")].map((action) => action.getBoundingClientRect())];
        const box = {
          id: el.dataset.graphFlowLabel,
          priority: Number(el.dataset.labelPriority ?? 0),
          left: Math.min(...rects.map((r) => r.left)),
          top: Math.min(...rects.map((r) => r.top)),
          right: Math.max(...rects.map((r) => r.right)),
          bottom: Math.max(...rects.map((r) => r.bottom))
        };
        if (box.right >= bounds.left && box.left <= bounds.right && box.bottom >= bounds.top && box.top <= bounds.bottom) boxes.push(box);
      }
      const obstacles = [...root.querySelectorAll(".react-flow__node:not(.react-flow__node-chain-group), .react-flow__panel")].map((el) => el.getBoundingClientRect()).filter((rect) => rect.width > 0 && rect.height > 0);
      const visible = admitEdgeLabels(boxes, obstacles, gap);
      const hidden = boxes.length - visible.size;
      setState((old) => old.hidden === hidden && sameIds(old.visible, visible) ? old : { visible, hidden });
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    const resize = new ResizeObserver(schedule);
    resize.observe(root);
    const mutation = new MutationObserver(schedule);
    mutation.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["style", "data-label-priority"] });
    schedule();
    return () => {
      cancelAnimationFrame(frame);
      resize.disconnect();
      mutation.disconnect();
    };
  }, [rootRef, zoom, gap]);
  return state;
}
var sameIds;
var init_useEdgeLabelLayout = __esm({
  "src/engines/flow/useEdgeLabelLayout.ts"() {
    init_edgeLabelLayout();
    sameIds = (a, b) => a.size === b.size && [...a].every((id) => b.has(id));
  }
});
function choiceVocabulary(edges) {
  const relationship = edges.length > 0 && edges.every((edge) => edge.data?.kind === "relationship");
  return { relationship, noun: relationship ? "connection" : "flow", plural: relationship ? "connections" : "flows" };
}
function containsSelectedFlow(edge, selectedId) {
  if (!selectedId) return false;
  const ids = [edge.id, ...originalEdgeIds(edge)];
  return ids.includes(selectedId) || ids.includes(foldedEdgeId(selectedId));
}
function FlowChoiceControl({ edges, nodes, selectedId, open, onOpen, onClear, onLocate, buttonRef }) {
  const { noun, plural: plural2 } = choiceVocabulary(edges);
  const descriptionId = React17.useId();
  const localButtonRef = React17.useRef(null);
  const triggerRef = buttonRef ?? localButtonRef;
  const edge = edges.find((e) => containsSelectedFlow(e, selectedId));
  const multiple = edges.length > 1;
  if (!edges.length && !selectedId) return null;
  return /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 flex-wrap items-center gap-2", children: [
      edges.length > 0 && /* @__PURE__ */ jsxs(
        Button,
        {
          ref: triggerRef,
          size: "sm",
          variant: "outline",
          "aria-label": `Inspect ${multiple ? plural2 : noun}`,
          "aria-haspopup": multiple ? "dialog" : void 0,
          "aria-expanded": multiple ? open : void 0,
          "aria-describedby": selectedId ? descriptionId : void 0,
          className: selectedId ? "border-primary bg-primary/10 text-primary" : void 0,
          onClick: onOpen,
          children: [
            "Inspect ",
            multiple ? `${plural2} (${edges.length})` : noun
          ]
        }
      ),
      edge && onLocate && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", "aria-label": `Locate selected ${noun}`, onClick: onLocate, children: "Locate" }),
      selectedId && onClear && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", "aria-label": `Clear ${noun} selection`, onClick: () => {
        onClear();
        triggerRef.current?.focus({ preventScroll: true });
      }, children: "Clear" })
    ] }),
    selectedId && /* @__PURE__ */ jsx("div", { id: descriptionId, role: "status", className: "min-w-0 space-y-0.5 text-xs", children: edge ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("p", { className: "font-medium", children: [
        edge.id === selectedId ? `Selected ${noun}` : `Group contains selected ${noun}`,
        ": ",
        /* @__PURE__ */ jsx(EdgeLabelContent, { data: edge.data ?? {}, fallback: true })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "break-words", children: [
        compactEndpoint(nodes.find((node) => node.id === edge.source), edge.source),
        " ",
        noun === "connection" ? "\u2194" : "\u2192",
        " ",
        compactEndpoint(nodes.find((node) => node.id === edge.target), edge.target)
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "text-muted-foreground", children: [
        "Outlined in graph",
        multiple ? ` \xB7 other ${plural2} dimmed` : ""
      ] })
    ] }) : /* @__PURE__ */ jsxs("p", { children: [
      "Selected ",
      noun,
      " is outside this view. Clear the view filters to see it."
    ] }) })
  ] });
}
function compactEndpoint(node, id) {
  const name = node?.data.label || node?.data.address || id;
  return name === node?.data.address || name === id ? shortenAddress(name) : name;
}
function endpoint(node, id) {
  const data = node?.data;
  const name = data?.label || data?.address || id;
  const address = data?.address ? shortenAddress(data.address) : null;
  const chainName2 = data?.chain ? chainDisplayName(data.chain) : null;
  return [
    name,
    data?.address !== name && address !== name ? address : null,
    chainName2 && name !== chainName2 && !name.endsWith(` \xB7 ${chainName2}`) ? chainName2 : null
  ].filter(Boolean).join(" \xB7 ");
}
function flowSearchText(edge, nodes) {
  const data = edge.data;
  return [
    edge.id,
    edgeKindLabel(data?.kind),
    data?.displayName,
    data?.label,
    data?.assetLabel,
    data?.ticker,
    data?.tokenAddress,
    data?.amount,
    data?.amountRaw,
    data?.fromChain,
    data?.toChain,
    data?.sourceLayerLabel,
    ...[edge.source, edge.target].flatMap((id) => [endpoint(nodes.get(id), id), nodes.get(id)?.data.address])
  ].filter(Boolean).join(" ").toLowerCase();
}
function FlowChooser({ edges, nodes, candidates, onClose, onSelect, returnFocusRef, selectedId }) {
  const { relationship, noun, plural: plural2 } = choiceVocabulary(edges);
  const [query, setQuery] = React17.useState("");
  const [limit, setLimit] = React17.useState(PAGE_SIZE);
  const [nearbyOnly, setNearbyOnly] = React17.useState(Boolean(candidates));
  const byNode = React17.useMemo(() => new Map(nodes.map((node) => [node.id, node])), [nodes]);
  const index = React17.useMemo(() => edges.map((edge) => ({ edge, search: flowSearchText(edge, byNode) })), [edges, byNode]);
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const matches = index.filter(({ edge, search }) => (!nearbyOnly || candidates?.includes(edge.id)) && words.every((word) => search.includes(word))).sort((a, b) => Number(containsSelectedFlow(b.edge, selectedId)) - Number(containsSelectedFlow(a.edge, selectedId)));
  const selected = React17.useRef(null);
  return /* @__PURE__ */ jsx(Dialog, { open: true, onOpenChange: (open) => {
    if (!open) onClose();
  }, children: /* @__PURE__ */ jsxs(DialogContent, { className: "max-w-2xl", onCloseAutoFocus: (event) => {
    if (returnFocusRef?.current?.isConnected) {
      event.preventDefault();
      returnFocusRef.current.focus({ preventScroll: true });
    }
    if (selected.current) {
      event.preventDefault();
      const edge = selected.current;
      selected.current = null;
      onSelect(edge);
    }
  }, children: [
    /* @__PURE__ */ jsxs(DialogHeader, { children: [
      /* @__PURE__ */ jsxs(DialogTitle, { children: [
        "Inspect ",
        plural2
      ] }),
      /* @__PURE__ */ jsx(DialogDescription, { children: nearbyOnly ? "Lines at this point overlap. Select a row to highlight that connection and open its details." : `Select a ${noun} to highlight it and open its details. The full graph stays visible.` })
    ] }),
    /* @__PURE__ */ jsx(Input, { "aria-label": `Search ${plural2}`, placeholder: relationship ? "Address, chain or evidence" : "Asset, address, chain or amount", value: query, onChange: (event) => {
      setQuery(event.target.value);
      setLimit(PAGE_SIZE);
    } }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center justify-between gap-2 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsxs("p", { role: "status", children: [
        matches.length,
        " matching ",
        matches.length === 1 ? noun : plural2,
        matches.length > limit ? ` \xB7 showing ${limit}` : ""
      ] }),
      nearbyOnly && /* @__PURE__ */ jsxs(Button, { size: "sm", variant: "outline", onClick: () => {
        setNearbyOnly(false);
        setLimit(PAGE_SIZE);
      }, children: [
        "Search all ",
        edges.length,
        " ",
        plural2
      ] })
    ] }),
    /* @__PURE__ */ jsx("ul", { className: "max-h-[50dvh] space-y-1 overflow-y-auto", "aria-label": `Matching ${plural2}`, children: matches.slice(0, limit).map(({ edge }) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        "aria-current": containsSelectedFlow(edge, selectedId) ? "true" : void 0,
        className: `flex min-h-11 w-full flex-col gap-1 rounded border p-3 text-left text-xs hover:bg-accent focus-ring ${containsSelectedFlow(edge, selectedId) ? "border-primary bg-primary/10" : ""}`,
        onClick: () => {
          selected.current = edge;
          onClose();
        },
        children: [
          containsSelectedFlow(edge, selectedId) && /* @__PURE__ */ jsx("span", { className: "font-semibold text-primary", children: edge.id === selectedId ? `\u2713 Selected ${noun}` : `\u2713 Contains selected ${noun}` }),
          /* @__PURE__ */ jsx("span", { className: "font-medium", children: /* @__PURE__ */ jsx(EdgeLabelContent, { data: edge.data ?? {}, fallback: true }) }),
          edge.data?.assetLabel && /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: edge.data.assetLabel }),
          /* @__PURE__ */ jsxs("span", { className: "break-all", children: [
            relationship ? "Address" : "From",
            ": ",
            endpoint(byNode.get(edge.source), edge.source)
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "break-all", children: [
            relationship ? "Connected address" : "To",
            ": ",
            endpoint(byNode.get(edge.target), edge.target)
          ] }),
          edge.data?.sourceLayerLabel && /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: edge.data.sourceLayerLabel }),
          edge.data?.context && /* @__PURE__ */ jsx("span", { children: "Connection context \xB7 outside the selected filter" })
        ]
      }
    ) }, edge.id)) }),
    matches.length === 0 && /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
      "No loaded ",
      plural2,
      " match. Try an endpoint address."
    ] }),
    matches.length > limit && /* @__PURE__ */ jsxs(Button, { variant: "outline", onClick: () => setLimit((value) => value + PAGE_SIZE), children: [
      "Show more ",
      plural2
    ] })
  ] }) });
}
var PAGE_SIZE;
var init_FlowChooser = __esm({
  "src/engines/flow/FlowChooser.tsx"() {
    init_edges();
    init_edgeBundling();
    PAGE_SIZE = 50;
  }
});
function useFlowSelection(controlledId, onInspect, onClear) {
  const [localId, setLocalId] = React17.useState(null);
  const [inspection, setInspection] = React17.useState(0);
  const selectedId = controlledId === void 0 ? localId : controlledId;
  const inspect = React17.useCallback((edge) => {
    setLocalId(edge.id);
    setInspection((value) => value + 1);
    onInspect?.(edge);
  }, [onInspect]);
  const clear = React17.useCallback(() => {
    setLocalId(null);
    onClear?.();
  }, [onClear]);
  return { selectedId, inspect, clear, inspection };
}
var init_useFlowSelection = __esm({
  "src/engines/useFlowSelection.ts"() {
  }
});
function canvasHasRoomForOverlays(size) {
  return size.width >= OVERLAY_MIN_CANVAS.width && size.height >= OVERLAY_MIN_CANVAS.height;
}
function useCanvasRoom(ref, enabled = true) {
  const [room, setRoom] = React17.useState(true);
  useMeasureEffect(() => {
    const el = ref.current;
    if (!enabled || !el) return void 0;
    const measure = () => setRoom(canvasHasRoomForOverlays({ width: el.clientWidth, height: el.clientHeight }));
    measure();
    if (typeof ResizeObserver === "undefined") return void 0;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, enabled]);
  return room;
}
var OVERLAY_MIN_CANVAS, useMeasureEffect;
var init_canvasRoom = __esm({
  "src/engines/flow/canvasRoom.ts"() {
    OVERLAY_MIN_CANVAS = { width: 560, height: 420 };
    useMeasureEffect = typeof window === "undefined" ? React17.useEffect : React17.useLayoutEffect;
  }
});
function useGraphNodeMenu(containerRef, assignment, nodeActions) {
  const assignmentEnabled = assignment != null && (hasAssignmentActions(assignment.handlers) || assignment.renderEditor != null);
  const [menu, setMenu] = React17.useState(null);
  const open = React17.useCallback((node, clientX, clientY, actions = []) => {
    const rect = containerRef.current?.getBoundingClientRect();
    setMenu({ node, x: clientX - (rect?.left ?? 0), y: clientY - (rect?.top ?? 0), actions });
  }, [containerRef]);
  const onContextMenu = React17.useCallback((event, node) => {
    const data = node.data;
    const ref = { id: node.id, label: data.label, address: data.address, chainId: data.chain, entityId: data.entityId };
    const actions = nodeActions?.(ref) ?? [];
    if (!assignmentEnabled && actions.length === 0) return;
    event.preventDefault();
    open(ref, event.clientX, event.clientY, actions);
  }, [assignmentEnabled, nodeActions, open]);
  const close = React17.useCallback(() => setMenu(null), []);
  const content = menu && (assignment || menu.actions.length > 0) ? /* @__PURE__ */ jsxs(Popover, { open: true, onOpenChange: (open2) => {
    if (!open2) close();
  }, children: [
    /* @__PURE__ */ jsx(PopoverAnchor, { asChild: true, children: /* @__PURE__ */ jsx("span", { "aria-hidden": true, style: { position: "absolute", left: menu.x, top: menu.y, width: 0, height: 0 } }) }),
    /* @__PURE__ */ jsxs(PopoverContent, { align: "start", side: "right", className: "w-auto max-w-xs p-3", children: [
      menu.actions.length > 0 && !assignment ? /* @__PURE__ */ jsx(NodeMenuHeader, { node: menu.node }) : null,
      menu.actions.length > 0 ? /* @__PURE__ */ jsx("div", { role: "menu", "aria-label": `Actions for ${menu.node.label ?? menu.node.id}`, className: cn("flex flex-col gap-1", assignment && "mb-3 border-b pb-3"), children: menu.actions.map((action) => /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          role: "menuitem",
          disabled: action.disabled || action.busy,
          "aria-busy": action.busy || void 0,
          className: "rounded-md px-2 py-1.5 text-left text-sm hover:bg-muted disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-transparent focus-ring",
          onClick: () => {
            close();
            action.onSelect();
          },
          children: [
            /* @__PURE__ */ jsx("span", { className: "block font-medium", children: action.label }),
            action.hint ? /* @__PURE__ */ jsx("span", { className: "block text-xs text-muted-foreground", children: action.hint }) : null
          ]
        },
        action.id
      )) }) : null,
      assignment ? /* @__PURE__ */ jsx(
        NodeAssignMenu,
        {
          node: menu.node,
          state: assignment.getState?.(menu.node.id),
          handlers: assignment.handlers,
          entityOptions: assignment.entityOptions,
          editor: assignment.renderEditor?.(menu.node, close),
          onDone: close
        }
      ) : null
    ] })
  ] }) : null;
  return { assignmentEnabled, open, onContextMenu, close, content };
}
function NodeMenuHeader({ node }) {
  const headline = displayChainText(node.label);
  const chain = node.chainId ? chainDisplayName(node.chainId) || node.chainId : null;
  const address = node.address && !labelIsAddress(node.label, node.address, node.chainId) ? node.address : void 0;
  return /* @__PURE__ */ jsxs("div", { className: "mb-2 min-w-0 border-b px-2 pb-2", "data-testid": "graph-node-menu-header", children: [
    /* @__PURE__ */ jsx("p", { className: "truncate text-sm font-semibold", title: node.address ?? headline.title, children: headline.text }),
    address || chain ? /* @__PURE__ */ jsxs("p", { className: "truncate text-xs text-muted-foreground", title: address, children: [
      address ? /* @__PURE__ */ jsx(AddressDisplay, { address, interactive: false }) : null,
      address && chain ? " \xB7 " : null,
      chain
    ] }) : null
  ] });
}
function labelIsAddress(label, address, chainId) {
  const text2 = label ? normalizeAddress(label, chainId) : "";
  const whole = normalizeAddress(address, chainId);
  if (!text2 || text2 === whole) return Boolean(text2);
  const [head, tail, ...rest] = text2.split("\u2026");
  return rest.length === 0 && Boolean(head) && Boolean(tail) && whole.startsWith(head) && whole.endsWith(tail);
}
var init_useGraphNodeMenu = __esm({
  "src/engines/useGraphNodeMenu.tsx"() {
  }
});

// src/engines/flow/sceneGroups.ts
function rectArea(r) {
  return Math.max(0, r.maxX - r.minX) * Math.max(0, r.maxY - r.minY);
}
function intersectionArea(a, b) {
  const w = Math.min(a.maxX, b.maxX) - Math.max(a.minX, b.minX);
  const h = Math.min(a.maxY, b.maxY) - Math.max(a.minY, b.minY);
  return w > 0 && h > 0 ? w * h : 0;
}
function unionRect(a, b) {
  return {
    minX: Math.min(a.minX, b.minX),
    minY: Math.min(a.minY, b.minY),
    maxX: Math.max(a.maxX, b.maxX),
    maxY: Math.max(a.maxY, b.maxY)
  };
}
function isSubset(child, parent) {
  if (child.size > parent.size) return false;
  for (const id of child) if (!parent.has(id)) return false;
  return true;
}
function sharesMember(a, b) {
  const [small, large] = a.size <= b.size ? [a, b] : [b, a];
  for (const id of small) if (large.has(id)) return true;
  return false;
}
function sizeOf(measured, styled, fallback) {
  return measured ?? (typeof styled === "number" ? styled : fallback);
}
function footprints(nodes, w, h, positions, sizes) {
  const byId = new Map(nodes.map((n) => [n.id, n]));
  return (id) => {
    const node = byId.get(id);
    if (!node) return void 0;
    const at = positions?.[id] ?? node.position;
    const measured = sizes?.[id];
    return {
      x: at.x,
      y: at.y,
      w: measured?.width ?? sizeOf(node.measured?.width, node.style?.width, w),
      h: measured?.height ?? sizeOf(node.measured?.height, node.style?.height, h)
    };
  };
}
function memberBox(memberNodeIds, at) {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  const members = /* @__PURE__ */ new Set();
  for (const memberId of memberNodeIds) {
    const box = at(memberId);
    if (!box) continue;
    members.add(memberId);
    minX = Math.min(minX, box.x);
    minY = Math.min(minY, box.y);
    maxX = Math.max(maxX, box.x + box.w);
    maxY = Math.max(maxY, box.y + box.h);
  }
  return members.size === 0 ? null : { members, raw: { minX, minY, maxX, maxY } };
}
function groupBoxes(groups, at) {
  const boxes = [];
  for (const group of groups) {
    const box = memberBox(group.memberNodeIds, at);
    if (box) boxes.push({ group, ...box });
  }
  return boxes;
}
function byAreaDesc(boxes) {
  return boxes.map((_, i) => i).sort(
    (a, b) => rectArea(boxes[b].raw) - rectArea(boxes[a].raw) || (boxes[a].group.id < boxes[b].group.id ? -1 : 1)
  );
}
function entangledTypes(boxes) {
  const byType = /* @__PURE__ */ new Map();
  for (const box of boxes) {
    const bucket = byType.get(box.group.groupType);
    if (bucket) bucket.push(box);
    else byType.set(box.group.groupType, [box]);
  }
  const loose = /* @__PURE__ */ new Set();
  for (const [type, bucket] of byType) {
    if (bucket.length <= MAX_ENTANGLED_BANDS) continue;
    let entangled = 0;
    for (let i = 0; i < bucket.length; i++) {
      const shares = bucket.some(
        (other, j) => i !== j && sharesMember(bucket[i].members, other.members)
      );
      if (shares) entangled += 1;
    }
    if (entangled > MAX_ENTANGLED_BANDS) loose.add(type);
  }
  return loose;
}
function computeParents(boxes) {
  const loose = entangledTypes(boxes);
  const rank = /* @__PURE__ */ new Map();
  byAreaDesc(boxes).forEach((idx, r) => rank.set(idx, r));
  return boxes.map((child, ci) => {
    if (loose.has(child.group.groupType)) return null;
    const ca = rectArea(child.raw);
    let best = null;
    let bestArea = Infinity;
    for (let pi = 0; pi < boxes.length; pi++) {
      if (pi === ci) continue;
      const parent = boxes[pi];
      if (loose.has(parent.group.groupType)) continue;
      const pa = rectArea(parent.raw);
      const larger = pa > ca || pa === ca && rank.get(pi) < rank.get(ci);
      if (!larger) continue;
      const nestable = isSubset(child.members, parent.members) || sharesMember(child.members, parent.members) && intersectionArea(child.raw, parent.raw) > 0;
      if (!nestable) continue;
      if (pa < bestArea || pa === bestArea && best !== null && rank.get(pi) > rank.get(best)) {
        bestArea = pa;
        best = pi;
      }
    }
    return best;
  });
}
function capNesting(parent, boxes) {
  const capped = [...parent];
  const depth = new Array(boxes.length).fill(0);
  for (const i of byAreaDesc(boxes)) {
    const p = capped[i];
    if (p == null) continue;
    const d = depth[p] + 1;
    if (d > MAX_NEST_DEPTH) capped[i] = null;
    else depth[i] = d;
  }
  return capped;
}
function buildChainGroupNodes(nodes, groups, options = {}) {
  if (groups.length === 0 || nodes.length === 0) return [];
  const w = options.nodeWidth ?? DEFAULT_NODE_W;
  const h = options.nodeHeight ?? DEFAULT_NODE_H;
  const pad = options.padding ?? DEFAULT_PAD;
  const boxes = groupBoxes(groups, footprints(nodes, w, h, void 0, options.sizes));
  if (boxes.length === 0) return [];
  const parent = capNesting(computeParents(boxes), boxes);
  const depthCache = new Array(boxes.length);
  const depthOf = (i) => {
    const cached = depthCache[i];
    if (cached !== void 0) return cached;
    const p = parent[i];
    const d = p == null ? 0 : depthOf(p) + 1;
    depthCache[i] = d;
    return d;
  };
  const depths = boxes.map((_, i) => depthOf(i));
  const maxDepth = depths.reduce((m, d) => Math.max(m, d), 0);
  const eff = boxes.map((b) => ({ ...b.raw }));
  for (let i = 0; i < boxes.length; i++) {
    let a = parent[i];
    while (a != null) {
      eff[a] = unionRect(eff[a], boxes[i].raw);
      a = parent[a];
    }
  }
  const built = boxes.map((box, i) => {
    const depth = depths[i];
    const extra = (maxDepth - depth) * NEST_GAP;
    const r = eff[i];
    const node = chainGroupNode(
      box.group.id,
      {
        label: box.group.label,
        // Stated rather than left implicit in the node id: it is what makes the
        // label clickable, and a band synthesized from something other than a
        // scene group must stay inert.
        groupId: box.group.id,
        fill: box.group.fill,
        border: box.group.border,
        text: box.group.text
      },
      {
        x: r.minX - pad - extra,
        y: r.minY - pad - extra - HEADER_PAD,
        width: r.maxX - r.minX + (pad + extra) * 2,
        height: r.maxY - r.minY + (pad + extra) * 2 + HEADER_PAD
      }
    );
    return { node: { ...node, zIndex: GROUP_Z_BASE + depth }, depth };
  });
  built.sort((a, b) => a.depth - b.depth);
  return built.map((b) => b.node);
}
function pairwiseDisjoint(boxes) {
  const seen = /* @__PURE__ */ new Set();
  for (const box of boxes) {
    for (const id of box.members) {
      if (seen.has(id)) return false;
      seen.add(id);
    }
  }
  return true;
}
function dominantPartition(boxes) {
  const byType = /* @__PURE__ */ new Map();
  for (const box of boxes) {
    const bucket = byType.get(box.group.groupType);
    if (bucket) bucket.push(box);
    else byType.set(box.group.groupType, [box]);
  }
  let best = [];
  let bestReach = 0;
  for (const [, bucket] of [...byType].sort(([a], [b]) => a < b ? -1 : 1)) {
    if (bucket.length < 2 || !pairwiseDisjoint(bucket)) continue;
    const reach = bucket.reduce((total, box) => total + box.members.size, 0);
    if (bucket.length > best.length || bucket.length === best.length && reach > bestReach) {
      best = bucket;
      bestReach = reach;
    }
  }
  return best;
}
function separateGroupBands(positions, nodes, groups, options = {}) {
  if (groups.length < 2 || nodes.length === 0) return positions;
  if (options.rankBy === "time") {
    const timeBands = groups.filter((group) => group.groupType === "time");
    if (timeBands.length) {
      const categories = groups.filter((group) => group.groupType !== "time");
      let result = positions;
      for (const band of timeBands) {
        const members2 = new Set(band.memberNodeIds);
        const bandNodes = nodes.filter((node) => members2.has(node.id));
        const nested = groupsWithinBands([band], categories).slice(1);
        result = separateGroupBands(result, bandNodes, nested, options);
      }
      return result;
    }
  }
  const pad = options.padding ?? DEFAULT_PAD;
  const at = footprints(
    nodes,
    options.nodeWidth ?? DEFAULT_NODE_W,
    options.nodeHeight ?? DEFAULT_NODE_H,
    positions,
    options.sizes
  );
  const ranked = options.rankBy === "hop" || options.rankBy === "time" ? options.rankBy : null;
  const bands = dominantPartition(groupBoxes(groups, at).filter((box) => box.group.groupType !== ranked));
  if (bands.length < 2) return positions;
  const gap = 2 * (pad + NEST_GAP) + HEADER_PAD + BAND_BREATHING;
  const acrossY = (options.direction ?? "LR") === "LR" || options.direction === "RL";
  const start = (b) => acrossY ? b.raw.minY : b.raw.minX;
  const end = (b) => acrossY ? b.raw.maxY : b.raw.maxX;
  let edge = null;
  let moved = null;
  const sweep = [];
  for (const band of [...bands].sort((a, b) => start(a) - start(b))) {
    const shift = edge === null ? 0 : Math.max(0, edge + gap - start(band));
    sweep.push({ start: start(band), shift });
    if (shift > 0) {
      moved ??= { ...positions };
      for (const id of band.members) {
        const box = at(id);
        if (box) moved[id] = acrossY ? { x: box.x, y: box.y + shift } : { x: box.x + shift, y: box.y };
      }
    }
    edge = Math.max(edge ?? -Infinity, end(band) + shift);
  }
  if (!moved) return positions;
  const members = /* @__PURE__ */ new Set();
  for (const band of bands) for (const id of band.members) members.add(id);
  for (const node of nodes) {
    if (members.has(node.id)) continue;
    const box = at(node.id);
    if (!box) continue;
    const from = acrossY ? box.y : box.x;
    let shift = 0;
    for (const step of sweep) if (step.start <= from) shift = step.shift;
    if (shift > 0) moved[node.id] = acrossY ? { x: box.x, y: box.y + shift } : { x: box.x + shift, y: box.y };
  }
  return moved;
}
var DEFAULT_NODE_W, DEFAULT_NODE_H, DEFAULT_PAD, HEADER_PAD, NEST_GAP, BAND_BREATHING, MAX_NEST_DEPTH, MAX_ENTANGLED_BANDS, GROUP_Z_BASE;
var init_sceneGroups = __esm({
  "src/engines/flow/sceneGroups.ts"() {
    init_nodes();
    init_clusterGroups();
    DEFAULT_NODE_W = 260;
    DEFAULT_NODE_H = 100;
    DEFAULT_PAD = 30;
    HEADER_PAD = 14;
    NEST_GAP = 16;
    BAND_BREATHING = 24;
    MAX_NEST_DEPTH = 2;
    MAX_ENTANGLED_BANDS = 4;
    GROUP_Z_BASE = -10;
  }
});
function PanelCloseButton({ onClick, label, className }) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick,
      "aria-label": label,
      title: label,
      className: cn(
        "pointer-events-auto flex size-4 shrink-0 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground",
        className
      ),
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          viewBox: "0 0 24 24",
          width: "11",
          height: "11",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2.5",
          strokeLinecap: "round",
          "aria-hidden": true,
          children: /* @__PURE__ */ jsx("path", { d: "M6 6l12 12M18 6L6 18" })
        }
      )
    }
  );
}
var init_PanelCloseButton = __esm({
  "src/panels/PanelCloseButton.tsx"() {
  }
});
function Swatch({ color, shape = "line" }) {
  if (shape === "dot") {
    return /* @__PURE__ */ jsx("span", { className: "size-2.5 rounded-full", style: { backgroundColor: color } });
  }
  if (shape === "box") {
    return /* @__PURE__ */ jsx("span", { className: "h-2.5 w-3 rounded-sm border", style: { borderColor: color, backgroundColor: `${color}` } });
  }
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: "h-0 w-4",
      style: {
        borderTopWidth: 2,
        borderTopStyle: shape === "dashed" ? "dashed" : "solid",
        borderTopColor: color
      }
    }
  );
}
function LegendRows({ items }) {
  return /* @__PURE__ */ jsx("ul", { className: "space-y-1", children: items.map((item) => /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-2 text-muted-foreground", children: [
    /* @__PURE__ */ jsx(Swatch, { color: item.color, shape: item.shape }),
    /* @__PURE__ */ jsx("span", { children: item.label })
  ] }, `${item.group ?? ""}:${item.label}`)) });
}
function partitionByGroup(items) {
  const ungrouped = [];
  const groups = [];
  const index = /* @__PURE__ */ new Map();
  for (const item of items) {
    if (!item.group) {
      ungrouped.push(item);
      continue;
    }
    let gi = index.get(item.group);
    if (gi === void 0) {
      gi = groups.length;
      index.set(item.group, gi);
      groups.push({ name: item.group, items: [] });
    }
    groups[gi].items.push(item);
  }
  return { ungrouped, groups };
}
function GraphLegend({ items, title = "Legend", className, onClose }) {
  const { ungrouped, groups } = partitionByGroup(items);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      tabIndex: 0,
      role: "region",
      "aria-label": "Graph legend",
      className: cn(
        "pointer-events-auto relative max-h-48 max-w-[min(24rem,70vw)] overflow-y-auto select-none rounded-md border bg-card/90 p-2 text-xs shadow-xs backdrop-blur",
        onClose && "pr-6",
        className
      ),
      children: [
        onClose ? /* @__PURE__ */ jsx(PanelCloseButton, { className: "absolute right-1 top-1", onClick: onClose, label: "Hide legend" }) : null,
        ungrouped.length > 0 ? /* @__PURE__ */ jsxs("div", { children: [
          title ? /* @__PURE__ */ jsx("p", { className: "mb-1 font-medium text-foreground", children: title }) : null,
          /* @__PURE__ */ jsx(LegendRows, { items: ungrouped })
        ] }) : null,
        groups.map((group, gi) => /* @__PURE__ */ jsxs("div", { className: cn((ungrouped.length > 0 || gi > 0) && "mt-2"), children: [
          /* @__PURE__ */ jsx("p", { className: "mb-1 font-medium text-foreground", children: group.name }),
          /* @__PURE__ */ jsx(LegendRows, { items: group.items })
        ] }, group.name))
      ]
    }
  );
}
var DEFAULT_EDGE_LEGEND;
var init_GraphLegend = __esm({
  "src/legend/GraphLegend.tsx"() {
    init_PanelCloseButton();
    DEFAULT_EDGE_LEGEND = GRAPH_EDGE_VARIANTS.map((variant) => ({
      label: GRAPH_EDGE_VARIANT_LABELS[variant],
      color: GRAPH_EDGE_VARIANT_COLOR[variant],
      shape: variant === "flow" ? "dashed" : "line"
    }));
  }
});
function positionsOf(nodes) {
  const positions = {};
  for (const node of nodes) positions[node.id] = node.position;
  return positions;
}
function nodeSetSignature(nodes) {
  return nodes.map((node) => node.id).sort().join("\0");
}
function ranksVertically(direction) {
  return direction === "TB" || direction === "BT";
}
function chooseEdgeSides(positions, nodes, edges, direction, sizes) {
  const canonical = WITH_FLOW[direction] ?? WITH_FLOW.LR;
  const vertical = ranksVertically(direction);
  const out = {};
  if (edges.length === 0) return out;
  const centre2 = (id) => {
    const at = positions[id];
    if (!at) return void 0;
    const size = sizes?.[id];
    return {
      x: at.x + (size?.width ?? DEFAULTS.nodeWidth) / 2,
      y: at.y + (size?.height ?? DEFAULTS.nodeHeight) / 2
    };
  };
  const span = vertical ? "height" : "width";
  let typical = 0;
  for (const node of nodes) {
    typical = Math.max(typical, sizes?.[node.id]?.[span] ?? 0);
  }
  const sameRank = (typical || (vertical ? 100 : 260)) * 0.5;
  for (const edge of edges) {
    const from = centre2(edge.source);
    const to = centre2(edge.target);
    if (!from || !to) continue;
    const along = vertical ? to.y - from.y : to.x - from.x;
    const across = vertical ? to.x - from.x : to.y - from.y;
    const forward = direction === "TB" || direction === "LR" ? along : -along;
    if (forward > sameRank) continue;
    if (Math.abs(along) <= sameRank) {
      const near = vertical ? across >= 0 ? "right" : "left" : across >= 0 ? "bottom" : "top";
      out[edge.id] = { source: near, target: OPPOSITE[near] };
      continue;
    }
    out[edge.id] = { source: canonical.target, target: canonical.source };
  }
  return out;
}
function sizesInvalidate(previous, next) {
  for (const [id, size] of Object.entries(next)) {
    const before = previous[id];
    if (!before) continue;
    if (before.width !== size.width || before.height !== size.height) return true;
  }
  return false;
}
function placeAddedNodes(known, nodes, edges, options = {}) {
  const opts = { ...DEFAULTS, ...options };
  const present = new Set(nodes.map((node) => node.id));
  const placed = {};
  for (const node of nodes) {
    const position = known[node.id];
    if (position) placed[node.id] = position;
  }
  let pending = nodes.filter((node) => !placed[node.id]);
  if (pending.length === 0) return placed;
  const neighbours = /* @__PURE__ */ new Map();
  const link = (from, to) => {
    const list = neighbours.get(from);
    if (list) list.push(to);
    else neighbours.set(from, [to]);
  };
  for (const edge of edges) {
    if (!present.has(edge.source) || !present.has(edge.target)) continue;
    link(edge.source, edge.target);
    link(edge.target, edge.source);
  }
  while (pending.length > 0) {
    const stuck = [];
    for (const node of pending) {
      const anchors = (neighbours.get(node.id) ?? []).map((id) => placed[id]).filter((position) => position !== void 0);
      if (anchors.length === 0) {
        stuck.push(node);
        continue;
      }
      placed[node.id] = freeSpot(centroid(anchors), placed, opts);
    }
    if (stuck.length === pending.length) break;
    pending = stuck;
  }
  let next = { x: rightEdge(placed) + opts.nodeWidth + opts.nodeSep, y: 0 };
  for (const node of pending) {
    placed[node.id] = next;
    next = { x: next.x, y: next.y + opts.nodeHeight + opts.nodeSep };
  }
  return placed;
}
function centroid(positions) {
  const sum = positions.reduce((acc, p) => ({ x: acc.x + p.x, y: acc.y + p.y }), { x: 0, y: 0 });
  return { x: sum.x / positions.length, y: sum.y / positions.length };
}
function rightEdge(placed) {
  let max = 0;
  for (const position of Object.values(placed)) max = Math.max(max, position.x);
  return max;
}
function freeSpot(start, placed, opts) {
  const stepX = opts.nodeWidth + opts.nodeSep;
  const stepY = opts.nodeHeight + opts.nodeSep;
  const taken = Object.values(placed);
  const collides = (candidate) => taken.some(
    (p) => Math.abs(p.x - candidate.x) < stepX * 0.9 && Math.abs(p.y - candidate.y) < stepY * 0.9
  );
  for (let rank = 0; rank <= 4; rank += 1) {
    for (const row of rowsFrom(rank)) {
      const candidate = { x: start.x + rank * stepX, y: start.y + row * stepY };
      if (!collides(candidate)) return candidate;
    }
  }
  return { x: start.x + 5 * stepX, y: start.y };
}
function rowsFrom(reach) {
  const rows = [0];
  for (let step = 1; step <= reach; step += 1) rows.push(step, -step);
  return rows;
}
function dims(node, opts) {
  const measured = opts.sizes?.[node.id];
  return {
    width: measured?.width ?? node.measured?.width ?? opts.nodeWidth,
    height: measured?.height ?? node.measured?.height ?? opts.nodeHeight
  };
}
function collectNodeSizes(nodes) {
  const sizes = {};
  for (const node of nodes) {
    const { width, height } = node.measured ?? {};
    if (width == null || height == null || width <= 0 || height <= 0) continue;
    sizes[node.id] = {
      width: Math.ceil(width / SIZE_GRID) * SIZE_GRID,
      height: Math.ceil(height / SIZE_GRID) * SIZE_GRID
    };
  }
  return sizes;
}
function nodeSizeSignature(sizes) {
  return Object.keys(sizes).sort().map((id) => `${id}:${sizes[id].width}x${sizes[id].height}`).join("\0");
}
function connectedEdges(nodes, edges) {
  const present = new Set(nodes.map((node) => node.id));
  return edges.filter((edge) => present.has(edge.source) && present.has(edge.target));
}
function connectedComponents(nodes, edges) {
  const byId = new Map(nodes.map((node) => [node.id, node]));
  const neighbours = /* @__PURE__ */ new Map();
  for (const edge of edges) {
    if (!byId.has(edge.source) || !byId.has(edge.target)) continue;
    (neighbours.get(edge.source) ?? neighbours.set(edge.source, []).get(edge.source)).push(edge.target);
    (neighbours.get(edge.target) ?? neighbours.set(edge.target, []).get(edge.target)).push(edge.source);
  }
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const node of nodes) {
    if (seen.has(node.id)) continue;
    const group = [];
    const stack = [node.id];
    seen.add(node.id);
    while (stack.length) {
      const id = stack.pop();
      const member = byId.get(id);
      if (member) group.push(member);
      for (const next of neighbours.get(id) ?? []) {
        if (seen.has(next)) continue;
        seen.add(next);
        stack.push(next);
      }
    }
    out.push(group);
  }
  return out;
}
function packBoxes(boxes, { targetAspect = 16 / 9, gap = 80 } = {}) {
  if (boxes.length === 0) return [];
  const area = boxes.reduce((sum, box) => sum + (box.width + gap) * (box.height + gap), 0);
  const widest = Math.max(...boxes.map((box) => box.width));
  const rowWidth = Math.max(widest, Math.sqrt(area * targetAspect));
  const out = [];
  let x = 0;
  let y = 0;
  let rowHeight = 0;
  for (const box of boxes) {
    if (x > 0 && x + box.width > rowWidth) {
      x = 0;
      y += rowHeight + gap;
      rowHeight = 0;
    }
    out.push({ x, y });
    x += box.width + gap;
    rowHeight = Math.max(rowHeight, box.height);
  }
  return out;
}
function boundsOf(nodes, opts) {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const node of nodes) {
    const { width, height } = dims(node, opts);
    minX = Math.min(minX, node.position.x);
    minY = Math.min(minY, node.position.y);
    maxX = Math.max(maxX, node.position.x + width);
    maxY = Math.max(maxY, node.position.y + height);
  }
  return { minX, minY, width: maxX - minX, height: maxY - minY };
}
function dagreOne(nodes, edges, opts) {
  const graph = new dagre.graphlib.Graph();
  graph.setDefaultEdgeLabel(() => ({}));
  graph.setGraph({ rankdir: opts.direction, ranksep: opts.rankSep, nodesep: opts.nodeSep });
  for (const node of nodes) {
    const { width, height } = dims(node, opts);
    graph.setNode(node.id, { width, height });
  }
  for (const edge of connectedEdges(nodes, edges)) {
    graph.setEdge(edge.source, edge.target);
  }
  dagre.layout(graph);
  return nodes.map((node) => {
    const laid = graph.node(node.id);
    if (!laid) return node;
    const { width, height } = dims(node, opts);
    return { ...node, position: { x: laid.x - width / 2, y: laid.y - height / 2 } };
  });
}
function wrapWideStory(nodes, options = {}) {
  const opts = { ...DEFAULTS, ...options };
  if (nodes.length < MIN_WRAP_NODES) return nodes;
  const box = boundsOf(nodes, opts);
  if (box.width <= 0 || box.height <= 0) return nodes;
  if (Math.max(box.width / box.height, box.height / box.width) <= MAX_STORY_ASPECT) return nodes;
  const horizontal = opts.direction === "LR" || opts.direction === "RL";
  const alongOf = (node) => horizontal ? node.position.x : node.position.y;
  const acrossOf = (node) => horizontal ? node.position.y : node.position.x;
  const alongSize = (node) => horizontal ? dims(node, opts).width : dims(node, opts).height;
  const acrossSize = (node) => horizontal ? dims(node, opts).height : dims(node, opts).width;
  const gap = Math.max(opts.nodeSep, opts.rankSep);
  const area = nodes.reduce(
    (sum, node) => sum + (alongSize(node) + gap) * (acrossSize(node) + gap),
    0
  );
  const targetAspect = 16 / 9;
  const screenWidth = Math.sqrt(area * targetAspect);
  const screenHeight = Math.sqrt(area / targetAspect);
  const maxAlong = horizontal ? screenWidth : screenHeight;
  const maxAcross = horizontal ? screenHeight : screenWidth;
  const ranks = /* @__PURE__ */ new Map();
  for (const node of nodes) {
    const key = Math.round(alongOf(node));
    const rank = ranks.get(key);
    if (rank) rank.push(node);
    else ranks.set(key, [node]);
  }
  const lines = [];
  for (const key of [...ranks.keys()].sort((a, b) => a - b)) {
    const rank = [...ranks.get(key)].sort((a, b) => acrossOf(a) - acrossOf(b));
    let line = [];
    let used = 0;
    for (const node of rank) {
      const size = acrossSize(node) + gap;
      if (line.length > 0 && used + size > maxAcross) {
        lines.push(line);
        line = [];
        used = 0;
      }
      line.push(node);
      used += size;
    }
    if (line.length > 0) lines.push(line);
  }
  const moved = /* @__PURE__ */ new Map();
  let alongCursor = 0;
  let acrossBand = 0;
  let bandAcross = 0;
  for (const line of lines) {
    const lineAlong = Math.max(...line.map(alongSize));
    if (alongCursor > 0 && alongCursor + lineAlong > maxAlong) {
      acrossBand += bandAcross + gap;
      alongCursor = 0;
      bandAcross = 0;
    }
    let acrossCursor = 0;
    for (const node of line) {
      const along = alongCursor;
      const across = acrossBand + acrossCursor;
      moved.set(node.id, horizontal ? { x: along, y: across } : { x: across, y: along });
      acrossCursor += acrossSize(node) + gap;
    }
    bandAcross = Math.max(bandAcross, acrossCursor - gap);
    alongCursor += lineAlong + gap;
  }
  return nodes.map((node) => {
    const position = moved.get(node.id);
    return position ? { ...node, position } : node;
  });
}
function ranksByRecordedValue(options) {
  return Boolean(options) && (options.rankBy === "hop" || options.rankBy === "time");
}
function layoutWithHops(nodes, options = {}) {
  const opts = { ...DEFAULTS, ...options };
  const vertical = ranksVertically(opts.direction);
  const ranks = /* @__PURE__ */ new Map();
  for (const node of nodes) {
    const hop = opts.rankBy === "time" ? node.data.timeRank : node.data.hop;
    const rank = typeof hop === "number" && Number.isFinite(hop) && hop >= 0 ? hop : Infinity;
    const band = ranks.get(rank) ?? [];
    band.push(node);
    ranks.set(rank, band);
  }
  const positions = /* @__PURE__ */ new Map();
  const bands = [];
  let offset = 0;
  for (const [, members] of [...ranks].sort((a, b) => a[0] - b[0])) {
    members.sort((a, b) => a.id.localeCompare(b.id));
    const sizes = members.map((n) => dims(n, opts));
    const width = Math.max(...sizes.map((s) => s.width));
    const height = Math.max(...sizes.map((s) => s.height));
    const columns = Math.min(4, Math.ceil(Math.sqrt(members.length)));
    const rows = Math.ceil(members.length / columns);
    members.forEach((node, index) => {
      const cross = index % columns * ((vertical ? width : height) + opts.nodeSep);
      const along2 = offset + Math.floor(index / columns) * ((vertical ? height : width) + opts.nodeSep);
      positions.set(node.id, vertical ? { x: cross, y: opts.direction === "BT" ? -along2 : along2 } : { x: opts.direction === "RL" ? -along2 : along2, y: cross });
    });
    const along = rows * (vertical ? height : width) + (rows - 1) * opts.nodeSep;
    const across = Math.min(columns, members.length) * ((vertical ? width : height) + opts.nodeSep) - opts.nodeSep;
    bands.push({ ids: members.map((n) => n.id), start: offset, along, across });
    offset += along + opts.rankSep;
  }
  foldLongTrail(bands, positions, opts, vertical);
  return nodes.map((n) => ({ ...n, position: positions.get(n.id) }));
}
function foldLongTrail(bands, positions, opts, vertical) {
  if (bands.length < MIN_FOLD_RANKS) return;
  const last = bands[bands.length - 1];
  const length = last.start + last.along;
  const widest = Math.max(...bands.map((band) => band.across));
  if (widest <= 0 || length / widest <= MAX_STORY_ASPECT) return;
  const lineGap = opts.rankSep + opts.nodeSep;
  const area = bands.reduce((sum, band) => sum + (band.along + opts.rankSep) * (band.across + lineGap), 0);
  const targetAspect = 16 / 9;
  const lineLength = vertical ? Math.sqrt(area / targetAspect) : Math.sqrt(area * targetAspect);
  const sign = opts.direction === "BT" || opts.direction === "RL" ? -1 : 1;
  let lineStart = 0;
  let lineAcross = 0;
  let acrossOffset = 0;
  for (const band of bands) {
    if (band.start > lineStart && band.start + band.along - lineStart > lineLength) {
      acrossOffset += lineAcross + lineGap;
      lineStart = band.start;
      lineAcross = 0;
    }
    lineAcross = Math.max(lineAcross, band.across);
    if (lineStart === 0 && acrossOffset === 0) continue;
    for (const id of band.ids) {
      const at = positions.get(id);
      positions.set(id, vertical ? { x: at.x + acrossOffset, y: at.y - sign * lineStart } : { x: at.x - sign * lineStart, y: at.y + acrossOffset });
    }
  }
}
function layoutWithDagre(nodes, edges, options = {}) {
  if (ranksByRecordedValue(options)) return layoutWithHops(nodes, options);
  const opts = { ...DEFAULTS, ...options };
  const components = connectedComponents(nodes, connectedEdges(nodes, edges));
  if (components.length <= 1) return wrapWideStory(dagreOne(nodes, edges, opts), options);
  const laidOut = components.map((group) => wrapWideStory(dagreOne(group, edges, opts), options));
  const boxes = laidOut.map((group) => boundsOf(group, opts));
  const placements = packBoxes(boxes, { gap: Math.max(opts.nodeSep, opts.rankSep) });
  const moved = /* @__PURE__ */ new Map();
  laidOut.forEach((group, index) => {
    const box = boxes[index];
    const place = placements[index];
    for (const node of group) {
      moved.set(node.id, {
        x: node.position.x - box.minX + place.x,
        y: node.position.y - box.minY + place.y
      });
    }
  });
  return nodes.map((node) => {
    const position = moved.get(node.id);
    return position ? { ...node, position } : node;
  });
}
function loadElk() {
  elkModule ??= import('elkjs/lib/elk.bundled.js').then(
    (m) => m.default ?? m
  );
  return elkModule;
}
async function layoutWithElk(nodes, edges, options = {}) {
  if (ranksByRecordedValue(options)) return layoutWithHops(nodes, options);
  const opts = { ...DEFAULTS, ...options };
  const ELK = await loadElk();
  const elk = new ELK();
  const layoutOptions = {
    "elk.algorithm": "layered",
    "elk.direction": ELK_DIRECTION[opts.direction],
    "elk.layered.spacing.nodeNodeBetweenLayers": String(opts.rankSep),
    "elk.spacing.nodeNode": String(opts.nodeSep)
  };
  const graph = {
    id: "root",
    layoutOptions,
    children: nodes.map((node) => {
      const { width, height } = dims(node, opts);
      return { id: node.id, width, height };
    }),
    edges: connectedEdges(nodes, edges).map((edge) => ({
      id: edge.id,
      sources: [edge.source],
      targets: [edge.target]
    }))
  };
  const result = await elk.layout(graph);
  const positioned = new Map((result.children ?? []).map((child) => [child.id, child]));
  return nodes.map((node) => {
    const laid = positioned.get(node.id);
    if (!laid || laid.x === void 0 || laid.y === void 0) return node;
    return { ...node, position: { x: laid.x, y: laid.y } };
  });
}
var DEFAULTS, WITH_FLOW, OPPOSITE, SIZE_GRID, MAX_STORY_ASPECT, MIN_WRAP_NODES, MIN_FOLD_RANKS, ELK_DIRECTION, elkModule;
var init_layout = __esm({
  "src/engines/flow/layout.ts"() {
    DEFAULTS = {
      rankBy: "topology",
      direction: "LR",
      nodeWidth: 260,
      nodeHeight: 100,
      rankSep: 110,
      nodeSep: 90
    };
    WITH_FLOW = {
      TB: { source: "bottom", target: "top" },
      BT: { source: "top", target: "bottom" },
      LR: { source: "right", target: "left" },
      RL: { source: "left", target: "right" }
    };
    OPPOSITE = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    };
    SIZE_GRID = 4;
    MAX_STORY_ASPECT = 4;
    MIN_WRAP_NODES = 12;
    MIN_FOLD_RANKS = 10;
    ELK_DIRECTION = {
      TB: "DOWN",
      BT: "UP",
      LR: "RIGHT",
      RL: "LEFT"
    };
    elkModule = null;
  }
});
function layoutDirectionForView(view) {
  return view === "temporal" ? "LR" : "TB";
}
function layoutForView(view, overrides) {
  if (view === "force") return false;
  return { direction: layoutDirectionForView(view), ...overrides };
}
function engineForView(view) {
  return view === "force" ? "force" : "flow";
}
var init_viewMode = __esm({
  "src/view/viewMode.ts"() {
  }
});

// src/search/match.ts
function factText(facts) {
  if (!Array.isArray(facts)) return [];
  const out = [];
  for (const fact of facts) {
    if (!fact || typeof fact !== "object") continue;
    const { label, value } = fact;
    if (typeof label === "string") out.push(label);
    if (typeof value === "string" || typeof value === "number") out.push(String(value));
  }
  return out;
}
function fieldText(node, field) {
  const data = node.data;
  switch (field) {
    case "id":
      return [node.id];
    case "label":
      return [data.label];
    case "subtitle":
      return [data.subtitle];
    case "chain":
      return [data.chain];
    case "badge":
      return [data.badge, ...(data.contextBadges ?? []).flatMap((b) => [b.label, b.title])];
    case "tags":
      return data.tags ?? [];
    case "address":
      return [data.address];
    case "entity":
      return [data.entityId];
    case "protocol":
      return [data.protocol, ...data.receiptProtocolIds ?? [], ...receiptProtocolNames(data.receiptProtocolIds)];
    case "kind":
      return [data.kind];
    case "value":
      return [data.value];
    case "facts":
      return factText(data.facts);
    case "members":
      return data.memberSearchText ? [...data.memberSearchText] : [];
    default:
      return [];
  }
}
function hit(text2, query, mode) {
  switch (mode) {
    case "prefix":
      return text2.startsWith(query);
    case "exact":
      return text2 === query;
    default:
      return text2.includes(query);
  }
}
function matchGraphNodes(nodes, query, spec = {}) {
  const q = query.trim().toLowerCase();
  if (!q) return new Set(nodes.map((n) => n.id));
  const fields = spec.fields ?? DEFAULT_SEARCH_FIELDS;
  const mode = spec.mode ?? "contains";
  const matched = /* @__PURE__ */ new Set();
  for (const node of nodes) {
    for (const field of fields) {
      const texts = fieldText(node, field);
      const found = texts.some(
        (text2) => typeof text2 === "string" && text2.length > 0 && hit(text2.toLowerCase(), q, mode)
      );
      if (found) {
        matched.add(node.id);
        break;
      }
    }
  }
  return matched;
}
function allNodesMatch(nodes, matched) {
  return matched.size >= nodes.length;
}
var GRAPH_SEARCH_FIELDS, GRAPH_SEARCH_MODES, DEFAULT_SEARCH_FIELDS, ALL_SEARCH_FIELDS;
var init_match = __esm({
  "src/search/match.ts"() {
    init_receiptProtocols();
    GRAPH_SEARCH_FIELDS = [
      "id",
      "label",
      "subtitle",
      "chain",
      "badge",
      "tags",
      "address",
      "entity",
      "protocol",
      "kind",
      "value",
      "facts",
      "members"
    ];
    GRAPH_SEARCH_MODES = ["contains", "prefix", "exact"];
    DEFAULT_SEARCH_FIELDS = [
      "id",
      "label",
      "subtitle",
      "chain",
      "badge",
      "tags",
      "address",
      "entity",
      "protocol",
      "kind",
      "members"
    ];
    ALL_SEARCH_FIELDS = GRAPH_SEARCH_FIELDS;
  }
});
function useGraphSearch(nodes, spec = {}, options = {}) {
  const [query, setQueryState] = React17.useState(options.initialQuery ?? "");
  const [index, setIndex] = React17.useState(0);
  const fields = spec.fields;
  const mode = spec.mode;
  const matches = React17.useMemo(
    () => matchGraphNodes(nodes, query, { fields, mode }),
    [nodes, query, fields, mode]
  );
  const trimmed = query.trim();
  const searching = trimmed.length > 0;
  const matchIds = React17.useMemo(
    () => searching ? nodes.filter((node) => matches.has(node.id)).map((node) => node.id) : [],
    [searching, nodes, matches]
  );
  const active = searching && matchIds.length > 0;
  const setQuery = React17.useCallback((next) => {
    setQueryState(next);
    setIndex(0);
  }, []);
  const step = React17.useCallback(
    (delta) => {
      setIndex((prev) => {
        if (matchIds.length === 0) return 0;
        return (prev + delta + matchIds.length) % matchIds.length;
      });
    },
    [matchIds.length]
  );
  const clear = React17.useCallback(() => {
    setQueryState("");
    setIndex(0);
  }, []);
  const safeIndex = matchIds.length === 0 ? -1 : Math.min(index, matchIds.length - 1);
  return {
    query,
    setQuery,
    matches,
    matchIds,
    active,
    index: safeIndex,
    focusId: safeIndex >= 0 ? matchIds[safeIndex] : void 0,
    next: React17.useCallback(() => step(1), [step]),
    prev: React17.useCallback(() => step(-1), [step]),
    clear
  };
}
var init_useGraphSearch = __esm({
  "src/search/useGraphSearch.ts"() {
    init_match();
  }
});
function GraphSearchBox({
  search,
  placeholder = "Search nodes",
  className
}) {
  const { query, setQuery, matchIds, index, next, prev, clear } = search;
  const inputRef = React17.useRef(null);
  const [open, setOpen] = React17.useState(false);
  const expanded = open || query.length > 0;
  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (event.shiftKey) prev();
      else next();
    } else if (event.key === "Escape") {
      event.preventDefault();
      clear();
      setOpen(false);
      inputRef.current?.blur();
    }
  };
  if (!expanded) {
    return /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        "aria-label": "Search the graph",
        title: "Search the graph",
        className: cn("size-7 p-0", className),
        onClick: () => {
          setOpen(true);
          window.setTimeout(() => inputRef.current?.focus(), 0);
        },
        children: /* @__PURE__ */ jsx(SearchIcon, { size: 13 })
      }
    );
  }
  const count = matchIds.length;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex items-center gap-1", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsx("span", { className: "pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground", children: /* @__PURE__ */ jsx(SearchIcon, { size: 13 }) }),
      /* @__PURE__ */ jsx(
        Input,
        {
          ref: inputRef,
          value: query,
          onChange: (event) => setQuery(event.target.value),
          onKeyDown,
          onBlur: () => {
            if (query.length === 0) setOpen(false);
          },
          placeholder,
          "aria-label": "Search the graph",
          className: "h-7 w-40 pl-7 pr-2 text-xs"
        }
      )
    ] }),
    query.trim().length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "min-w-[3.5rem] text-center text-xs tabular-nums text-muted-foreground",
          "aria-live": "polite",
          children: count === 0 ? "No matches" : `${index + 1} of ${count}`
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "button",
          variant: "outline",
          size: "sm",
          className: "size-7 p-0",
          "aria-label": "Previous match",
          title: "Previous match (Shift+Enter)",
          disabled: count === 0,
          onClick: prev,
          children: /* @__PURE__ */ jsx(ChevronUpIcon, { size: 13 })
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "button",
          variant: "outline",
          size: "sm",
          className: "size-7 p-0",
          "aria-label": "Next match",
          title: "Next match (Enter)",
          disabled: count === 0,
          onClick: next,
          children: /* @__PURE__ */ jsx(ChevronDownIcon, { size: 13 })
        }
      )
    ] }) : null
  ] });
}
var init_GraphSearchBox = __esm({
  "src/search/GraphSearchBox.tsx"() {
  }
});

// src/search/index.ts
var init_search = __esm({
  "src/search/index.ts"() {
    init_match();
    init_useGraphSearch();
    init_GraphSearchBox();
  }
});

// src/edgeKinds.ts
function edgeVariantForKind(kind) {
  return kind && EDGE_KIND_TO_VARIANT[kind] || "flow";
}
function isFlowEdgeKind(kind) {
  return kind != null && FLOW_EDGE_KINDS.has(kind);
}
function isLinkEdgeKind(kind) {
  return kind != null && LINK_EDGE_KINDS.has(kind);
}
var EDGE_KIND_TO_VARIANT, FLOW_EDGE_KINDS, LINK_EDGE_KINDS;
var init_edgeKinds = __esm({
  "src/edgeKinds.ts"() {
    EDGE_KIND_TO_VARIANT = {
      // Value movement. `erc721` / `erc1155` joined when the flow source learned to
      // read transaction BODIES: before that a walk emitted only `native`, so an
      // NFT leg had never reached this map and fell through to the neutral `flow`
      // variant — drawn identically to an edge whose kind nothing recognised.
      transfer: "transfer",
      erc20: "transfer",
      erc721: "transfer",
      erc1155: "transfer",
      native: "transfer",
      // Calls / verification steps.
      approval: "approval",
      call: "call",
      internal: "call",
      verify: "call",
      // Structural relations (parent → child). `creates` shares the variant because
      // it is the same shape of claim — a factory produced this pool, a pool is made
      // of this token — and deliberately not a value-movement variant: nothing moved.
      contains: "inheritance",
      creates: "inheritance",
      // Cross-chain / bridge legs.
      cross_chain: "bridge",
      bridge: "bridge",
      bridge_in: "bridge",
      bridge_out: "bridge",
      // Receipt correlation only: deliberately absent from FLOW_EDGE_KINDS below.
      bridge_link: "bridge",
      // A passage through a drained venue (a rug's pool): who took a deposit out,
      // on a finding's word — a relationship with no amount, so not animated.
      venue_link: "flow",
      // A deposit credited to a validator, or stake one validator absorbed from
      // another: where the ether went on the beacon chain. The deposit leg already
      // carries the money, so this is drawn and not animated.
      validator_link: "flow",
      // A custodial bridge's crossing (Wagyu: XMR on Monero -> XMR1 on HyperCore):
      // the token's claim, linked to no deposit — drawn as a bridge, never animated.
      custodial_link: "bridge",
      // A custodial bridge's per-order account, the same address on its other chain
      // (Wagyu: paid XMR1 on HyperCore, fronted USDC on Arbitrum): drawn, never animated.
      order_account_link: "bridge",
      // Generic.
      flow: "flow"
    };
    FLOW_EDGE_KINDS = /* @__PURE__ */ new Set([
      "transfer",
      "erc20",
      // An NFT leg carries value and animates like any other transfer. Omitted
      // until the flow source could read bodies, because no walk emitted one.
      "erc721",
      "erc1155",
      "native",
      "flow",
      "cross_chain",
      "bridge",
      "bridge_in",
      "bridge_out"
    ]);
    LINK_EDGE_KINDS = /* @__PURE__ */ new Set([
      "bridge_link",
      "venue_link",
      "validator_link",
      "custodial_link",
      "order_account_link"
    ]);
  }
});
function nodeClass(node) {
  const d = node.data;
  return [stringOrEmpty(d.kind), stringOrEmpty(d.variant), stringOrEmpty(d.badge), stringOrEmpty(d.chain), stringOrEmpty(d.protocol), typeof d.hop === "number" ? d.hop : ""].join("|");
}
function isBareAddress(label, address, chain) {
  if (addressesEqual(label, address, chain)) return true;
  const parts = label.split(/…|\.\.\./);
  if (parts.length !== 2 || parts[0].length === 0) return false;
  const caseless = addressesEqual(address.toUpperCase(), address, chain);
  const fold = (text2) => caseless ? text2.toLowerCase() : text2;
  const whole = fold(normalizeAddress(address, chain));
  return whole.startsWith(fold(parts[0])) && whole.endsWith(fold(parts[1]));
}
function carriesIdentity(node) {
  const d = node.data;
  if (d.cluster) return true;
  if (d.entityId || d.riskLevel || d.impersonates || d.accentClassName || d.accentToken) return true;
  if (typeof d.riskScore === "number" && d.riskScore > 0) return true;
  if ((d.tags?.length ?? 0) > 0 || (d.contested?.length ?? 0) > 0) return true;
  if (d.failed || d.virtual || d.origin === "user") return true;
  return typeof d.address === "string" && d.address !== "" && !isBareAddress(d.label, d.address, asString(d.chain));
}
function hash(text2) {
  let h = 5381;
  for (let i = 0; i < text2.length; i += 1) h = (h << 5) + h + text2.charCodeAt(i) | 0;
  return (h >>> 0).toString(36);
}
function fanLabel(members) {
  const first = members[0];
  if (first.data.address) return titled(plural(stringOrEmpty(first.data.badge) || "address"));
  const word = leadingWord(first.data.label);
  if (word && members.every((member) => leadingWord(member.data.label) === word)) return titled(plural(word));
  return titled(plural(stringOrEmpty(first.data.badge) || "node"));
}
function clusterByFan(nodes, edges, options = {}) {
  const minSize = options.minSize ?? FAN_FOLD_MIN_SIZE;
  const edgeBudget = options.edgeBudget ?? FAN_FOLD_EDGE_BUDGET;
  if (nodes.length < Math.min(minSize, FAN_FOLD_MIN_SPOKES)) return null;
  const keep = options.keep;
  const byId = new Map(nodes.map((node) => [node.id, node]));
  const adjacency = /* @__PURE__ */ new Map();
  const join = (from, to, relation) => {
    let neighbours = adjacency.get(from);
    if (!neighbours) adjacency.set(from, neighbours = /* @__PURE__ */ new Map());
    let relations = neighbours.get(to);
    if (!relations) neighbours.set(to, relations = /* @__PURE__ */ new Set());
    relations.add(relation);
  };
  for (const edge of edges) {
    if (edge.source === edge.target || !byId.has(edge.source) || !byId.has(edge.target)) continue;
    const kind = `${stringOrEmpty(edge.data?.kind)}/${stringOrEmpty(edge.data?.variant)}`;
    join(edge.source, edge.target, `out|${kind}`);
    join(edge.target, edge.source, `in|${kind}`);
  }
  const relationsOf = (relations) => [...relations].sort().join(",");
  const foldable = (node) => !keep?.has(node.id) && !carriesIdentity(node);
  const isLeaf = (id) => adjacency.get(id)?.size === 1;
  const assigned = /* @__PURE__ */ new Map();
  const assign = (signature, members) => {
    const chain = stringOrEmpty(members[0].data.chain);
    const key = {
      id: `fan:${hash(signature)}`,
      label: fanLabel(members),
      ...chain && members.every((member) => member.data.chain === chain) ? { chain } : {}
    };
    for (const member of members) assigned.set(member.id, key);
    return key;
  };
  const collect = (groups, signature, node) => {
    const group = groups.get(signature);
    if (group) group.push(node);
    else groups.set(signature, [node]);
  };
  const leafFans = /* @__PURE__ */ new Map();
  for (const node of nodes) {
    if (!isLeaf(node.id) || !foldable(node)) continue;
    const [hub, relations] = [...adjacency.get(node.id)][0];
    collect(leafFans, `leaf|${hub}|${relationsOf(relations)}|${nodeClass(node)}`, node);
  }
  for (const [signature, members] of leafFans) if (members.length >= minSize) assign(signature, members);
  const spokes = /* @__PURE__ */ new Map();
  const anchorsOf = /* @__PURE__ */ new Map();
  const leavesOf = /* @__PURE__ */ new Map();
  for (const node of nodes) {
    const neighbours = adjacency.get(node.id);
    if (!neighbours || neighbours.size < 2 || assigned.has(node.id) || !foldable(node)) continue;
    const anchors = [];
    const leaves = [];
    const own = [];
    let folds = true;
    for (const [other, relations] of neighbours) {
      if (!isLeaf(other)) {
        anchors.push(`${other}:${relationsOf(relations)}`);
        continue;
      }
      const leaf = byId.get(other);
      if (assigned.has(other) || !foldable(leaf)) {
        folds = false;
        break;
      }
      leaves.push(`${relationsOf(relations)}:${nodeClass(leaf)}`);
      own.push(leaf);
    }
    if (!folds || anchors.length === 0) continue;
    const signature = `spoke|${nodeClass(node)}|${anchors.sort().join(";")}|${leaves.sort().join(";")}`;
    collect(spokes, signature, node);
    anchorsOf.set(signature, anchors.length);
    leavesOf.set(node.id, own);
  }
  for (const [signature, members] of spokes) {
    const tangled = members.length >= FAN_FOLD_MIN_SPOKES && members.length * (anchorsOf.get(signature) ?? 0) >= edgeBudget;
    if (members.length < minSize && !tangled) continue;
    const spokeKey = assign(signature, members);
    const carried = /* @__PURE__ */ new Map();
    for (const member of members) {
      for (const leaf of leavesOf.get(member.id) ?? []) {
        const relations = relationsOf(adjacency.get(leaf.id).get(member.id));
        collect(carried, `${spokeKey.id}|leaf|${relations}|${nodeClass(leaf)}`, leaf);
      }
    }
    for (const [leafSignature, leaves] of carried) assign(leafSignature, leaves);
  }
  if (assigned.size === 0) return null;
  return (node) => assigned.get(node.id) ?? null;
}
function firstClusterKey(...fns) {
  const present = fns.filter((fn) => fn != null);
  return (node) => {
    for (const fn of present) {
      const key = fn(node);
      if (key) return key;
    }
    return null;
  };
}
var FAN_FOLD_MIN_SIZE, FAN_FOLD_EDGE_BUDGET, FAN_FOLD_MIN_SPOKES, stringOrEmpty, plural, titled, leadingWord;
var init_fan = __esm({
  "src/cluster/fan.ts"() {
    FAN_FOLD_MIN_SIZE = 26;
    FAN_FOLD_EDGE_BUDGET = 100;
    FAN_FOLD_MIN_SPOKES = 6;
    stringOrEmpty = (value) => asString(value) ?? "";
    plural = (word) => /(s|x|ch|sh)$/.test(word) ? `${word}es` : `${word}s`;
    titled = (word) => word.charAt(0).toUpperCase() + word.slice(1);
    leadingWord = (label) => (/^[A-Za-z]+/.exec(label)?.[0] ?? "").toLowerCase();
  }
});

// src/cluster/separateFlows.ts
function flowComponents(nodes, edges) {
  const components = /* @__PURE__ */ new Map();
  for (const group of connectedComponents(nodes, edges)) {
    const members = group.map((node) => node.id);
    for (const id of members) components.set(id, members);
  }
  return components;
}
function clusterSeparateFlows(nodes, edges, keep) {
  const components = flowComponents(nodes, edges);
  const byId = new Map(nodes.map((node) => [node.id, node]));
  const assigned = /* @__PURE__ */ new Map();
  const buckets = /* @__PURE__ */ new Map();
  for (const members of new Set(components.values())) {
    if (members.length > MAX_FLOW_REVEAL) continue;
    const first = byId.get(members[0]);
    if (members.some((id) => {
      const node = byId.get(id);
      return keep?.has(id) || carriesIdentity(node) || node.data.hop === 0 || node.data.chain !== first.data.chain || node.data.timeRank !== first.data.timeRank || node.data.hop !== first.data.hop;
    })) continue;
    const key = JSON.stringify([first.data.chain ?? null, first.data.timeRank ?? null, first.data.hop ?? null, members.length === 1]);
    const bucket = buckets.get(key) ?? [];
    bucket.push(members);
    buckets.set(key, bucket);
  }
  for (const [bucket, flows] of buckets) {
    if (flows.length < 2) continue;
    const first = byId.get(flows[0][0]);
    const key = {
      id: `${SEPARATE_FLOWS_PREFIX}${bucket}`,
      label: flows[0].length === 1 ? "Unconnected nodes" : "Separate flows",
      ...typeof first.data.chain === "string" ? { chain: first.data.chain } : {}
    };
    for (const flow of flows) for (const id of flow) assigned.set(id, key);
  }
  return { keyFn: (node) => assigned.get(node.id) ?? null, components };
}
var MAX_FLOW_REVEAL, SEPARATE_FLOWS_PREFIX;
var init_separateFlows = __esm({
  "src/cluster/separateFlows.ts"() {
    init_layout();
    init_fan();
    MAX_FLOW_REVEAL = 25;
    SEPARATE_FLOWS_PREFIX = "separate-flows:";
  }
});
function clusterIdFromNodeId(nodeId2) {
  return nodeId2.startsWith("cluster:") ? nodeId2.slice("cluster:".length) : null;
}
function buildClusters(nodes, keyFn, options = {}) {
  const minSize = options.minSize ?? 2;
  const map = /* @__PURE__ */ new Map();
  const order = [];
  for (const node of nodes) {
    const key = keyFn(node);
    if (!key) continue;
    let def = map.get(key.id);
    if (!def) {
      def = { id: key.id, label: key.label ?? key.id, memberIds: [], chain: key.chain };
      map.set(key.id, def);
      order.push(key.id);
    }
    def.memberIds.push(node.id);
  }
  return order.map((id) => map.get(id)).filter((c) => c.memberIds.length >= minSize);
}
function hopRingLabel(hop) {
  return hop === 0 ? "Seed" : "Hop " + hop;
}
function composeClusterKeys(...fns) {
  return (node) => {
    const ids = [];
    const labels = [];
    let chain;
    let entered = false;
    for (const fn of fns) {
      const part = fn(node);
      if (!part) {
        if (entered) break;
        continue;
      }
      entered = true;
      ids.push(part.id);
      labels.push(part.label ?? part.id);
      chain = chain ?? part.chain;
    }
    if (ids.length === 0) return null;
    return { id: ids.join("/"), label: labels.join(" \xB7 "), ...chain ? { chain } : {} };
  };
}
function searchTextOf(node) {
  const data = node.data;
  const out = [node.id];
  for (const value of [
    data.label,
    data.subtitle,
    data.address,
    data.entityId,
    data.protocol,
    data.chain,
    data.badge,
    data.kind
  ]) {
    if (typeof value === "string" && value) out.push(value);
  }
  for (const tag of data.tags ?? []) {
    if (typeof tag === "string" && tag) out.push(tag);
  }
  return out;
}
function centroid2(nodes) {
  if (nodes.length === 0) return { x: 0, y: 0 };
  const sum = nodes.reduce((acc, n) => ({ x: acc.x + n.position.x, y: acc.y + n.position.y }), { x: 0, y: 0 });
  return { x: sum.x / nodes.length, y: sum.y / nodes.length };
}
function applyClusters(nodes, edges, clusters, collapsed, options = {}) {
  const collapsedClusters = clusters.filter((c) => collapsed.has(c.id));
  if (collapsedClusters.length === 0) return { nodes, edges };
  const nodeById = new Map(nodes.map((n) => [n.id, n]));
  const memberToCluster = /* @__PURE__ */ new Map();
  for (const c of collapsedClusters) {
    const cid = clusterNodeId(c.id);
    for (const m of c.memberIds) if (nodeById.has(m)) memberToCluster.set(m, cid);
  }
  const internalEdges = /* @__PURE__ */ new Map();
  const internalChanges = /* @__PURE__ */ new Map();
  for (const edge of edges) {
    const group = memberToCluster.get(edge.source);
    if (group && group === memberToCluster.get(edge.target)) {
      internalEdges.set(group, (internalEdges.get(group) ?? 0) + (edge.data?.count ?? 1));
      const changes = internalChanges.get(group) ?? [];
      changes.push(edge.data);
      internalChanges.set(group, changes);
    }
  }
  const outNodes = nodes.filter((n) => !memberToCluster.has(n.id));
  for (const c of collapsedClusters) {
    const members = c.memberIds.map((id) => nodeById.get(id)).filter((n) => Boolean(n));
    if (members.length === 0) continue;
    const badges = /* @__PURE__ */ new Map();
    for (const member of members) {
      for (const badge of member.data.contextBadges ?? []) {
        const key = `${badge.id}:${badge.label}`;
        const entry = badges.get(key) ?? { label: badge.label, count: 0, ...badge.tone ? { tone: badge.tone } : {} };
        entry.count += 1;
        badges.set(key, entry);
      }
    }
    const base = {
      liveChange: foldedLiveChange([
        ...members.map((member) => member.data.liveChange),
        ...(internalChanges.get(clusterNodeId(c.id)) ?? []).map((data) => data?.liveChange)
      ]),
      ...badges.size ? { contextBadges: [...badges].map(([id, badge]) => ({
        id,
        label: `${badge.count} \xD7 ${badge.label}`,
        ...badge.tone ? { tone: badge.tone } : {},
        title: `${badge.count} of ${members.length} members: ${badge.label}. Expand this group to inspect each member\u2019s evidence; this does not classify the other members.`
      })) } : {},
      label: c.label,
      subtitle: `${members.length} nodes${internalEdges.has(clusterNodeId(c.id)) ? ` \xB7 ${internalEdges.get(clusterNodeId(c.id))} internal edges` : ""}`,
      variant: "cluster",
      badge: String(members.length),
      chain: c.chain,
      // A folded ring retains its rank; topology/transfer direction is not distance.
      ...members.every((m) => m.data.hop === members[0]?.data.hop) && typeof members[0]?.data.hop === "number" ? { hop: members[0].data.hop } : {},
      // The same for a place on the time axis, so a folded band keeps its column.
      ...members.every((m) => m.data.timeRank === members[0]?.data.timeRank) && typeof members[0]?.data.timeRank === "number" ? { timeRank: members[0].data.timeRank } : {}
    };
    outNodes.push(
      txNode(
        clusterNodeId(c.id),
        {
          ...base,
          ...options.summarize?.(members, base) ?? {},
          cluster: true,
          clusterId: c.id,
          memberCount: members.length,
          // The members themselves, so a host can list what was folded in here.
          // Expanding is the other answer to that question, and it answers it by
          // putting all of them back on the canvas.
          memberIds: members.map((member) => member.id),
          memberSearchText: members.flatMap(searchTextOf)
        },
        centroid2(members)
      )
    );
  }
  const remap = (id) => memberToCluster.get(id) ?? id;
  const agg = /* @__PURE__ */ new Map();
  for (const e of edges) {
    const source = remap(e.source);
    const target = remap(e.target);
    if (source === target) continue;
    const variant = e.data?.variant ?? "default";
    const key = `${source}|${target}|${variant}${e.data?.assetKey ? `|asset:${e.data.assetKey}` : ""}${e.data?.displayName ? `|name:${e.id}` : ""}${e.data?.provisional ? "|provisional" : ""}${e.data?.context ? "|context" : ""}`;
    const existing = agg.get(key);
    if (existing) existing.members.push(e);
    else agg.set(key, { edge: { ...e, source, target }, members: [e] });
  }
  const outEdges = [];
  for (const [key, { edge, members }] of agg) {
    const count = members.length;
    if (count > 1) {
      outEdges.push(txEdge(`agg:${key}`, edge.source, edge.target, aggregateData(members, count)));
    } else {
      outEdges.push(edge);
    }
  }
  return { nodes: outNodes, edges: outEdges };
}
function aggregateData(members, count) {
  const first = members[0];
  const failed = members.some((e) => e.data?.failed === true);
  const animated = members.some((e) => e.data?.animated === true);
  let usd = 0;
  let hasUsd = false;
  for (const e of members) {
    if (typeof e.data?.valueUsd === "number" && Number.isFinite(e.data.valueUsd)) {
      usd += e.data.valueUsd;
      hasUsd = true;
    }
  }
  const agreed = (read) => {
    const value = read(first);
    return value !== void 0 && members.every((e) => read(e) === value) ? value : void 0;
  };
  const unit = members.every((e) => e.data?.kind != null && !isFlowEdgeKind(e.data.kind)) ? "links" : "flows";
  return {
    variant: failed ? "failed" : first.data?.variant ?? "default",
    label: `${count} ${unit}${first.data?.assetLabel ? ` \xB7 ${first.data.assetLabel}` : ""}`,
    assetKey: first.data?.assetKey,
    assetColor: first.data?.assetColor,
    assetLabel: first.data?.assetLabel,
    displayName: agreed((e) => e.data?.displayName),
    ...aggregateAmounts(members),
    aggregateUnit: unit,
    valueUsd: hasUsd ? usd : void 0,
    failed,
    animated: animated && !failed,
    liveChange: foldedLiveChange(members.map((edge) => edge.data?.liveChange)),
    kind: agreed((e) => e.data?.kind),
    fromChain: agreed((e) => e.data?.fromChain),
    toChain: agreed((e) => e.data?.toChain),
    aggregated: true,
    count,
    memberIds: members.flatMap(originalEdgeIds),
    // Supporting paths must stay faint after folding, separate from matches.
    ...first.data?.context ? { context: true } : {},
    // Grouped by it (see the key above), so one member says it for all.
    ...first.data?.provisional ? { provisional: true, dashed: true } : {}
  };
}
function resolveAutoCluster(spec, nodeCount) {
  const cfg = typeof spec === "object" ? spec : {};
  const threshold = cfg.threshold ?? AUTO_CLUSTER_THRESHOLD;
  const enabled = spec !== false && nodeCount > threshold;
  return {
    enabled,
    keyFn: cfg.by ?? clusterByEntity,
    ...cfg.summarize ? { summarize: cfg.summarize } : {},
    ...cfg.minSize != null ? { minSize: Math.max(2, cfg.minSize) } : {}
  };
}
function autoClusteredGraph(nodes, edges, spec) {
  const { keyFn, minSize, summarize } = resolveGraphClustering(nodes, edges, spec);
  const clusters = buildClusters(nodes, keyFn, { minSize });
  if (clusters.length === 0) return { nodes, edges };
  return applyClusters(nodes, edges, clusters, new Set(clusters.map((c) => c.id)), { summarize });
}
function resolveGraphClustering(nodes, edges, spec, keepVisibleId) {
  const resolved = resolveAutoCluster(spec, nodes.length);
  const ownAxis = spec === false || typeof spec === "object" && spec.by != null;
  const keep = keepVisibleId ? /* @__PURE__ */ new Set([keepVisibleId]) : void 0;
  const fan = ownAxis ? null : clusterByFan(nodes, edges, { keep });
  const separate = !ownAxis && resolved.enabled ? clusterSeparateFlows(nodes, edges, keep) : null;
  let keyFn = resolved.enabled ? resolved.keyFn : NO_CLUSTER;
  if (fan) keyFn = firstClusterKey(keyFn, fan);
  if (separate) keyFn = firstClusterKey(separate.keyFn, keyFn);
  const selectedKey = keyFn;
  return {
    keyFn: keepVisibleId ? ((node) => node.id === keepVisibleId ? null : selectedKey(node)) : keyFn,
    minSize: fan || separate ? 2 : resolved.minSize,
    summarize: resolved.summarize,
    components: separate?.components
  };
}
var clusterNodeId, dataStr, clusterByEntity, clusterByKind, clusterByHop, clusterByHopOrUnknown, clusterByHopAndChain, clusterByChain, AUTO_CLUSTER_THRESHOLD, NO_CLUSTER;
var init_clustering = __esm({
  "src/cluster/clustering.ts"() {
    init_nodes();
    init_edges();
    init_aggregateAmounts();
    init_edgeKinds();
    init_fan();
    init_separateFlows();
    init_graphChanges();
    clusterNodeId = (clusterId) => `cluster:${clusterId}`;
    dataStr = (value) => typeof value === "string" && value ? value : void 0;
    clusterByEntity = (node) => {
      const id = dataStr(node.data.entityId) ?? dataStr(node.data.clusterId);
      if (!id) return null;
      const label = dataStr(node.data.entityLabel) ?? dataStr(node.data.clusterLabel) ?? id;
      return { id: `entity:${id}`, label, chain: dataStr(node.data.chain) };
    };
    clusterByKind = (node) => {
      const kind = dataStr(node.data.kind);
      if (!kind) return null;
      return { id: `kind:${kind}`, label: kind };
    };
    clusterByHop = (node) => {
      const hop = node.data.hop;
      if (typeof hop !== "number") return null;
      return { id: `hop:${hop}`, label: hopRingLabel(hop) };
    };
    clusterByHopOrUnknown = (node) => node.data.inPrimaryLayer === false ? { id: "hop:other-layers", label: "Other trace layers" } : clusterByHop(node) ?? { id: "hop:unknown", label: "Hop not recorded" };
    clusterByHopAndChain = (node) => composeClusterKeys(clusterByHop, clusterByChain)(node);
    clusterByChain = (node) => {
      const chain = dataStr(node.data.chain);
      if (!chain) return null;
      return { id: `chain:${chain}`, label: chainDisplayName(chain), chain };
    };
    AUTO_CLUSTER_THRESHOLD = 100;
    NO_CLUSTER = () => null;
  }
});
function useGraphClusters(options) {
  const { nodes, edges, keyFn, minSize, initialCollapsed = "all", maxExpandedSize, summarize } = options;
  const clusters = React17.useMemo(() => buildClusters(nodes, keyFn, { minSize }), [nodes, keyFn, minSize]);
  const clusterIds = React17.useMemo(() => clusters.map((c) => c.id), [clusters]);
  const seed = React17.useCallback(
    (ids) => {
      if (initialCollapsed === "none") return /* @__PURE__ */ new Set();
      if (initialCollapsed === "all") return new Set(ids);
      return new Set(initialCollapsed.filter((id) => ids.includes(id)));
    },
    [initialCollapsed]
  );
  const [state, setState] = React17.useState(() => ({ known: clusterIds, collapsed: seed(clusterIds) }));
  const [revealed, setRevealed] = React17.useState(/* @__PURE__ */ new Set());
  const idsChanged = clusterIds.length !== state.known.length || clusterIds.some((id) => !state.known.includes(id));
  const oversized = maxExpandedSize == null ? [] : clusters.filter((c) => c.memberIds.filter((id) => !revealed.has(id)).length > maxExpandedSize && !state.collapsed.has(c.id));
  let collapsed = state.collapsed;
  if (idsChanged || oversized.length > 0) {
    collapsed = new Set([...state.collapsed].filter((id) => clusterIds.includes(id)));
    for (const id of seed(clusterIds.filter((id2) => !state.known.includes(id2)))) collapsed.add(id);
    for (const c of oversized) collapsed.add(c.id);
    setState({ known: clusterIds, collapsed });
  }
  const setCollapsed = React17.useCallback((update) => {
    setState((prev) => ({ ...prev, collapsed: typeof update === "function" ? update(prev.collapsed) : update }));
  }, []);
  const derived = React17.useMemo(
    () => applyClusters(nodes, edges, clusters.map((c) => ({ ...c, memberIds: c.memberIds.filter((id) => !revealed.has(id)) })), collapsed, { summarize }),
    [nodes, edges, clusters, collapsed, revealed, summarize]
  );
  const reveal = React17.useCallback((nodeId2) => {
    setRevealed((prev) => new Set(prev).add(nodeId2));
  }, []);
  const revealMany = React17.useCallback((nodeIds) => {
    setRevealed((prev) => /* @__PURE__ */ new Set([...prev, ...nodeIds]));
  }, []);
  const collapse = React17.useCallback((id) => {
    setCollapsed((prev) => prev.has(id) ? prev : new Set(prev).add(id));
  }, [setCollapsed]);
  const expand = React17.useCallback((id) => {
    setCollapsed((prev) => {
      if (!prev.has(id)) return prev;
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, [setCollapsed]);
  const toggle = React17.useCallback(
    (id) => {
      if (!id) return;
      setCollapsed((prev) => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        return next;
      });
    },
    [setCollapsed]
  );
  const collapseAll = React17.useCallback(() => {
    setCollapsed(new Set(clusterIds));
    setRevealed(/* @__PURE__ */ new Set());
  }, [clusterIds, setCollapsed]);
  const expandAll = React17.useCallback(() => setCollapsed(/* @__PURE__ */ new Set()), [setCollapsed]);
  const isCollapsed = React17.useCallback((id) => collapsed.has(id), [collapsed]);
  return {
    clusters,
    collapsed,
    nodes: derived.nodes,
    edges: derived.edges,
    isCollapsed,
    collapse,
    expand,
    toggle,
    reveal,
    revealMany,
    collapseAll,
    expandAll
  };
}
var init_useGraphClusters = __esm({
  "src/cluster/useGraphClusters.ts"() {
    init_clustering();
  }
});
function canExpandCluster(memberCount, visibleCount) {
  return memberCount <= MAX_CLUSTER_EXPANSION && visibleCount - 1 + memberCount <= MAX_EXPLORED_NODES;
}
function useClusterExploration({ nodes, edges, autoCluster, onNodeClick, onNodeReveal, keepVisibleId }) {
  const resolved = React17.useMemo(() => resolveGraphClustering(nodes, edges, autoCluster, keepVisibleId), [nodes, edges, autoCluster, keepVisibleId]);
  const clusters = useGraphClusters({
    nodes,
    edges,
    keyFn: resolved.keyFn,
    maxExpandedSize: MAX_CLUSTER_EXPANSION,
    summarize: resolved.summarize,
    minSize: resolved.minSize
  });
  const [inspectedId, setInspectedId] = React17.useState(null);
  const [query, setQuery] = React17.useState("");
  const [page, setPage] = React17.useState(0);
  const inspected = clusters.clusters.find((c) => c.id === inspectedId);
  const members = React17.useMemo(() => {
    const ids = new Set(inspected?.memberIds ?? []);
    const all = nodes.filter((n) => ids.has(n.id));
    const matches = matchGraphNodes(all, query);
    return all.filter((n) => matches.has(n.id));
  }, [nodes, inspected, query]);
  const pageCount = Math.max(1, Math.ceil(members.length / PAGE_SIZE2));
  const safePage = Math.min(page, pageCount - 1);
  const visibleIds = new Set(clusters.nodes.map((n) => n.id));
  const separateFlows = inspected?.id.startsWith(SEPARATE_FLOWS_PREFIX);
  const revealIds = (node) => separateFlows ? resolved.components?.get(node.id) ?? [node.id] : [node.id];
  const handleNodeClick = React17.useCallback((node) => {
    const id = clusterIdFromNodeId(node.id);
    const cluster = clusters.clusters.find((c) => c.id === id);
    if (!cluster) {
      onNodeClick?.(node);
      return;
    }
    const count = typeof node.data.memberCount === "number" ? node.data.memberCount : cluster.memberIds.length;
    if (canExpandCluster(count, clusters.nodes.length)) {
      clusters.expand(cluster.id);
      setInspectedId(null);
    } else {
      setInspectedId(cluster.id);
      setQuery("");
      setPage(0);
    }
  }, [clusters, onNodeClick]);
  const controls = clusters.clusters.length === 0 ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "absolute bottom-3 left-14 z-20 rounded-md border bg-background p-1 shadow-xs", children: [
      /* @__PURE__ */ jsxs("span", { className: "px-2 text-xs text-muted-foreground", role: "status", children: [
        nodes.length.toLocaleString(),
        " nodes \xB7 ",
        clusters.nodes.filter((n) => n.data.cluster).length,
        " folded groups"
      ] }),
      /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: () => {
        clusters.collapseAll();
        setInspectedId(null);
      }, children: "Collapse groups" })
    ] }),
    inspected && /* @__PURE__ */ jsxs("section", { "aria-label": "Group members", style: { maxHeight: "calc(100% - 5rem)" }, className: "absolute right-3 top-14 z-20 flex w-80 max-w-[calc(100%-1.5rem)] flex-col gap-2 overflow-auto rounded-md border bg-background p-3 shadow-lg", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-start justify-between gap-2", children: [
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("h3", { className: "text-sm font-semibold", children: inspected.label }),
          /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
            inspected.memberIds.length,
            " nodes"
          ] })
        ] }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: () => setInspectedId(null), children: "Close" })
      ] }),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: separateFlows ? "These are separate recorded flows, grouped for readability, not shared ownership. Find an address to reveal its connected flow." : "This group is too large to open at once. Find an address and reveal it, or narrow the graph filters." }),
      onNodeClick && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: () => {
        const node = clusters.nodes.find((n) => clusterIdFromNodeId(n.id) === inspected.id);
        if (node) onNodeClick(node);
      }, children: "Group details" }),
      /* @__PURE__ */ jsx(Input, { "aria-label": "Search group members", placeholder: "Find address or label", value: query, onChange: (e) => {
        setQuery(e.target.value);
        setPage(0);
      } }),
      /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", role: "status", children: [
        members.length,
        " matches \xB7 Page ",
        safePage + 1,
        " of ",
        pageCount
      ] }),
      /* @__PURE__ */ jsx("ul", { className: "space-y-1", children: members.slice(safePage * PAGE_SIZE2, (safePage + 1) * PAGE_SIZE2).map((node) => /* @__PURE__ */ jsxs("li", { className: "flex items-center justify-between gap-2 rounded-sm border p-2", children: [
        /* @__PURE__ */ jsxs("div", { className: "min-w-0", children: [
          /* @__PURE__ */ jsx("div", { className: "truncate text-xs font-medium", title: node.data.address ?? node.id, children: node.data.label }),
          node.data.address && /* @__PURE__ */ jsx("div", { className: "truncate text-3xs text-muted-foreground", children: node.data.address })
        ] }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", disabled: visibleIds.has(node.id) || clusters.nodes.length + revealIds(node).filter((id) => !visibleIds.has(id)).length > MAX_EXPLORED_NODES, onClick: () => {
          clusters.revealMany(revealIds(node));
          onNodeReveal?.(node);
        }, children: visibleIds.has(node.id) ? "Shown" : separateFlows ? "Reveal flow" : "Reveal" })
      ] }, node.id)) }),
      members.length === 0 && /* @__PURE__ */ jsx("p", { className: "text-xs", children: "No matching addresses in this group." }),
      clusters.nodes.length >= MAX_EXPLORED_NODES && /* @__PURE__ */ jsx("p", { className: "text-xs", children: "100 nodes are visible. Collapse groups or narrow the filters before revealing more." }),
      pageCount > 1 && /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", disabled: safePage === 0, onClick: () => setPage(safePage - 1), children: "Previous" }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", disabled: safePage + 1 === pageCount, onClick: () => setPage(safePage + 1), children: "Next" })
      ] })
    ] })
  ] });
  return { nodes: clusters.nodes, edges: clusters.edges, onNodeClick: handleNodeClick, controls };
}
var MAX_CLUSTER_EXPANSION, MAX_EXPLORED_NODES, PAGE_SIZE2;
var init_useClusterExploration = __esm({
  "src/cluster/useClusterExploration.tsx"() {
    init_match();
    init_clustering();
    init_separateFlows();
    init_useGraphClusters();
    MAX_CLUSTER_EXPANSION = MAX_FLOW_REVEAL;
    MAX_EXPLORED_NODES = 100;
    PAGE_SIZE2 = 20;
  }
});
function shouldRefitForResize(previous, next, { readerMovedView }) {
  if (next.width === previous.width && next.height === previous.height) return false;
  if (next.width === 0 || next.height === 0) return false;
  return !readerMovedView;
}
function needsFreshArrangement(cache, next) {
  return cache.key === "" || cache.nonce !== next.nonce || cache.sizeEpoch !== next.sizeEpoch || cache.groupKey !== next.groupKey || cache.optionsKey !== next.optionsKey;
}
function mergeSizes(prev, nodes) {
  const fresh = collectNodeSizes(nodes.filter((node) => node.type !== "chain-group"));
  const merged = {};
  for (const node of nodes) {
    if (node.type === "chain-group") continue;
    const size = fresh[node.id] ?? prev.sizes[node.id];
    if (size) merged[node.id] = size;
  }
  const key = nodeSizeSignature(merged);
  if (key === prev.key) return prev;
  return {
    sizes: merged,
    key,
    epoch: sizesInvalidate(prev.sizes, merged) ? prev.epoch + 1 : prev.epoch
  };
}
function TransactionGraphInner({
  nodes,
  edges,
  layout,
  viewMode = "hierarchical",
  rankBy,
  legend,
  showMiniMap = true,
  showControls = true,
  showBackground = true,
  fitView = true,
  zoomOnScroll = false,
  className,
  onNodeClick,
  onNodeReveal,
  onNodeDoubleClick,
  onEdgeClick: onInspectEdge,
  showFlowChooser = true,
  selectedEdgeId: controlledEdgeId,
  onClearEdgeSelection: onClearSelection,
  edgeQuickAction,
  edgeLabelPolicy,
  onConnect,
  layoutNonce = 0,
  focusNodeId,
  searchQuery,
  emphasis,
  frameEmphasis = false,
  onSelectionChange,
  live,
  layoutEngine = "dagre",
  autoCluster = true,
  pinnedPositions,
  onNodePositionChange,
  chainGroups: inputGroups,
  flowParticles = true,
  highlightNeighbors = true,
  assignment,
  nodeActions
}) {
  const selection = useFlowSelection(controlledEdgeId, onInspectEdge, onClearSelection);
  const selectedEdgeId = selection.selectedId;
  const onEdgeClick = onInspectEdge ? selection.inspect : void 0;
  const onClearEdgeSelection = selection.clear;
  const reducedMotion = useReducedMotion();
  const resolvedMode = useOptionalTheme()?.resolvedMode ?? "light";
  const exploration = useClusterExploration({ nodes, edges, autoCluster, onNodeClick, onNodeReveal, keepVisibleId: focusNodeId ?? void 0 });
  const exploreNode = exploration.onNodeClick;
  const sourceNodes = exploration.nodes;
  const sourceEdges = exploration.edges;
  const chainGroups = React17.useMemo(() => groupsForVisibleNodes(inputGroups, sourceNodes), [inputGroups, sourceNodes]);
  const [dragOverrides, setDragOverrides] = React17.useState(
    () => pinnedPositions ?? {}
  );
  const seenPins = React17.useRef({});
  React17.useEffect(() => {
    const incoming = pinnedPositions ?? {};
    const arrived = {};
    let any = false;
    for (const [id, position] of Object.entries(incoming)) {
      const seen = seenPins.current[id];
      if (seen && seen.x === position.x && seen.y === position.y) continue;
      arrived[id] = position;
      any = true;
    }
    seenPins.current = incoming;
    if (any) setDragOverrides((prev) => ({ ...prev, ...arrived }));
  }, [pinnedPositions]);
  const lastTidy = React17.useRef(layoutNonce);
  React17.useEffect(() => {
    if (lastTidy.current === layoutNonce) return;
    lastTidy.current = layoutNonce;
    setDragOverrides(pinnedPositions ?? {});
  }, [layoutNonce, pinnedPositions]);
  const pinned = React17.useMemo(
    () => ({ ...pinnedPositions ?? {}, ...dragOverrides }),
    [dragOverrides, pinnedPositions]
  );
  const resolvedLayout = React17.useMemo(
    () => layout !== void 0 ? layout : { ...layoutForView(viewMode), rankBy },
    [layout, viewMode, rankBy]
  );
  const useElk = layoutEngine === "elk" && resolvedLayout !== false;
  const [measured, setMeasured] = React17.useState(NO_SIZES);
  const sizedLayout = React17.useMemo(
    () => resolvedLayout === false ? false : { ...resolvedLayout, sizes: measured.sizes },
    [resolvedLayout, measured.sizes]
  );
  const nodeSetKey = React17.useMemo(() => nodeSetSignature(sourceNodes), [sourceNodes]);
  const groupKey = React17.useMemo(
    () => (chainGroups ?? []).map((group) => `${group.id}=${[...group.memberNodeIds].sort().join(",")}`).sort().join("\0"),
    [chainGroups]
  );
  const optionsKey = React17.useMemo(
    () => resolvedLayout === false ? "none" : JSON.stringify(resolvedLayout),
    [resolvedLayout]
  );
  const layoutKey = `${nodeSetKey}${groupKey}${optionsKey}`;
  const [dagreLayout, setDagreLayout] = React17.useState(NO_LAYOUT);
  const dagreActive = resolvedLayout !== false && !useElk;
  const dagreStale = dagreLayout.key !== layoutKey || dagreLayout.nonce !== layoutNonce || dagreLayout.sizeEpoch !== measured.epoch;
  if (dagreActive && sizedLayout !== false && dagreStale) {
    const laid = ranksByRecordedValue(sizedLayout) || needsFreshArrangement(dagreLayout, {
      nonce: layoutNonce,
      groupKey,
      sizeEpoch: measured.epoch,
      optionsKey
    }) ? positionsOf(layoutWithDagre(sourceNodes, sourceEdges, sizedLayout)) : placeAddedNodes(dagreLayout.positions, sourceNodes, sourceEdges, sizedLayout);
    setDagreLayout({
      key: layoutKey,
      nonce: layoutNonce,
      groupKey,
      sizeEpoch: measured.epoch,
      optionsKey,
      // Pull the chain bands apart before anything is drawn: the rectangles are
      // derived from these positions, so the nodes are what has to move.
      positions: separateGroupBands(laid, sourceNodes, chainGroups ?? [], sizedLayout)
    });
  }
  const dagrePositions = dagreActive ? dagreLayout.positions : null;
  const [elkPositions, setElkPositions] = React17.useState(null);
  React17.useEffect(() => {
    if (sizedLayout === false || !useElk) {
      setElkPositions(null);
      return void 0;
    }
    let alive = true;
    void layoutWithElk(sourceNodes, sourceEdges, sizedLayout).then((laid) => {
      if (alive) {
        setElkPositions(separateGroupBands(positionsOf(laid), sourceNodes, chainGroups ?? [], sizedLayout));
      }
    }).catch((error) => {
      if (!alive) return;
      log.warn("elk layout failed; falling back to dagre", { error: String(error) });
      const fallback = positionsOf(layoutWithDagre(sourceNodes, sourceEdges, sizedLayout));
      setElkPositions(separateGroupBands(fallback, sourceNodes, chainGroups ?? [], sizedLayout));
    });
    return () => {
      alive = false;
    };
  }, [useElk, nodeSetKey, groupKey, layoutNonce, resolvedLayout, measured.epoch]);
  const layoutDirection = resolvedLayout === false ? "LR" : resolvedLayout.direction ?? "LR";
  const laidOutNodes = React17.useMemo(() => {
    const computed = useElk ? elkPositions : dagrePositions;
    const anchors = connectionAnchors(layoutDirection);
    return sourceNodes.map((node) => {
      const position = pinned[node.id] ?? computed?.[node.id];
      return { ...node, ...position ? { position } : {}, sourcePosition: anchors.source, targetPosition: anchors.target };
    });
  }, [useElk, elkPositions, dagrePositions, sourceNodes, pinned, layoutDirection]);
  const edgeSides = React17.useMemo(
    () => chooseEdgeSides(
      positionsOf(laidOutNodes),
      laidOutNodes,
      sourceEdges,
      layoutDirection,
      measured.sizes
    ),
    [laidOutNodes, sourceEdges, layoutDirection, measured.sizes]
  );
  const groupNodes = React17.useMemo(() => {
    if (!chainGroups || chainGroups.length === 0) return [];
    const dims2 = resolvedLayout ? { nodeWidth: resolvedLayout.nodeWidth, nodeHeight: resolvedLayout.nodeHeight } : {};
    return buildChainGroupNodes(laidOutNodes, chainGroups, { ...dims2, sizes: measured.sizes });
  }, [laidOutNodes, chainGroups, resolvedLayout, measured.sizes]);
  const matched = React17.useMemo(
    () => searchQuery && searchQuery.trim() ? matchGraphNodes(sourceNodes, searchQuery) : null,
    [sourceNodes, searchQuery]
  );
  const adjacency = React17.useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    const link = (a, b) => {
      let set = map.get(a);
      if (!set) map.set(a, set = /* @__PURE__ */ new Set());
      set.add(b);
    };
    for (const edge of sourceEdges) {
      link(edge.source, edge.target);
      link(edge.target, edge.source);
    }
    return map;
  }, [sourceEdges]);
  const [hoverId, setHoverId] = React17.useState(null);
  const liveHoverId = sourceNodes.some((node) => node.id === hoverId) ? hoverId : null;
  const liveFocusId = sourceNodes.some((node) => node.id === focusNodeId) ? focusNodeId : null;
  const focusId = highlightNeighbors ? liveHoverId ?? liveFocusId ?? null : null;
  const focusSet = React17.useMemo(() => {
    if (!focusId || emphasis) return null;
    const set = /* @__PURE__ */ new Set([focusId]);
    for (const neighbor of adjacency.get(focusId) ?? []) set.add(neighbor);
    return set;
  }, [focusId, adjacency, emphasis]);
  const [rfNodes, setNodes, onNodesChange] = useNodesState(laidOutNodes);
  const [rfEdges, setEdges, onEdgesChange] = useEdgesState(sourceEdges);
  const reactFlow = useReactFlow();
  const nodesInitialized = useNodesInitialized();
  const selectedFlows = React17.useMemo(
    () => sourceEdges.filter((edge) => containsSelectedFlow(edge, selectedEdgeId)),
    [sourceEdges, selectedEdgeId]
  );
  const selectedEndpoints = React17.useMemo(
    () => new Set(selectedFlows.flatMap((edge) => [edge.source, edge.target])),
    [selectedFlows]
  );
  const readerMovedView = React17.useRef(false);
  const selectedTarget = React17.useRef(selectedEndpoints);
  selectedTarget.current = selectedEndpoints;
  const frameTarget = React17.useRef(null);
  frameTarget.current = frameEmphasis && emphasis && emphasis.nodeIds.size > 0 ? emphasis : null;
  const fitCamera = React17.useCallback(
    (duration) => {
      if (reducedMotion) duration = 0;
      if (selectedTarget.current.size) {
        void reactFlow.fitView({
          nodes: [...selectedTarget.current].map((id) => ({ id })),
          padding: 0.4,
          minZoom: MIN_GRAPH_ZOOM,
          maxZoom: 1.25,
          duration
        });
        return;
      }
      const framed = frameTarget.current;
      if (framed) {
        const targets = reactFlow.getNodes().filter((node) => emphasisHas(framed.nodeIds, node.id, node.data.memberIds)).map((node) => ({ id: node.id }));
        if (targets.length > 0) {
          void reactFlow.fitView({ nodes: targets, duration, padding: 0.2, minZoom: MIN_GRAPH_ZOOM, maxZoom: 1.25 });
          return;
        }
      }
      void reactFlow.fitView({ ...FIT_VIEW_OPTIONS, duration });
    },
    [reactFlow, reducedMotion]
  );
  const locateSelectedFlow = React17.useCallback(() => {
    if (!selectedTarget.current.size) return;
    readerMovedView.current = true;
    fitCamera(250);
  }, [fitCamera]);
  const fitKey = `${layoutKey}${layoutNonce}${measured.epoch}`;
  React17.useEffect(() => {
    if (!fitView || readerMovedView.current || !nodeSetKey) return void 0;
    const frame = requestAnimationFrame(() => {
      if (!readerMovedView.current) fitCamera(200);
    });
    return () => cancelAnimationFrame(frame);
  }, [fitKey, fitView, fitCamera, elkPositions]);
  const selectionKey = selectedEndpoints.size ? JSON.stringify([selectedEdgeId, selection.inspection, [...selectedEndpoints].sort()]) : "";
  const selectionRequest = React17.useRef(selectionKey);
  selectionRequest.current = selectionKey;
  const framedSelection = React17.useRef("");
  React17.useEffect(() => {
    if (!selectionKey) {
      framedSelection.current = "";
      return;
    }
    if (!nodesInitialized || selectionKey === framedSelection.current) return;
    readerMovedView.current = false;
    const frame = requestAnimationFrame(() => {
      framedSelection.current = selectionKey;
      if (!readerMovedView.current) fitCamera(250);
    });
    return () => cancelAnimationFrame(frame);
  }, [selectionKey, nodesInitialized, fitCamera]);
  React17.useEffect(() => {
    setNodes((prev) => {
      const previous = new Map(prev.map((n) => [n.id, n]));
      const decorated = laidOutNodes.map((node) => {
        const carried = previous.get(node.id);
        return {
          ...node,
          ariaLabel: node.ariaLabel ?? graphNodeAccessibleLabel(node),
          // Carry the size the renderer already measured for this node. It isn't
          // on `laidOutNodes` (those come from the props array), so rebuilding
          // without it makes every node unmeasured again — which would drop the
          // sizes the layout above depends on and re-run it on the fallbacks.
          measured: carried?.measured ?? node.measured,
          selected: carried?.selected ?? node.selected,
          data: {
            ...node.data,
            dimmed: Boolean(carried?.data.dimmed),
            highlighted: Boolean(carried?.data.highlighted),
            flowSelected: Boolean(carried?.data.flowSelected)
          }
        };
      });
      return [...groupNodes, ...decorated];
    });
  }, [laidOutNodes, groupNodes, setNodes]);
  React17.useEffect(() => {
    setMeasured((prev) => mergeSizes(prev, rfNodes));
  }, [rfNodes]);
  React17.useEffect(() => {
    setNodes(
      (prev) => prev.map((node) => {
        if (node.type === "chain-group") return node;
        const lit = selectedEndpoints.size ? selectedEndpoints.has(node.id) : emphasis ? emphasisHas(emphasis.nodeIds, node.id, node.data.memberIds) : null;
        const searchDimmed = matched && lit === null ? !matched.has(node.id) : false;
        const focusDimmed = focusSet ? !focusSet.has(node.id) : false;
        const highlighted = lit ?? (focusSet ? focusSet.has(node.id) : false);
        const dimmed = lit === null ? searchDimmed || focusDimmed : !lit;
        const flowSelected = selectedEndpoints.has(node.id);
        if (node.data.dimmed === dimmed && node.data.highlighted === highlighted && node.data.flowSelected === flowSelected) {
          return node;
        }
        return { ...node, data: { ...node.data, dimmed, highlighted, flowSelected } };
      })
    );
  }, [matched, focusSet, focusId, focusNodeId, emphasis, setNodes, selectedEndpoints]);
  const parallelInfo = React17.useMemo(() => {
    const groups = /* @__PURE__ */ new Map();
    for (const edge of sourceEdges) {
      const key = edge.source === edge.target ? `self\0${edge.id}` : edge.source < edge.target ? `${edge.source}\0${edge.target}` : `${edge.target}\0${edge.source}`;
      const list = groups.get(key);
      if (list) list.push(edge.id);
      else groups.set(key, [edge.id]);
    }
    const info = /* @__PURE__ */ new Map();
    for (const ids of groups.values()) {
      ids.forEach((id, index) => info.set(id, { index, count: ids.length }));
    }
    return info;
  }, [sourceEdges]);
  React17.useEffect(() => {
    const decorated = sourceEdges.map((edge) => {
      let dimmed = false;
      let highlighted = false;
      if (selectedFlows.length) {
        highlighted = containsSelectedFlow(edge, selectedEdgeId);
        dimmed = !highlighted;
      } else if (emphasis) {
        highlighted = emphasisLightsEdge(emphasis, edge);
        dimmed = !highlighted;
      } else if (focusSet && focusId) {
        const incident = edge.source === focusId || edge.target === focusId;
        highlighted = incident;
        dimmed = !incident;
      } else if (matched) {
        dimmed = !(matched.has(edge.source) && matched.has(edge.target));
      }
      const parallel = parallelInfo.get(edge.id);
      const sides = edgeSides[edge.id];
      return {
        ...edge,
        selected: containsSelectedFlow(edge, selectedEdgeId),
        ...sides ? { sourceHandle: `source-${sides.source}`, targetHandle: `target-${sides.target}` } : { sourceHandle: void 0, targetHandle: void 0 },
        data: {
          ...edge.data,
          dimmed,
          highlighted,
          parallelIndex: parallel?.index,
          parallelCount: parallel?.count
        }
      };
    });
    setEdges(decorated);
  }, [sourceEdges, focusSet, focusId, matched, emphasis, parallelInfo, edgeSides, setEdges, selectedEdgeId, selectedFlows]);
  const containerRef = React17.useRef(null);
  const flowChooserButtonRef = React17.useRef(null);
  const zoom = useStore((state) => state.transform[2]);
  const labels = useEdgeLabelLayout(containerRef, zoom, edgeLabelPolicy);
  const [flowChoice, setFlowChoice] = React17.useState(null);
  const handleFlowPointer = React17.useCallback((event, edge) => {
    const root = containerRef.current;
    const hits = root && typeof document.elementsFromPoint === "function" ? flowHitIds(root, document.elementsFromPoint(event.clientX, event.clientY), edge.id) : [edge.id];
    const candidates = hits.filter((id) => rfEdges.some((item) => item.id === id));
    if (candidates.length > 1 && showFlowChooser) setFlowChoice({ candidates });
    else onEdgeClick?.(edge);
  }, [rfEdges, onEdgeClick, showFlowChooser]);
  const renderOptions = React17.useMemo(
    () => {
      const byId = new Map(rfEdges.map((edge) => [edge.id, edge]));
      return {
        particles: flowParticles && !reducedMotion,
        direction: layoutDirection,
        labelZoom: zoom,
        visibleEdgeLabels: labels.visible,
        inspectEdge: onEdgeClick ? (id) => {
          const edge = byId.get(id);
          if (edge) onEdgeClick(edge);
        } : void 0,
        edgeQuickAction: edgeQuickAction ? (id) => {
          const edge = byId.get(id);
          return edge ? edgeQuickAction(edge) : null;
        } : void 0
      };
    },
    [flowParticles, reducedMotion, layoutDirection, onEdgeClick, edgeQuickAction, rfEdges, zoom, labels.visible]
  );
  const handleNodeClick = React17.useCallback(
    (node) => {
      if (node.type === "chain-group") return;
      onClearEdgeSelection();
      exploreNode(node);
    },
    [exploreNode, onClearEdgeSelection]
  );
  const handleNodeDragStop = React17.useCallback(
    (_event, node) => {
      if (node.type === "chain-group") return;
      setDragOverrides((prev) => ({ ...prev, [node.id]: node.position }));
      onNodePositionChange?.(node.id, node.position);
    },
    [onNodePositionChange]
  );
  const handleNodeMouseEnter = React17.useCallback((_event, node) => {
    if (node.type !== "chain-group") setHoverId(node.id);
  }, []);
  const handleNodeMouseLeave = React17.useCallback(() => setHoverId(null), []);
  const handleSelectionChange = React17.useCallback(
    ({ nodes: selected }) => onSelectionChange?.(selected.map((node) => node.id)),
    [onSelectionChange]
  );
  const { assignmentEnabled, open: openMenuAt, onContextMenu, content: nodeMenu } = useGraphNodeMenu(containerRef, assignment, nodeActions);
  const handleNodeContextMenu = React17.useCallback((event, node) => {
    if (node.type !== "chain-group") onContextMenu(event, node);
  }, [onContextMenu]);
  const assignMenuApi = React17.useMemo(
    () => ({ enabled: assignmentEnabled, open: openMenuAt }),
    [assignmentEnabled, openMenuAt]
  );
  const handleConnect = React17.useCallback(
    (connection) => {
      const { source, target } = connection;
      if (!source || !target || source === target) return;
      onConnect?.(source, target);
    },
    [onConnect]
  );
  React17.useEffect(() => {
    if (!focusNodeId) return void 0;
    const selectionAtFocus = selectionRequest.current;
    const handle = window.setTimeout(() => {
      if (selectionRequest.current && selectionRequest.current !== selectionAtFocus) return;
      if (!reactFlow.getNode(focusNodeId)) return;
      reactFlow.fitView({ nodes: [{ id: focusNodeId }], duration: reducedMotion ? 0 : 400, padding: 0.6, maxZoom: 1.5 });
    }, 50);
    return () => window.clearTimeout(handle);
  }, [focusNodeId, reactFlow, reducedMotion]);
  const emphasisKey = React17.useMemo(
    () => frameEmphasis && emphasis ? [...emphasis.nodeIds].sort().join("") : "",
    [frameEmphasis, emphasis]
  );
  const framedEmphasis = React17.useRef("");
  React17.useEffect(() => {
    if (emphasisKey === framedEmphasis.current) return void 0;
    const handle = window.setTimeout(() => {
      framedEmphasis.current = emphasisKey;
      readerMovedView.current = false;
      fitCamera(emphasisKey ? 400 : 300);
    }, FRAME_EMPHASIS_MS);
    return () => window.clearTimeout(handle);
  }, [emphasisKey, fitCamera]);
  React17.useEffect(() => {
    const el = containerRef.current;
    if (!fitView || !el || typeof ResizeObserver === "undefined") return void 0;
    let size = { width: el.clientWidth, height: el.clientHeight };
    let timer = 0;
    const observer = new ResizeObserver(() => {
      const next = { width: el.clientWidth, height: el.clientHeight };
      const refit = shouldRefitForResize(size, next, { readerMovedView: readerMovedView.current });
      size = next;
      if (!refit) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (!readerMovedView.current) fitCamera(200);
      }, REFIT_ON_RESIZE_MS);
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
    };
  }, [fitView, fitCamera]);
  const minimapRoom = useCanvasRoom(containerRef, showMiniMap);
  return /* @__PURE__ */ jsx(GraphRenderContext.Provider, { value: renderOptions, children: /* @__PURE__ */ jsx(GraphAssignmentMenuContext.Provider, { value: assignMenuApi, children: /* @__PURE__ */ jsxs("div", { className: cn("flex size-full min-h-0 flex-col", className), children: [
    (onEdgeClick && showFlowChooser && (rfEdges.length > 0 || selectedEdgeId) || labels.hidden > 0) && /* @__PURE__ */ jsxs(
      "div",
      {
        "data-graph-export-exclude": true,
        className: "flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b bg-card px-2 py-1.5 text-xs",
        children: [
          onEdgeClick && showFlowChooser && /* @__PURE__ */ jsx(
            FlowChoiceControl,
            {
              edges: rfEdges,
              nodes: sourceNodes,
              selectedId: selectedEdgeId,
              buttonRef: flowChooserButtonRef,
              open: Boolean(flowChoice),
              onOpen: () => rfEdges.length === 1 ? onEdgeClick(rfEdges[0]) : setFlowChoice({ candidates: null }),
              onClear: onClearEdgeSelection,
              onLocate: locateSelectedFlow
            }
          ),
          labels.hidden > 0 && /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
            labels.hidden,
            " labels hidden to avoid overlap"
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        ref: containerRef,
        "data-graph-export-surface": true,
        className: "relative min-h-0 flex-1 [&_.react-flow__node:focus-visible]:outline-2 [&_.react-flow__node:focus-visible]:outline-offset-2 [&_.react-flow__node:focus-visible]:outline-foreground",
        onKeyDown: (event) => {
          const target = graphKeyboardTarget(event);
          if (!target) return;
          const node = target.kind === "node" ? rfNodes.find((item) => item.id === target.id) : void 0;
          const edge = target.kind === "edge" && onEdgeClick ? rfEdges.find((item) => item.id === target.id) : void 0;
          if (node?.type === "chain-group" || !node && !edge) return;
          event.preventDefault();
          event.stopPropagation();
          if (node) handleNodeClick(node);
          else if (edge) onEdgeClick?.(edge);
        },
        children: [
          /* @__PURE__ */ jsxs(
            ReactFlow,
            {
              colorMode: resolvedMode === "dark" ? "dark" : "light",
              nodes: rfNodes,
              edges: reducedMotion ? rfEdges.map((edge) => edge.animated ? { ...edge, animated: false } : edge) : rfEdges,
              nodeTypes,
              edgeTypes,
              onNodesChange,
              onEdgesChange,
              onNodeClick: (_event, node) => handleNodeClick(node),
              onEdgeClick: onEdgeClick ? handleFlowPointer : void 0,
              nodesConnectable: Boolean(onConnect),
              onConnect: handleConnect,
              onNodeContextMenu: assignmentEnabled || nodeActions ? handleNodeContextMenu : void 0,
              onNodeDoubleClick: onNodeDoubleClick ? (_event, node) => {
                if (node.type !== "chain-group") onNodeDoubleClick(node);
              } : void 0,
              onNodeDragStop: handleNodeDragStop,
              onNodeMouseEnter: highlightNeighbors ? handleNodeMouseEnter : void 0,
              onNodeMouseLeave: highlightNeighbors ? handleNodeMouseLeave : void 0,
              onSelectionChange: onSelectionChange ? handleSelectionChange : void 0,
              fitView,
              fitViewOptions: FIT_VIEW_OPTIONS,
              onMoveStart: (event) => {
                if (event) readerMovedView.current = true;
              },
              zoomOnScroll,
              preventScrolling: zoomOnScroll,
              minZoom: MIN_GRAPH_ZOOM,
              maxZoom: 2,
              children: [
                showBackground ? /* @__PURE__ */ jsx(Background, { gap: 16 }) : null,
                showControls ? /* @__PURE__ */ jsx(Controls, { fitViewOptions: FIT_VIEW_OPTIONS }) : null,
                live ? /* @__PURE__ */ jsx(Panel, { position: "top-left", children: live }) : null,
                showMiniMap && minimapRoom ? /* @__PURE__ */ jsx(
                  MiniMap,
                  {
                    pannable: true,
                    zoomable: true,
                    nodeColor: (node) => {
                      if (node.type === "chain-group") return "transparent";
                      const variant = node.data.variant ?? "tx";
                      return GRAPH_NODE_VARIANT_COLOR[variant];
                    }
                  }
                ) : null,
                legend && legend.length > 0 ? /* @__PURE__ */ jsx(Panel, { position: "top-right", children: /* @__PURE__ */ jsx(GraphLegend, { items: legend }) }) : null
              ]
            }
          ),
          exploration.controls,
          nodeMenu,
          flowChoice && onEdgeClick && /* @__PURE__ */ jsx(
            FlowChooser,
            {
              edges: rfEdges,
              nodes: rfNodes.filter((node) => node.type !== "chain-group"),
              candidates: flowChoice.candidates,
              selectedId: selectedEdgeId,
              returnFocusRef: flowChooserButtonRef,
              onClose: () => setFlowChoice(null),
              onSelect: (edge) => {
                setFlowChoice(null);
                onEdgeClick(edge);
              }
            }
          )
        ]
      }
    )
  ] }) }) });
}
function TransactionGraph(props) {
  return /* @__PURE__ */ jsx(ReactFlowProvider, { children: /* @__PURE__ */ jsx(TransactionGraphInner, { ...props }) });
}
var log, NO_LAYOUT, MIN_GRAPH_ZOOM, FIT_VIEW_OPTIONS, FRAME_EMPHASIS_MS, REFIT_ON_RESIZE_MS, NO_SIZES;
var init_TransactionGraph = __esm({
  "src/engines/flow/TransactionGraph.tsx"() {
    init_clusterGroups();
    init_nodes();
    init_edges();
    init_keyboard();
    init_edgeBundling();
    init_emphasis();
    init_renderContext();
    init_useEdgeLabelLayout();
    init_edgeLabelLayout();
    init_FlowChooser();
    init_useFlowSelection();
    init_canvasRoom();
    init_assignmentMenu();
    init_useGraphNodeMenu();
    init_sceneGroups();
    init_GraphLegend();
    init_layout();
    init_viewMode();
    init_search();
    init_useClusterExploration();
    log = createLogger("tx-graph:layout");
    NO_LAYOUT = {
      key: "",
      nonce: 0,
      groupKey: "",
      sizeEpoch: -1,
      optionsKey: "",
      positions: {}
    };
    MIN_GRAPH_ZOOM = 0.01;
    FIT_VIEW_OPTIONS = { minZoom: MIN_GRAPH_ZOOM, maxZoom: 1, padding: 0.15 };
    FRAME_EMPHASIS_MS = 120;
    REFIT_ON_RESIZE_MS = 150;
    NO_SIZES = { sizes: {}, key: "", epoch: 0 };
  }
});
function buildForceGraphData(nodes, edges, matched, flowParticles, emphasis = null) {
  const forceNodes = nodes.map((node) => {
    const dimmed = emphasis ? !emphasisHas(emphasis.nodeIds, node.id, node.data.memberIds) : matched != null && !matched.has(node.id);
    return {
      id: node.id,
      label: [node.data.label, ...(node.data.contextBadges ?? []).map((b) => b.label)].join(" \xB7 "),
      // `resolved` → concrete hsl() for the canvas (var() can't be used there).
      // Failed/reverted actors read in the critical-risk red.
      color: dimmed ? DIMMED_NODE_COLOR : node.data.failed ? graphEdgeColor("failed", true) : graphNodeColor(node.data.variant ?? "tx", true),
      // Dimmed means dimmed, full stop: an accent ring drawn over a node the
      // reader has set aside would be the loudest thing on the canvas.
      ...node.data.accentToken && !dimmed ? { accent: resolveTokenColor(node.data.accentToken) } : {},
      val: node.data.variant === "cluster" || node.data.variant === "entity" ? 4 : 2,
      ref: node
    };
  });
  const forceLinks = edges.map((edge) => {
    const failed = edge.data?.failed === true;
    const animated = flowParticles && edge.data?.animated === true && !failed;
    const lit = emphasis ? emphasisLightsEdge(emphasis, edge) : null;
    const dimmed = lit !== null ? !lit : matched != null && !(matched.has(edge.source) && matched.has(edge.target));
    return {
      ref: edge,
      source: edge.source,
      target: edge.target,
      color: dimmed ? DIMMED_EDGE_COLOR : edgeColor(edge.data, true),
      label: [edge.data?.displayName, edge.data?.label].filter(Boolean).join(" \xB7 "),
      dashed: edge.data?.dashed,
      width: edgeStrokeWidth(edge.data) + (lit ? 1.25 : 0),
      // 4 particles when value moves both ways, 2 one-way, 0 when static.
      particles: animated && !dimmed ? edge.data?.bidirectional ? 4 : 2 : 0
    };
  });
  return { nodes: forceNodes, links: forceLinks };
}
var DIMMED_NODE_COLOR, DIMMED_EDGE_COLOR;
var init_forceGraphData = __esm({
  "src/engines/force/forceGraphData.ts"() {
    init_edges();
    init_edgeBundling();
    init_emphasis();
    DIMMED_NODE_COLOR = "rgba(148, 163, 184, 0.35)";
    DIMMED_EDGE_COLOR = "rgba(148, 163, 184, 0.15)";
  }
});
function ForceGraphUnavailable() {
  return /* @__PURE__ */ jsxs("div", { className: "flex size-full items-center justify-center px-6 text-center text-sm text-muted-foreground", children: [
    "Force view needs the optional\xA0",
    /* @__PURE__ */ jsx("code", { className: "rounded-sm bg-muted px-1 py-0.5", children: "react-force-graph-2d" }),
    "\xA0package."
  ] });
}
function roundRect(ctx, x, y, w, h, r) {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
}
function ForceGraph({
  nodes,
  edges,
  legend,
  nodeRelSize = 6,
  className,
  loadingFallback,
  onNodeClick,
  onEdgeClick,
  showFlowChooser = true,
  selectedEdgeId: controlledEdgeId,
  onClearEdgeSelection,
  edgeQuickAction,
  nodeActions,
  assignment,
  groups,
  flowParticles = true,
  searchQuery,
  emphasis
}) {
  const reducedMotion = useReducedMotion();
  const containerRef = React17.useRef(null);
  const { selectedId: activeEdgeId, inspect, clear: clearSelection, inspection } = useFlowSelection(controlledEdgeId, onEdgeClick, onClearEdgeSelection);
  const selectedEdge = edges.find((edge) => containsSelectedFlow(edge, activeEdgeId));
  const selectedEndpoints = React17.useMemo(() => new Set(
    edges.filter((edge) => containsSelectedFlow(edge, activeEdgeId)).flatMap((edge) => [edge.source, edge.target])
  ), [edges, activeEdgeId]);
  const [chooserOpen, setChooserOpen] = React17.useState(false);
  const chooserButton = React17.useRef(null);
  const quickAction = selectedEdge ? edgeQuickAction?.(selectedEdge) : null;
  const nodeMenu = useGraphNodeMenu(containerRef, assignment, nodeActions);
  const [size, setSize] = React17.useState({ width: 0, height: 0 });
  const nodesRef = React17.useRef([]);
  React17.useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver((entries) => {
      const rect = entries[0]?.contentRect;
      if (rect) setSize({ width: rect.width, height: rect.height });
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const matched = React17.useMemo(
    () => searchQuery && searchQuery.trim() ? matchGraphNodes(nodes, searchQuery) : null,
    [nodes, searchQuery]
  );
  const graphData = React17.useMemo(
    () => buildForceGraphData(nodes, edges, matched, flowParticles && !reducedMotion, emphasis ?? null),
    [nodes, edges, flowParticles, reducedMotion, matched, emphasis]
  );
  nodesRef.current = graphData.nodes;
  const camera = React17.useRef(null);
  const framedSelection = React17.useRef("");
  const selectionKey = selectedEndpoints.size ? JSON.stringify([activeEdgeId, inspection, [...selectedEndpoints].sort(), size.width, size.height]) : "";
  const locateSelectedFlow = React17.useCallback(() => {
    const targets = nodesRef.current.filter((node) => selectedEndpoints.has(node.id));
    if (!camera.current || !targets.length || targets.some((node) => node.x == null || node.y == null)) return;
    const xs = targets.map((node) => node.x), ys = targets.map((node) => node.y);
    const left = Math.min(...xs), right = Math.max(...xs), top = Math.min(...ys), bottom = Math.max(...ys);
    const duration = reducedMotion ? 0 : 250;
    camera.current.centerAt((left + right) / 2, (top + bottom) / 2, duration);
    camera.current.zoom(Math.min(1.25, size.width / (right - left + 200), size.height / (bottom - top + 200)), duration);
    framedSelection.current = selectionKey;
  }, [selectedEndpoints, selectionKey, size, reducedMotion]);
  const locatePendingSelection = React17.useCallback(() => {
    if (!selectionKey) {
      framedSelection.current = "";
      return;
    }
    if (framedSelection.current !== selectionKey) locateSelectedFlow();
  }, [selectionKey, locateSelectedFlow]);
  React17.useEffect(locatePendingSelection, [locatePendingSelection]);
  const attachCamera = React17.useCallback((instance) => {
    camera.current = instance;
    if (instance) locatePendingSelection();
  }, [locatePendingSelection]);
  const paintSelection = React17.useCallback((link, ctx, scale) => {
    if (!containsSelectedFlow(link.ref, activeEdgeId)) return;
    const source = nodesRef.current.find((node) => node.id === link.ref.source);
    const target = nodesRef.current.find((node) => node.id === link.ref.target);
    if (source?.x == null || source.y == null || target?.x == null || target.y == null) return;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(source.x, source.y);
    ctx.lineTo(target.x, target.y);
    if (link.dashed) ctx.setLineDash([4, 4]);
    const width = Math.max(3, link.width + 2) / scale;
    ctx.strokeStyle = resolveTokenColor("--graph-selection");
    ctx.lineWidth = width + 8 / scale;
    ctx.stroke();
    ctx.strokeStyle = resolveTokenColor("--background");
    ctx.lineWidth = width + 3 / scale;
    ctx.stroke();
    ctx.restore();
  }, [activeEdgeId]);
  const handleNodeClick = React17.useCallback(
    (node) => onNodeClick?.(node.ref),
    [onNodeClick]
  );
  const drawGroups = React17.useCallback(
    (ctx, globalScale) => {
      if (!groups || groups.length === 0) return;
      const byId = new Map(nodesRef.current.map((n) => [n.id, n]));
      for (const group of groups) {
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let count = 0;
        for (const memberId of group.memberNodeIds) {
          const node = byId.get(memberId);
          if (!node || node.x == null || node.y == null) continue;
          minX = Math.min(minX, node.x);
          minY = Math.min(minY, node.y);
          maxX = Math.max(maxX, node.x);
          maxY = Math.max(maxY, node.y);
          count += 1;
        }
        if (count === 0) continue;
        const x = minX - GROUP_PAD;
        const y = minY - GROUP_PAD;
        const w = maxX - minX + GROUP_PAD * 2;
        const h = maxY - minY + GROUP_PAD * 2;
        roundRect(ctx, x, y, w, h, 10);
        ctx.fillStyle = group.fill;
        ctx.fill();
        ctx.lineWidth = 1.5 / globalScale;
        ctx.strokeStyle = group.border;
        ctx.setLineDash([6 / globalScale, 4 / globalScale]);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = group.text;
        ctx.font = `${11 / globalScale}px ui-sans-serif, system-ui, sans-serif`;
        ctx.textBaseline = "bottom";
        ctx.fillText(group.label, x + 6 / globalScale, y - 2 / globalScale);
      }
    },
    [groups]
  );
  const paintAccent = React17.useCallback(
    (node, ctx, globalScale) => {
      const accent = selectedEndpoints.size ? selectedEndpoints.has(node.id) ? resolveTokenColor("--graph-selection") : void 0 : node.accent;
      if (!accent || node.x == null || node.y == null) return;
      const radius = Math.sqrt(Math.max(node.val, 1)) * nodeRelSize;
      ctx.beginPath();
      ctx.arc(node.x, node.y, radius + 1.5, 0, 2 * Math.PI);
      ctx.strokeStyle = accent;
      ctx.lineWidth = 2 / globalScale;
      ctx.stroke();
    },
    [nodeRelSize, selectedEndpoints]
  );
  return /* @__PURE__ */ jsxs("div", { className: cn("flex size-full min-h-0 flex-col", className), children: [
    (onEdgeClick && showFlowChooser && (edges.length > 0 || activeEdgeId) || quickAction) && /* @__PURE__ */ jsxs(
      "div",
      {
        "data-graph-export-exclude": true,
        className: "flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b bg-card px-2 py-1.5 text-xs",
        children: [
          onEdgeClick && showFlowChooser && /* @__PURE__ */ jsx(
            FlowChoiceControl,
            {
              edges,
              nodes,
              selectedId: activeEdgeId,
              open: chooserOpen,
              buttonRef: chooserButton,
              onOpen: () => edges.length === 1 ? inspect(edges[0]) : setChooserOpen(true),
              onClear: clearSelection,
              onLocate: locateSelectedFlow
            }
          ),
          quickAction && selectedEdge && /* @__PURE__ */ jsxs("div", { "aria-label": "Selected flow action", className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(GraphEdgeQuickAction, { action: quickAction, flowLabel: selectedEdge.data?.label ?? "Selected flow" }),
            !onEdgeClick && /* @__PURE__ */ jsx("button", { type: "button", "aria-label": "Dismiss flow action", onClick: clearSelection, children: "\xD7" })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { ref: containerRef, "data-graph-export-surface": true, className: "relative min-h-0 flex-1", children: [
      /* @__PURE__ */ jsx(
        React17.Suspense,
        {
          fallback: loadingFallback ?? /* @__PURE__ */ jsx("div", { role: "status", "aria-busy": "true", className: "flex size-full items-center justify-center text-sm text-muted-foreground", children: "Loading graph renderer\u2026" }),
          children: size.width > 0 && size.height > 0 ? /* @__PURE__ */ jsx(
            ForceGraph2D,
            {
              ref: attachCamera,
              onEngineStop: locatePendingSelection,
              warmupTicks: reducedMotion ? 100 : 0,
              cooldownTicks: reducedMotion ? 0 : 100,
              graphData,
              nodeId: "id",
              nodeLabel: "label",
              nodeVal: "val",
              nodeRelSize,
              nodeColor: (node) => selectedEndpoints.size ? selectedEndpoints.has(node.id) ? node.ref.data.failed ? graphEdgeColor("failed", true) : graphNodeColor(node.ref.data.variant ?? "tx", true) : DIMMED_NODE_COLOR : node.color,
              linkColor: (link) => selectedEdge ? containsSelectedFlow(link.ref, activeEdgeId) ? edgeColor(link.ref.data, true) : DIMMED_EDGE_COLOR : link.color,
              linkLabel: (link) => link.label ?? "",
              linkCanvasObjectMode: () => "before",
              linkCanvasObject: paintSelection,
              linkLineDash: (link) => link.dashed ? [4, 4] : null,
              linkWidth: (link) => containsSelectedFlow(link.ref, activeEdgeId) ? Math.max(3, link.width + 2) : link.width,
              linkDirectionalArrowLength: 4,
              linkDirectionalArrowRelPos: 1,
              linkDirectionalParticles: (link) => selectedEdge && !containsSelectedFlow(link.ref, activeEdgeId) ? 0 : link.particles,
              linkDirectionalParticleWidth: (link) => Math.max(2, link.width),
              linkDirectionalParticleSpeed: 6e-3,
              width: size.width,
              height: size.height,
              backgroundColor: "rgba(0,0,0,0)",
              onRenderFramePre: groups && groups.length > 0 ? drawGroups : void 0,
              nodeCanvasObjectMode: () => "after",
              nodeCanvasObject: paintAccent,
              onNodeClick: (node) => {
                clearSelection();
                handleNodeClick(node);
              },
              onLinkClick: onEdgeClick || edgeQuickAction ? (link) => inspect(link.ref) : void 0,
              onNodeRightClick: nodeActions || nodeMenu.assignmentEnabled ? (node, event) => nodeMenu.onContextMenu(event, node.ref) : void 0
            }
          ) : null
        }
      ),
      chooserOpen && onEdgeClick && /* @__PURE__ */ jsx(
        FlowChooser,
        {
          edges,
          nodes,
          candidates: null,
          selectedId: activeEdgeId,
          returnFocusRef: chooserButton,
          onClose: () => setChooserOpen(false),
          onSelect: (edge) => {
            setChooserOpen(false);
            inspect(edge);
          }
        }
      ),
      nodeMenu.content,
      legend && legend.length > 0 ? /* @__PURE__ */ jsx("div", { className: "absolute right-2 top-2", children: /* @__PURE__ */ jsx(GraphLegend, { items: legend }) }) : null
    ] })
  ] });
}
var ForceGraph2D, GROUP_PAD;
var init_ForceGraph = __esm({
  "src/engines/force/ForceGraph.tsx"() {
    init_GraphLegend();
    init_edges();
    init_search();
    init_forceGraphData();
    init_useGraphNodeMenu();
    init_GraphEdgeQuickAction();
    init_FlowChooser();
    init_useFlowSelection();
    ForceGraph2D = React17.lazy(async () => {
      try {
        const mod = await import('react-force-graph-2d');
        return { default: mod.default };
      } catch {
        return { default: ForceGraphUnavailable };
      }
    });
    GROUP_PAD = 26;
  }
});
function ToolbarButton({
  active,
  label,
  hint,
  shape = "icon",
  disabled,
  onClick,
  children
}) {
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: active ? "secondary" : "outline",
        size: "sm",
        "aria-pressed": active,
        "aria-label": label,
        disabled,
        onClick,
        className: cn(
          shape === "icon" ? "size-7 p-0" : "h-7 px-2 text-xs",
          active && "ring-1 ring-brand/50"
        ),
        children
      }
    ) }),
    /* @__PURE__ */ jsx(TooltipContent, { side: "bottom", children: hint ?? label })
  ] });
}
var TOOLBAR_TOOLTIP_DELAY_MS;
var init_ToolbarButton = __esm({
  "src/engines/ToolbarButton.tsx"() {
    TOOLBAR_TOOLTIP_DELAY_MS = 200;
  }
});
function GraphToolbar({ fullscreen, bundle, particles, relayout, extra, className }) {
  const hasBuiltins = Boolean(fullscreen || bundle || particles || relayout);
  if (!hasBuiltins && !extra) return null;
  return /* @__PURE__ */ jsx(TooltipProvider, { delayDuration: TOOLBAR_TOOLTIP_DELAY_MS, children: /* @__PURE__ */ jsxs("div", { className: cn("flex items-center gap-1 rounded-md bg-card/80 p-1 shadow-xs backdrop-blur", className), children: [
    relayout ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        label: "Tidy layout",
        hint: "Arrange every node again, discarding manual moves",
        onClick: relayout.onClick,
        children: /* @__PURE__ */ jsx(TidyIcon, { size: 14 })
      }
    ) : null,
    particles ? /* @__PURE__ */ jsx(ToolbarButton, { active: particles.active, disabled: particles.reducedMotion, label: particles.reducedMotion ? "Flow animation off: reduced motion enabled" : "Animate value flow", hint: particles.reducedMotion ? "Animation follows your device\u2019s reduced motion preference. Arrows still show transfer direction." : "Moving dots illustrate transfer direction; they are not a loading or progress indicator.", onClick: particles.onToggle, children: /* @__PURE__ */ jsx(FlowIcon, { size: 14 }) }) : null,
    bundle ? /* @__PURE__ */ jsx(ToolbarButton, { active: bundle.active, label: "Bundle parallel edges", onClick: bundle.onToggle, children: /* @__PURE__ */ jsx(BundleIcon, { size: 14 }) }) : null,
    fullscreen ? /* @__PURE__ */ jsx(ToolbarButton, { active: fullscreen.active, label: fullscreen.active ? "Exit fullscreen" : "Fullscreen", onClick: fullscreen.onToggle, children: fullscreen.active ? /* @__PURE__ */ jsx(MinimizeIcon, { size: 14 }) : /* @__PURE__ */ jsx(MaximizeIcon, { size: 14 }) }) : null,
    extra ? /* @__PURE__ */ jsxs(Fragment, { children: [
      hasBuiltins ? /* @__PURE__ */ jsx("span", { className: "mx-0.5 h-4 w-px bg-border", "aria-hidden": true }) : null,
      extra
    ] }) : null
  ] }) });
}
var init_GraphToolbar = __esm({
  "src/engines/GraphToolbar.tsx"() {
    init_ToolbarButton();
  }
});
function useFullscreen(ref) {
  const supported = typeof document !== "undefined";
  const [isNative, setIsNative] = React17.useState(false);
  const [maximised, setMaximised] = React17.useState(false);
  React17.useEffect(() => {
    if (typeof document === "undefined") return void 0;
    const onChange = () => {
      const native = document.fullscreenElement === ref.current;
      setIsNative(native);
      if (native) setMaximised(false);
    };
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, [ref]);
  React17.useEffect(() => {
    if (!maximised) return void 0;
    const onKey = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      if (event.target instanceof Element && event.target.closest('[role="menu"], [role="dialog"], [role="listbox"], [role="combobox"]')) return;
      setMaximised(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [maximised]);
  const enter = React17.useCallback(() => {
    const el = ref.current;
    if (!el || document.fullscreenElement === el) return;
    if (!document.fullscreenEnabled || typeof el.requestFullscreen !== "function") {
      setMaximised(true);
      return;
    }
    let settled = false;
    const timer = setTimeout(() => {
      if (!settled && document.fullscreenElement !== el) setMaximised(true);
    }, FALLBACK_AFTER_MS);
    void el.requestFullscreen().then(
      () => {
        settled = true;
        clearTimeout(timer);
      },
      () => {
        settled = true;
        clearTimeout(timer);
        setMaximised(true);
      }
    );
  }, [ref]);
  const exit = React17.useCallback(() => {
    setMaximised(false);
    if (typeof document !== "undefined" && document.fullscreenElement) {
      void document.exitFullscreen?.().catch(() => void 0);
    }
  }, []);
  const toggle = React17.useCallback(() => {
    if (typeof document === "undefined") return;
    if (maximised || document.fullscreenElement === ref.current) exit();
    else enter();
  }, [ref, enter, exit, maximised]);
  return { isFullscreen: isNative || maximised, maximised, toggle, enter, exit, supported };
}
var FALLBACK_AFTER_MS;
var init_useFullscreen = __esm({
  "src/engines/useFullscreen.ts"() {
    FALLBACK_AFTER_MS = 700;
  }
});
function GraphViewModeToggle({
  value,
  onChange,
  modes = GRAPH_VIEW_MODES,
  size = "sm",
  className
}) {
  const options = React17.useMemo(
    () => modes.map((mode) => ({ value: mode, label: GRAPH_VIEW_MODE_LABELS[mode] })),
    [modes]
  );
  return /* @__PURE__ */ jsx(
    ViewModeToggle,
    {
      "aria-label": "Graph view mode",
      options,
      value,
      onChange,
      size,
      className
    }
  );
}
var init_GraphViewModeToggle = __esm({
  "src/view/GraphViewModeToggle.tsx"() {
  }
});
function hasGraphFilters(filters) {
  return filters.maxHop != null || Boolean(filters.chain || filters.kind || filters.assets?.length);
}
function graphAssetKey(edge, chains) {
  const chain = edge.data?.assetChain ?? chains.get(edge.source) ?? "";
  const token = edge.data?.tokenAddress;
  return JSON.stringify([chain, token == null ? "native" : normalizeAddress(token, chain), ...edge.data?.tokenId != null ? [edge.data.tokenId] : []]);
}
function hasGraphAsset(edge) {
  return Boolean(edge.data?.tokenAddress) || NATIVE_COIN_FLOW_KINDS.has(edge.data?.kind);
}
function nativeOptionLabel(chain) {
  const symbol = chain ? nativeTokenMeta(chain).symbol : void 0;
  return symbol ? `${symbol} (native)` : "Native asset";
}
function tokenOptionLabel(ticker, token, chain) {
  const text2 = safeTicker(ticker).text;
  const native = chain ? nativeTokenMeta(chain).symbol : void 0;
  if (text2 && native && text2.trim().toUpperCase() === native.toUpperCase()) {
    return `\u201C${text2}\u201D token ${shortenAddress(token)}`;
  }
  return `${text2 || "Token"} ${shortenAddress(token)}`;
}
function graphFlowLabel(edge, sourceChain = "") {
  const data = edge.data;
  const chain = data?.assetChain ?? sourceChain;
  const asset = data?.tokenAddress ? tokenOptionLabel(data.ticker, data.tokenAddress, chain) : nativeOptionLabel(chain);
  return `${FLOW_KIND_LABELS[String(data?.kind)] ?? data?.kind ?? "Flow"}: ${asset}${chain ? ` \xB7 ${chainDisplayName(chain)}` : ""}`;
}
function graphRouteNodeLabel(node) {
  return `${node.data.label}${node.data.chain ? ` (${chainDisplayName(node.data.chain)})` : ""}`;
}
function graphFilterOptions(graph) {
  const chains = new Map(graph.nodes.map((n) => [n.id, n.data.chain ?? ""]));
  const assets = /* @__PURE__ */ new Map();
  for (const edge of graph.edges) {
    const chain = String(edge.data?.assetChain ?? chains.get(edge.source) ?? "");
    const token = edge.data?.tokenAddress;
    if (!hasGraphAsset(edge)) continue;
    const label = token ? tokenOptionLabel(edge.data?.ticker, token, chain) : nativeOptionLabel(chain);
    assets.set(graphAssetKey(edge, chains), `${label}${edge.data?.tokenId != null ? ` #${edge.data.tokenId}` : ""}${chain ? ` \xB7 ${chainDisplayName(chain)}` : ""}`);
  }
  return {
    hops: [...new Set(graph.nodes.flatMap((n) => typeof n.data.hop === "number" ? [n.data.hop] : []))].sort((a, b) => a - b),
    chains: [...new Set([...chains.values()].filter(Boolean))].sort(),
    kinds: [...new Set(graph.edges.flatMap((e) => typeof e.data?.kind === "string" ? [e.data.kind] : []))].sort(),
    assets: [...assets].sort((a, b) => a[1].localeCompare(b[1]))
  };
}
function connectedGraph(graph) {
  const connected = new Set(graph.edges.flatMap((e) => [e.source, e.target]));
  const nodes = graph.nodes.filter((n) => connected.has(n.id));
  return nodes.length === graph.nodes.length ? graph : { ...graph, nodes };
}
function filterGraph(graph, filters, options = {}) {
  if (!hasGraphFilters(filters)) return graph;
  const assets = new Set(filters.assets);
  const chains = new Map(graph.nodes.map((n) => [n.id, n.data.chain ?? ""]));
  const nodes = graph.nodes.filter(
    (n) => filters.maxHop == null || typeof n.data.hop === "number" && n.data.hop <= filters.maxHop
  );
  const ids = new Set(nodes.map((n) => n.id));
  const within = graph.edges.filter((e) => ids.has(e.source) && ids.has(e.target));
  let edges = within.filter((e) => (
    // A chain focus includes its recorded crossings. Dropping the other-chain
    // endpoint hid the very bridge that explains how these funds arrived.
    (!filters.chain || chains.get(e.source) === filters.chain || chains.get(e.target) === filters.chain) && (!filters.kind || e.data?.kind === filters.kind) && (!assets.size || hasGraphAsset(e) && assets.has(graphAssetKey(e, chains)))
  ));
  if (filters.kind || assets.size || filters.chain) {
    const seeds = nodes.filter((n) => n.data.hop === 0).map((n) => n.id);
    const context = options.connectSeeds ? seedPaths(seeds, within, edges) : [];
    edges = [...edges, ...context.map((e) => ({ ...e, data: { ...e.data, context: true } }))];
  }
  if (options.connectSeeds && filters.maxHop != null && filters.maxHop > 0) {
    const touched = new Set(edges.flatMap((e) => [e.source, e.target]));
    const seeds = new Set(nodes.filter((n) => n.data.hop === 0 && touched.has(n.id)).map((n) => n.id));
    const unranked = new Set(graph.nodes.filter((n) => typeof n.data.hop !== "number").map((n) => n.id));
    const funding = graph.edges.filter((e) => unranked.has(e.source) && seeds.has(e.target));
    edges = [...edges, ...funding.map((e) => ({ ...e, data: { ...e.data, context: true } }))];
  }
  if (filters.maxHop === 0 && !filters.kind && !assets.size) {
    return { nodes: nodes.filter((n) => !filters.chain || n.data.chain === filters.chain), edges: edges.filter((e) => !filters.chain || chains.get(e.source) === filters.chain && chains.get(e.target) === filters.chain) };
  }
  return connectedGraph({ nodes: graph.nodes, edges });
}
function seedPaths(seeds, within, kept) {
  const group = /* @__PURE__ */ new Map();
  const root = (id) => {
    let at = id;
    while (group.has(at) && group.get(at) !== at) at = group.get(at);
    return at;
  };
  for (const e of kept) {
    for (const id of [e.source, e.target]) if (!group.has(id)) group.set(id, id);
    group.set(root(e.source), root(e.target));
  }
  const seeded = new Set(seeds.filter((id) => group.has(id)).map(root));
  const adjacent = /* @__PURE__ */ new Map();
  for (const e of within) {
    adjacent.set(e.source, [...adjacent.get(e.source) ?? [], e]);
    adjacent.set(e.target, [...adjacent.get(e.target) ?? [], e]);
  }
  const via = new Map(seeds.map((id) => [id, null]));
  const order = [...seeds];
  for (let i = 0; i < order.length; i++) {
    for (const e of adjacent.get(order[i]) ?? []) {
      const next = e.source === order[i] ? e.target : e.source;
      if (via.has(next)) continue;
      via.set(next, e);
      order.push(next);
    }
  }
  const pair = (e) => [e.source, e.target].sort().join("\0");
  const keptPairs = new Set(kept.map(pair));
  const added = /* @__PURE__ */ new Map();
  const joined = new Set(seeded);
  for (const id of order) {
    if (!group.has(id) || joined.has(root(id))) continue;
    joined.add(root(id));
    for (let at = id, e = via.get(at); e; e = via.get(at)) {
      if (!keptPairs.has(pair(e))) added.set(e.id, e);
      at = e.source === at ? e.target : e.source;
    }
  }
  return [...added.values()];
}
var FLOW_KIND_LABELS;
var init_filters = __esm({
  "src/exploration/filters.ts"() {
    FLOW_KIND_LABELS = {
      native: "Native value",
      internal: "Internal call",
      closure: "Balance sweep / closure",
      erc20: "Token (ERC-20)",
      erc721: "NFT (ERC-721)",
      erc1155: "NFT (ERC-1155)",
      bridge_in: "Bridge in",
      bridge_out: "Bridge out",
      cross_chain: "Cross-chain",
      bridge_link: "Verified settlement link",
      venue_link: "Through a drained venue",
      validator_link: "Credited to a validator",
      custodial_link: "Custodial bridge (the token's claim, no linked deposit)",
      order_account_link: "Same-address candidate on another chain",
      // The other families' token kinds (commons.interfaces.models.token_flow.FLOW_KINDS).
      hip1: "HyperCore token (HIP-1)",
      spl: "Solana token (SPL)",
      trc20: "Token (TRC-20)",
      trc10: "TRON asset (TRC-10)",
      nep141: "NEAR token (NEP-141)",
      metaprotocol: "UTXO metaprotocol token",
      cosmos_bank: "Cosmos bank denom",
      ledger_asset: "Ledger asset"
    };
  }
});

// src/exploration/assetColors.ts
function assetColor(key, palette = ASSET_PALETTE) {
  let hash2 = 2166136261;
  for (const char of key) hash2 = Math.imul(hash2 ^ char.charCodeAt(0), 16777619);
  const colors = palette.length ? palette : ASSET_PALETTE;
  return colors[(hash2 >>> 0) % colors.length];
}
function withAssetColors(graph, palette, enabled = true) {
  const chains = new Map(graph.nodes.map((n) => [n.id, n.data.chain ?? ""]));
  const assets = new Map(graphFilterOptions(graph).assets);
  return { ...graph, edges: graph.edges.map((edge) => {
    const key = graphAssetKey(edge, chains);
    const label = assets.get(key);
    if (!label || !hasGraphAsset(edge)) return edge;
    const data = { ...edge.data, assetKey: key, assetColor: enabled ? assetColor(key, palette) : void 0, assetLabel: label };
    return { ...edge, data, markerEnd: typeof edge.markerEnd === "object" ? { ...edge.markerEnd, color: edgeColor(data) } : edge.markerEnd };
  }) };
}
function assetColorLegend(edges) {
  const seen = /* @__PURE__ */ new Map();
  for (const { data } of edges) {
    if (data?.assetKey && data.assetColor && data.assetLabel) seen.set(data.assetKey, {
      label: data.assetLabel,
      color: data.assetColor,
      shape: "line",
      group: "Assets \xB7 labels identify each token"
    });
  }
  return [...seen].sort(([a], [b]) => a.localeCompare(b)).map(([, row]) => row);
}
var ASSET_PALETTE;
var init_assetColors = __esm({
  "src/exploration/assetColors.ts"() {
    init_filters();
    init_edges();
    ASSET_PALETTE = ["#2684cf", "#a56bdb", "#009b8e", "#c18a25", "#ce68a8", "#6279c8", "#5c9639", "#8f879f"];
  }
});
function GraphCanvas({
  viewMode = "hierarchical",
  header,
  notice,
  onViewModeChange,
  showViewModeToggle = false,
  viewModes,
  engine,
  loadingFallback,
  showFullscreen = false,
  showEdgeBundleToggle = false,
  bundleParallelEdges: bundleInitial = false,
  onBundleParallelEdgesChange,
  showFlowToggle = false,
  showRelayout = false,
  extraToolbar,
  containerRef: containerRefProp,
  ...graphProps
}) {
  const flowSelection = useFlowSelection(graphProps.selectedEdgeId, graphProps.onEdgeClick, graphProps.onClearEdgeSelection);
  const [layoutNonce, setLayoutNonce] = React17.useState(0);
  const controlled = onViewModeChange != null;
  const [keyboardLayout, setKeyboardLayout] = React17.useState(false);
  const [internalMode, setInternalMode] = React17.useState(viewMode);
  const mode = controlled ? viewMode : internalMode;
  const setMode = React17.useCallback(
    (next) => {
      setKeyboardLayout(false);
      if (!controlled) setInternalMode(next);
      onViewModeChange?.(next);
    },
    [controlled, onViewModeChange]
  );
  const [internalBundle, setInternalBundle] = React17.useState(bundleInitial);
  const bundle = onBundleParallelEdgesChange ? bundleInitial : internalBundle;
  const toggleBundle = () => {
    if (!onBundleParallelEdgesChange) setInternalBundle(!bundle);
    onBundleParallelEdgesChange?.(!bundle);
  };
  const [particles, setParticles] = React17.useState(graphProps.flowParticles ?? true);
  const reducedMotion = useReducedMotion();
  const animateFlow = particles && !reducedMotion;
  const ownContainerRef = React17.useRef(null);
  const containerRef = containerRefProp ?? ownContainerRef;
  const fullscreen = useFullscreen(containerRef);
  const resolvedEngine = keyboardLayout ? engineForView("hierarchical") : engine ?? engineForView(mode);
  const edges = React17.useMemo(
    () => bundle ? bundleParallelEdges(graphProps.edges) : expandFoldedEdges(graphProps.edges),
    [bundle, graphProps.edges]
  );
  const exploration = useClusterExploration({
    nodes: graphProps.nodes,
    edges,
    autoCluster: graphProps.autoCluster,
    onNodeClick: graphProps.onNodeClick,
    onNodeReveal: graphProps.onNodeReveal,
    keepVisibleId: graphProps.focusNodeId ?? void 0
  });
  const visibleGroups = React17.useMemo(
    () => groupsForVisibleNodes(graphProps.chainGroups, exploration.nodes),
    [graphProps.chainGroups, exploration.nodes]
  );
  const renderedFocusId = graphProps.focusNodeId ? exploration.nodes.find((n) => n.id === graphProps.focusNodeId || Array.isArray(n.data.memberIds) && n.data.memberIds.includes(graphProps.focusNodeId))?.id : void 0;
  const legend = React17.useMemo(
    () => graphProps.legend ?? assetColorLegend(exploration.edges),
    [graphProps.legend, exploration.edges]
  );
  const canvas = resolvedEngine === "force" ? /* @__PURE__ */ jsx(
    ForceGraph,
    {
      nodes: exploration.nodes,
      edges: exploration.edges,
      legend,
      className: graphProps.className,
      loadingFallback,
      onNodeClick: exploration.onNodeClick,
      onEdgeClick: graphProps.onEdgeClick ? flowSelection.inspect : void 0,
      showFlowChooser: graphProps.showFlowChooser,
      selectedEdgeId: graphProps.onEdgeClick ? flowSelection.selectedId : graphProps.selectedEdgeId,
      onClearEdgeSelection: flowSelection.clear,
      edgeQuickAction: graphProps.edgeQuickAction,
      nodeActions: graphProps.nodeActions,
      assignment: graphProps.assignment,
      groups: visibleGroups,
      flowParticles: animateFlow,
      searchQuery: graphProps.searchQuery,
      emphasis: graphProps.emphasis
    }
  ) : /* @__PURE__ */ jsx(
    TransactionGraph,
    {
      ...graphProps,
      onEdgeClick: graphProps.onEdgeClick ? flowSelection.inspect : void 0,
      selectedEdgeId: graphProps.onEdgeClick ? flowSelection.selectedId : graphProps.selectedEdgeId,
      onClearEdgeSelection: flowSelection.clear,
      legend,
      nodes: exploration.nodes,
      edges: exploration.edges,
      chainGroups: visibleGroups,
      onNodeClick: exploration.onNodeClick,
      autoCluster: false,
      focusNodeId: renderedFocusId,
      viewMode: keyboardLayout ? "hierarchical" : mode,
      flowParticles: animateFlow,
      layoutNonce
    }
  );
  const canTidy = showRelayout && resolvedEngine !== "force" && graphProps.layout !== false;
  const toolbar = /* @__PURE__ */ jsx(
    GraphToolbar,
    {
      fullscreen: showFullscreen && fullscreen.supported ? { active: fullscreen.isFullscreen, onToggle: fullscreen.toggle } : void 0,
      bundle: showEdgeBundleToggle ? { active: bundle, onToggle: toggleBundle } : void 0,
      particles: showFlowToggle ? { active: animateFlow, reducedMotion, onToggle: () => setParticles((p) => !p) } : void 0,
      relayout: canTidy ? { onClick: () => setLayoutNonce((n) => n + 1) } : void 0,
      extra: extraToolbar
    }
  );
  const hasToolbar = showFullscreen || showEdgeBundleToggle || showFlowToggle || canTidy || extraToolbar != null;
  if (!header && !notice && !showViewModeToggle && !hasToolbar && !exploration.controls && resolvedEngine !== "force") return canvas;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: (
        // Fills the viewport when the browser refused real fullscreen — see
        // `useFullscreen`. Above page chrome; Escape or the toggle leaves it.
        fullscreen.maximised ? "fixed inset-0 z-50 flex flex-col bg-background" : "relative flex size-full flex-col bg-background"
      ),
      children: [
        header && /* @__PURE__ */ jsx("div", { "aria-label": "Graph display controls", tabIndex: 0, className: "min-h-0 max-h-[45%] shrink-0 overflow-y-auto", children: header }),
        notice && /* @__PURE__ */ jsx("div", { className: "shrink-0", children: notice }),
        resolvedEngine === "force" && /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 flex-wrap items-center gap-2 border-b px-3 py-1 text-xs", children: [
          /* @__PURE__ */ jsx("span", { children: "Force is a spatial overview. For keyboard and screen-reader navigation, use the same evidence in Hierarchical view." }),
          /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", onClick: () => {
            setMode("hierarchical");
            setKeyboardLayout(true);
          }, children: "Use keyboard-friendly graph" })
        ] }),
        showViewModeToggle || hasToolbar ? /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 flex-wrap items-center justify-between gap-2 border-b p-2", children: [
          showViewModeToggle ? /* @__PURE__ */ jsx(GraphViewModeToggle, { value: keyboardLayout ? "hierarchical" : mode, onChange: setMode, modes: viewModes, size: "sm" }) : /* @__PURE__ */ jsx("span", {}),
          hasToolbar ? toolbar : null
        ] }) : null,
        /* @__PURE__ */ jsxs("div", { className: "relative min-h-0 flex-1", children: [
          canvas,
          exploration.controls
        ] })
      ]
    }
  );
}
var init_GraphCanvas = __esm({
  "src/engines/GraphCanvas.tsx"() {
    init_TransactionGraph();
    init_ForceGraph();
    init_edgeBundling();
    init_useClusterExploration();
    init_clusterGroups();
    init_GraphToolbar();
    init_useFullscreen();
    init_viewMode();
    init_GraphViewModeToggle();
    init_assetColors();
    init_useFlowSelection();
  }
});
function GraphEmptyState({
  reason,
  className,
  size = "md"
}) {
  const copy = reason && COPY[reason] || FALLBACK;
  return /* @__PURE__ */ jsx(
    EmptyState,
    {
      title: copy.title,
      description: copy.description,
      className,
      size
    }
  );
}
var COPY, FALLBACK;
var init_GraphEmptyState = __esm({
  "src/scene/GraphEmptyState.tsx"() {
    COPY = {
      no_semantic_tree: {
        title: "Nothing decoded",
        description: "No protocol was recognised in this transaction, so there is no story to draw. The raw call and logs are still available on the transaction detail."
      },
      decluttered_empty: {
        title: "Nothing left to show",
        description: "Everything in this transaction was classified as plumbing by its protocol's scene settings. Raise the detail level to see it."
      },
      no_flow_source: {
        title: "No value flow to draw",
        description: "This view is built from token movements and none were available for this transaction. The semantic graph may still describe what happened."
      },
      no_value_moved: {
        title: "No public token movements observed",
        description: "No public token movements were found in the available logs and traces. The semantic graph may show contract calls, approvals, or shielded activity."
      },
      new_issuance: {
        title: "New coins, no sender",
        description: "This transaction created its value \u2014 a block reward paid to the miner \u2014 so there is no sender to draw a flow from. The semantic graph shows who received it."
      },
      pooled: {
        title: "Pooled in a CoinJoin round",
        description: "Every participant's input funded the round and the round paid every output, so no input can be linked to any output \u2014 drawing one would invent it. The semantic graph shows the round: inputs into it, outputs out of it."
      },
      relocked: {
        title: "Paid back to its own address",
        description: "Every output pays an address this transaction spent from, so no value changed hands \u2014 only the fee left. An XMR\u2194BTC swap's cancel re-locks its BTC this way; a wallet consolidating to itself looks the same. The semantic graph says which."
      },
      shielded: {
        title: "Value moved through a privacy pool",
        description: "Value entered, left or moved inside a shielded pool, where the chain publishes no address on the other side to draw a flow to. The inputs and outputs show the transparent side and the amount the pool published."
      }
    };
    FALLBACK = {
      title: "Nothing to show",
      description: "This graph came back empty."
    };
  }
});
function shortCorrelation(key) {
  const value = key.includes(":") ? key.slice(key.lastIndexOf(":") + 1) : key;
  return shortenIdentifier(value);
}
function firstTag(node, overlay) {
  const backend = node.attributes?.tags;
  if (Array.isArray(backend)) {
    for (const tag of backend) {
      const value = asTrimmedString(tag);
      if (value) return value;
    }
  }
  for (const tag of overlay?.tags ?? []) {
    const value = asTrimmedString(tag);
    if (value) return value;
  }
  return void 0;
}
function overlayFor(node, ctx) {
  const address = node.address ?? void 0;
  return address ? ctx.resolveOverlay?.(address, node.chain_id ?? void 0) : void 0;
}
function transactionBandKey(ref) {
  return `${ref.chain_id ?? ""}|${ref.id}`;
}
function groupingDimension(id) {
  return BY_ID.get(id);
}
function groupingDimensionLabel(id) {
  return BY_ID.get(id)?.label ?? id;
}
var OFFCHAIN_CHAIN_ID, CHAIN_LABEL_ATTR, SAGA_KEY_ATTR, SAGA_LABEL_ATTR, SAGA_AWAITING_ATTR, PROTOCOL_COLOR, ENTITY_COLOR, TAG_COLOR, LABEL_COLOR, KIND_COLOR, SAGA_COLOR, SAGA_AWAITING_COLOR, CHAIN, PROTOCOL, ENTITY, TAG, LABEL, KIND, CATALOG_GROUP, SAGA, SHARED_TRANSACTIONS_KEY, TRANSACTION_COLORS, TRANSACTION, HOP, RELATED, HOLDER_SHARE, DIMENSIONS, GROUPING_DIMENSION_LIST, BY_ID;
var init_dimensions = __esm({
  "src/grouping/dimensions.ts"() {
    OFFCHAIN_CHAIN_ID = "offchain";
    CHAIN_LABEL_ATTR = "chain_label";
    SAGA_KEY_ATTR = "saga_key";
    SAGA_LABEL_ATTR = "saga_label";
    SAGA_AWAITING_ATTR = "saga_awaiting";
    PROTOCOL_COLOR = "#8b5cf6";
    ENTITY_COLOR = "#14b8a6";
    TAG_COLOR = "#f97316";
    LABEL_COLOR = "#64748b";
    KIND_COLOR = "#64748b";
    SAGA_COLOR = "#0ea5e9";
    SAGA_AWAITING_COLOR = "#f59e0b";
    CHAIN = {
      id: "chain",
      label: "Blockchain",
      description: "Network where each address appears.",
      groupType: "chain",
      // A chain band of one is the chain's name — worth drawing on its own.
      minMembers: 1,
      resolve(node) {
        const chainId = node.chain_id;
        if (chainId && chainId !== OFFCHAIN_CHAIN_ID && isReconstruction(node)) {
          return { key: `reconstruction:${chainId}`, label: `${chainDisplayName(chainId)} \xB7 reconstruction (unverified)`, chainId, color: "#b45309" };
        }
        if (!chainId || chainId === OFFCHAIN_CHAIN_ID || node.off_chain) return null;
        return {
          key: chainId,
          // Defaults to the id: `toSceneView` resolves the human name from the FE
          // chain registry, and a member's hint covers the ids it can't name.
          label: asTrimmedString(node.attributes?.[CHAIN_LABEL_ATTR]) ?? chainId,
          chainId
        };
      }
    };
    PROTOCOL = {
      id: "protocol",
      label: "Protocol",
      description: "Recorded protocol context.",
      groupType: "protocol",
      minMembers: 2,
      resolve(node) {
        const protocol = asTrimmedString(node.attributes?.protocol);
        if (!protocol) return null;
        return { key: protocol.toLowerCase(), label: protocol, color: PROTOCOL_COLOR };
      }
    };
    ENTITY = {
      id: "entity",
      label: "Entity",
      description: "Shared catalog entity attribution; review its evidence.",
      groupType: "cluster",
      minMembers: 2,
      resolve(node, ctx) {
        const overlay = overlayFor(node, ctx);
        const entityId = asTrimmedString(node.entity_id) ?? overlay?.primaryEntityId;
        if (!entityId) return null;
        return {
          key: entityId.toLowerCase(),
          // The host's resolver first (it may know entities this graph never drew),
          // then the name the overlay already resolved for this very node, and only
          // then the id. The middle step was missing, and since nothing supplies
          // `entityLabel`, every band was titled with a hash — the id is a fallback
          // for a band we genuinely cannot name, not the normal case.
          label: ctx.entityLabel?.(entityId) ?? (overlay?.primaryEntityId === entityId ? overlay.primaryEntityName : void 0) ?? entityId,
          color: ENTITY_COLOR
        };
      }
    };
    TAG = {
      id: "tag",
      label: "Tag",
      description: "First recorded tag; a category, not common ownership.",
      groupType: "tag",
      minMembers: 2,
      resolve(node, ctx) {
        const tag = firstTag(node, overlayFor(node, ctx));
        if (!tag) return null;
        return { key: tag.toLowerCase(), label: tag, color: TAG_COLOR };
      }
    };
    LABEL = {
      id: "label",
      label: "Catalog label",
      description: "Same display label; names may refer to different entities.",
      groupType: "label",
      minMembers: 2,
      resolve(node, ctx) {
        const label = overlayFor(node, ctx)?.label;
        if (!label) return null;
        return { key: label.toLowerCase(), label, color: LABEL_COLOR };
      }
    };
    KIND = {
      id: "kind",
      label: "Node type",
      description: "Recorded address or contract type.",
      groupType: "kind",
      minMembers: 2,
      /**
       * Resolved through the node-kind registry, which is the same thing the CARD
       * reads for its variant and badge — so a band and the nodes inside it agree
       * about what they are.
       *
       * It used to title itself by prettifying the raw wire string, and that is two
       * bugs rather than one. The label was wrong (`don` → "Don", `eoa` → "Eoa",
       * `defi` → "Defi", where the registry says "Oracle network", "Wallet", "DeFi
       * protocol"), and the KEY was the raw string — so `address`, `wallet` and
       * `eoa` drew three separate bands for one kind, as did `cex` and `exchange`.
       * Grouping by a vocabulary nobody had normalised is grouping by spelling.
       */
      resolve(node) {
        const raw = asTrimmedString(node.kind);
        if (!raw) return null;
        const offChain = node.off_chain === true;
        const kind = domainKindForSceneKind(raw, { offChain });
        return {
          key: kind ?? raw.toLowerCase(),
          label: nodeKindLabel(raw, { offChain }) ?? raw,
          color: KIND_COLOR
        };
      }
    };
    CATALOG_GROUP = {
      id: "catalog_group",
      label: "Catalog group",
      description: "Primary catalog membership, grouped by ID rather than name.",
      groupType: "catalog_group",
      minMembers: 2,
      resolve(node, ctx) {
        const group = overlayFor(node, ctx)?.catalogGroups?.find((entry) => entry.id.trim());
        if (!group) return null;
        return { key: group.id, label: group.label || group.id, color: group.color ?? LABEL_COLOR };
      }
    };
    SAGA = {
      id: "saga",
      label: "Cross-chain transfer",
      description: "Recorded cross-chain transfer correlation.",
      groupType: "saga",
      minMembers: 2,
      resolve(node) {
        const key = asTrimmedString(node.attributes?.[SAGA_KEY_ATTR]);
        if (!key) return null;
        const name = asTrimmedString(node.attributes?.[SAGA_LABEL_ATTR]);
        return {
          key: key.toLowerCase(),
          // The correlation id is what makes one transfer distinguishable from the
          // next: a case with ten CCIP messages drew ten bands titled "Chainlink
          // CCIP" before this, which reads as one grouping gone wrong.
          label: name ? `${name} ${shortCorrelation(key)}` : shortCorrelation(key),
          color: node.attributes?.[SAGA_AWAITING_ATTR] ? SAGA_AWAITING_COLOR : SAGA_COLOR
        };
      }
    };
    SHARED_TRANSACTIONS_KEY = "shared";
    TRANSACTION_COLORS = ["#0ea5e9", "#8b5cf6", "#f97316", "#14b8a6", "#e11d48", "#65a30d"];
    TRANSACTION = {
      id: "transaction",
      label: "Transaction",
      description: "Transactions containing each node.",
      groupType: "transaction",
      minMembers: 1,
      /**
       * Which transaction drew this node — `in_txs`, stamped by the group merge.
       *
       * A band must be a partition, and a node two transactions share (the user
       * who deposited and was refunded, a vault both legs touch) belongs to both.
       * Putting it in either band would say it belongs to that one only; putting it
       * in both is a layout nobody can draw. So it gets a band of its own, and the
       * edges from it into each transaction's band still say where each leg went.
       */
      resolve(node, ctx) {
        const refs = txMembership(node.attributes);
        if (refs.length === 0) return null;
        if (refs.length > 1) {
          return { key: SHARED_TRANSACTIONS_KEY, label: "Shared by several transactions", color: LABEL_COLOR };
        }
        const ref = refs[0];
        const key = transactionBandKey(ref);
        const leg = ctx.transactions?.get(key);
        const label = [
          roleLabel(leg?.role),
          chainDisplayName(ref.chain_id ?? leg?.chain_id),
          shortenIdentifier(ref.tx_hash ?? ref.id)
        ].filter(Boolean).join(" \xB7 ");
        return {
          key,
          label,
          color: TRANSACTION_COLORS[(leg?.index ?? 0) % TRANSACTION_COLORS.length]
        };
      }
    };
    HOP = {
      id: "hop",
      label: "Hop",
      description: "Recorded distance from the starting address.",
      groupType: "hop",
      minMembers: 1,
      resolve(node) {
        if (!("hop" in (node.attributes ?? {}))) return null;
        if (node.attributes?.in_primary_layer === false) {
          return { key: "other-layers", label: "Other trace layers", color: LABEL_COLOR };
        }
        const hop = node.attributes?.hop;
        if (typeof hop !== "number" || !Number.isInteger(hop) || hop < 0) {
          return { key: "unknown", label: "Hop not recorded", color: LABEL_COLOR };
        }
        return { key: String(hop), label: hop === 0 ? "Seed \xB7 Hop 0" : `Hop ${hop}`, color: "#6366f1" };
      }
    };
    RELATED = {
      id: "related",
      label: "Related addresses",
      description: "Evidence-backed relationships, subject to confidence settings.",
      groupType: "cluster",
      minMembers: 2,
      resolve(node, ctx) {
        return ctx.relatedAddresses?.get(node.id) ?? null;
      }
    };
    HOLDER_SHARE = {
      id: "holder_share",
      label: "Supply share",
      description: "Reported balance bands at the selected snapshot; not common ownership.",
      groupType: "holder_share",
      minMembers: 1,
      resolve(node) {
        const label = asTrimmedString(node.attributes?.holder_share_band);
        return label ? { key: label, label, color: ENTITY_COLOR } : null;
      }
    };
    DIMENSIONS = [HOLDER_SHARE, RELATED, HOP, CHAIN, TRANSACTION, PROTOCOL, ENTITY, TAG, LABEL, CATALOG_GROUP, KIND, SAGA];
    GROUPING_DIMENSION_LIST = DIMENSIONS;
    BY_ID = new Map(DIMENSIONS.map((d) => [d.id, d]));
  }
});
function withSceneContext(scene, options) {
  if (options.transactions) return options;
  const legs = groupSceneLegs(scene.attributes);
  if (legs.length === 0) return options;
  return { ...options, transactions: new Map(legs.map((leg) => [transactionBandKey(leg), leg])) };
}
function bandId(parentId, dimension, key) {
  const own = `${dimension.id}:${key}`;
  return parentId ? `${parentId}/${own}` : own;
}
function resolveDimensions(spec) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const id of spec.dimensions ?? []) {
    if (seen.has(id)) continue;
    seen.add(id);
    const dimension = groupingDimension(id);
    if (dimension) out.push(dimension);
  }
  return out;
}
function applyCaps(bands, spec) {
  const dropped = /* @__PURE__ */ new Set();
  const byDimension = /* @__PURE__ */ new Map();
  for (const band of bands) {
    const bucket = byDimension.get(band.dimension.id);
    if (bucket) bucket.push(band);
    else byDimension.set(band.dimension.id, [band]);
  }
  for (const [id, bucket] of byDimension) {
    const options = spec.options?.[id];
    const minMembers = options?.min_members ?? groupingDimension(id)?.minMembers ?? 1;
    const maxBands = options?.max_bands ?? DEFAULT_MAX_BANDS;
    const kept = bucket.filter((band) => {
      if (band.members.length >= minMembers) return true;
      dropped.add(band.id);
      return false;
    }).sort((a, b) => b.members.length - a.members.length || a.seq - b.seq);
    for (const band of kept.slice(maxBands)) dropped.add(band.id);
  }
  const survives = (band) => {
    if (dropped.has(band.id)) return false;
    if (!band.parentId) return true;
    return !dropped.has(band.parentId);
  };
  const out = [];
  for (const band of bands.sort((a, b) => a.level - b.level || a.seq - b.seq)) {
    if (survives(band)) out.push(band);
    else dropped.add(band.id);
  }
  return out.slice(0, MAX_TOTAL_BANDS);
}
function uniqueLabels(bands) {
  const used = /* @__PURE__ */ new Map();
  const labels = /* @__PURE__ */ new Map();
  for (const band of bands) {
    const scope = `${band.parentId ?? ""}\0${band.value.label.toLowerCase()}`;
    const seen = (used.get(scope) ?? 0) + 1;
    used.set(scope, seen);
    labels.set(band.id, seen === 1 ? band.value.label : `${band.value.label} (${seen})`);
  }
  return labels;
}
function applyGrouping(scene, spec, options = {}) {
  const dimensions = resolveDimensions(spec);
  if (dimensions.length === 0) return scene;
  options = withSceneContext(scene, options);
  const bands = /* @__PURE__ */ new Map();
  const paths = /* @__PURE__ */ new Map();
  let seq = 0;
  for (const node of scene.nodes) {
    const path = [];
    let parentId = null;
    for (let level = 0; level < dimensions.length; level++) {
      const dimension = dimensions[level];
      const value = dimension.resolve(node, options);
      if (!value) {
        if (path.length === 0) continue;
        break;
      }
      const id = bandId(parentId, dimension, value.key);
      let band = bands.get(id);
      if (!band) {
        band = { id, parentId, dimension, level, value, members: [], seq: seq++ };
        bands.set(id, band);
      } else if (!band.value.color && value.color) {
        band.value = { ...band.value, color: value.color };
      }
      band.members.push(node.id);
      path.push(id);
      parentId = id;
    }
    if (path.length > 0) paths.set(node.id, path);
  }
  const kept = applyCaps([...bands.values()], spec);
  const keptIds = new Set(kept.map((band) => band.id));
  const labels = uniqueLabels(kept);
  const groups = kept.map((band) => ({
    id: band.id,
    group_type: band.dimension.groupType,
    chain_id: band.value.chainId ?? null,
    label: labels.get(band.id) ?? band.value.label,
    member_node_ids: band.members,
    color: band.value.color ?? null,
    icon: null
  }));
  const nodes = scene.nodes.map((node) => {
    const path = paths.get(node.id);
    let groupId = null;
    for (const id of path ?? []) {
      if (keptIds.has(id)) groupId = id;
    }
    return node.group_id === groupId ? node : { ...node, group_id: groupId };
  });
  return { ...scene, nodes, groups };
}
function applicableDimensions(scene, options = {}) {
  const out = /* @__PURE__ */ new Set();
  options = withSceneContext(scene, options);
  for (const dimension of GROUPING_DIMENSION_LIST) {
    const counts = /* @__PURE__ */ new Map();
    for (const node of scene.nodes) {
      const value = dimension.resolve(node, options);
      if (!value) continue;
      counts.set(value.key, (counts.get(value.key) ?? 0) + 1);
    }
    const min = dimension.minMembers ?? 1;
    for (const count of counts.values()) {
      if (count >= min) {
        out.add(dimension.id);
        break;
      }
    }
  }
  return out;
}
var DEFAULT_MAX_BANDS, MAX_TOTAL_BANDS;
var init_applyGrouping = __esm({
  "src/grouping/applyGrouping.ts"() {
    init_dimensions();
    DEFAULT_MAX_BANDS = 12;
    MAX_TOTAL_BANDS = 48;
  }
});

// src/grouping/index.ts
var init_grouping = __esm({
  "src/grouping/index.ts"() {
    init_applyGrouping();
    init_dimensions();
  }
});
function overlayKey(address, chainId) {
  return `${toCanonicalChainId(chainId) ?? chainId ?? ""}|${normalizeAddress(address, chainId)}`;
}
function addressOf(node) {
  const candidate = node.address ?? node.attributes?.address;
  return typeof candidate === "string" && candidate ? candidate : void 0;
}
function graphCatalogRefs(graph) {
  if (!graph || typeof graph !== "object") return [];
  const value = graph;
  if (value.scene) return graphCatalogRefs(value.scene);
  if (!Array.isArray(value.nodes)) return [];
  const refs = /* @__PURE__ */ new Map();
  for (const raw of value.nodes) {
    if (!raw || typeof raw !== "object") continue;
    const node = raw;
    const data = node.data && typeof node.data === "object" ? node.data : node;
    if (data.manual === true || node.manual === true) continue;
    const address = addressOf(data);
    if (!address) continue;
    const chain = data.chain ?? data.chainId ?? data.chain_id;
    const chainId = typeof chain === "string" ? chain : void 0;
    refs.set(overlayKey(address, chainId), { address, chainId });
  }
  return [...refs.values()];
}
function freezeRefs(refs, resolve) {
  if (!resolve) return null;
  const frozen = {};
  for (const { address, chainId } of refs) {
    const key = overlayKey(address, chainId);
    if (key in frozen) continue;
    const overlay = resolve(address, chainId);
    if (overlay) frozen[key] = overlay;
  }
  return Object.keys(frozen).length ? frozen : null;
}
function freezeCatalogSnapshot(scene, resolve) {
  return freezeRefs(graphCatalogRefs(scene), resolve);
}
function freezeCatalogSnapshotFromNodes(nodes, resolve) {
  return freezeRefs(graphCatalogRefs({ nodes }), resolve);
}
function catalogResolverFrom(snapshot) {
  if (!snapshot || typeof snapshot !== "object") return void 0;
  const entries = snapshot;
  if (!Object.keys(entries).length) return void 0;
  return (address, chainId) => entries[overlayKey(address, chainId)] ?? entries[overlayKey(normalizeAddress(address, chainId))];
}
function withOverlay(node, overlay) {
  const data = node.data;
  return {
    ...node,
    data: {
      ...data,
      label: overlay.label ?? data.label,
      ...overlay.logo ? { icon: overlay.logo, iconAlt: overlay.label ?? data.label } : {},
      ...overlay.color ? { avatarColor: overlay.color } : {},
      ...overlay.primaryEntityName ? { avatarEntity: overlay.primaryEntityName } : {},
      ...data.entityId ?? overlay.primaryEntityId ? { entityId: data.entityId ?? overlay.primaryEntityId } : {},
      ...overlay.tags?.length ? { tags: overlay.tags } : {},
      ...overlay.riskLevel ? { riskLevel: overlay.riskLevel } : {},
      ...overlay.riskScore !== void 0 ? { riskScore: overlay.riskScore } : {}
    }
  };
}
function applyCatalogOverlay(nodes, resolve) {
  if (!resolve || !nodes.length) return nodes;
  let changed = false;
  const next = nodes.map((node) => {
    const address = node.data?.address;
    if (!address) return node;
    const overlay = resolve(address, node.data?.chain);
    if (!overlay) return node;
    changed = true;
    return withOverlay(node, overlay);
  });
  return changed ? next : nodes;
}
var init_catalogSnapshot = __esm({
  "src/share/catalogSnapshot.ts"() {
  }
});
function toNode(view, options = {}) {
  const brandAccent = options.brandAccent;
  const authored = view.origin === "user";
  const brandClass = view.offChain && view.protocol && brandAccent ? brandAccent(view.protocol) : void 0;
  const accentClassName = brandClass ?? (authored ? AUTHORED_ACCENT_CLASS : void 0);
  return txNode(view.id, {
    label: view.label,
    subtitle: view.sublabel,
    receiptProtocolIds: view.receiptProtocolIds,
    chain: view.chainId,
    icon: view.icon?.url,
    iconAlt: view.icon?.alt,
    ...view.avatarColor ? { avatarColor: view.avatarColor } : {},
    ...view.avatarEntity ? { avatarEntity: view.avatarEntity } : {},
    badge: authored ? view.kind === "situation" ? badgeForKind("situation") : view.badge === "Reconstruction" ? view.badge : AUTHORED_BADGE : view.badge,
    value: view.value,
    // A synthesized node scored zero is a leg nobody has observed — the
    // "Awaiting destination" placeholder — not one observed with no support.
    // Drawn as "Evidence 0%", it read as a measured doubt about a transaction
    // that does not exist yet; the dashed outline and "expected" badge already
    // say what it is.
    confidence: (view.virtual || authored) && !view.confidence ? void 0 : view.confidence,
    evidence: view.evidence,
    // This comes from the graph projector's evidence, not the catalog's
    // ownership/label assessment. Never call a known address "100% attributed".
    confidenceLabel: "Evidence",
    tags: view.tags,
    // `GraphNode` has always rendered a `RiskBadge` from these two; until the
    // catalog overlay carried a severity there was nothing to put in them, so a
    // node labelled "Fake_Phishing7575952" drew the same neutral card as a
    // router. See `@authe/fe-commons` `overlays/risk`.
    riskLevel: view.riskLevel,
    riskScore: view.riskScore,
    failed: view.failed,
    virtual: view.virtual,
    // Hover detail, mirroring the edges: the SSOT facts placed on this node plus
    // its provenance.
    facts: view.facts,
    // The whole token list, not just the representative one `value` names — see
    // `SceneNodeView.assets`.
    assets: view.assets,
    sourceRefs: view.sourceRefs,
    origin: view.origin,
    contested: view.contested,
    // The address this node imitates, when the host's classifier says it is a
    // poisoning lookalike. Host-injected for the same reason `brandAccent` is:
    // the judgement is the caller's — a case classifies its own feed once, so
    // the table's flag, the facet, the hide count and this badge cannot
    // disagree. Until now the canvas could HIDE poisoning and not show it, so a
    // lookalike drew exactly like the payee it copies.
    ...view.address && options.impersonates?.(view.address) ? { impersonates: options.impersonates(view.address) } : {},
    address: view.address,
    entityId: view.entityId,
    kind: domainKindForSceneKind(view.kind, { offChain: view.offChain }),
    protocol: view.protocol,
    accentClassName: accentClassName ?? void 0
  });
}
function toEdge(view, options = {}) {
  const flag = options.flagOf && view.transfers && view.transfers.length > 0 ? edgeFlag(view.transfers.map((transfer) => options.flagOf(transfer.id))) : null;
  return txEdge(view.id, view.from, view.to, {
    ...flag ? { flag } : {},
    // A netted edge is the residue of several movements; the tooltip says so.
    netted: view.netted,
    netZero: view.netZero,
    contested: view.contested,
    // Which intermediaries were netted away to leave this edge — the tooltip
    // reads "N intermediaries (netted out)" from it.
    compressedVia: view.compressedVia,
    // A case feed's merge folds every repeat movement between the same pair onto
    // ONE arrow, and it has to say so: three transfers in the table beside one
    // arrow reads as a missing arrow. Fed through the existing "this edge stands
    // for N" channel rather than a second vocabulary, so it thickens the stroke
    // and lands in the tooltip the way a bundled edge already does.
    aggregated: (view.mergedCount ?? 1) > 1 ? true : void 0,
    count: (view.mergedCount ?? 1) > 1 ? view.mergedCount : void 0,
    // Which transactions, each with its own amount: named on hover, and drawn
    // back out as separate arrows when bundling is off.
    transfers: view.transfers,
    // Failed/reverted calls override the kind colour with the critical-risk red;
    // an analyst's own edge takes the authored variant, so it can't be read as
    // an observed flow. Failure wins over provenance — an authored edge marked
    // failed is still, first, a failure.
    variant: view.failed ? "failed" : view.origin === "user" ? "authored" : edgeVariantForKind(view.kind),
    failed: view.failed,
    label: view.label,
    // Hover detail: the SSOT facts placed on this edge + the context needed to
    // read them (what kind of hop, whether it was observed, which chains).
    facts: view.facts,
    origin: view.origin,
    kind: view.kind,
    fromChain: view.fromChain,
    toChain: view.toChain,
    amount: view.amount,
    amountRaw: view.amountRaw,
    ticker: view.symbol,
    tokenAddress: view.tokenAddress,
    tokenId: view.tokenId,
    valueUsd: view.valueUsd,
    basis: view.basis,
    minAmount: view.minAmount,
    minAmountRaw: view.minAmountRaw,
    maxAmount: view.maxAmount,
    maxAmountRaw: view.maxAmountRaw,
    tokenLogo: view.icon?.url,
    tokenLogoAlt: view.icon?.alt,
    // Value-carrying flows animate (a particle travels the edge); a failed or
    // virtual hop stays static. Bidirectional pairs animate a particle each way.
    animated: !view.failed && isFlowEdgeKind(view.kind) && flag?.mode !== "demote",
    bidirectional: view.bidirectional,
    // Synthesised cross-chain hops (e.g. a CCIP bridge-destination leg) render
    // dashed so analysts can tell them from observed on-chain flows.
    dashed: view.dashed
  });
}
function sceneViewToElements(view, options = {}) {
  const nodes = view.nodes.map((n) => toNode(n, options));
  return {
    nodes,
    edges: [...view.edges.map((e) => toEdge(e, options)), ...imitationEdges(nodes)],
    groups: view.groups,
    layoutHint: view.layoutHint
  };
}
function imitationEdges(nodes) {
  const byAddress = /* @__PURE__ */ new Map();
  for (const node of nodes) {
    const address = node.data?.address;
    const chain = node.data?.chain ?? "";
    if (typeof address === "string" && address) byAddress.set(`${chain}|${normalizeAddress(address, chain)}`, node);
  }
  const out = [];
  for (const node of nodes) {
    const mimics = node.data?.impersonates;
    if (typeof mimics !== "string" || !mimics) continue;
    const chain = node.data?.chain ?? "";
    const genuine = byAddress.get(`${chain}|${normalizeAddress(mimics, chain)}`);
    if (!genuine || genuine.id === node.id) continue;
    out.push(
      txEdge(`imitates:${node.id}->${genuine.id}`, node.id, genuine.id, {
        relation: "imitates",
        label: "imitates",
        variant: "default",
        animated: false
      })
    );
  }
  return out;
}
function toScene(scene, options = {}) {
  return sceneViewToElements(toSceneView(scene, options), {
    brandAccent: options.brandAccent,
    impersonates: options.impersonates,
    flagOf: options.flagOf
  });
}
var AUTHORED_ACCENT_CLASS, AUTHORED_BADGE;
var init_toScene = __esm({
  "src/transpose/toScene.ts"() {
    init_nodes();
    init_edges();
    init_nodeKinds();
    init_edgeKinds();
    AUTHORED_ACCENT_CLASS = "border-highlight/70";
    AUTHORED_BADGE = "Added";
  }
});
function graphExportElements(graph, options = {}) {
  if (!graph) return { nodes: [], edges: [] };
  const scene = graph.scene;
  if (scene) {
    const elements = toScene(scene, options);
    return { nodes: elements.nodes, edges: elements.edges };
  }
  return {
    nodes: Array.isArray(graph.nodes) ? [...graph.nodes] : [],
    edges: Array.isArray(graph.edges) ? [...graph.edges] : []
  };
}
function exportGraphNodes(nodes, opts = {}) {
  return exportDataset({
    rows: nodes,
    columns: NODE_COLUMNS,
    format: opts.format ?? "csv",
    filenameBase: opts.filenameBase ?? "graph-nodes",
    download: opts.download
  });
}
function exportGraphEdges(edges, opts = {}) {
  return exportDataset({
    rows: edges,
    columns: EDGE_COLUMNS,
    format: opts.format ?? "csv",
    filenameBase: opts.filenameBase ?? "graph-edges",
    download: opts.download
  });
}
async function exportGraphData(graph, opts = {}) {
  const elements = graphExportElements(graph);
  const nodes = await exportGraphNodes(elements.nodes, opts);
  const edges = await exportGraphEdges(elements.edges, opts);
  return { nodes, edges };
}
var NODE_COLUMNS, EDGE_COLUMNS;
var init_exportGraphData = __esm({
  "src/export/exportGraphData.ts"() {
    init_toScene();
    NODE_COLUMNS = [
      { key: "id", header: "node_id" },
      { key: "label", header: "label", value: (n) => n.data.label },
      { key: "subtitle", header: "subtitle", value: (n) => n.data.subtitle ?? "" },
      { key: "chain", header: "chain", value: (n) => n.data.chain ?? "" },
      { key: "variant", header: "variant", value: (n) => n.data.variant ?? "" },
      { key: "context", header: "investigation_context", value: (n) => JSON.stringify(n.data.contextBadges ?? []) },
      { key: "badge", header: "badge", value: (n) => n.data.badge ?? "" }
    ];
    EDGE_COLUMNS = [
      { key: "id", header: "edge_id" },
      { key: "source", header: "source" },
      { key: "target", header: "target" },
      { key: "label", header: "label", value: (e) => e.data?.label ?? "" },
      { key: "kind", header: "kind", value: (e) => e.data?.kind ?? "" },
      { key: "variant", header: "variant", value: (e) => e.data?.variant ?? "" },
      { key: "amount", header: "amount", value: (e) => e.data?.amount ?? "" },
      { key: "ticker", header: "token", value: (e) => e.data?.ticker ?? "" },
      { key: "valueUsd", header: "value_usd", value: (e) => e.data?.valueUsd ?? "" },
      { key: "basis", header: "amount_basis", value: (e) => e.data?.basis ?? "" },
      { key: "netted", header: "netted", value: (e) => e.data?.netted ? "true" : "" },
      { key: "fromChain", header: "from_chain", value: (e) => e.data?.fromChain ?? "" },
      { key: "toChain", header: "to_chain", value: (e) => e.data?.toChain ?? "" },
      { key: "timestamp", header: "timestamp", value: (e) => e.data?.timestamp ?? "" }
    ];
  }
});

// src/export/exportPng.ts
async function toPng(node, options) {
  const mod = await import('html-to-image');
  return mod.toPng(node, options);
}
function resolveTarget(container) {
  return container.matches("[data-graph-export-surface]") ? container : container.querySelector("[data-graph-export-surface]") ?? container.querySelector(".react-flow") ?? container;
}
function includeInGraphImage(node) {
  return !node.matches?.("[data-graph-export-exclude], .react-flow__controls, .react-flow__minimap, [role=menu]");
}
function backgroundOf(element) {
  for (let current = element; current; current = current.parentElement) {
    const color = getComputedStyle(current).backgroundColor;
    if (color && color !== "transparent" && color !== "rgba(0, 0, 0, 0)") return color;
  }
  return "#ffffff";
}
function addContext(dataUrl, context, ratio) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("Cannot render export context"));
        return;
      }
      const pad = 16 * ratio, font = 13 * ratio, lineHeight = 19 * ratio;
      canvas.width = image.width;
      ctx.font = `${font}px sans-serif`;
      const wrapped = [];
      for (const paragraph of [context.title, ...context.lines]) {
        let line = "";
        for (const word of paragraph.split(/\s+/)) {
          const candidate = line ? `${line} ${word}` : word;
          if (ctx.measureText(candidate).width <= image.width - 2 * pad) {
            line = candidate;
            continue;
          }
          if (line) wrapped.push(line);
          line = "";
          for (const char of word) {
            if (line && ctx.measureText(line + char).width > image.width - 2 * pad) {
              wrapped.push(line);
              line = "";
            }
            line += char;
          }
        }
        wrapped.push(line);
      }
      canvas.height = image.height + 2 * pad + wrapped.length * lineHeight;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);
      ctx.fillStyle = "#1f2937";
      ctx.font = `${font}px sans-serif`;
      ctx.textBaseline = "top";
      wrapped.forEach((line, index) => ctx.fillText(line, pad, image.height + pad + index * lineHeight));
      resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = () => reject(new Error("Failed to load graph image for context"));
    image.src = dataUrl;
  });
}
function applyWatermark(dataUrl, text2, background) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(dataUrl);
        return;
      }
      ctx.fillStyle = background;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);
      const pad = Math.round(canvas.width * 0.012) + 8;
      const fontSize = Math.max(12, Math.round(canvas.width * 0.014));
      ctx.font = `${fontSize}px sans-serif`;
      ctx.textAlign = "right";
      ctx.textBaseline = "bottom";
      ctx.fillStyle = "rgba(100, 116, 139, 0.65)";
      ctx.fillText(text2, canvas.width - pad, canvas.height - pad);
      resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = () => reject(new Error("Failed to load graph image for watermarking"));
    image.src = dataUrl;
  });
}
function triggerDownload(dataUrl, fileName) {
  const link = document.createElement("a");
  link.download = fileName.endsWith(".png") ? fileName : `${fileName}.png`;
  link.href = dataUrl;
  link.click();
}
async function exportGraphPng(container, options = {}) {
  const { fileName, pixelRatio = 2, watermark, context } = options;
  const target = resolveTarget(container);
  const backgroundColor = options.backgroundColor ?? backgroundOf(target);
  let dataUrl = await toPng(target, { backgroundColor, pixelRatio, cacheBust: true, filter: includeInGraphImage });
  if (context) dataUrl = await addContext(dataUrl, context, pixelRatio);
  if (watermark) {
    dataUrl = await applyWatermark(dataUrl, watermark, backgroundColor);
  }
  if (fileName) {
    triggerDownload(dataUrl, fileName);
  }
  return dataUrl;
}
var init_exportPng = __esm({
  "src/export/exportPng.ts"() {
  }
});
function readGraphViewContext(value) {
  if (!value || typeof value !== "object") return void 0;
  const { title, lines } = value;
  if (typeof title !== "string" || !Array.isArray(lines) || !lines.every((line) => typeof line === "string")) return void 0;
  return { title, lines };
}
function GraphViewContext({ value }) {
  if (!value) return null;
  return /* @__PURE__ */ jsxs("details", { className: "border-b px-3 py-2 text-xs", "aria-label": "Saved graph context", children: [
    /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer font-medium", children: [
      value.title,
      " \xB7 saved scope and caveats"
    ] }),
    /* @__PURE__ */ jsx("div", { className: "mt-2 space-y-1", children: value.lines.map((line, index) => /* @__PURE__ */ jsx("p", { children: line }, index)) })
  ] });
}
var init_GraphViewContext = __esm({
  "src/share/GraphViewContext.tsx"() {
  }
});
function GraphExportMenu({
  graph,
  containerRef,
  filenameBase = "graph",
  watermark,
  exportContext,
  historyHref,
  label = "Export",
  buttonVariant = "outline",
  buttonSize = "sm",
  disabled
}) {
  const ledger = useExportLedger();
  const [busy, setBusy] = React17.useState(false);
  const overlayResolver = React17.useMemo(
    () => catalogResolverFrom(graph?.catalog),
    [graph]
  );
  const { nodes, edges } = React17.useMemo(
    () => graphExportElements(graph, overlayResolver ? { resolveOverlay: overlayResolver } : {}),
    [graph, overlayResolver]
  );
  const record = React17.useCallback(
    async (resource, filename, rowCount, columns, error) => {
      if (!ledger) return;
      await ledger.record({
        ...exportContext,
        resource,
        format: resource === "graph-image" ? "json" : "csv",
        filename,
        rowCount,
        columns,
        status: error ? ExportLedgerStatus.FAILED : ExportLedgerStatus.RECORDED,
        error
      }).catch(() => null);
    },
    [ledger, exportContext]
  );
  const run = React17.useCallback(
    async (kind) => {
      setBusy(true);
      try {
        if (kind === "png") {
          const container = containerRef?.current;
          if (!container) throw new Error("the graph canvas is not mounted yet");
          const filename = buildExportFilename(filenameBase, "json", { timestamp: true }).replace(
            /\.json$/,
            ".png"
          );
          const context = readGraphViewContext(graph?.viewContext);
          await exportGraphPng(container, {
            fileName: filename,
            ...watermark ? { watermark } : {},
            pixelRatio: 2,
            context: {
              title: context?.title ?? "Graph view",
              lines: [
                "Current camera view. Off-screen elements may be cropped; use Fit View before exporting the whole graph.",
                ...context?.lines ?? [],
                `Exported ${(/* @__PURE__ */ new Date()).toISOString()}.`
              ]
            }
          });
          await record("graph-image", filename, nodes.length, []);
          return;
        }
        if (kind === "json") {
          const filename = buildExportFilename(filenameBase, "json", { timestamp: true });
          const blob = new Blob([JSON.stringify(graph ?? {}, null, 2)], {
            type: "application/json"
          });
          downloadBlob(blob, filename);
          await record("graph-snapshot", filename, nodes.length + edges.length, ["nodes", "edges"]);
          return;
        }
        const isNodes = kind === "nodes";
        const result = isNodes ? await exportGraphNodes([...nodes], { filenameBase: `${filenameBase}-nodes` }) : await exportGraphEdges([...edges], { filenameBase: `${filenameBase}-edges` });
        await record(
          isNodes ? "graph-nodes" : "graph-edges",
          result.filename,
          result.rowCount,
          result.columns
        );
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        notifyError(error, { title: `Couldn't export the graph as ${KIND_LABELS[kind]}.` });
        await record(`graph-${kind}`, "", 0, [], error.message);
      } finally {
        setBusy(false);
      }
    },
    [containerRef, filenameBase, watermark, graph, nodes, edges, record]
  );
  const kinds = [
    ...containerRef ? ["png"] : [],
    "nodes",
    "edges",
    "json"
  ];
  const empty = nodes.length === 0 && edges.length === 0;
  return /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        variant: buttonVariant,
        size: buttonSize,
        disabled: disabled || busy || empty,
        title: empty ? "Apply or import a graph to export it" : "Export this graph",
        children: busy ? "Exporting\u2026" : label
      }
    ) }),
    /* @__PURE__ */ jsxs(DropdownMenuContent, { align: "end", children: [
      /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Download as" }),
      /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
      kinds.map((kind) => /* @__PURE__ */ jsx(DropdownMenuItem, { disabled: busy, onSelect: () => void run(kind), children: KIND_LABELS[kind] }, kind)),
      /* @__PURE__ */ jsx(ExportHistoryItem, { href: historyHref })
    ] })
  ] });
}
function downloadBlob(blob, filename) {
  if (typeof document === "undefined" || typeof URL?.createObjectURL !== "function") return;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1e4);
}
var KIND_LABELS;
var init_GraphExportMenu = __esm({
  "src/export/GraphExportMenu.tsx"() {
    init_catalogSnapshot();
    init_exportGraphData();
    init_exportPng();
    init_GraphViewContext();
    KIND_LABELS = {
      png: "Current view image (PNG)",
      nodes: "Nodes (CSV)",
      edges: "Edges (CSV)",
      json: "Graph snapshot (JSON)"
    };
  }
});
function effectiveVariant(node) {
  return node.data.variant ?? variantForKind(node.data.kind);
}
function computeGraphStats(nodes, edges) {
  const byVariant = /* @__PURE__ */ new Map();
  const byChain = /* @__PURE__ */ new Map();
  let offChainCount = 0;
  for (const node of nodes) {
    const variant = effectiveVariant(node);
    byVariant.set(variant, (byVariant.get(variant) ?? 0) + 1);
    const chain = node.data.chain;
    if (typeof chain === "string" && chain) byChain.set(chain, (byChain.get(chain) ?? 0) + 1);
    if (isOffChainKind(node.data.kind)) offChainCount += 1;
  }
  return {
    nodeCount: nodes.length,
    edgeCount: edges.length,
    byVariant: rankedCounts(byVariant),
    byChain: rankedCounts(byChain),
    offChainCount
  };
}
var init_computeStats = __esm({
  "src/stats/computeStats.ts"() {
    init_nodeKinds();
  }
});
function StatBlock({ value, label }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold tabular-nums text-foreground", children: value.toLocaleString() }),
    /* @__PURE__ */ jsx("span", { className: "text-3xs uppercase tracking-wide text-muted-foreground", children: label })
  ] });
}
function CountRow({
  swatch,
  logo,
  label,
  count
}) {
  const [failedLogo, setFailedLogo] = React17.useState(null);
  const drawn = logo && logo !== failedLogo ? logo : null;
  return /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-2 text-muted-foreground", children: [
    drawn ? /* @__PURE__ */ jsx(
      "img",
      {
        src: drawn,
        alt: "",
        "aria-hidden": true,
        className: "size-3 shrink-0 rounded-full object-cover",
        onError: () => setFailedLogo(drawn)
      }
    ) : swatch ? /* @__PURE__ */ jsx("span", { className: "size-2.5 shrink-0 rounded-full", style: { backgroundColor: swatch } }) : /* @__PURE__ */ jsx("span", { className: "size-2.5 shrink-0" }),
    /* @__PURE__ */ jsx("span", { className: "min-w-0 flex-1 truncate text-foreground", children: label }),
    /* @__PURE__ */ jsx("span", { className: "tabular-nums", children: count.toLocaleString() })
  ] });
}
function GraphStatsPanel({
  nodes,
  edges,
  stats: statsProp,
  title = "Chain stats",
  maxRows = 6,
  className,
  onClose
}) {
  const stats = React17.useMemo(
    () => statsProp ?? computeGraphStats(nodes ?? [], edges ?? []),
    [statsProp, nodes, edges]
  );
  const chains = stats.byChain.slice(0, maxRows);
  const chainsHidden = stats.byChain.length - chains.length;
  const variants = stats.byVariant.slice(0, maxRows);
  const variantsHidden = stats.byVariant.length - variants.length;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "relative select-none rounded-md border bg-card/90 p-2 text-xs shadow-xs backdrop-blur",
        onClose && "pr-6",
        className
      ),
      children: [
        onClose ? /* @__PURE__ */ jsx(PanelCloseButton, { className: "absolute right-1 top-1", onClick: onClose, label: "Hide chain stats" }) : null,
        title ? /* @__PURE__ */ jsx("p", { className: "mb-1.5 font-medium text-foreground", children: title }) : null,
        /* @__PURE__ */ jsxs("div", { className: "mb-2 flex gap-4", children: [
          /* @__PURE__ */ jsx(StatBlock, { value: stats.nodeCount, label: "Nodes" }),
          /* @__PURE__ */ jsx(StatBlock, { value: stats.edgeCount, label: "Edges" }),
          stats.offChainCount > 0 && /* @__PURE__ */ jsx(StatBlock, { value: stats.offChainCount, label: "Off-chain" })
        ] }),
        chains.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-2", children: [
          /* @__PURE__ */ jsxs("p", { className: "mb-1 text-3xs uppercase tracking-wide text-muted-foreground", children: [
            "Chains",
            stats.byChain.length > 1 ? ` (${stats.byChain.length})` : ""
          ] }),
          /* @__PURE__ */ jsxs("ul", { className: "space-y-1", children: [
            chains.map((row) => {
              const chain = resolveChain(row.key);
              return /* @__PURE__ */ jsx(
                CountRow,
                {
                  logo: chain?.logoUrl,
                  swatch: chain?.brandColor ?? void 0,
                  label: chain?.name ?? row.key,
                  count: row.count
                },
                row.key
              );
            }),
            chainsHidden > 0 && /* @__PURE__ */ jsxs("li", { className: "text-2xs text-muted-foreground", children: [
              "+",
              chainsHidden,
              " more"
            ] })
          ] })
        ] }),
        variants.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("p", { className: "mb-1 text-3xs uppercase tracking-wide text-muted-foreground", children: [
            "Node types",
            stats.byVariant.length > 1 ? ` (${stats.byVariant.length})` : ""
          ] }),
          /* @__PURE__ */ jsxs("ul", { className: "space-y-1", children: [
            variants.map((row) => /* @__PURE__ */ jsx(
              CountRow,
              {
                swatch: GRAPH_NODE_VARIANT_COLOR[row.key],
                label: GRAPH_NODE_VARIANT_LABELS[row.key],
                count: row.count
              },
              row.key
            )),
            variantsHidden > 0 && /* @__PURE__ */ jsxs("li", { className: "text-2xs text-muted-foreground", children: [
              "+",
              variantsHidden,
              " more"
            ] })
          ] })
        ] })
      ]
    }
  );
}
var init_GraphStatsPanel = __esm({
  "src/stats/GraphStatsPanel.tsx"() {
    init_PanelCloseButton();
    init_computeStats();
  }
});
function useGraphDetailTier(view, options = {}) {
  const { tier: controlledTier, defaultTier, expandable = true } = options;
  const [internalTier, setInternalTier] = React17.useState(
    // Compact-first fallback (mirrors the scene's `default_detail_tier` default);
    // reached only if neither an explicit default nor the view carries a tier.
    defaultTier ?? view.defaultDetailTier ?? "compact"
  );
  const tier = controlledTier ?? internalTier;
  const [expandedNodeIds, setExpandedNodeIds] = React17.useState(
    () => /* @__PURE__ */ new Set()
  );
  const toggleNode = React17.useCallback(
    (id) => setExpandedNodeIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    }),
    []
  );
  const collapseAll = React17.useCallback(() => setExpandedNodeIds(/* @__PURE__ */ new Set()), []);
  const effectiveExpanded = expandable ? expandedNodeIds : EMPTY;
  const filteredView = React17.useMemo(
    () => filterSceneViewByDetailTier(view, tier, {
      expandedNodeIds: effectiveExpanded
    }),
    [view, tier, effectiveExpanded]
  );
  const expandableNodeIds = React17.useMemo(
    () => expandable ? nodesWithHiddenChildren(view, tier, { expandedNodeIds: effectiveExpanded }) : EMPTY,
    [view, tier, effectiveExpanded, expandable]
  );
  const isExpandable = React17.useCallback(
    (id) => expandableNodeIds.has(id),
    [expandableNodeIds]
  );
  const coverage = React17.useMemo(
    () => ({
      shown: filteredView.nodes.length,
      total: view.nodes.length,
      hidden: Math.max(0, view.nodes.length - filteredView.nodes.length)
    }),
    [filteredView, view]
  );
  return {
    view: filteredView,
    tier,
    coverage,
    setTier: setInternalTier,
    expandedNodeIds,
    toggleNode,
    collapseAll,
    expandableNodeIds,
    isExpandable
  };
}
var EMPTY;
var init_useGraphDetailTier = __esm({
  "src/scene/useGraphDetailTier.ts"() {
    EMPTY = /* @__PURE__ */ new Set();
  }
});
function GraphGroupingOptions({ grouping, within }) {
  const descriptionId = React17.useId();
  const order = grouping.value.dimensions;
  const groupable = GROUPING_DIMENSION_LIST.filter(
    (dimension) => grouping.applicable.has(dimension.id) || order.includes(dimension.id)
  );
  const toggleDimension = (id, on) => {
    const next = on ? [...order.filter((d) => d !== id), id] : order.filter((d) => d !== id);
    grouping.onChange({ ...grouping.value, dimensions: next });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    within && /* @__PURE__ */ jsxs(DropdownMenuLabel, { className: "whitespace-normal text-xs font-normal", children: [
      within,
      " stays in order. Groups repeat within each band; grouping does not filter movements."
    ] }),
    /* @__PURE__ */ jsx(DropdownMenuItem, { onSelect: (event) => {
      event.preventDefault();
      grouping.onChange({ ...grouping.value, dimensions: [] });
    }, children: within ? `${within} only` : "No grouping" }),
    /* @__PURE__ */ jsxs(DropdownMenuLabel, { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ jsx("span", { children: "Group by" }),
      /* @__PURE__ */ jsx("span", { className: "text-xs font-normal text-muted-foreground", children: order.length > 1 ? "Outermost first" : "Pick fields to nest" })
    ] }),
    groupable.map((dimension) => {
      const position = order.indexOf(dimension.id);
      return /* @__PURE__ */ jsx(
        DropdownMenuCheckboxItem,
        {
          "aria-label": dimension.label,
          "aria-describedby": `${descriptionId}-${dimension.id}`,
          checked: position >= 0,
          onCheckedChange: (checked) => toggleDimension(dimension.id, checked === true),
          onSelect: (event) => event.preventDefault(),
          children: /* @__PURE__ */ jsxs("span", { className: "flex w-full items-center justify-between gap-2", children: [
            /* @__PURE__ */ jsxs("span", { children: [
              /* @__PURE__ */ jsx("span", { className: "block", children: dimension.label }),
              /* @__PURE__ */ jsx("span", { id: `${descriptionId}-${dimension.id}`, className: "block text-xs font-normal text-muted-foreground", children: dimension.description })
            ] }),
            position >= 0 && order.length > 1 ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: position + 1 }) : null
          ] })
        },
        dimension.id
      );
    }),
    order.length > 1 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Nesting order" }),
      order.slice(1).map((id, index) => /* @__PURE__ */ jsxs(DropdownMenuItem, { onSelect: (event) => {
        event.preventDefault();
        const next = [...order];
        [next[index], next[index + 1]] = [next[index + 1], next[index]];
        grouping.onChange({ ...grouping.value, dimensions: next });
      }, children: [
        "Move ",
        groupingDimensionLabel(id),
        " before ",
        groupingDimensionLabel(order[index])
      ] }, id))
    ] }) : null,
    /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
    /* @__PURE__ */ jsx("p", { className: "px-2 py-1.5 text-xs text-muted-foreground", children: "Groups arrange the visible addresses. They do not change the trace or prove common ownership. Catalog options appear when matching metadata is available." })
  ] });
}
function GraphGroupingMenu({ grouping, disabled = false, within }) {
  const label = grouping.value.dimensions.map(groupingDimensionLabel).join(" \u2192 ") || "None";
  const displayLabel = within ? `${within}${grouping.value.dimensions.length ? ` \u2192 ${label}` : " only"}` : label;
  return /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        className: "h-7 max-w-72 text-xs",
        disabled,
        "aria-label": `Group by: ${displayLabel}`,
        title: `Group by: ${displayLabel}`,
        children: /* @__PURE__ */ jsxs("span", { className: "truncate", children: [
          "Group: ",
          displayLabel
        ] })
      }
    ) }),
    /* @__PURE__ */ jsx(DropdownMenuContent, { align: "end", className: "w-72 max-h-[80vh] overflow-y-auto", children: /* @__PURE__ */ jsx(GraphGroupingOptions, { grouping, within }) })
  ] });
}
var init_GraphGroupingMenu = __esm({
  "src/settings/GraphGroupingMenu.tsx"() {
    init_grouping();
  }
});
function GraphSettingsMenu({
  detail,
  grouping,
  toggles = [],
  settings = []
}) {
  const showGrouping = Boolean(grouping && (grouping.applicable.size || grouping.value.dimensions.length));
  return /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        "aria-label": "Graph settings",
        title: "Graph settings",
        className: "size-7 p-0",
        children: /* @__PURE__ */ jsx(SettingsIcon, { size: 14 })
      }
    ) }),
    /* @__PURE__ */ jsxs(DropdownMenuContent, { align: "end", className: "w-64 max-h-[80vh] overflow-y-auto", children: [
      detail ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Detail level" }),
        GRAPH_DETAIL_TIERS.map((tier) => {
          const active = tier === detail.value;
          return /* @__PURE__ */ jsxs(
            DropdownMenuItem,
            {
              className: "relative pl-8",
              "aria-checked": active,
              onSelect: (event) => {
                event.preventDefault();
                detail.onChange(tier);
              },
              children: [
                /* @__PURE__ */ jsx("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: active ? /* @__PURE__ */ jsx(CheckIcon, { size: 14 }) : null }),
                GRAPH_DETAIL_TIER_LABELS[tier]
              ]
            },
            tier
          );
        })
      ] }) : null,
      detail && showGrouping ? /* @__PURE__ */ jsx(DropdownMenuSeparator, {}) : null,
      showGrouping && grouping ? /* @__PURE__ */ jsx(GraphGroupingOptions, { grouping }) : null,
      (detail || showGrouping) && toggles.length > 0 ? /* @__PURE__ */ jsx(DropdownMenuSeparator, {}) : null,
      toggles.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Panels" }),
        toggles.map((toggle) => /* @__PURE__ */ jsx(
          DropdownMenuCheckboxItem,
          {
            checked: toggle.visible,
            onCheckedChange: (checked) => toggle.onChange(checked === true),
            onSelect: (event) => event.preventDefault(),
            children: toggle.label
          },
          toggle.key
        ))
      ] }) : null,
      settings.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        detail || showGrouping || toggles.length > 0 ? /* @__PURE__ */ jsx(DropdownMenuSeparator, {}) : null,
        /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Behaviour" }),
        settings.map((setting) => /* @__PURE__ */ jsx(
          DropdownMenuCheckboxItem,
          {
            checked: setting.checked,
            onCheckedChange: (checked) => setting.onChange(checked === true),
            onSelect: (event) => event.preventDefault(),
            children: setting.hint ? /* @__PURE__ */ jsxs("span", { className: "flex flex-col gap-0.5", children: [
              /* @__PURE__ */ jsx("span", { children: setting.label }),
              /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: setting.hint })
            ] }) : setting.label
          },
          setting.key
        ))
      ] }) : null
    ] })
  ] });
}
var init_GraphSettingsMenu = __esm({
  "src/settings/GraphSettingsMenu.tsx"() {
    init_GraphGroupingMenu();
  }
});

// src/share/serialize.ts
function compactGraphState(input) {
  const { nodes: _nodes, edges: _edges, scene: _scene, catalog: _catalog, groups: _groups, ...rest } = input;
  return rest;
}
function graphShareStateHasContent(state) {
  if (!state) return false;
  return Boolean(
    state.scene?.nodes?.length || state.scene?.edges?.length || state.nodes?.length || state.edges?.length || state.rootIds?.length || state.expanded?.length
  );
}
function parseGraphSnapshot(json) {
  try {
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}
var init_serialize = __esm({
  "src/share/serialize.ts"() {
  }
});
function GraphDefaultsProvider({
  value,
  children
}) {
  const outer = React17.useContext(GraphDefaultsContext);
  const merged = React17.useMemo(() => ({ ...outer, ...value }), [outer, value]);
  return /* @__PURE__ */ jsx(GraphDefaultsContext.Provider, { value: merged, children });
}
function useGraphDefaults() {
  return React17.useContext(GraphDefaultsContext);
}
var GRAPH_DEFAULTS_CONTEXT_KEY, GraphDefaultsContext;
var init_GraphDefaults = __esm({
  "src/scene/GraphDefaults.tsx"() {
    GRAPH_DEFAULTS_CONTEXT_KEY = /* @__PURE__ */ Symbol.for("@authe/tx-graph/GraphDefaultsContext");
    GraphDefaultsContext = globalThis[GRAPH_DEFAULTS_CONTEXT_KEY] ??= React17.createContext({});
  }
});
function hiddenLabel(ref) {
  const label = ref.label?.trim();
  if (label) return label;
  const id = ref.kind === "node" ? parseNodeId(ref.id).address : ref.id;
  return shortenIdentifier(id);
}
function HiddenMenu({
  count,
  hidden,
  onUnhide,
  onRestoreAll
}) {
  const perElement = onUnhide && hidden.length > 0;
  if (!perElement) {
    return /* @__PURE__ */ jsxs(
      ToolbarButton,
      {
        shape: "text",
        label: `Restore ${count}`,
        hint: `${count} element${count === 1 ? "" : "s"} hidden`,
        onClick: onRestoreAll,
        children: [
          "Restore ",
          count
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        className: "h-7 px-2 text-xs",
        "aria-label": `${count} element${count === 1 ? "" : "s"} hidden`,
        children: [
          "Hidden ",
          count
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(DropdownMenuContent, { align: "end", className: "w-60", children: [
      /* @__PURE__ */ jsxs(DropdownMenuLabel, { className: "flex flex-col gap-0.5", children: [
        /* @__PURE__ */ jsx("span", { children: "Hidden on this graph" }),
        /* @__PURE__ */ jsx("span", { className: "text-xs font-normal text-muted-foreground", children: "Left out of the view. Nothing was deleted." })
      ] }),
      hidden.map((ref) => /* @__PURE__ */ jsx(
        DropdownMenuItem,
        {
          onSelect: (event) => {
            event.preventDefault();
            onUnhide(ref);
          },
          children: /* @__PURE__ */ jsxs("span", { className: "flex w-full items-center justify-between gap-2", children: [
            /* @__PURE__ */ jsx("span", { className: "truncate", children: hiddenLabel(ref) }),
            /* @__PURE__ */ jsx("span", { className: "shrink-0 text-xs text-muted-foreground", children: ref.kind === "edge" ? "link" : "node" })
          ] })
        },
        `${ref.kind}:${ref.id}`
      )),
      /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
      /* @__PURE__ */ jsxs(DropdownMenuItem, { onSelect: () => onRestoreAll(), children: [
        "Restore all ",
        count
      ] })
    ] })
  ] });
}
function GraphAuthoringBar({
  api,
  selection,
  linking,
  linkSourceLabel,
  onToggleLinking,
  describing,
  onDescribed,
  onAuthored
}) {
  const [draftLabel, setDraftLabel] = React17.useState("");
  const [draftKind, setDraftKind] = React17.useState(DEFAULT_AUTHORED_KIND);
  const [adding, setAdding] = React17.useState(false);
  const [draftChain, setDraftChain] = React17.useState("");
  const chainPickerId = React17.useId();
  const [renaming, setRenaming] = React17.useState(false);
  const [renameLabel, setRenameLabel] = React17.useState("");
  const [reason, setReason] = React17.useState("");
  const describedId = React17.useRef(void 0);
  if (describedId.current !== describing?.id) {
    describedId.current = describing?.id;
    const existing = describing ? api.reasonFor?.({ kind: describing.kind, id: describing.id }) ?? "" : "";
    if (reason !== existing) setReason(existing);
  }
  const commitReason = React17.useCallback(() => {
    onDescribed?.(reason.trim());
    setReason("");
  }, [onDescribed, reason]);
  const commitAdd = React17.useCallback(() => {
    const label = draftLabel.trim();
    if (!label) return;
    const added = api.onAddNode?.({ label, kind: draftKind, chainId: draftChain || null });
    setDraftLabel("");
    setDraftKind(DEFAULT_AUTHORED_KIND);
    setDraftChain("");
    setAdding(false);
    if (added) onAuthored?.({ id: added.id, kind: "node", ask: "added" });
  }, [api, draftLabel, draftKind, draftChain, onAuthored]);
  const commitRename = React17.useCallback(() => {
    const label = renameLabel.trim();
    if (!label || !selection) {
      setRenaming(false);
      return;
    }
    api.onRelabel?.(selection, label);
    setRenaming(false);
    if (!selection.authored) {
      onAuthored?.({ id: selection.id, kind: selection.kind, ask: "renamed" });
    }
  }, [api, renameLabel, selection, onAuthored]);
  const explainSelection = React17.useCallback(() => {
    if (!selection) return;
    onAuthored?.({
      id: selection.id,
      kind: selection.kind,
      ask: selection.kind === "edge" ? "linked" : "added"
    });
  }, [onAuthored, selection]);
  const askedFor = describing ? {
    added: "Why is this on the graph?",
    linked: "Why are these connected?",
    renamed: "Why this name?"
  }[describing.ask] : "";
  const canEdit = selection != null;
  const renameTarget = React17.useRef(selection?.id);
  if (renameTarget.current !== selection?.id) {
    renameTarget.current = selection?.id;
    if (renaming) setRenaming(false);
  }
  const hidden = api.hiddenCount ?? 0;
  const showRestore = hidden > 0 && Boolean(api.onRestoreHidden);
  const showPromote = Boolean(api.onPromote) && api.canPromote === true;
  const published = api.publishedCount ?? 0;
  const showManage = Boolean(api.onManagePublished) && published > 0;
  const showRevert = selection != null && Boolean(api.onRevert) && !selection.authored && (api.isPatched?.(selection) ?? false);
  const showExplain = selection != null && Boolean(api.onExplain) && !describing;
  const showHide = canEdit && Boolean(api.onHide) && !selection.authored;
  const showRemove = canEdit && Boolean(api.onRemove) && selection.authored === true;
  const showPrompt = Boolean(describing && onDescribed);
  if (!api.onAddNode && !api.onConnect && !api.onRelabel && !showHide && !showRemove && !showRevert && !showExplain && !showPrompt && !showRestore && !showPromote && !showManage) {
    return null;
  }
  const controls = /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
    api.onAddNode ? adding ? /* @__PURE__ */ jsxs("span", { className: "flex flex-wrap items-center gap-1", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          autoFocus: true,
          value: draftLabel,
          onChange: (e) => setDraftLabel(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") commitAdd();
            if (e.key === "Escape") setAdding(false);
          },
          placeholder: "Node name\u2026",
          "aria-label": "New node name",
          className: "h-7 w-36 text-xs"
        }
      ),
      /* @__PURE__ */ jsx(
        NativeSelect,
        {
          value: draftKind,
          onChange: (e) => setDraftKind(e.target.value),
          "aria-label": "New node type",
          density: "sm",
          children: AUTHORABLE_NODE_KINDS.map((option) => /* @__PURE__ */ jsx("option", { value: option.kind, children: option.label }, option.kind))
        }
      ),
      /* @__PURE__ */ jsx("label", { htmlFor: chainPickerId, className: "sr-only", children: "New node chain context" }),
      /* @__PURE__ */ jsx(
        ChainSelect,
        {
          id: chainPickerId,
          value: draftChain,
          onChange: setDraftChain,
          valueKind: "caip2",
          offer: "registered",
          includeTestnets: true,
          allowAny: true,
          anyLabel: "Off-chain / no blockchain",
          showAvatar: true,
          className: "w-56"
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "button", size: "sm", className: "h-7 px-2 text-xs", onClick: commitAdd, children: "Add" }),
      /* @__PURE__ */ jsx(Button, { type: "button", size: "sm", variant: "ghost", onClick: () => setAdding(false), children: "Cancel" }),
      draftKind === "situation" && /* @__PURE__ */ jsx("span", { className: "basis-full text-xs text-muted-foreground", children: "Reported incident or hypothesis, not a confirmed detection or an account." })
    ] }) : /* @__PURE__ */ jsx(ToolbarButton, { label: "Add node", onClick: () => setAdding(true), children: /* @__PURE__ */ jsx(PlusIcon, { size: 13 }) }) : null,
    describing && onDescribed ? /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          autoFocus: true,
          value: reason,
          onChange: (e) => setReason(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") commitReason();
            if (e.key === "Escape") onDescribed(null);
          },
          placeholder: askedFor,
          "aria-label": askedFor,
          className: "h-7 w-52 text-xs"
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "button", size: "sm", className: "h-7 px-2 text-xs", onClick: commitReason, children: "Save" }),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "h-7 px-2 text-xs",
          onClick: () => onDescribed(null),
          children: "Skip"
        }
      )
    ] }) : api.onConnect ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        active: linking,
        label: linking ? "Cancel connecting" : "Connect two nodes",
        hint: linking ? linkSourceLabel ? `Click the target node (from ${linkSourceLabel})` : "Click the source node" : void 0,
        onClick: onToggleLinking,
        children: /* @__PURE__ */ jsx(LinkIcon, { size: 13 })
      }
    ) : null,
    canEdit && api.onRelabel ? renaming ? /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          autoFocus: true,
          value: renameLabel,
          onChange: (e) => setRenameLabel(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") commitRename();
            if (e.key === "Escape") setRenaming(false);
          },
          "aria-label": "New name",
          className: "h-7 w-36 text-xs"
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "button", size: "sm", className: "h-7 px-2 text-xs", onClick: commitRename, children: "Save" })
    ] }) : /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Rename",
        hint: `Rename this ${selection.kind}`,
        onClick: () => {
          setRenameLabel(selection.label ?? "");
          setRenaming(true);
        },
        children: "Rename"
      }
    ) : null,
    showExplain && !renaming ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Why",
        hint: api.reasonFor?.(selection) ? "Revise why this is on the graph" : `Say why this ${selection.kind} is on the graph`,
        onClick: explainSelection,
        children: "Why"
      }
    ) : null,
    showRevert ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Restore original name",
        hint: "Drop the rename and show what the decode called it",
        onClick: () => api.onRevert?.(selection),
        children: "Undo rename"
      }
    ) : null,
    showHide ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Hide",
        hint: "Leave this out of the view (reversible)",
        onClick: () => api.onHide?.(selection),
        children: "Hide"
      }
    ) : null,
    showRemove ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Remove",
        hint: "Delete this annotation",
        onClick: () => api.onRemove?.(selection),
        children: "Remove"
      }
    ) : null,
    showRestore ? /* @__PURE__ */ jsx(
      HiddenMenu,
      {
        count: hidden,
        hidden: api.hidden ?? [],
        onUnhide: api.onUnhide,
        onRestoreAll: () => api.onRestoreHidden?.()
      }
    ) : null,
    showManage ? /* @__PURE__ */ jsxs(
      ToolbarButton,
      {
        shape: "text",
        label: `Published ${published}`,
        hint: `${published} published annotation${published === 1 ? "" : "s"} on this graph`,
        onClick: () => api.onManagePublished?.(),
        children: [
          "Published ",
          published
        ]
      }
    ) : null,
    showPromote ? /* @__PURE__ */ jsx(
      ToolbarButton,
      {
        shape: "text",
        label: "Publish",
        hint: "Publish these annotations beyond this case",
        onClick: () => api.onPromote?.(),
        children: "Publish\u2026"
      }
    ) : null
  ] });
  return /* @__PURE__ */ jsx(TooltipProvider, { delayDuration: TOOLBAR_TOOLTIP_DELAY_MS, children: controls });
}
var DEFAULT_AUTHORED_KIND;
var init_GraphAuthoring = __esm({
  "src/scene/GraphAuthoring.tsx"() {
    init_ToolbarButton();
    init_nodeKinds();
    DEFAULT_AUTHORED_KIND = "entity";
  }
});
function legendForElements(nodes, edges, labels = {}) {
  const present = /* @__PURE__ */ new Set();
  for (const edge of edges) {
    if (edge.data?.relation) continue;
    present.add(edge.data?.variant ?? "call");
  }
  const items = GRAPH_EDGE_VARIANTS.filter((v) => present.has(v)).map(
    (variant) => ({
      label: labels[variant] ?? GRAPH_EDGE_VARIANT_LABELS[variant],
      color: GRAPH_EDGE_VARIANT_COLOR[variant],
      shape: variant === "flow" ? "dashed" : "line"
    })
  );
  const hasExpected = edges.some((e) => e.data?.dashed === true) || nodes.some((n) => n.data?.virtual === true);
  if (hasExpected) items.push(EXPECTED_LEGEND_ITEM);
  if (nodes.some((n) => n.data?.origin === "user") && !present.has("authored")) {
    items.push(AUTHORED_LEGEND_ITEM);
  }
  if (nodes.some((n) => n.data?.riskLevel === "high" || n.data?.riskLevel === "severe")) {
    items.push(FLAGGED_LEGEND_ITEM);
  }
  const flagged = new Set(edges.map((e) => e.data?.flag?.kind).filter(Boolean));
  for (const kind of TRANSACTION_FLAG_KINDS) {
    if (!flagged.has(kind)) continue;
    const meta = TRANSACTION_FLAG_META[kind];
    items.push({
      label: meta.legend,
      color: meta.graphEdge === "alert" ? FLAG_ALERT_STROKE : FLAG_DEMOTE_STROKE,
      shape: meta.graphEdge === "alert" ? "line" : "dashed"
    });
  }
  if (nodes.some((n) => typeof n.data?.impersonates === "string")) items.push(LOOKALIKE_LEGEND_ITEM);
  return items;
}
function sceneEdgeLabels(chainIds) {
  const vocabularies = new Set(chainIds.map((chainId) => chainDecodeVocabulary(chainId)));
  const [vocabulary] = vocabularies;
  return vocabularies.size === 1 && vocabulary ? { call: vocabulary.interaction } : {};
}
function SceneGraphView({
  scene,
  cdnBase: cdnBaseProp,
  resolvePlaceholder: resolvePlaceholderProp,
  chainLabel,
  resolveOverlay,
  viewMode,
  defaultViewMode,
  brandAccent: brandAccentProp,
  impersonates,
  flagOf,
  height: heightProp,
  className,
  onNodeClick,
  // Pulled out of `canvasProps` so authoring can select the clicked edge before
  // handing it on. A host that wires its own (the investigation canvas opens its
  // inspector on one) still gets every click.
  onEdgeClick,
  onClusterClick,
  onGroupClick,
  detailTier,
  defaultDetailTier: defaultDetailTierProp,
  decorateElements,
  onDetailTierChange,
  showDetailToggle: showDetailToggleProp,
  enableNodeExpand = true,
  renderHighlights,
  showSummary: showSummaryProp,
  showLegend: showLegendProp,
  extraLegend,
  showStats: showStatsProp,
  showFullscreen: showFullscreenProp,
  showFlowToggle: showFlowToggleProp,
  showEdgeBundleToggle: showEdgeBundleToggleProp,
  showRelayout: showRelayoutProp,
  showMiniMap: showMiniMapProp,
  hiddenPanels: hiddenPanelsProp,
  defaultHiddenPanels,
  onHiddenPanelsChange,
  grouping: groupingProp,
  defaultGrouping: defaultGrouping2,
  groupingContext,
  onGroupingChange,
  showGroupingControl: showGroupingControlProp,
  showSearch: showSearchProp,
  showExport: showExportProp,
  search: searchProp,
  defaultSearchQuery,
  graphId,
  seed,
  onApplyView,
  showViewsBar = true,
  editable = false,
  authoring,
  settingToggles,
  // `legend` is a host override for the auto-derived edge legend below.
  legend: legendOverride,
  ...canvasProps
}) {
  const defaults = useGraphDefaults();
  const height = useGraphHeight(heightProp);
  const cdnBase = cdnBaseProp ?? defaults.cdnBase;
  const resolvePlaceholder = resolvePlaceholderProp ?? defaults.resolvePlaceholder;
  const brandAccent = brandAccentProp ?? defaults.brandAccent;
  const defaultDetailTier = defaultDetailTierProp ?? defaults.defaultDetailTier;
  const showDetailToggle = showDetailToggleProp ?? defaults.showDetailToggle ?? true;
  const showSummary = showSummaryProp ?? defaults.showSummary ?? true;
  const showLegend = showLegendProp ?? defaults.showLegend ?? true;
  const showStats = showStatsProp ?? defaults.showStats ?? false;
  const showFullscreen = showFullscreenProp ?? defaults.showFullscreen ?? true;
  const showFlowToggle = showFlowToggleProp ?? defaults.showFlowToggle ?? true;
  const showEdgeBundleToggle = showEdgeBundleToggleProp ?? defaults.showEdgeBundleToggle ?? true;
  const showRelayout = showRelayoutProp ?? defaults.showRelayout ?? true;
  const showMiniMap = showMiniMapProp ?? defaults.showMiniMap ?? true;
  const showGroupingControl = showGroupingControlProp ?? defaults.showGroupingControl ?? true;
  const showSearch = showSearchProp ?? defaults.showSearch ?? true;
  const showExport = showExportProp ?? defaults.showExport ?? true;
  const searchSpec = searchProp ?? defaults.search;
  const highlights = React17.useMemo(
    () => parseKeyAttributeGroups(scene.highlights),
    [scene.highlights]
  );
  const [internalHidden, setInternalHidden] = React17.useState(
    () => defaultHiddenPanels ?? []
  );
  const hiddenList = hiddenPanelsProp ?? internalHidden;
  const isHidden = React17.useCallback(
    (key) => hiddenList.includes(key),
    [hiddenList]
  );
  const setHiddenPanels = React17.useCallback(
    (next) => {
      if (hiddenPanelsProp === void 0) setInternalHidden(next);
      onHiddenPanelsChange?.(next);
    },
    [hiddenPanelsProp, onHiddenPanelsChange]
  );
  const setPanelVisible = React17.useCallback(
    (key, visible) => {
      const next = visible ? hiddenList.filter((k) => k !== key) : [...hiddenList, key];
      if (next.length === hiddenList.length && visible) return;
      if (!visible && hiddenList.includes(key)) return;
      setHiddenPanels(next);
    },
    [hiddenList, setHiddenPanels]
  );
  const [internalGrouping, setInternalGrouping] = React17.useState(
    () => defaultGrouping2 ?? defaults.grouping
  );
  const grouping = groupingProp ?? internalGrouping;
  const setGrouping = React17.useCallback(
    (next) => {
      if (groupingProp === void 0) setInternalGrouping(next);
      onGroupingChange?.(next);
    },
    [groupingProp, onGroupingChange]
  );
  const groupedScene = React17.useMemo(
    () => grouping ? applyGrouping(scene, grouping, { ...groupingContext, resolveOverlay }) : scene,
    [scene, grouping, groupingContext, resolveOverlay]
  );
  const sceneViewOptions = React17.useMemo(
    () => ({ cdnBase, resolvePlaceholder, chainLabel, resolveOverlay }),
    [cdnBase, resolvePlaceholder, chainLabel, resolveOverlay]
  );
  const fullView = React17.useMemo(
    () => toSceneView(groupedScene, sceneViewOptions),
    [groupedScene, sceneViewOptions]
  );
  const detail = useGraphDetailTier(fullView, {
    tier: detailTier,
    defaultTier: defaultDetailTier,
    expandable: enableNodeExpand
  });
  const { nodes, edges, groups, layoutHint } = React17.useMemo(() => {
    const elements = sceneViewToElements(detail.view, { brandAccent, impersonates, flagOf });
    return decorateElements ? decorateElements(elements) : elements;
  }, [detail.view, brandAccent, impersonates, flagOf, decorateElements]);
  const bandApi = React17.useMemo(() => {
    if (!onGroupClick) return null;
    return {
      enabled: true,
      open: (groupId) => {
        const group = groups.find((candidate) => candidate.id === groupId);
        if (group) {
          onGroupClick({ id: groupId, label: group.label, memberIds: group.memberNodeIds });
        }
      }
    };
  }, [onGroupClick, groups]);
  const search = useGraphSearch(nodes, searchSpec ?? EMPTY_SEARCH_SPEC, {
    initialQuery: defaultSearchQuery
  });
  const legend = React17.useMemo(() => {
    const base = legendOverride ?? (showLegend ? legendForElements(nodes, edges, sceneEdgeLabels(scene.chain_ids ?? [])) : []);
    const extra = showLegend || legendOverride ? extraLegend ?? [] : [];
    if (base.length === 0 && extra.length === 0) return void 0;
    const taggedBase = extra.length > 0 ? base.map((item) => item.group ? item : { ...item, group: "Edge types" }) : base;
    return [...taggedBase, ...extra];
  }, [legendOverride, showLegend, nodes, edges, extraLegend, scene.chain_ids]);
  const [appliedMode, setAppliedMode] = React17.useState(
    defaultViewMode
  );
  const canvasContainerRef = React17.useRef(null);
  const canvasRoom = useCanvasRoom(canvasContainerRef);
  const [legendOpened, setLegendOpened] = React17.useState(false);
  const resolvedMode = viewMode ?? appliedMode ?? (VIEW_MODES.has(layoutHint) ? layoutHint : "hierarchical");
  const authoringOn = editable && authoring != null;
  const [linking, setLinking] = React17.useState(false);
  const [linkSource, setLinkSource] = React17.useState();
  const handleNodeMoved = React17.useMemo(
    () => authoringOn && authoring?.onMove ? authoring.onMove : void 0,
    [authoringOn, authoring]
  );
  const pinnedPositions = React17.useMemo(() => {
    const pins = {};
    for (const node of fullView.nodes) {
      if (node.position) pins[node.id] = node.position;
    }
    return pins;
  }, [fullView.nodes]);
  const [describing, setDescribing] = React17.useState();
  const [selection, setSelection] = React17.useState();
  const toggleLinking = React17.useCallback(() => {
    setLinking((on) => !on);
    setLinkSource(void 0);
  }, []);
  const connect = React17.useCallback(
    (source, target) => {
      const drawn = authoring?.onConnect?.(source, target);
      setDescribing(
        drawn ? { id: drawn.id, kind: "edge", ask: "linked", nameless: true } : void 0
      );
      return drawn;
    },
    [authoring]
  );
  const describe = React17.useCallback(
    (reason) => {
      if (describing && reason !== null) {
        const target = { kind: describing.kind, id: describing.id };
        authoring?.onExplain?.(target, reason);
        if (reason && describing.nameless) authoring?.onRelabel?.(target, reason);
      }
      setDescribing(void 0);
    },
    [authoring, describing]
  );
  const handleNodeClick = React17.useMemo(() => {
    if (!authoringOn && !onNodeClick && !onClusterClick) return void 0;
    return (node) => {
      if (authoringOn && linking) {
        if (!linkSource) {
          setLinkSource(node);
          return;
        }
        if (linkSource.id !== node.id) connect(linkSource.id, node.id);
        setLinking(false);
        setLinkSource(void 0);
        return;
      }
      const members = node.data?.memberIds;
      if (node.data?.cluster && members && members.length > 0) {
        onClusterClick?.({ id: node.id, label: node.data.label, memberIds: members });
        return;
      }
      if (authoringOn) {
        setSelection({
          kind: "node",
          id: node.id,
          authored: node.data?.origin === "user",
          label: node.data?.label
        });
      }
      onNodeClick?.(node.id);
    };
  }, [authoringOn, linking, linkSource, connect, onNodeClick, onClusterClick]);
  const handleEdgeClick = React17.useMemo(() => {
    if (!authoringOn && !onEdgeClick) return void 0;
    return (edge) => {
      if (authoringOn && !linking && !edge.data?.aggregated) {
        setSelection({
          kind: "edge",
          // A transfer drawn out of a folded arrow annotates the arrow it came
          // from — that is the id the scene (and the annotation layer) holds.
          id: annotatableEdgeId(edge),
          authored: edge.data?.origin === "user",
          label: edge.data?.label
        });
      }
      onEdgeClick?.(edge);
    };
  }, [authoringOn, linking, onEdgeClick]);
  const handleConnect = React17.useMemo(
    () => authoringOn ? connect : void 0,
    [authoringOn, connect]
  );
  const liveSelection = React17.useMemo(() => {
    if (!selection) return void 0;
    const live = selection.kind === "edge" ? edges.find((e) => e.id === selection.id) : nodes.find((n) => n.id === selection.id);
    if (!live) return void 0;
    const label = live.data?.label;
    return label === selection.label ? selection : { ...selection, label };
  }, [selection, nodes, edges]);
  const setTier = React17.useCallback(
    (tier) => {
      detail.setTier(tier);
      onDetailTierChange?.(tier);
    },
    [detail, onDetailTierChange]
  );
  const catalogSnapshot = React17.useMemo(
    () => freezeCatalogSnapshot(scene, resolveOverlay),
    [scene, resolveOverlay]
  );
  const shareState = React17.useMemo(
    () => ({
      viewMode: resolvedMode,
      detailTier: detail.tier,
      hiddenPanels: [...hiddenList],
      ...grouping ? { grouping } : {},
      ...search.query.trim() ? { search: search.query } : {},
      scene,
      // The overlay this graph is being READ with, frozen alongside it. This is
      // the surface that resolves overlays, so it is the only place that can:
      // by the time a view reaches the share dialog the resolver is long gone,
      // which is why `owner_snapshot` had nothing to hand back.
      ...catalogSnapshot ? { catalog: catalogSnapshot } : {},
      // The re-fetch recipe, when the host has said what this graph IS. It rides
      // the same state the snapshot does, so one saved view backs both halves of
      // the share matrix.
      ...seed ? {
        resource: seed.resource,
        rootIds: [...seed.rootIds],
        ...seed.expandedIds?.length ? { expanded: [...seed.expandedIds] } : {},
        ...seed.filters ? { filters: seed.filters } : {}
      } : {}
    }),
    [resolvedMode, detail.tier, hiddenList, grouping, search.query, scene, catalogSnapshot, seed]
  );
  const openedWith = React17.useRef(null);
  if (openedWith.current === null) {
    openedWith.current = {
      viewMode: defaultViewMode,
      detailTier: defaultDetailTier ?? scene.default_detail_tier,
      hiddenPanels: [...defaultHiddenPanels ?? []],
      grouping: defaultGrouping2 ?? defaults.grouping,
      search: ""
    };
  }
  const applyView = React17.useCallback(
    (state) => {
      if (onApplyView) {
        onApplyView(state);
        return;
      }
      const next = state ?? openedWith.current;
      setAppliedMode(next.viewMode);
      if (next.detailTier) setTier(next.detailTier);
      setHiddenPanels([...next.hiddenPanels ?? []]);
      if (next.grouping) setGrouping(next.grouping);
      search.setQuery(next.search ?? "");
    },
    [onApplyView, setTier, setHiddenPanels, setGrouping, search]
  );
  const expandApi = React17.useMemo(
    () => ({
      enabled: enableNodeExpand,
      isExpandable: detail.isExpandable,
      isExpanded: (id) => detail.expandedNodeIds.has(id),
      toggle: detail.toggleNode
    }),
    [enableNodeExpand, detail.isExpandable, detail.expandedNodeIds, detail.toggleNode]
  );
  const legendAvailable = Boolean(legend && legend.length > 0);
  const highlightsAvailable = Boolean(renderHighlights) && highlights.length > 0;
  const statsAvailable = showStats;
  const minimapAvailable = showMiniMap && resolvedMode !== "force" && nodes.length > 0;
  const showLegendPanel = legendAvailable && !isHidden("legend");
  const showStatsPanel = statsAvailable && !isHidden("stats");
  const showHighlightsPanel = highlightsAvailable && !isHidden("highlights");
  const showMiniMapPanel = minimapAvailable && !isHidden("minimap");
  const panelToggles = [];
  const addToggle = (key, visible) => {
    panelToggles.push({
      key,
      label: GRAPH_PANEL_LABELS[key],
      visible,
      onChange: (v) => setPanelVisible(key, v)
    });
  };
  if (legendAvailable) addToggle("legend", showLegendPanel);
  if (highlightsAvailable) addToggle("highlights", showHighlightsPanel);
  if (statsAvailable) addToggle("stats", showStatsPanel);
  if (minimapAvailable) addToggle("minimap", showMiniMapPanel);
  const detailControl = showDetailToggle ? { value: detail.tier, onChange: setTier } : void 0;
  const applicable = React17.useMemo(
    () => applicableDimensions(scene, { ...groupingContext, resolveOverlay }),
    [scene, groupingContext, resolveOverlay]
  );
  const groupingControl = showGroupingControl ? { value: grouping ?? { dimensions: [] }, onChange: setGrouping, applicable } : void 0;
  const hostSettings = React17.useMemo(() => [...settingToggles ?? []], [settingToggles]);
  const settingsGear = detailControl || groupingControl || panelToggles.length > 0 || hostSettings.length > 0 ? /* @__PURE__ */ jsx(
    GraphSettingsMenu,
    {
      detail: detailControl,
      grouping: groupingControl,
      toggles: panelToggles,
      settings: hostSettings
    }
  ) : void 0;
  const authoringBar = authoringOn ? /* @__PURE__ */ jsx(
    GraphAuthoringBar,
    {
      api: authoring,
      selection: liveSelection,
      linking,
      linkSourceLabel: linkSource?.data?.label,
      onToggleLinking: toggleLinking,
      describing,
      onDescribed: describe,
      onAuthored: setDescribing
    }
  ) : null;
  const searchBox = showSearch ? /* @__PURE__ */ jsx(GraphSearchBox, { search }) : null;
  const exportMenu = showExport ? /* @__PURE__ */ jsx(
    GraphExportMenu,
    {
      graph: shareState,
      containerRef: canvasContainerRef,
      filenameBase: graphId ?? "graph",
      ...defaults.exportContext ? { exportContext: defaults.exportContext } : {}
    }
  ) : null;
  const viewsBar = showViewsBar && defaults.renderViewsBar ? defaults.renderViewsBar({ graphId, state: shareState, onApplyState: applyView }) : null;
  const toolbarExtra = viewsBar || authoringBar || searchBox || exportMenu || settingsGear ? /* @__PURE__ */ jsxs(Fragment, { children: [
    viewsBar,
    authoringBar,
    searchBox,
    exportMenu,
    settingsGear
  ] }) : void 0;
  const hasCanvasToolbar = showFullscreen || showFlowToggle || showEdgeBundleToggle || showRelayout || toolbarExtra != null;
  const canvasInner = /* @__PURE__ */ jsxs(Fragment, { children: [
    showLegendPanel && legend ? (
      // `pointer-events-none` so panning still passes through the legend's box;
      // the `GraphLegend` root and its × button re-enable events where needed.
      /* @__PURE__ */ jsx("div", { className: cn("pointer-events-none absolute right-2 z-10", hasCanvasToolbar ? "top-12" : "top-2"), children: canvasRoom || legendOpened ? /* @__PURE__ */ jsx(
        GraphLegend,
        {
          items: legend,
          onClose: canvasRoom ? () => setPanelVisible("legend", false) : () => setLegendOpened(false)
        }
      ) : /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "pointer-events-auto rounded-md border bg-card/90 px-2 py-1 text-xs font-medium text-foreground shadow-xs backdrop-blur hover:bg-card",
          "aria-expanded": false,
          onClick: () => setLegendOpened(true),
          children: "Legend"
        }
      ) })
    ) : null,
    showStatsPanel ? /* @__PURE__ */ jsx("div", { className: "absolute bottom-2 left-2 z-10 max-w-[16rem]", children: /* @__PURE__ */ jsx(GraphStatsPanel, { nodes, edges, onClose: () => setPanelVisible("stats", false) }) }) : null,
    nodes.length === 0 ? (
      // Not a failure: a message-only receive or an approval genuinely has
      // nothing to draw. The backend says WHICH kind of nothing on
      // `attributes.empty_reason`, and rendering that is the difference
      // between an answer and a blank frame that reads as a broken build.
      /* @__PURE__ */ jsx(
        GraphEmptyState,
        {
          reason: fullView.emptyReason,
          className: "pointer-events-none absolute inset-0 z-10"
        }
      )
    ) : null,
    /* @__PURE__ */ jsx(GraphExpandContext.Provider, { value: expandApi, children: /* @__PURE__ */ jsx(GraphGroupBandContext.Provider, { value: bandApi, children: /* @__PURE__ */ jsx(
      GraphCanvas,
      {
        ...canvasProps,
        containerRef: canvasContainerRef,
        nodes,
        edges,
        chainGroups: groups,
        viewMode: resolvedMode,
        showMiniMap: showMiniMapPanel,
        showFullscreen,
        showFlowToggle,
        showEdgeBundleToggle,
        showRelayout,
        extraToolbar: toolbarExtra,
        searchQuery: search.query || canvasProps.searchQuery,
        focusNodeId: search.focusId ?? canvasProps.focusNodeId,
        onNodeClick: handleNodeClick,
        onEdgeClick: handleEdgeClick,
        showFlowChooser: Boolean(onEdgeClick),
        onClearEdgeSelection: () => {
          setSelection((current) => current?.kind === "edge" ? void 0 : current);
          canvasProps.onClearEdgeSelection?.();
        },
        onConnect: handleConnect,
        pinnedPositions,
        onNodePositionChange: handleNodeMoved
      }
    ) }) })
  ] });
  const summarySource = showSummary ? scene.summary?.trim() || void 0 : void 0;
  const summary = React17.useMemo(
    () => summarySource ? displayChainText(summarySource, { maxChars: 240 }) : void 0,
    [summarySource]
  );
  const summaryText = summary?.text;
  const incompleteFlows = ["partial", "unsupported_family"].includes(String(scene.attributes?.flow_coverage));
  const allocatedFlows = scene.attributes?.flow_basis === "includes_balance_allocations";
  const nextTier = React17.useMemo(() => {
    const order = GRAPH_DETAIL_TIERS;
    const at = order.indexOf(detail.tier);
    return at >= 0 && at < order.length - 1 ? order[at + 1] : void 0;
  }, [detail.tier]);
  const coverageNote = showDetailToggle && detail.coverage.hidden > 0 && nextTier ? /* @__PURE__ */ jsxs(
    "p",
    {
      className: "flex flex-wrap items-center gap-x-1.5 text-2xs text-muted-foreground",
      "data-testid": "scene-detail-coverage",
      children: [
        /* @__PURE__ */ jsxs("span", { children: [
          GRAPH_DETAIL_TIER_LABELS[detail.tier],
          " detail \u2014 including",
          " ",
          detail.coverage.shown.toLocaleString(),
          " of ",
          detail.coverage.total.toLocaleString(),
          " ",
          "nodes before grouping."
        ] }),
        /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: () => setTier(nextTier),
            className: "underline underline-offset-2 hover:text-foreground",
            title: `Draw this graph at the ${GRAPH_DETAIL_TIER_LABELS[nextTier] ?? nextTier} detail level.`,
            children: [
              "Show ",
              (GRAPH_DETAIL_TIER_LABELS[nextTier] ?? nextTier).toLowerCase()
            ]
          }
        )
      ]
    }
  ) : null;
  if (!summaryText && !showHighlightsPanel && !coverageNote && !incompleteFlows && !allocatedFlows) {
    return /* @__PURE__ */ jsx("div", { className, style: { position: "relative", height }, children: canvasInner });
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className,
      style: { height, display: "flex", flexDirection: "column", minHeight: 0, gap: "0.75rem" },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: "space-y-2 px-3 pt-1",
            style: { maxHeight: "45%", minHeight: 0, flex: "0 1 auto", overflowY: "auto" },
            children: [
              summaryText ? /* @__PURE__ */ jsx(
                "p",
                {
                  className: "text-sm font-medium text-foreground",
                  "data-testid": "scene-intent",
                  title: summary?.title,
                  children: summaryText
                }
              ) : null,
              showHighlightsPanel ? /* @__PURE__ */ jsxs("div", { className: "relative", children: [
                /* @__PURE__ */ jsx(
                  PanelCloseButton,
                  {
                    className: "absolute right-0 top-0 z-10",
                    onClick: () => setPanelVisible("highlights", false),
                    label: "Hide transaction highlights"
                  }
                ),
                /* @__PURE__ */ jsx("div", { className: "pr-5", children: renderHighlights(highlights) })
              ] }) : null,
              coverageNote,
              allocatedFlows ? /* @__PURE__ */ jsx("p", { role: "status", className: "text-xs text-muted-foreground", "data-testid": "scene-flow-basis", children: "Reconstructed allocations \u2014 some edges describe transaction-local routing, not individually observed wallet transfers." }) : null,
              incompleteFlows ? /* @__PURE__ */ jsx("p", { role: "status", className: "text-xs text-muted-foreground", "data-testid": "scene-flow-coverage", children: "Partial transfer coverage \u2014 some movements could not be reconstructed. Shown flows are not a complete balance reconciliation." }) : null
            ]
          }
        ),
        /* @__PURE__ */ jsx("div", { style: { position: "relative", flex: "1 1 0%", minHeight: 0 }, children: canvasInner })
      ]
    }
  );
}
var VIEW_MODES, EMPTY_SEARCH_SPEC, EXPECTED_LEGEND_ITEM, FLAGGED_LEGEND_ITEM, AUTHORED_LEGEND_ITEM, LOOKALIKE_LEGEND_ITEM;
var init_SceneGraphView = __esm({
  "src/scene/SceneGraphView.tsx"() {
    init_GraphCanvas();
    init_edgeBundling();
    init_edges();
    init_GraphEmptyState();
    init_grouping();
    init_search();
    init_GraphExportMenu();
    init_catalogSnapshot();
    init_toScene();
    init_GraphLegend();
    init_GraphStatsPanel();
    init_PanelCloseButton();
    init_expandControl();
    init_canvasRoom();
    init_groupBandControl();
    init_useGraphDetailTier();
    init_GraphSettingsMenu();
    init_GraphDefaults();
    init_GraphAuthoring();
    VIEW_MODES = /* @__PURE__ */ new Set(["hierarchical", "temporal", "force"]);
    EMPTY_SEARCH_SPEC = {};
    EXPECTED_LEGEND_ITEM = {
      label: "Expected (not yet observed)",
      // The neutral/muted token the dashed synthesized elements read as (mirrors the
      // `default` edge variant); the *dashed* shape is what carries the meaning.
      color: "hsl(var(--muted-foreground))",
      shape: "dashed"
    };
    FLAGGED_LEGEND_ITEM = {
      label: "Flagged address",
      color: "hsl(var(--risk-critical))",
      shape: "line"
    };
    AUTHORED_LEGEND_ITEM = {
      // Matches `AUTHORED_ACCENT_CLASS` / the `authored` edge variant token, so one
      // colour means "somebody asserted this" throughout the graph.
      label: "Analyst-added",
      color: "hsl(var(--risk-medium))",
      shape: "line"
    };
    LOOKALIKE_LEGEND_ITEM = {
      label: "Lookalike \u22EF the address it imitates",
      color: FLAG_DEMOTE_STROKE,
      shape: "dot"
    };
  }
});
function mergeNeighborhood(nodes, edges, incoming) {
  const nodeIds = new Set(nodes.map((n) => n.id));
  const edgeIds = new Set(edges.map((e) => e.id));
  return {
    nodes: [...nodes, ...incoming.nodes.filter((n) => !nodeIds.has(n.id))],
    edges: [...edges, ...incoming.edges.filter((e) => !edgeIds.has(e.id))]
  };
}
function useGraphLiveUpdates(options) {
  const { channel, parse, onUpdate, enabled = true } = options;
  const parseRef = React17.useRef(parse);
  parseRef.current = parse;
  const onUpdateRef = React17.useRef(onUpdate);
  onUpdateRef.current = onUpdate;
  const handleMessage = React17.useCallback((message) => {
    const neighborhood = parseRef.current(message);
    if (neighborhood && (neighborhood.nodes.length || neighborhood.edges.length)) {
      onUpdateRef.current(neighborhood, message);
    }
  }, []);
  useStream(channel, { onMessage: handleMessage, enabled });
}
var init_useGraphLiveUpdates = __esm({
  "src/live/useGraphLiveUpdates.ts"() {
  }
});
function useGraphChangeHistory(graph, scope, options = {}) {
  const historyLimit = Math.max(1, options.historyLimit ?? LIVE_GRAPH_DEFAULTS.historyLimit);
  const highlightMs = Math.max(0, options.highlightMs ?? LIVE_GRAPH_DEFAULTS.highlightMs);
  const evidenceKey = graphEvidenceKey(graph);
  const previous = React17.useRef({ graph, scope });
  const sequence = React17.useRef(0);
  const [history, setHistory] = React17.useState([]);
  const [recent, setRecent] = React17.useState([]);
  React17.useEffect(() => {
    const old = previous.current;
    previous.current = { graph, scope };
    if (old.scope !== scope) {
      sequence.current = 0;
      setHistory([]);
      setRecent([]);
      return;
    }
    const changes = diffGraphEvidence(old.graph, graph);
    if (!changes.length) return;
    const observedAt = Date.now();
    const events = changes.map((change) => ({ ...change, sequence: ++sequence.current, observedAt })).reverse();
    setHistory((items) => [...events, ...items].slice(0, historyLimit));
    const changedIds = new Set(changes.map((change) => `${change.element}:${change.id}`));
    setRecent((items) => [...events, ...items.filter((item) => !changedIds.has(`${item.element}:${item.id}`))].slice(0, historyLimit));
  }, [evidenceKey, scope, historyLimit]);
  React17.useEffect(() => {
    if (!recent.length) return;
    const nextExpiry = Math.min(...recent.map((change) => change.observedAt + highlightMs));
    const timer = setTimeout(() => setRecent((items) => items.filter((item) => item.observedAt + highlightMs > Date.now())), Math.max(0, nextExpiry - Date.now()));
    return () => clearTimeout(timer);
  }, [recent, highlightMs]);
  return { history, recent, evidenceKey };
}
var LIVE_GRAPH_DEFAULTS;
var init_useGraphChangeHistory = __esm({
  "src/live/useGraphChangeHistory.ts"() {
    init_graphChanges();
    LIVE_GRAPH_DEFAULTS = { historyLimit: 100, highlightMs: 6e3 };
  }
});

// src/live/index.ts
var init_live = __esm({
  "src/live/index.ts"() {
    init_useGraphLiveUpdates();
    init_graphChanges();
    init_useGraphChangeHistory();
  }
});

// src/share/LiveGraphLayer.tsx
var LiveGraphLayer_exports = {};
__export(LiveGraphLayer_exports, {
  default: () => LiveGraphLayer_default
});
function SubscribedGraphLayer({
  channel,
  nodesRef,
  edgesRef,
  parse,
  onMerge
}) {
  const descriptor = React17.useMemo(
    () => channel.query ? channel : subscribeDescriptor(channel.id),
    [channel]
  );
  useGraphLiveUpdates({
    channel: descriptor,
    parse,
    onUpdate: (incoming) => {
      onMerge(mergeNeighborhood(nodesRef.current, edgesRef.current, incoming));
    }
  });
  return null;
}
function LiveGraphLayer(props) {
  const client = useOptionalStreamingClient();
  if (!client) return null;
  return /* @__PURE__ */ jsx(SubscribedGraphLayer, { ...props });
}
var LiveGraphLayer_default;
var init_LiveGraphLayer = __esm({
  "src/share/LiveGraphLayer.tsx"() {
    init_live();
    LiveGraphLayer_default = LiveGraphLayer;
  }
});
function emptyScene(options = {}) {
  const { kind = "semantic", layoutHint = "hierarchical" } = options;
  return {
    version: "1",
    kind,
    summary: null,
    nodes: [],
    edges: [],
    groups: [],
    highlights: [],
    chain_ids: [],
    multi_chain: false,
    layout_hint: layoutHint,
    default_detail_tier: "compact",
    attributes: {}
  };
}
function unionMembers(existing, next) {
  const members = [...existing.member_node_ids];
  const seen = new Set(members);
  for (const member of next.member_node_ids) {
    if (!seen.has(member)) {
      members.push(member);
      seen.add(member);
    }
  }
  return { ...existing, member_node_ids: members };
}
function rawOf(edge) {
  const raw = edge.asset?.amount_raw;
  if (raw == null || raw === "") return void 0;
  try {
    return BigInt(String(raw).trim());
  } catch {
    return void 0;
  }
}
function usdOf(edge) {
  const usd = edge.asset?.usd;
  if (usd == null || usd === "") return void 0;
  const parsed = Number(usd);
  return Number.isFinite(parsed) ? parsed : void 0;
}
function refsOf(members) {
  const byId = /* @__PURE__ */ new Map();
  for (const member of members) {
    for (const ref of mergedTxRefs(member.attributes)) {
      const seen = byId.get(ref.id);
      if (seen) {
        if (seen.amount_raw != null && ref.amount_raw != null) {
          seen.amount_raw = (BigInt(seen.amount_raw) + BigInt(ref.amount_raw)).toString();
        }
        continue;
      }
      if (byId.size >= MERGED_TXS_LIMIT) continue;
      byId.set(ref.id, { ...ref });
    }
  }
  return [...byId.values()];
}
function txCountOf(node) {
  const value = node.attributes?.[TX_COUNT_ATTR];
  return typeof value === "number" && value > 0 ? value : 1;
}
function recounted(node, count) {
  if (count === txCountOf(node)) return node;
  return {
    ...node,
    sublabel: isTxCountSublabel(node.sublabel) ? txCountSublabel(count) : node.sublabel,
    attributes: { ...node.attributes, [TX_COUNT_ATTR]: count }
  };
}
function stampTx(scene, ref) {
  if (!ref) return scene;
  let changed = false;
  const edges = scene.edges.map((edge) => {
    if (!FOLDABLE_EDGE_KINDS.has(edge.kind) || edge.attributes?.[MERGED_TXS_ATTR] !== void 0) {
      return edge;
    }
    changed = true;
    const amount = edge.asset?.amount_raw;
    const own = amount ? { ...ref, amount_raw: String(amount) } : ref;
    return { ...edge, attributes: { ...edge.attributes, [MERGED_TXS_ATTR]: [own] } };
  });
  return changed ? { ...scene, edges } : scene;
}
function foldKey(edge) {
  return `${edge.source}\0${edge.target}\0${edge.asset?.token_address || "native"}`;
}
function foldedEdge(members, total) {
  const first = members[0];
  let asset = first.asset;
  if (asset) {
    const usd = members.map(usdOf);
    asset = {
      ...asset,
      // `null` total: members with no amount, combined only because they are
      // the same arrow. There is nothing to sum, so nothing is claimed.
      amount_raw: total === null ? null : total.toString(),
      amount: total !== null && asset.decimals != null ? formatUnits(total, asset.decimals) : null,
      usd: total !== null && usd.every((v) => v !== void 0) ? String(usd.reduce((a, b) => a + (b ?? 0), 0)) : null,
      min_amount_raw: null,
      min_amount: null,
      max_amount_raw: null,
      max_amount: null
    };
  }
  const { netted: _n, net_zero: _z, ...attributes } = first.attributes ?? {};
  if (members.some((m) => m.attributes?.netted === true)) attributes.netted = true;
  if (members.every((m) => m.attributes?.net_zero === true)) attributes.net_zero = true;
  const via = [];
  for (const member of members) {
    const hops = member.attributes?.compressed_via;
    if (!Array.isArray(hops)) continue;
    for (const hop of hops) if (typeof hop === "string" && !via.includes(hop)) via.push(hop);
  }
  if (via.length > 0) attributes.compressed_via = via;
  attributes[MERGED_COUNT_ATTR] = members.reduce((n, m) => n + mergedCount(m.attributes), 0);
  const refs = refsOf(members);
  if (refs.length > 0) attributes[MERGED_TXS_ATTR] = refs;
  else delete attributes[MERGED_TXS_ATTR];
  return {
    ...first,
    asset,
    label: members.every((m) => m.label === first.label) ? first.label : null,
    facts: [],
    // An arrow standing for at least one OBSERVED movement is observed.
    origin: members.some((m) => m.origin === "decoded") ? "decoded" : first.origin,
    attributes
  };
}
function foldValueEdges(edges) {
  const slots = [];
  const buckets = /* @__PURE__ */ new Map();
  const unpriced = /* @__PURE__ */ new Map();
  const seenIds = /* @__PURE__ */ new Set();
  for (const edge of edges) {
    if (!FOLDABLE_EDGE_KINDS.has(edge.kind)) {
      if (seenIds.has(edge.id)) continue;
      seenIds.add(edge.id);
      slots.push({ edge });
      continue;
    }
    const raw = rawOf(edge);
    if (raw === void 0) {
      const key2 = `id\0${edge.id}`;
      const bucket2 = unpriced.get(key2);
      if (bucket2) bucket2.push(edge);
      else {
        unpriced.set(key2, [edge]);
        slots.push({ unpriced: key2 });
      }
      continue;
    }
    const key = foldKey(edge);
    const bucket = buckets.get(key);
    if (bucket) {
      bucket.members.push(edge);
      bucket.total += raw;
    } else {
      buckets.set(key, { members: [edge], total: raw });
      slots.push({ bucket: key });
    }
  }
  const pricedById = /* @__PURE__ */ new Map();
  for (const [key, bucket] of buckets) pricedById.set(bucket.members[0].id, key);
  const joined = /* @__PURE__ */ new Map();
  const joinedInto = /* @__PURE__ */ new Map();
  for (const [key, members] of unpriced) {
    const bucketKey = pricedById.get(members[0].id);
    if (bucketKey === void 0) continue;
    joined.set(bucketKey, members);
    joinedInto.set(key, bucketKey);
  }
  const placed = /* @__PURE__ */ new Set();
  const out = [];
  const placeBucket = (key) => {
    if (placed.has(key)) return;
    placed.add(key);
    out.push(pricedEdge(key));
  };
  for (const slot of slots) {
    if ("edge" in slot) out.push(slot.edge);
    else if ("bucket" in slot) placeBucket(slot.bucket);
    else if (joinedInto.has(slot.unpriced)) placeBucket(joinedInto.get(slot.unpriced));
    else {
      const members = unpriced.get(slot.unpriced);
      out.push(members.length === 1 ? members[0] : foldedEdge(members, null));
    }
  }
  return out;
  function pricedEdge(key) {
    const { members, total } = buckets.get(key);
    const extra = joined.get(key);
    if (extra) return foldedEdge([...members, ...extra], null);
    return members.length === 1 ? members[0] : foldedEdge(members, total);
  }
}
function mergeScenes(scenes, options = {}) {
  const first = scenes[0];
  if (!first) return emptyScene(options);
  if (scenes.length === 1) return first;
  const { kind = "semantic", layoutHint = "hierarchical", foldValueEdges: fold = false } = options;
  const nodesById = /* @__PURE__ */ new Map();
  const edgesById = /* @__PURE__ */ new Map();
  const groupsById = /* @__PURE__ */ new Map();
  const txCounts = /* @__PURE__ */ new Map();
  const summaries = [];
  for (const scene of scenes) {
    for (const node of scene.nodes) {
      if (!nodesById.has(node.id)) nodesById.set(node.id, node);
      if (fold) txCounts.set(node.id, (txCounts.get(node.id) ?? 0) + txCountOf(node));
    }
    if (!fold) {
      for (const edge of scene.edges) if (!edgesById.has(edge.id)) edgesById.set(edge.id, edge);
    }
    for (const group of scene.groups) {
      const existing = groupsById.get(group.id);
      groupsById.set(group.id, existing ? unionMembers(existing, group) : group);
    }
    if (scene.summary) summaries.push(scene.summary);
  }
  const nodes = fold ? [...nodesById.values()].map((node) => recounted(node, txCounts.get(node.id) ?? 1)) : [...nodesById.values()];
  const chainIds = [
    ...new Set(nodes.filter((n) => n.chain_id && !n.off_chain).map((n) => n.chain_id))
  ].sort();
  return {
    ...emptyScene({ kind, layoutHint }),
    summary: summaries.length > 0 ? summaries.join("; ") : null,
    nodes,
    edges: fold ? foldValueEdges(scenes.flatMap((scene) => scene.edges)) : [...edgesById.values()],
    groups: [...groupsById.values()],
    chain_ids: chainIds,
    multi_chain: chainIds.length > 1,
    attributes: {
      ...scenes.some((scene) => scene.attributes?.flow_basis === "includes_balance_allocations") ? { flow_basis: "includes_balance_allocations" } : {},
      ...scenes.some((scene) => ["partial", "unsupported_family"].includes(String(scene.attributes?.flow_coverage))) ? { flow_coverage: "partial" } : {},
      ...scenes.some((scene) => scene.attributes?.truncated) ? { truncated: true } : {}
    }
  };
}
var FOLDABLE_EDGE_KINDS;
var init_mergeScenes = __esm({
  "src/transpose/mergeScenes.ts"() {
    FOLDABLE_EDGE_KINDS = /* @__PURE__ */ new Set(["transfer", "flow"]);
  }
});
function endpoint2(id, address) {
  return id || address || "";
}
function nativeToken(chainId) {
  if (!chainId) return {};
  const chain = resolveChain(chainId);
  if (!chain) return {};
  return { symbol: chain.nativeToken, decimals: chain.decimals };
}
function humanAmount(raw, decimals) {
  if (decimals == null || raw == null || raw === "") return void 0;
  try {
    return formatUnits(raw, decimals);
  } catch {
    return void 0;
  }
}
function sceneNode(node, defaultChainId) {
  const address = node.address || null;
  const chainId = node.chain_id ?? defaultChainId ?? null;
  const txCount = node.tx_count ?? 0;
  return {
    id: endpoint2(node.id, address),
    kind: node.node_type || "address",
    label: node.label || address || "",
    // `"<n> tx"` is the coarse tier's only extra signal — how many of the
    // transactions in scope touched this address. The scene renderer keeps an
    // explicit sublabel over its own short-address derivation.
    sublabel: txCount > 0 ? `${txCount} tx` : null,
    chain_id: chainId,
    address,
    group_id: null,
    off_chain: false,
    entity_id: null,
    icon: null,
    assets: [],
    value: null,
    badge: null,
    // Counters aren't part of the scene contract, but dropping them would lose
    // the aggregate's only quantitative content — keep them addressable.
    attributes: { degree: node.degree ?? 0, tx_count: txCount, receipt_protocol_ids: node.receipt_protocol_ids ?? [], ..."hop" in node ? { hop: node.hop } : {} },
    source_refs: [],
    confidence: 1,
    detail_tier: "compact",
    facts: [],
    // Observed: every edge here comes from a real transaction in the feed.
    origin: "decoded"
  };
}
function sceneEdge(edge, defaultChainId, options) {
  const source = endpoint2(edge.from_id, edge.from_address);
  const target = endpoint2(edge.to_id, edge.to_address);
  const rawKind = edge.kind ?? "";
  const tokenChain = edge.token_chain_id ?? edge.from_chain ?? defaultChainId ?? void 0;
  const native = edge.token_address ? {} : nativeToken(tokenChain);
  const symbol = options.resolveSymbol?.(edge.token_address, tokenChain) ?? native.symbol;
  const decimals = options.resolveDecimals?.(edge.token_address, tokenChain) ?? native.decimals;
  const hasAsset = Boolean(edge.token_address) || edge.raw_amount_total != null && edge.raw_amount_total !== "0";
  const asset = hasAsset ? {
    token_address: edge.token_address ?? null,
    token_id: "token_id" in edge ? edge.token_id ?? null : null,
    token_chain_id: edge.token_chain_id ?? null,
    symbol: symbol ?? null,
    decimals: decimals ?? null,
    amount_raw: edge.raw_amount_total ?? null,
    amount: humanAmount(edge.raw_amount_total, decimals) ?? null
  } : null;
  const kind = EDGE_KIND[rawKind] ?? "flow";
  const virtual = VIRTUAL_EDGE_KINDS.has(kind);
  return {
    id: graphEdgeId(edge),
    source,
    target,
    kind,
    label: null,
    asset,
    direction: null,
    from_chain: edge.from_chain ?? null,
    to_chain: edge.to_chain ?? null,
    cross_chain: Boolean(edge.from_chain && edge.to_chain && edge.from_chain !== edge.to_chain) || virtual,
    virtual,
    icon: null,
    attributes: {
      ...rawKind ? { flow_kind: rawKind } : {},
      interaction_count: edge.interaction_count ?? 0,
      // The row tier already sums repeat transfers between a pair; it just never
      // said so, so a row-built arrow standing for three sends read as one. Under
      // the SAME key the scene fold writes, so the two tiers compose when the
      // case graph folds one into the other and the renderer reads one channel.
      ...(edge.interaction_count ?? 0) > 1 ? { [MERGED_COUNT_ATTR]: edge.interaction_count } : {},
      // Which rows it was summed from, when a row tier built it — present even
      // for one row, because folding this edge into a decoded one has to union
      // BOTH sides' transactions, and a missing list would lose this side's.
      ..."tx_refs" in edge && edge.tx_refs && edge.tx_refs.length > 0 ? { [MERGED_TXS_ATTR]: edge.tx_refs } : {}
    },
    detail_tier: "compact",
    facts: [],
    origin: virtual ? "synthesized" : "decoded"
  };
}
function interactionGraphToScene(graph, options = {}) {
  const { kind = "interaction", layoutHint = "hierarchical", chainId } = options;
  const base = emptyScene({ kind, layoutHint });
  if (!graph) return base;
  const nodes = (graph.nodes ?? []).map((n) => sceneNode(n, chainId));
  const edges = (graph.edges ?? []).map((e) => sceneEdge(e, chainId, options));
  const chainIds = [...new Set(nodes.filter((n) => n.chain_id).map((n) => n.chain_id))].sort();
  return {
    ...base,
    nodes,
    edges,
    chain_ids: chainIds,
    multi_chain: chainIds.length > 1
  };
}
var EDGE_KIND, VIRTUAL_EDGE_KINDS;
var init_interactionGraphToScene = __esm({
  "src/transpose/interactionGraphToScene.ts"() {
    init_mergeScenes();
    EDGE_KIND = {
      native: "transfer",
      internal: "call",
      closure: "transfer",
      erc20: "transfer",
      trc10: "transfer",
      trc20: "transfer",
      nep141: "transfer",
      erc721: "transfer",
      erc1155: "transfer",
      spl: "transfer",
      hip1: "transfer",
      metaprotocol: "transfer",
      cosmos_bank: "transfer",
      ledger_asset: "transfer",
      bridge_in: "bridge_in",
      bridge_out: "bridge_out",
      cross_chain: "cross_chain"
    };
    VIRTUAL_EDGE_KINDS = /* @__PURE__ */ new Set(["bridge_out", "bridge_in", "cross_chain"]);
  }
});

// src/share/caseShare.ts
function stepAmount(step) {
  const contract = step.asset && /^0x[0-9a-fA-F]{40}$/.test(step.asset) ? `${step.asset.slice(0, 6)}\u2026${step.asset.slice(-4)}` : step.asset;
  const asset = contract ? step.assetVerified ? contract : `${contract} (unverified token)` : null;
  const parts = [step.amount, asset].filter(Boolean);
  return parts.length ? parts.join(" ") : null;
}
function stableStringify(value) {
  if (value === null || typeof value !== "object") return JSON.stringify(value ?? null);
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(",")}]`;
  const entries = Object.entries(value).filter(([, v]) => v !== void 0).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0);
  return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${stableStringify(v)}`).join(",")}}`;
}
function hash53(text2) {
  let h1 = 3735928559;
  let h2 = 1103547991;
  for (let i = 0; i < text2.length; i++) {
    const ch = text2.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}
function fingerprintOf(value) {
  return hash53(stableStringify(value));
}
function orderEvidence(items) {
  const rank = (e) => e.role === "excluded" ? 1 : 0;
  return [...items].sort(
    (a, b) => rank(a) - rank(b) || (a.pinnedAt ?? Number.MAX_SAFE_INTEGER) - (b.pinnedAt ?? Number.MAX_SAFE_INTEGER) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0)
  );
}
function buildCaseShareBundle(input) {
  const content = {
    caseId: input.caseId,
    title: input.title,
    description: input.description ?? null,
    status: input.status,
    period: input.period ?? null,
    watches: [...input.watches ?? []],
    acts: [...input.acts ?? []],
    evidence: orderEvidence(input.evidence ?? []),
    evidenceTruncated: Boolean(input.evidenceTruncated),
    workflow: input.workflow ? [...input.workflow] : null,
    comments: input.comments ? [...input.comments] : null
  };
  const graph = input.graph && input.graph.scene ? input.graph : null;
  return {
    kind: CASE_SHARE_KIND,
    version: CASE_SHARE_VERSION,
    mode: input.mode,
    frozenAt: input.frozenAt ?? Date.now(),
    ...content,
    graph,
    fingerprint: {
      content: fingerprintOf(content),
      graph: graph ? fingerprintOf(graph) : null
    }
  };
}
function isCaseShareBundle(value) {
  return !!value && typeof value === "object" && value.kind === CASE_SHARE_KIND;
}
function asArray(value) {
  return Array.isArray(value) ? value : [];
}
function asText(value) {
  if (typeof value === "string") return value || null;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return null;
}
function asMillis(value) {
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? seconds * 1e3 : null;
}
function parseTrailStep(raw) {
  if (!raw || typeof raw !== "object") return null;
  const s = raw;
  const venue = s.venue && typeof s.venue === "object" ? s.venue : null;
  return {
    hop: Number(s.hop) || 0,
    chainId: String(s.chain_id ?? ""),
    fromAddress: String(s.from_address ?? ""),
    toAddress: String(s.to_address ?? ""),
    fromLabel: asText(s.from_label),
    toLabel: asText(s.to_label),
    asset: asText(s.asset),
    assetVerified: s.asset_verified !== false,
    amount: asText(s.amount),
    venue: venue && (venue.kind || venue.name) ? { kind: String(venue.kind ?? ""), name: String(venue.name ?? "") } : null,
    txHash: asText(s.tx_hash),
    at: asMillis(s.at),
    until: asMillis(s.until),
    isNew: s.new === true
  };
}
function liftTrailScene(graph) {
  const meta = /* @__PURE__ */ new Map();
  for (const edge of graph.edges ?? []) {
    const token = typeof edge.token_address === "string" ? edge.token_address.toLowerCase() : "";
    if (!token || meta.has(token)) continue;
    meta.set(token, {
      ...typeof edge.symbol === "string" && edge.symbol ? { symbol: edge.symbol } : {},
      ...typeof edge.decimals === "number" ? { decimals: edge.decimals } : {}
    });
  }
  return interactionGraphToScene(graph, {
    layoutHint: "hierarchical",
    resolveSymbol: (token) => token ? meta.get(token.toLowerCase())?.symbol : void 0,
    resolveDecimals: (token) => token ? meta.get(token.toLowerCase())?.decimals : void 0
  });
}
function parseCaseShareFinding(raw) {
  if (!raw || typeof raw !== "object") return void 0;
  const f = raw;
  const sagaKind = asText(f.saga_kind);
  if (!sagaKind) return void 0;
  const occurredAt = Number(f.occurred_at);
  return {
    sagaKind,
    severity: asText(f.severity),
    validity: f.validity === "retracted" || f.validity === "superseded" ? f.validity : "active",
    occurredAt: Number.isFinite(occurredAt) && occurredAt > 0 ? occurredAt * 1e3 : null,
    chainId: asText(f.chain_id),
    subjects: asArray(f.subjects).filter((s) => s && typeof s === "object" && asText(s.address)).map((s) => ({
      chainId: String(s.chain_id ?? ""),
      address: String(s.address),
      role: String(s.role ?? ""),
      accused: s.accused === true
    })),
    refs: asArray(f.refs).map(asText).filter((r) => r !== null)
  };
}
function parseEvidence(raw) {
  const { finding: rawFinding, ...rest } = raw;
  const finding = parseCaseShareFinding(rawFinding);
  return { ...rest, acts: asArray(rest.acts), ...finding ? { finding } : {} };
}
function parseCaseShareTrails(raw) {
  if (!Array.isArray(raw)) return void 0;
  const trails = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const t = item;
    const key = asText(t.key);
    if (!key) continue;
    const graph = t.graph && typeof t.graph === "object" && Array.isArray(t.graph.nodes) ? t.graph : null;
    const scene = t.scene && typeof t.scene === "object" && Array.isArray(t.scene.nodes) ? t.scene : graph && (graph.edges ?? []).length ? liftTrailScene(graph) : null;
    const steps = asArray(t.steps).map(parseTrailStep).filter((s) => s !== null);
    trails.push({
      key,
      name: asText(t.name) ?? "Money trail",
      direction: t.direction === "inbound" ? "inbound" : "outbound",
      seeds: asArray(t.seeds).filter((seed) => seed && typeof seed === "object").map((seed) => ({
        chainId: String(seed.chain_id ?? ""),
        address: String(seed.address ?? ""),
        label: asText(seed.label)
      })),
      walkedAt: asMillis(t.walked_at),
      hops: Number(t.hops) || steps.reduce((max, s) => Math.max(max, s.hop), 0),
      steps,
      newSteps: Number.isFinite(Number(t.new_steps)) ? Number(t.new_steps) : steps.filter((s) => s.isNew).length,
      scene,
      truncated: Boolean(t.truncated),
      following: t.following === true,
      intervalSeconds: Number.isFinite(Number(t.interval_seconds)) && Number(t.interval_seconds) > 0 ? Number(t.interval_seconds) : null,
      nextWalkAt: asMillis(t.next_walk_at),
      followUntil: asMillis(t.follow_until)
    });
  }
  return trails;
}
function parseCaseShareBundle(raw) {
  if (!isCaseShareBundle(raw)) return null;
  const b = raw;
  const version = Number(b.version);
  if (!Number.isFinite(version) || version > CASE_SHARE_VERSION) return null;
  const graph = b.graph && typeof b.graph === "object" && b.graph.scene ? b.graph : null;
  const fp = b.fingerprint ?? {};
  const trails = parseCaseShareTrails(b.trails);
  return {
    kind: CASE_SHARE_KIND,
    version: CASE_SHARE_VERSION,
    mode: b.mode === "live" ? "live" : "frozen",
    frozenAt: Number(b.frozenAt) || 0,
    caseId: String(b.caseId ?? ""),
    title: typeof b.title === "string" && b.title ? b.title : "Untitled investigation",
    description: typeof b.description === "string" ? b.description : null,
    status: typeof b.status === "string" ? b.status : "open",
    period: b.period && typeof b.period === "object" ? b.period : null,
    publication: b.publication && typeof b.publication === "object" ? b.publication : void 0,
    catalogItems: asArray(b.catalogItems),
    watches: asArray(b.watches),
    acts: asArray(b.acts).map((a) => ({ ...a, asserted: asArray(a.asserted), chains: asArray(a.chains) })),
    evidence: asArray(b.evidence).map(parseEvidence),
    evidenceTruncated: Boolean(b.evidenceTruncated),
    workflow: Array.isArray(b.workflow) ? b.workflow : null,
    comments: Array.isArray(b.comments) ? b.comments : null,
    graph,
    ...trails ? { trails, trailsTruncated: b.trailsTruncated === true } : {},
    fingerprint: {
      content: typeof fp.content === "string" ? fp.content : "",
      graph: typeof fp.graph === "string" ? fp.graph : null
    }
  };
}
function caseShareRefresh(stored, next) {
  const haveGraph = next.graph !== null;
  if (!stored) return { refresh: true, keepGraph: !haveGraph };
  const contentChanged = stored.content !== next.fingerprint.content;
  const graphChanged = haveGraph && stored.graph !== next.fingerprint.graph;
  return { refresh: contentChanged || graphChanged, keepGraph: !haveGraph };
}
function withGraphFrom(next, previous) {
  if (next.graph || !previous?.graph) return next;
  return {
    ...next,
    graph: previous.graph,
    fingerprint: { ...next.fingerprint, graph: previous.fingerprint.graph }
  };
}
var CASE_SHARE_KIND, CASE_SHARE_VERSION;
var init_caseShare = __esm({
  "src/share/caseShare.ts"() {
    init_interactionGraphToScene();
    CASE_SHARE_KIND = "authe.case-share";
    CASE_SHARE_VERSION = 1;
  }
});
function sentenceOf(finding) {
  return findingSentence({
    saga_kind: finding.sagaKind,
    chain_id: finding.chainId,
    severity: finding.severity,
    validity: finding.validity,
    occurred_at: finding.occurredAt === null ? null : finding.occurredAt / 1e3,
    subjects: finding.subjects.map((s) => ({ chain_id: s.chainId, address: s.address, role: s.role, accused: s.accused })),
    signal: { refs: finding.refs }
  });
}
function partyLine(subject) {
  const chain = subject.chainId ? chainDisplayName(subject.chainId) || subject.chainId : null;
  return `${subject.address}${subject.roleLabel ? ` \u2014 ${subject.roleLabel}` : ""} (${subject.stance})${chain ? ` on ${chain}` : ""}`;
}
function findingItems(finding) {
  const sentence = sentenceOf(finding);
  const standing = finding.validity === "active" ? VALIDITY_LABELS.active : `${VALIDITY_LABELS[finding.validity]} \u2014 no longer active: the parties are what it recorded, not a current accusation`;
  const parties = [...sentence.accused, ...sentence.others].map(partyLine);
  return [
    { label: "Finding", value: `${sentence.title}. ${sentence.detail}` },
    { label: "Severity", value: sentence.severityLabel },
    { label: "Validity", value: standing },
    { label: "Occurred (UTC)", value: utc(finding.occurredAt) },
    { label: "Parties", value: parties.length ? parties.join("\n") : "None named" },
    { label: "Finding evidence", value: finding.refs.length ? `${finding.refs.length} transaction${finding.refs.length === 1 ? "" : "s"}
${finding.refs.join("\n")}` : "No transaction cited" }
  ];
}
function exhibitSections(e, i, bundle) {
  return [
    { id: `exhibit-${i}`, kind: "facts", title: e.label || `Evidence ${i + 1}`, items: [
      { label: "Role / type", value: `${e.role} / ${e.refType}` },
      { label: "Reference", value: e.refId },
      { label: "Chain", value: e.chainId ? chainDisplayName(e.chainId) : "Not specified" },
      { label: "Pinned (UTC)", value: utc(e.pinnedAt) },
      { label: "Story", value: e.acts.map((id) => bundle.acts.find((a) => a.id === id)?.title || id).join(", ") || "Not linked" },
      ...e.finding ? findingItems(e.finding) : []
    ] },
    ...e.note ? [{ id: `exhibit-note-${i}`, kind: "narrative", body: e.note }] : []
  ];
}
function trailSections(trail, i) {
  const steps = [...trail.steps].sort((a, b) => a.hop - b.hop);
  const destinations = steps.filter((s) => s.venue).map((s) => `hop ${s.hop}: ${s.venue.kind.replace(/_/g, " ")}${s.venue.name ? ` ${s.venue.name}` : ""}${stepAmount(s) ? ` \xB7 ${stepAmount(s)}` : ""}`);
  const walk = steps.map(
    (s) => `hop ${s.hop}${s.at ? ` \xB7 ${utc(s.at)}${s.until && s.until !== s.at ? ` \u2013 ${utc(s.until)}` : ""}` : ""} \xB7 ${chainDisplayName(s.chainId) || s.chainId || "\u2014"} \xB7 ${partyName(s.fromLabel, s.fromAddress)} \u2192 ${partyName(s.toLabel, s.toAddress)}${stepAmount(s) ? ` \xB7 ${stepAmount(s)}` : ""}${s.txHash ? ` \xB7 ${s.txHash}` : ""}`
  );
  return [
    { id: `trail-${i}`, kind: "facts", title: trail.name, items: [
      { label: "Direction", value: trail.direction },
      { label: trail.direction === "inbound" ? "Into" : "From", value: trail.seeds.map((s) => `${partyName(s.label, s.address)}${s.chainId ? ` (${chainDisplayName(s.chainId) || s.chainId})` : ""}`).join("\n") || "Not specified" },
      { label: "Hops", value: String(trail.hops) },
      { label: "Walked (UTC)", value: utc(trail.walkedAt) },
      { label: "Moves", value: trail.following ? `Re-walked by the server on a schedule${trail.nextWalkAt ? `; next walk ${utc(trail.nextWalkAt)}` : ""}.` : "Only when an investigator re-runs the tracer." },
      ...trail.truncated ? [{ label: "Truncated", value: `The walk stopped at its budget: these are the first ${steps.length} step${steps.length === 1 ? "" : "s"}, not the whole trail.` }] : [],
      { label: "Destinations reached", value: destinations.length ? destinations.join("\n") : "No exchange, bridge, mixer or custodian reached: every hop so far lands on an unnamed address." },
      { label: "Steps", value: walk.length ? walk.join("\n") : "No hop walked yet." }
    ] }
  ];
}
function trailsSections(trails, { absent, truncated = false }) {
  if (trails === void 0) {
    return [{ id: "trails", kind: "narrative", title: "Money trails", body: absent }];
  }
  if (!trails.length) {
    return [{ id: "trails", kind: "narrative", title: "Money trails", body: "No tracer has walked this case yet." }];
  }
  return [
    { id: "trails", kind: "narrative", title: "Money trails", body: `${trails.length} walked trail${trails.length === 1 ? "" : "s"}, as last walked. Each hop's amount is the tracer's own figure in that hop's asset; they are listed, not summed.` + (truncated ? " The case has more tracers than are listed here." : "") },
    ...trails.flatMap(trailSections)
  ];
}
function caseShareReport(bundle, generatedAt = Date.now()) {
  const sections = [
    { id: "summary", kind: "narrative", title: "Case summary", body: bundle.description || "No summary published." },
    { id: "scope", kind: "facts", title: "Followed subjects", items: bundle.watches.map((w) => ({
      label: w.kind,
      value: `${w.label}
${w.ref || w.label}
Chains: ${w.chains.map(chainDisplayName).join(", ") || "All chains"}`
    })) },
    { id: "story", kind: "timeline", title: "Published story", empty: "No story published.", items: bundle.acts.map((a) => ({
      id: a.id,
      title: a.title,
      tags: [a.phase].filter(Boolean),
      chains: a.chains.map(chainDisplayName),
      note: [a.note, ...a.asserted.map((v) => `Stated, not observed on chain: ${v.direction} ${v.amount} ${v.symbol} ${v.chain ? chainDisplayName(v.chain) : ""}. Source: ${v.source}`)].filter(Boolean).join("\n"),
      status: `${bundle.evidence.filter((e) => e.role === "exhibit" && e.acts.includes(a.id)).length} published exhibits`
    })) },
    {
      id: "evidence",
      kind: "narrative",
      title: "Published evidence and exclusions",
      body: bundle.evidenceTruncated ? "The publication contains a partial evidence list. This is not the full case record." : "Only evidence included in this publication is listed."
    },
    ...bundle.evidence.flatMap((e, i) => exhibitSections(e, i, bundle)),
    ...trailsSections(bundle.trails, {
      absent: "Money trails were not published: they are a live section the publisher has not included in this publication.",
      truncated: bundle.trailsTruncated
    }),
    {
      id: "workflow",
      kind: "timeline",
      title: "Published workflow",
      empty: bundle.workflow === null ? "Workflow was not published." : "No workflow steps.",
      items: (bundle.workflow ?? []).map((w) => ({ id: w.id, title: w.title, status: w.status, note: `${w.approvals} of ${w.requiredApprovals} required approvals` }))
    }
  ];
  for (const [i, item] of (bundle.catalogItems ?? []).entries()) sections.push(
    { id: `catalog-${i}`, kind: "facts", title: item.name || item.id, items: [
      { label: "Catalog kind", value: item.kind },
      { label: "Reference", value: item.id },
      { label: "Available", value: String(item.available) },
      { label: "Updated (UTC)", value: utcSeconds(item.updated_at) }
    ] },
    { id: `catalog-description-${i}`, kind: "narrative", body: item.description || "No description published." }
  );
  if (bundle.comments !== null) sections.push({ id: "discussion", kind: "timeline", title: "Published discussion", empty: "No discussion published.", items: bundle.comments.map((c) => ({ id: c.id, title: `${c.author || "Unknown"} \xB7 ${utc(c.createdAt)}`, note: c.body, status: c.resolved ? "Resolved" : "Open" })) });
  sections.push({ id: "limits", kind: "facts", title: "Provenance and limits", items: [
    { label: "Case", value: bundle.caseId },
    { label: "Publication", value: `${bundle.mode === "live" ? "Live publication read at generation; this report is a fixed copy" : "Frozen publication"}. Revision ${bundle.publication?.revision ?? "not recorded"}.` },
    { label: "Live sections", value: bundle.publication?.liveSections.join(", ") || "None" },
    { label: "Graph", value: bundle.graph ? `${bundle.graph.scene.nodes.length} nodes and ${bundle.graph.scene.edges.length} edges in the published graph. View the interactive graph on the shared case page; it is not reproduced in this text report.` : "No graph published." },
    ...bundle.graph?.hiddenRules?.length ? [{ label: "Graph filters", value: `${bundle.graph.hiddenRules.join(", ")}. Matching transactions were hidden from the published graph; pinned evidence and story citations remain visible. Source evidence retained.` }] : [],
    { label: "Interpretation", value: "Published assertions and labels are not proof of ownership or stolen-fund attribution. No private data, new chain queries or unpublished analysis are included." }
  ] });
  return {
    name: bundle.title,
    kicker: "Shared case report",
    classifier: bundle.status,
    sections,
    meta: [{ label: "Generated (UTC)", value: utc(generatedAt) }, { label: "Publication data (UTC)", value: utc(bundle.frozenAt) }, { label: "Incident period (UTC)", value: bundle.period ? `${utc(bundle.period.since)} \u2013 ${bundle.period.until ? utc(bundle.period.until) : "Open-ended"}` : "Not specified" }],
    status: bundle.evidenceTruncated ? { tone: "alert", text: "Partial published evidence. Do not treat this report as the complete case." } : void 0,
    footer: { left: "Authe \xB7 Shared case report", right: "Published information only" }
  };
}
var utc, utcSeconds, VALIDITY_LABELS, partyName;
var init_caseShareReport = __esm({
  "src/share/caseShareReport.ts"() {
    init_caseShare();
    utc = (ms) => ms ? new Date(ms).toISOString() : "Not specified";
    utcSeconds = (seconds) => utc(seconds ? seconds * 1e3 : null);
    VALIDITY_LABELS = { active: "Active", retracted: "Retracted", superseded: "Superseded" };
    partyName = (label, address) => label || address || "\u2014";
  }
});

// src/share/CaseShareReportView.tsx
var CaseShareReportView_exports = {};
__export(CaseShareReportView_exports, {
  default: () => CaseShareReportView
});
function CaseShareReportView({ bundle }) {
  const report = React17.useMemo(() => caseShareReport(bundle), [bundle]);
  return /* @__PURE__ */ jsx(ReportPreview, { report, actions: /* @__PURE__ */ jsx(ReportDownloadButton, { report }) });
}
var init_CaseShareReportView = __esm({
  "src/share/CaseShareReportView.tsx"() {
    init_caseShareReport();
  }
});

// src/share/CaseShareView.tsx
var CaseShareView_exports = {};
__export(CaseShareView_exports, {
  CaseShareView: () => CaseShareView,
  default: () => CaseShareView_default,
  findingHeadline: () => findingHeadline,
  liveGraphNote: () => liveGraphNote,
  trailDestinations: () => trailDestinations,
  trailFreshness: () => trailFreshness
});
function cadenceLabel(seconds) {
  if (seconds % 86400 === 0) return seconds === 86400 ? "every day" : `every ${seconds / 86400} days`;
  if (seconds % 3600 === 0) return seconds === 3600 ? "every hour" : `every ${seconds / 3600} hours`;
  return `every ${Math.round(seconds / 60)} minutes`;
}
function trailFreshness(trail) {
  if (!trail.following) return "Not re-walked on a schedule: this trail moves when its investigators run the tracer again.";
  const cadence = trail.intervalSeconds ? `Re-walked ${cadenceLabel(trail.intervalSeconds)}` : "Re-walked on a schedule";
  const next = formatUtcStamp(trail.nextWalkAt);
  const until = formatUtcStamp(trail.followUntil);
  return `${cadence}${next ? ` \xB7 next walk ${next}` : ""}${until ? ` \xB7 until ${until}` : ""}.`;
}
function plainMentions(body) {
  return body.replace(/@\[([^\]]+)\]\([^)]*\)/g, "@$1");
}
function liveGraphNote(publication) {
  if (publication.graphMode !== "live" || !publication.graph) return "The graph retains its published snapshot.";
  const { exhibits, withoutScene, leftOut } = publication.graph;
  const missing = [
    withoutScene ? `${withoutScene} not drawable yet` : "",
    leftOut ? `${leftOut} older left out` : ""
  ].filter(Boolean).join(", ");
  return `The graph draws the case\u2019s ${exhibits} pinned transaction${exhibits === 1 ? "" : "s"}${missing ? ` (${missing})` : ""}.`;
}
function periodLabel(period) {
  if (!period) return null;
  const since = formatUtcDay(period.since);
  const until = formatUtcDay(period.until);
  if (since && until) return `${since} \u2013 ${until}`;
  if (since) return `Since ${since}`;
  if (until) return `Until ${until}`;
  return null;
}
function ChainChips({ chains }) {
  if (!chains.length) return null;
  return /* @__PURE__ */ jsx("span", { className: "flex flex-wrap gap-1", children: chains.map((chain) => /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal text-2xs", children: chainDisplayName(chain) || chain }, chain)) });
}
function StorySection({
  acts,
  citedBy
}) {
  if (!acts.length) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No story written",
        description: "Nobody has written this case up as a sequence of steps yet. Its exhibits and graph are in the other tabs."
      }
    );
  }
  let lastPhase = "";
  return /* @__PURE__ */ jsx("ol", { className: "space-y-3", children: acts.map((act, index) => {
    const showPhase = act.phase && act.phase !== lastPhase;
    lastPhase = act.phase;
    const cited = citedBy.get(act.id) ?? 0;
    return /* @__PURE__ */ jsxs("li", { className: "space-y-2", children: [
      showPhase ? /* @__PURE__ */ jsx("div", { className: "pt-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground", children: act.phase }) : null,
      /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(CardContent, { className: "space-y-2 p-4", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline justify-between gap-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-baseline gap-2", children: [
            /* @__PURE__ */ jsxs("span", { className: "text-xs font-medium tabular-nums text-muted-foreground", children: [
              index + 1,
              "."
            ] }),
            /* @__PURE__ */ jsx("span", { className: "font-medium", children: act.title || "Untitled step" })
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "flex flex-wrap items-center gap-2", children: [
            /* @__PURE__ */ jsx(ChainChips, { chains: act.chains }),
            /* @__PURE__ */ jsxs(Badge, { variant: "secondary", className: "font-normal text-2xs", children: [
              cited,
              " exhibit",
              cited === 1 ? "" : "s"
            ] })
          ] })
        ] }),
        act.note ? /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap text-sm text-muted-foreground", children: act.note }) : null,
        act.asserted.length ? /* @__PURE__ */ jsxs("div", { className: "space-y-1 rounded-md border border-dashed p-2 text-xs", children: [
          /* @__PURE__ */ jsx("div", { className: "font-medium text-muted-foreground", children: "Stated, not observed on chain" }),
          act.asserted.map((amount, i) => /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline gap-x-2", children: [
            /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
              amount.direction === "in" ? "+" : "\u2212",
              amount.amount,
              " ",
              amount.symbol
            ] }),
            amount.chain ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
              "on ",
              chainDisplayName(amount.chain) || amount.chain
            ] }) : null,
            amount.source ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
              "\xB7 ",
              amount.source
            ] }) : null
          ] }, i))
        ] }) : null
      ] }) })
    ] }, act.id);
  }) });
}
function findingHeadline(finding) {
  return findingSentence({
    saga_kind: finding.sagaKind,
    chain_id: finding.chainId,
    severity: finding.severity,
    validity: finding.validity,
    subjects: finding.subjects.map((s) => ({ chain_id: s.chainId, address: s.address, role: s.role, accused: s.accused }))
  }).detail;
}
function FindingSubjectRow({ subject }) {
  const did = roleLabel(subject.role);
  return /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center gap-x-2 gap-y-1", children: [
    /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
      /* @__PURE__ */ jsx("span", { className: "font-mono", title: subject.address, children: shortenAddress(subject.address) }),
      /* @__PURE__ */ jsx(CopyButton, { value: subject.address, label: "Copy address" })
    ] }),
    did ? /* @__PURE__ */ jsx("span", { children: did }) : null,
    subject.chainId ? /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: chainDisplayName(subject.chainId) || subject.chainId }) : null,
    !subject.accused ? /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "named, not accused" }) : null
  ] });
}
function FindingExhibit({ finding }) {
  const accused = finding.subjects.filter((s) => s.accused);
  const others = finding.subjects.filter((s) => !s.accused);
  const when = formatUtcStamp(finding.occurredAt);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: findingHeadline(finding) }),
      finding.severity ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-normal text-2xs", children: [
        /* @__PURE__ */ jsx("span", { className: "capitalize", children: finding.severity }),
        "\xA0severity"
      ] }) : null,
      /* @__PURE__ */ jsx(Badge, { variant: finding.validity === "active" ? "secondary" : "outline", className: "font-normal text-2xs", children: VALIDITY_LABELS2[finding.validity] })
    ] }),
    finding.validity !== "active" ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "This detection is no longer active: the parties below are what it recorded, not a current accusation." }) : null,
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsxs("span", { children: [
        "When: ",
        when ?? "unknown"
      ] }),
      finding.chainId ? /* @__PURE__ */ jsx("span", { children: chainDisplayName(finding.chainId) || finding.chainId }) : null
    ] }),
    finding.subjects.length ? /* @__PURE__ */ jsxs("ul", { className: "space-y-1 text-xs", children: [
      accused.map((s, i) => /* @__PURE__ */ jsx(FindingSubjectRow, { subject: s }, `a:${s.chainId}:${s.address}:${i}`)),
      others.map((s, i) => /* @__PURE__ */ jsx(FindingSubjectRow, { subject: s }, `o:${s.chainId}:${s.address}:${i}`))
    ] }) : null,
    finding.refs.length ? /* @__PURE__ */ jsxs("div", { className: "space-y-1 text-xs", children: [
      /* @__PURE__ */ jsxs("div", { className: "text-muted-foreground", children: [
        "Evidence: ",
        finding.refs.length,
        " transaction",
        finding.refs.length === 1 ? "" : "s"
      ] }),
      /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: finding.refs.map((ref) => /* @__PURE__ */ jsxs("li", { className: "flex min-w-0 items-center gap-1 text-muted-foreground", children: [
        /* @__PURE__ */ jsx(MiddleEllipsis, { value: ref, kind: "auto" }),
        /* @__PURE__ */ jsx(CopyButton, { value: ref, label: "Copy reference" })
      ] }, ref)) })
    ] }) : null
  ] });
}
function EvidenceRow({
  item,
  actTitles
}) {
  const cites = item.acts.map((id) => actTitles.get(id)).filter(Boolean);
  if (item.finding) {
    return /* @__PURE__ */ jsxs("li", { className: "space-y-2 px-4 py-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          Badge,
          {
            variant: item.role === "excluded" ? "outline" : "secondary",
            className: "font-normal text-2xs",
            children: item.role === "excluded" ? "Ruled out" : "Exhibit"
          }
        ),
        /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal text-2xs", children: "Finding" })
      ] }),
      /* @__PURE__ */ jsx(FindingExhibit, { finding: item.finding }),
      item.note ? /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap text-sm text-muted-foreground", children: item.note }) : null,
      cites.length ? /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
        "Cited in: ",
        cites.join(" \xB7 ")
      ] }) : null
    ] });
  }
  const showRef = !item.label || item.refType !== "transaction";
  const labelIsRef = Boolean(item.label && /^(0x)?[0-9a-fA-F]{40,}$/.test(item.label));
  return /* @__PURE__ */ jsxs("li", { className: "space-y-1 px-4 py-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        Badge,
        {
          variant: item.role === "excluded" ? "outline" : "secondary",
          className: "font-normal text-2xs",
          children: item.role === "excluded" ? "Ruled out" : "Exhibit"
        }
      ),
      /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal capitalize text-2xs", children: item.refType }),
      item.label ? /* @__PURE__ */ jsxs("span", { className: "flex min-w-0 items-center gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "min-w-0 truncate text-sm font-medium", children: item.label }),
        labelIsRef ? /* @__PURE__ */ jsx(CopyButton, { value: item.label, label: "Copy" }) : null
      ] }) : null,
      showRef ? /* @__PURE__ */ jsxs("span", { className: "flex min-w-0 items-center gap-1 text-xs text-muted-foreground", children: [
        /* @__PURE__ */ jsx(MiddleEllipsis, { value: item.refId, kind: "auto" }),
        /* @__PURE__ */ jsx(CopyButton, { value: item.refId, label: "Copy reference" })
      ] }) : null,
      item.chainId ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: chainDisplayName(item.chainId) || item.chainId }) : null
    ] }),
    item.note ? /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap text-sm text-muted-foreground", children: item.note }) : null,
    cites.length ? /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "Cited in: ",
      cites.join(" \xB7 ")
    ] }) : null
  ] });
}
function EvidenceSection({
  evidence,
  truncated,
  actTitles
}) {
  const exhibits = evidence.filter((e) => e.role !== "excluded");
  const excluded = evidence.filter((e) => e.role === "excluded");
  if (!evidence.length) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No exhibits pinned",
        description: "This case has not pinned any transactions, addresses or documents as evidence."
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    truncated ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Showing the exhibits that were readable when this was shared \u2014 the case holds more than were captured." }) : null,
    /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx("ul", { className: "divide-y", children: exhibits.map((item) => /* @__PURE__ */ jsx(EvidenceRow, { item, actTitles }, item.id)) }) }),
    excluded.length ? /* @__PURE__ */ jsxs("details", { className: "group", children: [
      /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer text-sm text-muted-foreground", children: [
        excluded.length,
        " reference",
        excluded.length === 1 ? "" : "s",
        " ruled out"
      ] }),
      /* @__PURE__ */ jsx(Card, { className: "mt-2", children: /* @__PURE__ */ jsx("ul", { className: "divide-y", children: excluded.map((item) => /* @__PURE__ */ jsx(EvidenceRow, { item, actTitles }, item.id)) }) })
    ] }) : null
  ] });
}
function WorkflowSection({ steps }) {
  if (steps === null) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "Workflow not captured",
        description: "The case's checklist could not be read when this was shared."
      }
    );
  }
  if (!steps.length) {
    return /* @__PURE__ */ jsx(EmptyState, { title: "No workflow", description: "This case has no checklist." });
  }
  return /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx("ul", { className: "divide-y", children: steps.map((step) => {
    const done = step.status === "done";
    return /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center justify-between gap-2 px-4 py-3", children: [
      /* @__PURE__ */ jsx("span", { className: cn("text-sm", done && "text-muted-foreground line-through"), children: step.title }),
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-2", children: [
        step.requiredApprovals > 0 ? /* @__PURE__ */ jsxs("span", { className: "text-xs tabular-nums text-muted-foreground", children: [
          step.approvals,
          "/",
          step.requiredApprovals,
          " approvals"
        ] }) : null,
        /* @__PURE__ */ jsx(Badge, { variant: done ? "secondary" : "outline", className: "font-normal capitalize text-2xs", children: step.status.replace(/_/g, " ") })
      ] })
    ] }, step.id);
  }) }) });
}
function DiscussionSection({ comments }) {
  if (comments === null) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "Discussion not shared",
        description: "The person who shared this case chose not to include its internal discussion."
      }
    );
  }
  if (!comments.length) {
    return /* @__PURE__ */ jsx(EmptyState, { title: "No discussion", description: "Nobody has commented on this case." });
  }
  const replies = /* @__PURE__ */ new Map();
  for (const c of comments) {
    if (c.parentId) replies.set(c.parentId, [...replies.get(c.parentId) ?? [], c]);
  }
  const top = comments.filter((c) => !c.parentId);
  const render = (c, reply = false) => /* @__PURE__ */ jsxs("li", { className: cn("space-y-1", reply && "ml-6 border-l pl-3"), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline gap-2 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: c.author ?? "Unknown" }),
      formatUtcStamp(c.createdAt) ? /* @__PURE__ */ jsx("span", { children: formatUtcStamp(c.createdAt) }) : null,
      c.resolved ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal text-3xs", children: "Resolved" }) : null
    ] }),
    /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap text-sm", children: plainMentions(c.body) }),
    (replies.get(c.id) ?? []).length ? /* @__PURE__ */ jsx("ul", { className: "space-y-3 pt-2", children: (replies.get(c.id) ?? []).map((r) => render(r, true)) }) : null
  ] }, c.id);
  return /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsx(CardContent, { className: "p-4", children: /* @__PURE__ */ jsx("ul", { className: "space-y-4", children: top.map((c) => render(c)) }) }) });
}
function partyName2(label, address) {
  return label || (address ? shortenAddress(address) : "\u2014");
}
function trailDestinations(steps) {
  const byVenue = /* @__PURE__ */ new Map();
  for (const step of [...steps].sort((a, b) => a.hop - b.hop)) {
    if (!step.venue) continue;
    const id = `${step.venue.kind}\0${step.venue.name}`;
    const entry = byVenue.get(id) ?? { kind: step.venue.kind, name: step.venue.name, arrivals: [] };
    entry.arrivals.push({ hop: step.hop, amount: stepAmount(step) });
    byVenue.set(id, entry);
  }
  return [...byVenue.values()];
}
function VenueBadge({ venue }) {
  return /* @__PURE__ */ jsxs(Badge, { variant: "secondary", className: "gap-1 font-normal text-2xs", children: [
    /* @__PURE__ */ jsx("span", { className: "capitalize text-muted-foreground", children: venue.kind.replace(/_/g, " ") }),
    venue.name ? /* @__PURE__ */ jsx("span", { children: venue.name }) : null
  ] });
}
function TrailDestinations({ steps }) {
  const destinations = trailDestinations(steps);
  if (!destinations.length) {
    return /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "No exchange, bridge, mixer or custodian reached: every hop so far lands on an unnamed address." });
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1 rounded-md border border-dashed p-2 text-xs", children: [
    /* @__PURE__ */ jsx("div", { className: "font-medium text-muted-foreground", children: "Where the money ended up" }),
    /* @__PURE__ */ jsx("ul", { className: "space-y-1", children: destinations.map((d) => /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center gap-x-2 gap-y-1", children: [
      /* @__PURE__ */ jsx(VenueBadge, { venue: d }),
      d.arrivals.map((a, i) => /* @__PURE__ */ jsxs("span", { className: "tabular-nums text-muted-foreground", children: [
        "hop ",
        a.hop,
        a.amount ? ` \xB7 ${a.amount}` : ""
      ] }, i))
    ] }, `${d.kind}:${d.name}`)) })
  ] });
}
function StepWhen({ step }) {
  const at = formatUtcStamp(step.at);
  const until = step.until !== null && step.until !== step.at ? formatUtcStamp(step.until) : null;
  if (!at) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { children: at }),
    until ? /* @__PURE__ */ jsxs("span", { className: "block text-muted-foreground", children: [
      "until ",
      until
    ] }) : null
  ] });
}
function TrailStepsTable({ steps }) {
  return /* @__PURE__ */ jsx("div", { className: "overflow-x-auto rounded-md border", children: /* @__PURE__ */ jsxs("table", { className: "w-full text-xs", children: [
    /* @__PURE__ */ jsx("thead", { className: "bg-muted/50 text-left text-muted-foreground", children: /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Hop" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "When (UTC)" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Chain" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "From \u2192 to" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Amount" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Venue" }),
      /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Transaction" })
    ] }) }),
    /* @__PURE__ */ jsx("tbody", { className: "divide-y", children: steps.map((step, i) => /* @__PURE__ */ jsxs("tr", { className: cn("align-top", step.isNew && "bg-primary/5"), children: [
      /* @__PURE__ */ jsxs("td", { className: "px-2 py-1.5 tabular-nums", children: [
        step.hop,
        step.isNew ? /* @__PURE__ */ jsx("span", { className: "ml-1 text-2xs font-medium uppercase text-primary", children: "new" }) : null
      ] }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 whitespace-nowrap tabular-nums", children: /* @__PURE__ */ jsx(StepWhen, { step }) }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 whitespace-nowrap", children: chainDisplayName(step.chainId) || step.chainId || "\u2014" }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-center gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium", ...step.fromAddress ? { title: step.fromAddress } : {}, children: partyName2(step.fromLabel, step.fromAddress) }),
        /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "text-muted-foreground", children: "\u2192" }),
        /* @__PURE__ */ jsx("span", { className: "font-medium", ...step.toAddress ? { title: step.toAddress } : {}, children: partyName2(step.toLabel, step.toAddress) })
      ] }) }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 whitespace-nowrap tabular-nums", children: stepAmount(step) ?? "\u2014" }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5", children: step.venue ? /* @__PURE__ */ jsx(VenueBadge, { venue: step.venue }) : null }),
      /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5", children: step.txHash ? /* @__PURE__ */ jsxs("span", { className: "flex min-w-0 items-center gap-1 text-muted-foreground", children: [
        /* @__PURE__ */ jsx(MiddleEllipsis, { value: step.txHash, kind: "hash" }),
        /* @__PURE__ */ jsx(CopyButton, { value: step.txHash, label: "Copy transaction hash" })
      ] }) : /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" }) })
    ] }, `${step.hop}:${step.txHash ?? i}`)) })
  ] }) });
}
function TrailCard({
  trail,
  resolveOverlay,
  mounted,
  graphClassName,
  focused,
  onNotify
}) {
  const walked = formatUtcStamp(trail.walkedAt);
  const card = React17.useRef(null);
  React17.useEffect(() => {
    if (focused) card.current?.scrollIntoView({ block: "start", behavior: "smooth" });
  }, [focused]);
  return /* @__PURE__ */ jsx(Card, { ref: card, id: `trail-${trail.key}`, className: focused ? "ring-2 ring-primary/40" : void 0, children: /* @__PURE__ */ jsxs(CardContent, { className: "space-y-3 p-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx("span", { className: "font-medium", children: trail.name }),
      /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal capitalize text-2xs", children: trail.direction }),
      /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-normal text-2xs tabular-nums", children: [
        trail.hops,
        " hop",
        trail.hops === 1 ? "" : "s"
      ] }),
      trail.newSteps > 0 ? /* @__PURE__ */ jsxs(Badge, { variant: "brand", className: "font-normal text-2xs tabular-nums", children: [
        trail.newSteps,
        " new step",
        trail.newSteps === 1 ? "" : "s"
      ] }) : null,
      walked ? /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
        "Walked ",
        walked
      ] }) : null,
      onNotify ? /* @__PURE__ */ jsx(
        Button,
        {
          size: "sm",
          variant: "outline",
          className: "ml-auto h-7 text-xs",
          onClick: onNotify,
          title: "Be told when the money on this case reaches your asset, exchange or address",
          children: "Notify me when\u2026"
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: trailFreshness(trail) }),
    trail.seeds.length ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5 text-xs", children: [
      /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: trail.direction === "inbound" ? "Into" : "From" }),
      trail.seeds.map((seed, i) => /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-0.5", children: [
        /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "max-w-[18rem] truncate font-normal", ...seed.address ? { title: seed.address } : {}, children: [
          partyName2(seed.label, seed.address),
          seed.chainId ? /* @__PURE__ */ jsx("span", { className: "ml-1 text-muted-foreground", children: chainDisplayName(seed.chainId) || seed.chainId }) : null
        ] }),
        seed.address ? /* @__PURE__ */ jsx(CopyButton, { value: seed.address, label: "Copy address" }) : null
      ] }, `${seed.chainId}:${seed.address}:${i}`))
    ] }) : null,
    trail.truncated ? /* @__PURE__ */ jsxs("p", { role: "note", className: "text-xs text-muted-foreground", children: [
      "The walk stopped at its budget: these are the first ",
      trail.steps.length,
      " step",
      trail.steps.length === 1 ? "" : "s",
      ", not the whole trail."
    ] }) : null,
    trail.steps.length ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(TrailDestinations, { steps: trail.steps }),
      trail.scene ? /* @__PURE__ */ jsx("div", { className: cn("w-full overflow-hidden rounded-md border", graphClassName), children: mounted ? /* @__PURE__ */ jsx(
        SceneGraphView,
        {
          scene: trail.scene,
          resolveOverlay,
          showViewsBar: false,
          className: "size-full"
        }
      ) : null }) : /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "No scene was drawn for this walk; the steps are listed below." }),
      /* @__PURE__ */ jsx(TrailStepsTable, { steps: trail.steps })
    ] }) : /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "This tracer has not found a hop yet: nothing has left its seeds since it was last walked." })
  ] }) });
}
function TrailsSection({
  trails,
  truncated,
  resolveOverlay,
  mounted,
  graphClassName,
  focusTrail,
  onNotify
}) {
  if (trails === void 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "Money trails not published",
        description: "Money trails are a live section; the publisher has not included them in this publication."
      }
    );
  }
  if (!trails.length) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No money trail yet",
        description: "No tracer has walked this case yet. Trails appear here once the case's tracers have run."
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    truncated ? /* @__PURE__ */ jsxs("p", { role: "note", className: "text-xs text-muted-foreground", children: [
      "The case has more tracers than a publication carries: these are its ",
      trails.length,
      " most recent."
    ] }) : null,
    trails.map((trail) => /* @__PURE__ */ jsx(
      TrailCard,
      {
        trail,
        resolveOverlay,
        mounted,
        graphClassName,
        focused: focusTrail === trail.key,
        onNotify
      },
      trail.key
    ))
  ] });
}
function CaseShareView({
  bundle,
  catalog,
  showTitle = false,
  graphClassName = "h-[70vh]",
  className,
  focusTrail,
  onNotifyTrail
}) {
  const citedBy = React17.useMemo(() => {
    const counts = /* @__PURE__ */ new Map();
    for (const e of bundle.evidence) {
      if (e.role === "excluded") continue;
      for (const id of e.acts) counts.set(id, (counts.get(id) ?? 0) + 1);
    }
    return counts;
  }, [bundle.evidence]);
  const actTitles = React17.useMemo(
    () => new Map(bundle.acts.map((a, i) => [a.id, a.title || `Step ${i + 1}`])),
    [bundle.acts]
  );
  const resolveOverlay = React17.useMemo(
    () => catalogResolverFrom(
      catalog && Object.keys(catalog).length ? catalog : bundle.graph?.catalog ?? null
    ),
    [catalog, bundle.graph]
  );
  const exhibitCount = bundle.evidence.filter((e) => e.role !== "excluded").length;
  const sections = [
    { id: "story", label: bundle.acts.length ? `Story \xB7 ${bundle.acts.length}` : "Story" },
    { id: "evidence", label: exhibitCount ? `Evidence \xB7 ${exhibitCount}` : "Evidence" },
    { id: "graph", label: "Graph" },
    { id: "trails", label: bundle.trails?.length ? `Money trail \xB7 ${bundle.trails.length}` : "Money trail" },
    { id: "workflow", label: "Workflow" },
    { id: "discussion", label: "Discussion" },
    { id: "report", label: "Case report" }
  ];
  const initial = focusTrail && bundle.trails?.some((t) => t.key === focusTrail) ? "trails" : bundle.acts.length ? "story" : bundle.evidence.length ? "evidence" : bundle.trails?.length ? "trails" : bundle.graph ? "graph" : "evidence";
  const [section, setSection] = React17.useState(initial);
  const changedAt = Math.max(
    0,
    ...(bundle.trails ?? []).map((t) => t.walkedAt ?? 0),
    bundle.publication?.graph?.builtAt ?? 0
  );
  const stamp = formatUtcStamp(bundle.mode === "live" && changedAt ? changedAt : bundle.frozenAt);
  const period = periodLabel(bundle.period);
  return /* @__PURE__ */ jsxs("div", { className: cn("flex min-w-0 flex-col gap-4", className), children: [
    /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(CardContent, { className: "space-y-3 p-4", children: [
      showTitle ? /* @__PURE__ */ jsx("h2", { className: "text-lg font-semibold tracking-tight", children: bundle.title }) : null,
      /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2 text-xs", children: [
        /* @__PURE__ */ jsx(Badge, { variant: bundle.status === "archived" ? "outline" : "secondary", className: "capitalize font-normal", children: bundle.status }),
        /* @__PURE__ */ jsx(Badge, { variant: bundle.mode === "live" ? "brand" : "outline", className: "font-normal", children: bundle.mode === "live" ? "Live" : "Snapshot" }),
        stamp ? /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: bundle.mode === "live" ? `Last change ${stamp}` : `Frozen ${stamp}` }) : null,
        period ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          "\xB7 Period ",
          period
        ] }) : null
      ] }),
      bundle.publication && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: bundle.mode === "live" ? `Live sections: ${bundle.publication.liveSections.join(", ") || "none"}. ${liveGraphNote(bundle.publication)} Workflow and discussion retain their published snapshot. Updates arrive as the case changes.` : "This is an immutable snapshot of the case at publication time." }),
      bundle.catalogItems?.length ? /* @__PURE__ */ jsxs("section", { "aria-label": "Published catalog information", className: "space-y-2", children: [
        /* @__PURE__ */ jsx("h3", { className: "text-sm font-medium", children: "Current public catalog information" }),
        bundle.catalogItems.map((item) => /* @__PURE__ */ jsxs("div", { className: "rounded border p-2 text-sm", children: [
          /* @__PURE__ */ jsx("span", { className: "font-medium", children: item.available ? item.name || item.id : `${item.id} \u2014 no longer publicly available` }),
          item.description && /* @__PURE__ */ jsx("p", { className: "text-muted-foreground", children: item.description })
        ] }, `${item.kind}:${item.id}`))
      ] }) : null,
      bundle.description ? /* @__PURE__ */ jsx("p", { className: "whitespace-pre-wrap text-sm text-muted-foreground", children: bundle.description }) : null,
      bundle.watches.length ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
        /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "Following" }),
        bundle.watches.map((w, i) => /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-0.5", children: [
          /* @__PURE__ */ jsx(
            Badge,
            {
              variant: "outline",
              className: "max-w-[18rem] truncate font-normal",
              ...w.ref ? { title: w.ref } : {},
              children: w.label
            }
          ),
          w.ref ? /* @__PURE__ */ jsx(CopyButton, { value: w.ref, label: "Copy address" }) : null
        ] }, `${w.kind}:${w.label}:${i}`))
      ] }) : null
    ] }) }),
    /* @__PURE__ */ jsxs(Tabs, { value: section, onValueChange: (v) => setSection(v), children: [
      /* @__PURE__ */ jsx(TabsList, { className: "w-full justify-start overflow-x-auto", children: sections.map((s) => /* @__PURE__ */ jsx(TabsTrigger, { value: s.id, className: "text-xs", children: s.label }, s.id)) }),
      /* @__PURE__ */ jsx(TabsContent, { value: "story", className: "pt-3", children: /* @__PURE__ */ jsx(StorySection, { acts: bundle.acts, citedBy }) }),
      /* @__PURE__ */ jsx(TabsContent, { value: "evidence", className: "pt-3", children: /* @__PURE__ */ jsx(
        EvidenceSection,
        {
          evidence: bundle.evidence,
          truncated: bundle.evidenceTruncated,
          actTitles
        }
      ) }),
      /* @__PURE__ */ jsxs(TabsContent, { value: "graph", className: "pt-3", children: [
        bundle.graph?.hiddenRules?.length ? /* @__PURE__ */ jsxs("p", { role: "note", className: "mb-2 text-xs text-muted-foreground", children: [
          "Published graph filters: ",
          bundle.graph.hiddenRules.join(", "),
          ". Matching transactions were hidden from this graph. Pinned evidence and story citations remain visible. The source evidence was retained."
        ] }) : null,
        bundle.graph ? /* @__PURE__ */ jsx("div", { className: cn("w-full overflow-hidden rounded-md border", graphClassName), children: section === "graph" ? /* @__PURE__ */ jsx(
          SceneGraphView,
          {
            scene: bundle.graph.scene,
            resolveOverlay,
            showViewsBar: false,
            className: "size-full"
          }
        ) : null }) : /* @__PURE__ */ jsx(
          EmptyState,
          {
            title: "Graph not captured",
            description: "No graph had been drawn for this case when it was shared. Its exhibits and story are in the other tabs."
          }
        )
      ] }),
      /* @__PURE__ */ jsx(TabsContent, { value: "trails", className: "pt-3", children: /* @__PURE__ */ jsx(
        TrailsSection,
        {
          trails: bundle.trails,
          truncated: bundle.trailsTruncated === true,
          resolveOverlay,
          mounted: section === "trails",
          graphClassName: "h-[50vh]",
          focusTrail,
          onNotify: onNotifyTrail
        }
      ) }),
      /* @__PURE__ */ jsx(TabsContent, { value: "workflow", className: "pt-3", children: /* @__PURE__ */ jsx(WorkflowSection, { steps: bundle.workflow }) }),
      /* @__PURE__ */ jsx(TabsContent, { value: "discussion", className: "pt-3", children: /* @__PURE__ */ jsx(DiscussionSection, { comments: bundle.comments }) }),
      /* @__PURE__ */ jsx(TabsContent, { value: "report", className: "pt-3", children: section === "report" ? /* @__PURE__ */ jsx(React17.Suspense, { fallback: /* @__PURE__ */ jsx("p", { role: "status", children: "Preparing case report\u2026" }), children: /* @__PURE__ */ jsx(CaseShareReportView2, { bundle }) }) : null })
    ] })
  ] });
}
var CaseShareReportView2, VALIDITY_LABELS2, CaseShareView_default;
var init_CaseShareView = __esm({
  "src/share/CaseShareView.tsx"() {
    init_SceneGraphView();
    init_catalogSnapshot();
    init_caseShare();
    CaseShareReportView2 = React17.lazy(() => Promise.resolve().then(() => (init_CaseShareReportView(), CaseShareReportView_exports)));
    VALIDITY_LABELS2 = {
      active: "Active",
      retracted: "Retracted",
      superseded: "Superseded"
    };
    CaseShareView_default = CaseShareView;
  }
});

// src/share/publicationEvents.ts
var publicationEvents_exports = {};
__export(publicationEvents_exports, {
  PUBLICATION_EVENTS_QUERY: () => PUBLICATION_EVENTS_QUERY,
  connectPublicationEvents: () => connectPublicationEvents,
  publicationEventKind: () => publicationEventKind,
  readerIsLive: () => readerIsLive,
  ticketSubject: () => ticketSubject
});
function publicationEventKind(payload) {
  if (!payload || typeof payload !== "object") return null;
  const kind = payload.kind;
  return kind === "publication-changed" || kind === "access-changed" ? kind : null;
}
function readerIsLive(state) {
  if (state.status !== "open") return false;
  const own = Object.entries(state.channels ?? {}).filter(([id]) => id.startsWith("publication-events:"));
  return own.length > 0 && own.every(([, channel]) => channel.status === "open");
}
function ticketSubject(ticket) {
  const payload = ticket.split(".")[1];
  if (!payload) return void 0;
  try {
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const sub = JSON.parse(json).sub;
    return typeof sub === "string" && sub ? sub : void 0;
  } catch {
    return void 0;
  }
}
function connectPublicationEvents(config, onEvent, createClient = createStreamingClient, onLive) {
  let ticket = "";
  let generation = 0;
  let unsubscribe = null;
  let offState = null;
  const pool = createAppSyncClientPool();
  const client = createClient({
    transport: createAppSyncTransport({ resolve: pool.resolve, selectPayload: selectAutheStreamPayload }),
    endpoint: aliasEndpointResolver(config.endpoint, config.region),
    region: config.region,
    getToken: () => ticket || void 0,
    // A ticket lives 30 minutes and every refetch brings a new one; when the
    // server refuses the one the socket was opened with, reconnect with the
    // newest rather than leaving the feed dead until the page is reloaded.
    refreshToken: () => ticket || void 0,
    // One reader, one tab: the ticket is this page's alone, and a dashboard
    // tab's shared socket (another identity) must never carry it.
    shareAcrossTabs: false
  });
  let started = false;
  let reader;
  return {
    setTicket(next) {
      if (!next || next === ticket) return;
      ticket = next;
      const who = ticketSubject(next);
      const changedReader = started && who !== reader;
      reader = who;
      unsubscribe?.();
      unsubscribe = null;
      if (changedReader) {
        client.stop();
        client.start();
      }
      if (!started) {
        started = true;
        offState = typeof client.onState === "function" ? client.onState((state) => onLive?.(readerIsLive(state))) : null;
        client.start();
      }
      unsubscribe = client.subscribeChannel(
        { id: `publication-events:${++generation}`, query: PUBLICATION_EVENTS_QUERY, variables: { ticket } },
        (message) => {
          const kind = publicationEventKind(message.payload);
          if (kind) onEvent(kind);
        }
      );
    },
    close() {
      unsubscribe?.();
      unsubscribe = null;
      offState?.();
      offState = null;
      onLive?.(false);
      client.destroy();
    }
  };
}
var PUBLICATION_EVENTS_QUERY;
var init_publicationEvents = __esm({
  "src/share/publicationEvents.ts"() {
    PUBLICATION_EVENTS_QUERY = `subscription PublicationEvents($ticket: String!) {
  subscribe: publicationEvents(ticket: $ticket) { name data }
}`;
  }
});

// src/scene/index.ts
init_SceneGraphView();

// src/scene/GroupGraphView.tsx
init_SceneGraphView();
function titleRole(role) {
  return role.length ? role.charAt(0).toUpperCase() + role.slice(1) : role;
}
function missingRolesLabel(group, fallback) {
  return group.missingRoles.length ? group.missingRoles.map(titleRole).join(" + ") : fallback;
}
function Deadline({ at, verb }) {
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: "font-normal opacity-80",
      title: formatTimestamp(at, { dateStyle: "medium", timeStyle: "short" }),
      children: [
        " ",
        "\xB7 ",
        verb,
        " ",
        formatRelativeTime(at)
      ]
    }
  );
}
function LifecycleBadge({ group }) {
  if (group.state === "timed_out") {
    return /* @__PURE__ */ jsxs(
      "span",
      {
        className: "inline-flex items-center gap-1.5 rounded-md border border-border bg-muted px-2 py-1 text-xs font-medium text-muted-foreground",
        title: "The grouping window closed before the remaining leg was observed. Nothing further will be joined to this group automatically.",
        children: [
          /* @__PURE__ */ jsx("span", { className: "inline-flex size-2 rounded-full bg-muted-foreground" }),
          "Timed out \u2014 ",
          missingRolesLabel(group, "the next leg"),
          " never arrived",
          group.expiresAt ? /* @__PURE__ */ jsx(Deadline, { at: group.expiresAt, verb: "deadline" }) : null
        ]
      }
    );
  }
  if (group.awaiting) {
    return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5 rounded-md border border-warning/40 bg-warning/10 px-2 py-1 text-xs font-medium text-warning", children: [
      /* @__PURE__ */ jsxs("span", { className: "relative inline-flex size-2", children: [
        /* @__PURE__ */ jsx("span", { className: "absolute inline-flex size-full animate-ping rounded-full bg-warning opacity-75" }),
        /* @__PURE__ */ jsx("span", { className: "relative inline-flex size-2 rounded-full bg-warning" })
      ] }),
      "Awaiting ",
      missingRolesLabel(group, "next leg"),
      group.expiresAt ? /* @__PURE__ */ jsx(Deadline, { at: group.expiresAt, verb: "expires" }) : null
    ] });
  }
  if (group.state === "completed") {
    return /* @__PURE__ */ jsx("span", { className: "inline-flex items-center rounded-md border border-success/40 bg-success/10 px-2 py-1 text-xs font-medium text-success", children: "Complete" });
  }
  if (group.partial) {
    return /* @__PURE__ */ jsx("span", { className: "inline-flex items-center rounded-md border border-warning/40 bg-warning/10 px-2 py-1 text-xs font-medium text-warning", children: "Partial \u2014 awaiting other leg" });
  }
  return null;
}
function TruncationNotice({
  truncation
}) {
  if (!truncation) return null;
  const { memberCount, totalMemberCount, membersTruncated, sceneLegCount, sceneLegsCapped } = truncation;
  if (!membersTruncated && !sceneLegsCapped) return null;
  const parts = [];
  if (membersTruncated) {
    parts.push(
      totalMemberCount != null ? `Showing ${memberCount.toLocaleString()} of ${totalMemberCount.toLocaleString()} members` : `Showing ${memberCount.toLocaleString()} members \u2014 the group has more`
    );
  }
  if (sceneLegsCapped) {
    parts.push(
      `the graph is drawn from a sample of ${sceneLegCount.toLocaleString()} leg${sceneLegCount === 1 ? "" : "s"}`
    );
  }
  return /* @__PURE__ */ jsxs(
    "p",
    {
      role: "status",
      className: "rounded-md border border-warning/40 bg-warning/10 px-2.5 py-1.5 text-xs text-warning",
      children: [
        parts.join(", and "),
        "."
      ]
    }
  );
}
function shortHash(value) {
  if (!value) return void 0;
  return shortenHash(value);
}
function shortCorrelationId(value) {
  if (!value) return void 0;
  return value.split(":").map((part) => shortenIdentifier(part)).join(":");
}
function shortAddr(value) {
  if (!value) return void 0;
  return shortenAddress(value);
}
function chainName(chainId, chainLabel) {
  return chainLabel?.(chainId) ?? getChainGroupColors(chainId).name;
}
function LegChip({
  leg,
  chainLabel
}) {
  const isSource = leg.role === "source";
  const tx = shortHash(leg.txHash);
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: "inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-xs",
      style: {
        borderColor: getChainGroupColors(leg.chainId).brandColor,
        background: getChainGroupColors(leg.chainId).fill
      },
      title: leg.txHash,
      children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium uppercase tracking-wide opacity-70", children: isSource ? "Source" : leg.role === "destination" ? "Destination" : roleLabel(leg.role) }),
        /* @__PURE__ */ jsx("span", { className: "font-medium", children: leg.label ?? chainName(leg.chainId, chainLabel) }),
        tx && /* @__PURE__ */ jsx("span", { className: "font-mono opacity-60", children: tx })
      ]
    }
  );
}
function ExpectedLegChip({
  leg,
  chainLabel
}) {
  const chain = leg.reach.chain;
  const status = leg.timedOut ? "never arrived" : leg.reach.kind === "uncovered" ? "not indexed" : "not observed yet";
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: "inline-flex items-center gap-1.5 rounded-md border border-dashed px-2 py-1 text-xs text-muted-foreground",
      style: chain ? { borderColor: getChainGroupColors(chain).brandColor } : void 0,
      title: leg.reach.kind === "uncovered" ? `The missing leg ${missingLegReason(leg.reach)}` : `Joins when ${leg.joinsWhen}.`,
      "data-testid": "expected-leg-chip",
      children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium uppercase tracking-wide opacity-70", children: roleLabel(leg.role) }),
        chain ? /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: chainLabel?.(chain) ?? chainDisplayName(chain) }) : null,
        /* @__PURE__ */ jsx("span", { className: "italic", children: status })
      ]
    }
  );
}
var LEG_CHIPS_SHOWN = 8;
function GroupGraphView({
  group,
  renderHighlights,
  chainLabel,
  live,
  expectedLegs: hostLegs,
  expectedLegAction,
  ...sceneProps
}) {
  const { highlights, legs, origin, originChain, messageId, idLabel, truncation } = group;
  const expected = React17.useMemo(() => hostLegs ?? expectedLegs(group), [hostLegs, group]);
  const scene = React17.useMemo(
    () => annotateExpectedLegs(group.scene, expected, Date.now(), group.protocolId),
    [group.scene, expected, group.protocolId]
  );
  const originName = origin ? shortAddr(origin) : void 0;
  const originChainName = originChain ? chainName(originChain, chainLabel) : void 0;
  const filling = useInGraphFrame();
  const [allLegs, setAllLegs] = React17.useState(false);
  const foldedLegs = Math.max(0, legs.length - LEG_CHIPS_SHOWN);
  const shownLegs = allLegs || foldedLegs === 0 ? legs : legs.slice(0, LEG_CHIPS_SHOWN);
  return (
    // `overflow-y-auto`: the graph below has a floor, so a header taller than
    // the frame scrolls inside it instead of spilling over what follows.
    /* @__PURE__ */ jsxs("div", { className: filling ? "flex h-full min-h-0 flex-col gap-3 overflow-y-auto" : "space-y-3", children: [
      renderHighlights && highlights.length > 0 && /* @__PURE__ */ jsx("div", { children: renderHighlights(highlights) }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
        shownLegs.map((leg, i) => /* @__PURE__ */ jsx(LegChip, { leg, chainLabel }, `${leg.role}:${leg.chainId}:${i}`)),
        foldedLegs > 0 ? /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "rounded-md border border-dashed px-2 py-1 text-xs text-muted-foreground hover:bg-muted focus-ring",
            "aria-expanded": allLegs,
            "data-testid": "group-legs-toggle",
            onClick: () => setAllLegs((open) => !open),
            children: allLegs ? "Show fewer" : `+${foldedLegs} more ${foldedLegs === 1 ? "leg" : "legs"}`
          }
        ) : null,
        expected.map((leg) => /* @__PURE__ */ jsx(ExpectedLegChip, { leg, chainLabel }, `expected:${leg.role}`)),
        live ?? /* @__PURE__ */ jsx(LifecycleBadge, { group }),
        expected.length > 0 && expectedLegAction ? /* @__PURE__ */ jsx("div", { className: "min-w-0 basis-full sm:basis-auto", "data-testid": "expected-leg-action", children: expectedLegAction }) : null
      ] }),
      (originName || messageId) && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground", children: [
        originName && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx("span", { className: "opacity-70", children: "Origin" }),
          " ",
          /* @__PURE__ */ jsx("span", { className: "font-mono", children: originName }),
          originChainName && /* @__PURE__ */ jsxs("span", { className: "opacity-70", children: [
            " on ",
            originChainName
          ] })
        ] }),
        messageId && /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx("span", { className: "opacity-70", children: sagaIdLabel(idLabel) }),
          " ",
          /* @__PURE__ */ jsx("span", { className: "font-mono", title: messageId, children: correlationIdText(messageId, idLabel, (raw) => shortCorrelationId(raw) ?? raw).text })
        ] })
      ] }),
      /* @__PURE__ */ jsx(TruncationNotice, { truncation }),
      filling ? (
        /* A nested frame so what is left is a DEFINITE height a percentage can
           resolve against — and a floor under it. It was `min-h-0`, "so the
           graph can give way to the header stack", and it gave way all the way:
           a header taller than the frame left a 0px canvas with its toolbar
           floating over nothing. A graph view that draws no graph is not a
           layout the header gets to choose. */
        /* @__PURE__ */ jsx(GraphFrame, { className: "min-h-[16rem] flex-1", children: /* @__PURE__ */ jsx(SceneGraphView, { scene, chainLabel, ...sceneProps }) })
      ) : /* @__PURE__ */ jsx(SceneGraphView, { scene, chainLabel, ...sceneProps })
    ] })
  );
}

// src/scene/index.ts
init_GraphAuthoring();
init_GraphDefaults();
init_useGraphDetailTier();
function GraphTimeline({
  controller,
  locale,
  showLabels = true,
  emptyState = null,
  className
}) {
  const { min, max, cursor, hasTimeline, setCursor } = controller;
  if (!hasTimeline) return /* @__PURE__ */ jsx(Fragment, { children: emptyState });
  return /* @__PURE__ */ jsxs("div", { className: cn("flex w-full flex-col gap-1", className), children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "range",
        min,
        max,
        step: 1,
        value: cursor,
        onChange: (event) => setCursor(Number(event.target.value)),
        "aria-label": "Replay timeline",
        className: "h-1.5 w-full cursor-pointer appearance-none rounded-full bg-muted accent-[hsl(var(--brand))]"
      }
    ),
    showLabels && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between text-2xs text-muted-foreground tabular-nums", children: [
      /* @__PURE__ */ jsx("span", { children: formatTimestamp(min, { locale }) }),
      /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: formatTimestamp(cursor, { locale }) }),
      /* @__PURE__ */ jsx("span", { children: formatTimestamp(max, { locale }) })
    ] })
  ] });
}
function clampRange([from, to], min, max) {
  const lo = Math.max(min, Math.min(from, to));
  const hi = Math.min(max, Math.max(from, to));
  return [lo, hi];
}
function TimeRangeSlider({
  min,
  max,
  value,
  onChange,
  step = 1,
  locale,
  timeZone,
  showLabels = true,
  emptyState = null,
  className,
  "aria-label": ariaLabel = "Time range filter"
}) {
  if (!(max > min)) return /* @__PURE__ */ jsx(Fragment, { children: emptyState });
  const [from, to] = clampRange(value, min, max);
  const isFullRange = from <= min && to >= max;
  const stamp = (at) => `${formatTimestamp(at, { locale, timeZone, timeStyle: "medium" })}${timeZone === "UTC" ? " UTC" : ""}`;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex w-full flex-col gap-1", className), children: [
    /* @__PURE__ */ jsx(
      Slider,
      {
        min,
        max,
        step,
        value: [from, to],
        thumbLabels: ["Start time (included)", "End time (included)"],
        getValueText: stamp,
        onValueChange: (next) => {
          const a = next[0] ?? min;
          const b = next[1] ?? max;
          onChange(clampRange([a, b], min, max));
        },
        "aria-label": ariaLabel
      }
    ),
    showLabels && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between text-2xs text-muted-foreground tabular-nums", children: [
      /* @__PURE__ */ jsx("span", { children: stamp(min) }),
      /* @__PURE__ */ jsx("span", { className: cn("font-medium", isFullRange ? "text-muted-foreground" : "text-foreground"), children: isFullRange ? "Full range" : `${stamp(from)} \u2013 ${stamp(to)}` }),
      /* @__PURE__ */ jsx("span", { children: stamp(max) })
    ] })
  ] });
}

// src/timeline/timeRange.ts
function edgeTime(edge) {
  const t = edge.data?.timestamp;
  return typeof t === "number" && Number.isFinite(t) ? t : void 0;
}
function graphTimeDomain(edges) {
  let min = Infinity;
  let max = -Infinity;
  for (const edge of edges) {
    const t = edgeTime(edge);
    if (t === void 0) continue;
    if (t < min) min = t;
    if (t > max) max = t;
  }
  if (min === Infinity) return null;
  return { min, max };
}
function filterGraphByTimeRange(nodes, edges, range, options = {}) {
  const [from, to] = range[0] <= range[1] ? range : [range[1], range[0]];
  const keptEdges = edges.filter((edge) => {
    const t = edgeTime(edge);
    if (t === void 0) return true;
    return t >= from && t <= to;
  });
  if (options.keepOrphanNodes) return { nodes, edges: keptEdges };
  const connected = /* @__PURE__ */ new Set();
  for (const edge of keptEdges) {
    connected.add(edge.source);
    connected.add(edge.target);
  }
  const keptNodes = nodes.filter((node) => connected.has(node.id));
  return { nodes: keptNodes, edges: keptEdges };
}
function useGraphTimeRange({
  nodes,
  edges,
  keepOrphanNodes
}) {
  const domain = React17.useMemo(() => graphTimeDomain(edges), [edges]);
  const domainKey = domain ? `${domain.min}:${domain.max}` : "";
  const [selection, setSelection] = React17.useState(null);
  const selected = selection && selection.key === domainKey ? selection.range : null;
  const effectiveRange = selected ?? (domain ? [domain.min, domain.max] : [0, 0]);
  const setRange = React17.useCallback(
    (next) => {
      setSelection(domainKey ? { key: domainKey, range: next } : null);
    },
    [domainKey]
  );
  const reset = React17.useCallback(() => setSelection(null), []);
  const filtered = React17.useMemo(() => {
    if (!domain) return { nodes, edges };
    return filterGraphByTimeRange(nodes, edges, effectiveRange, { keepOrphanNodes });
  }, [domain, nodes, edges, effectiveRange[0], effectiveRange[1], keepOrphanNodes]);
  const isFullRange = !domain || effectiveRange[0] <= domain.min && effectiveRange[1] >= domain.max;
  return {
    domain,
    hasTimeline: domain != null && domain.max > domain.min,
    range: effectiveRange,
    setRange,
    reset,
    isFullRange,
    nodes: filtered.nodes,
    edges: filtered.edges
  };
}
function useReplay({ edges, intervalMs = 700, autoPlay = false }) {
  const stamps = React17.useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const edge of edges) {
      const ts = edge.data?.timestamp;
      if (typeof ts === "number" && Number.isFinite(ts)) set.add(ts);
    }
    return Array.from(set).sort((a, b) => a - b);
  }, [edges]);
  const hasTimeline = stamps.length > 0;
  const min = hasTimeline ? stamps[0] : 0;
  const max = hasTimeline ? stamps[stamps.length - 1] : 0;
  const [cursor, setCursorRaw] = React17.useState(max);
  const [requested, setPlaying] = React17.useState(autoPlay && hasTimeline);
  const timelineKey = `${min}:${max}:${stamps.length}`;
  if (useDepsChanged([timelineKey])) {
    setCursorRaw(max);
    setPlaying(autoPlay && stamps.length > 0);
  }
  const nextStamp = React17.useCallback(
    (from) => stamps.find((s) => s > from) ?? from,
    [stamps]
  );
  const prevStamp = React17.useCallback(
    (from) => [...stamps].reverse().find((s) => s < from) ?? from,
    [stamps]
  );
  const playing = requested && nextStamp(cursor) > cursor;
  React17.useEffect(() => {
    if (!playing) return;
    const id = setInterval(() => setCursorRaw((current) => nextStamp(current)), intervalMs);
    return () => clearInterval(id);
  }, [playing, intervalMs, nextStamp]);
  const setCursor = React17.useCallback(
    (t) => setCursorRaw(Math.max(min, Math.min(max, t))),
    [min, max]
  );
  const pause = React17.useCallback(() => setPlaying(false), []);
  const play = React17.useCallback(() => {
    if (!hasTimeline) return;
    setCursorRaw((current) => current >= max ? min : current);
    setPlaying(true);
  }, [hasTimeline, min, max]);
  const toggle = React17.useCallback(() => playing ? pause() : play(), [playing, pause, play]);
  const stepForward = React17.useCallback(() => {
    setPlaying(false);
    setCursorRaw((current) => nextStamp(current));
  }, [nextStamp]);
  const stepBackward = React17.useCallback(() => {
    setPlaying(false);
    setCursorRaw((current) => prevStamp(current));
  }, [prevStamp]);
  const reset = React17.useCallback(() => {
    setPlaying(false);
    setCursorRaw(max);
  }, [max]);
  const visibleEdges = React17.useMemo(
    () => edges.filter((edge) => edge.data?.timestamp == null || edge.data.timestamp <= cursor),
    [edges, cursor]
  );
  const visibleEdgeIds = React17.useMemo(() => new Set(visibleEdges.map((e) => e.id)), [visibleEdges]);
  const progress = max > min ? (cursor - min) / (max - min) : 1;
  return {
    min,
    max,
    cursor,
    progress,
    playing,
    hasTimeline,
    setCursor,
    play,
    pause,
    toggle,
    stepForward,
    stepBackward,
    reset,
    visibleEdges,
    visibleEdgeIds
  };
}
function ReplayControls({
  controller,
  showStep = true,
  className
}) {
  const { playing, hasTimeline, play, pause, stepForward, stepBackward, reset } = controller;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex items-center gap-1", className), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: reset,
        disabled: !hasTimeline,
        "aria-label": "Reset replay",
        title: "Reset",
        children: "\u23EE"
      }
    ),
    showStep && /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: stepBackward,
        disabled: !hasTimeline,
        "aria-label": "Step backward",
        title: "Step back",
        children: "\u25C0"
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: playing ? pause : play,
        disabled: !hasTimeline,
        "aria-label": playing ? "Pause replay" : "Play replay",
        title: playing ? "Pause" : "Play",
        children: playing ? "\u23F8" : "\u25B6"
      }
    ),
    showStep && /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        onClick: stepForward,
        disabled: !hasTimeline,
        "aria-label": "Step forward",
        title: "Step forward",
        children: "\u25B6"
      }
    )
  ] });
}
function collectDescendants(parentId, provenance) {
  const direct = provenance[parentId] ?? [];
  return direct.flatMap((id) => [id, ...collectDescendants(id, provenance)]);
}
function dropErrors(errors, ids) {
  if (!ids.some((id) => id in errors)) return errors;
  const next = { ...errors };
  for (const id of ids) delete next[id];
  return next;
}
function graphExpansionReducer(state, action) {
  switch (action.type) {
    case "SET_GRAPH":
    case "RESET":
      return {
        nodes: action.nodes,
        edges: action.edges,
        provenance: {},
        expanded: [],
        loading: [],
        errors: {}
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.value ? state.loading.includes(action.id) ? state.loading : [...state.loading, action.id] : state.loading.filter((id) => id !== action.id)
      };
    case "FAILED": {
      const { [action.id]: _prior, ...rest } = state.errors;
      return {
        ...state,
        loading: state.loading.filter((id) => id !== action.id),
        errors: { ...rest, [action.id]: action.message }
      };
    }
    case "MERGE": {
      const nodeIds = new Set(state.nodes.map((node) => node.id));
      const edgeIds = new Set(state.edges.map((edge) => edge.id));
      const addedNodes = action.nodes.filter((node) => !nodeIds.has(node.id));
      const addedEdges = action.edges.filter((edge) => !edgeIds.has(edge.id));
      return {
        nodes: [...state.nodes, ...addedNodes],
        edges: [...state.edges, ...addedEdges],
        provenance: { ...state.provenance, [action.parentId]: addedNodes.map((node) => node.id) },
        expanded: state.expanded.includes(action.parentId) ? state.expanded : [...state.expanded, action.parentId],
        loading: state.loading.filter((id) => id !== action.parentId),
        errors: dropErrors(state.errors, [action.parentId])
      };
    }
    case "COLLAPSE": {
      const removeIds = new Set(collectDescendants(action.parentId, state.provenance));
      if (removeIds.size === 0) {
        return {
          ...state,
          expanded: state.expanded.filter((id) => id !== action.parentId),
          errors: dropErrors(state.errors, [action.parentId])
        };
      }
      const provenance = {};
      for (const [key, value] of Object.entries(state.provenance)) {
        if (key === action.parentId || removeIds.has(key)) continue;
        provenance[key] = value;
      }
      return {
        ...state,
        nodes: state.nodes.filter((node) => !removeIds.has(node.id)),
        edges: state.edges.filter((edge) => !removeIds.has(edge.source) && !removeIds.has(edge.target)),
        provenance,
        expanded: state.expanded.filter((id) => id !== action.parentId && !removeIds.has(id)),
        loading: state.loading.filter((id) => !removeIds.has(id)),
        errors: dropErrors(state.errors, [action.parentId, ...removeIds])
      };
    }
    default:
      return state;
  }
}
function useGraphReducer(options = {}) {
  const { initialNodes, initialEdges, loadNeighborhood } = options;
  const [state, dispatch] = React17.useReducer(graphExpansionReducer, void 0, () => ({
    nodes: initialNodes ?? [],
    edges: initialEdges ?? [],
    provenance: {},
    expanded: [],
    loading: [],
    errors: {}
  }));
  const inFlight = React17.useRef(/* @__PURE__ */ new Set());
  const expand = React17.useCallback(
    async (nodeId2) => {
      if (!loadNeighborhood || inFlight.current.has(nodeId2)) return;
      inFlight.current.add(nodeId2);
      dispatch({ type: "SET_LOADING", id: nodeId2, value: true });
      try {
        const neighborhood = await loadNeighborhood(nodeId2);
        dispatch({ type: "MERGE", parentId: nodeId2, nodes: neighborhood.nodes, edges: neighborhood.edges });
      } catch (error) {
        dispatch({
          type: "FAILED",
          id: nodeId2,
          message: error instanceof Error ? error.message : String(error)
        });
        throw error;
      } finally {
        inFlight.current.delete(nodeId2);
      }
    },
    [loadNeighborhood]
  );
  const collapse = React17.useCallback((nodeId2) => {
    dispatch({ type: "COLLAPSE", parentId: nodeId2 });
  }, []);
  const expandedSet = React17.useMemo(() => new Set(state.expanded), [state.expanded]);
  const toggle = React17.useCallback(
    (nodeId2) => {
      if (expandedSet.has(nodeId2)) collapse(nodeId2);
      else void expand(nodeId2).catch(() => void 0);
    },
    [expandedSet, collapse, expand]
  );
  const setGraph = React17.useCallback((nodes, edges) => {
    dispatch({ type: "SET_GRAPH", nodes, edges });
  }, []);
  const reset = React17.useCallback(() => {
    dispatch({ type: "RESET", nodes: initialNodes ?? [], edges: initialEdges ?? [] });
  }, [initialNodes, initialEdges]);
  const loadingSet = React17.useMemo(() => new Set(state.loading), [state.loading]);
  const errorMap = React17.useMemo(() => new Map(Object.entries(state.errors)), [state.errors]);
  return {
    nodes: state.nodes,
    edges: state.edges,
    expanded: expandedSet,
    loading: loadingSet,
    errors: errorMap,
    expand,
    collapse,
    toggle,
    setGraph,
    reset
  };
}
var log2 = createLogger("tx-graph:drilldown");
function NodeDrilldownPanel({
  node,
  onClose,
  onExpand,
  onCollapse,
  expanded = false,
  loading = false,
  children,
  className
}) {
  const handleExpand = React17.useCallback(async () => {
    if (!node) return;
    try {
      if (expanded) onCollapse?.(node.id);
      else await onExpand?.(node.id);
    } catch (error) {
      log2.error("neighbourhood expand failed", { nodeId: node.id });
      notifyError(error);
    }
  }, [node, expanded, onExpand, onCollapse]);
  if (!node) return null;
  const variant = node.data.variant ?? "tx";
  return /* @__PURE__ */ jsxs(
    "aside",
    {
      className: cn(
        "flex w-80 flex-col gap-3 rounded-md border bg-card p-4 text-sm shadow-xs",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("header", { className: "flex items-start justify-between gap-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "w-fit font-normal", children: GRAPH_NODE_VARIANT_LABELS[variant] }),
            /* @__PURE__ */ jsx("h3", { className: "font-medium leading-tight", children: node.data.label }),
            node.data.subtitle && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: node.data.subtitle })
          ] }),
          onClose && /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              variant: "ghost",
              size: "sm",
              onClick: onClose,
              "aria-label": "Close details",
              title: "Close",
              children: "\u2715"
            }
          )
        ] }),
        node.data.chain && /* @__PURE__ */ jsx(ChainAvatar, { chain: node.data.chain, size: "sm" }),
        (onExpand || onCollapse) && /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            variant: "outline",
            size: "sm",
            className: "w-full",
            onClick: handleExpand,
            disabled: loading,
            children: loading ? "Loading\u2026" : expanded ? "Collapse neighbourhood" : "Expand neighbourhood"
          }
        ),
        children
      ]
    }
  );
}

// src/share/index.ts
init_serialize();
init_GraphViewContext();
init_catalogSnapshot();

// src/share/dynamicSeed.ts
var GRAPH_DYNAMIC_SEED_KIND = "tx-graph";
function asStringArray(value) {
  if (!Array.isArray(value)) return [];
  return value.filter((v) => v != null).map((v) => String(v));
}
function asRecord(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}
function firstDefined(...values) {
  for (const v of values) if (v !== void 0 && v !== null) return v;
  return void 0;
}
function normalizeDynamicSeed(raw) {
  if (!raw || typeof raw !== "object") return null;
  const r = raw;
  const rootIds = asStringArray(firstDefined(r.root_ids, r.rootIds));
  const expandedIds = asStringArray(firstDefined(r.expanded_ids, r.expandedIds, r.expanded));
  const chainIds = asStringArray(firstDefined(r.chain_ids, r.chainIds));
  const filters = asRecord(firstDefined(r.filters));
  const grouping = firstDefined(r.grouping);
  const hiddenPanels = asStringArray(
    firstDefined(r.hidden_panels, r.hiddenPanels)
  );
  const rawChannel = firstDefined(r.stream_channel, r.streamChannel);
  const rawRange = firstDefined(r.time_range, r.timeRange);
  if (!rootIds.length && !expandedIds.length && !rawChannel && !r.resource) return null;
  const streamChannel = rawChannel ? {
    id: rawChannel.id != null ? String(rawChannel.id) : void 0,
    kind: rawChannel.kind != null ? String(rawChannel.kind) : void 0,
    params: asRecord(rawChannel.params)
  } : null;
  return {
    kind: r.kind != null ? String(r.kind) : GRAPH_DYNAMIC_SEED_KIND,
    resource: r.resource != null ? String(r.resource) : null,
    rootIds,
    expandedIds,
    chainIds,
    viewMode: firstDefined(r.view_mode, r.viewMode) ?? null,
    engine: firstDefined(r.engine) ?? null,
    expandDepth: Number(firstDefined(r.expand_depth, r.expandDepth) ?? 1) || 1,
    timeRange: rawRange ? { start: rawRange.start ?? null, end: rawRange.end ?? null } : null,
    filters,
    streamChannel,
    detailTier: firstDefined(r.detail_tier, r.detailTier) ?? null,
    grouping: grouping ? grouping : null,
    search: firstDefined(r.search) != null ? String(firstDefined(r.search)) : null,
    hiddenPanels
  };
}
function dynamicSeedToChannel(seed) {
  const id = seed?.streamChannel?.id;
  if (!id) return null;
  return { id };
}

// src/share/viewServing.ts
init_serialize();
function defaultStreamChannel(_rootIds) {
  return null;
}
function buildGraphViewServing(state, options = {}) {
  const {
    dataMode = "static",
    payloadVisibility,
    catalogResolution = "viewer",
    resource = GRAPH_DYNAMIC_SEED_KIND,
    streamChannel = defaultStreamChannel,
    frozenAt = Date.now()
  } = options;
  if (!state) {
    return {
      dataMode,
      payloadVisibility,
      catalogResolution,
      dynamicSeed: null,
      snapshot: null
    };
  }
  const nodes = Array.isArray(state.nodes) ? state.nodes : [];
  const edges = Array.isArray(state.edges) ? state.edges : [];
  const rootIds = Array.isArray(state.rootIds) ? state.rootIds.map(String) : [];
  const expandedIds = Array.isArray(state.expanded) ? state.expanded.map(String) : [];
  const descriptor = compactGraphState(state);
  const snapshot = state.scene ? { ...descriptor, scene: state.scene, frozenAt } : nodes.length || edges.length ? { ...descriptor, nodes, edges, frozenAt } : null;
  let dynamicSeed = null;
  if (rootIds.length || expandedIds.length) {
    const channel = streamChannel(rootIds);
    dynamicSeed = {
      kind: GRAPH_DYNAMIC_SEED_KIND,
      resource: state.resource ?? resource,
      root_ids: rootIds,
      expanded_ids: expandedIds,
      view_mode: state.viewMode ?? null,
      engine: state.engine ?? null,
      filters: state.filters ?? {},
      // The client-side view state travels with the recipe, not just with the
      // snapshot. A scene is a superset the client filters, bands and searches,
      // so a dynamic link that replays only the fetch reopens at Compact,
      // ungrouped and unsearched — the same saved view showing a different graph
      // depending on which way the link happened to serve it. `GraphShareState`
      // spells out why each of these has to survive; the snapshot honoured that
      // and the seed did not.
      detail_tier: state.detailTier ?? null,
      grouping: state.grouping ?? null,
      search: state.search ?? null,
      hidden_panels: state.hiddenPanels ?? [],
      ...channel ? { stream_channel: channel } : {}
    };
  }
  return {
    dataMode,
    payloadVisibility,
    catalogResolution,
    // Only when this state actually carries one — see the field's docstring.
    ...state.catalog ? { catalogSnapshot: state.catalog } : {},
    dynamicSeed,
    snapshot
  };
}

// src/share/SharedGraphView.tsx
init_GraphCanvas();
init_GraphExportMenu();
init_SceneGraphView();
init_catalogSnapshot();
init_GraphViewContext();
var LiveGraphLayer2 = React17.lazy(() => Promise.resolve().then(() => (init_LiveGraphLayer(), LiveGraphLayer_exports)));
function readViewState(source) {
  if (!source || typeof source !== "object") return {};
  const viewMode = source.viewMode ?? source.view_mode;
  const engine = source.engine;
  const detailTier = source.detailTier ?? source.detail_tier;
  const hiddenPanels = source.hiddenPanels ?? source.hidden_panels;
  const search = source.search;
  const grouping = source.grouping;
  const frozenAt = Number(source.frozenAt ?? source.frozen_at);
  return {
    viewContext: readGraphViewContext(source.viewContext),
    groups: Array.isArray(source.groups) ? source.groups : void 0,
    bundleParallelEdges: typeof source.bundleParallelEdges === "boolean" ? source.bundleParallelEdges : void 0,
    viewMode: typeof viewMode === "string" ? viewMode : void 0,
    engine: typeof engine === "string" ? engine : void 0,
    detailTier: typeof detailTier === "string" ? detailTier : void 0,
    grouping: grouping && typeof grouping === "object" ? grouping : void 0,
    search: typeof search === "string" && search ? search : void 0,
    hiddenPanels: Array.isArray(hiddenPanels) ? hiddenPanels : void 0,
    frozenAt: Number.isFinite(frozenAt) && frozenAt > 0 ? frozenAt : void 0
  };
}
function readSnapshot(snap) {
  if (!snap || typeof snap !== "object") return { nodes: [], edges: [], view: {} };
  const s = snap;
  const view = readViewState(s);
  if (s.scene && typeof s.scene === "object") {
    return { nodes: [], edges: [], scene: s.scene, view };
  }
  return {
    nodes: Array.isArray(s.nodes) ? s.nodes : [],
    edges: Array.isArray(s.edges) ? s.edges : [],
    view
  };
}
function describeUnservableShare(input) {
  if (input.dataMode !== "dynamic") return null;
  if (!input.hasSeed) {
    return "This link shares a live view, but it carries no re-fetch recipe \u2014 it may have been created before the view had one. Ask the owner to re-share it as a snapshot.";
  }
  if (!input.hasResolver && !input.hasChannel) {
    return "This link shares a live view, and this viewer isn't wired to fetch live graph data. Ask the owner for a snapshot link instead.";
  }
  return null;
}
function defaultParseLive(message) {
  const payload = message.payload;
  if (!payload || typeof payload !== "object") return null;
  const nodes = Array.isArray(payload.nodes) ? payload.nodes : [];
  const edges = Array.isArray(payload.edges) ? payload.edges : [];
  if (!nodes.length && !edges.length) return null;
  return { nodes, edges };
}
function SharedGraphView({
  dataMode,
  snapshot,
  dynamicSeed,
  seedResolver,
  parseLiveMessage,
  live = true,
  catalog,
  resolveOverlay: viewerOverlay,
  onCatalogRefsChange,
  showExport,
  viewMode,
  height,
  className,
  loadingSlot,
  emptySlot,
  errorSlot
}) {
  const seed = React17.useMemo(() => {
    if (!dynamicSeed) return null;
    if (Array.isArray(dynamicSeed.rootIds)) {
      return dynamicSeed;
    }
    return normalizeDynamicSeed(dynamicSeed);
  }, [dynamicSeed]);
  const staticGraph = React17.useMemo(
    () => dataMode === "static" ? readSnapshot(snapshot) : { nodes: [], edges: [], view: {} },
    [dataMode, snapshot]
  );
  const view = dataMode === "static" ? staticGraph.view : readViewState(seed);
  const [nodes, setNodes] = React17.useState(staticGraph.nodes);
  const [edges, setEdges] = React17.useState(staticGraph.edges);
  const [scene, setScene] = React17.useState(staticGraph.scene);
  const [compactScreen] = React17.useState(() => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(max-width: 639px)").matches);
  const [fetching, setFetching] = React17.useState(dataMode === "dynamic");
  const [fetchError, setFetchError] = React17.useState(void 0);
  const nodesRef = React17.useRef(nodes);
  nodesRef.current = nodes;
  const edgesRef = React17.useRef(edges);
  edgesRef.current = edges;
  React17.useEffect(() => {
    if (dataMode === "static") {
      setNodes(staticGraph.nodes);
      setEdges(staticGraph.edges);
      setScene(staticGraph.scene);
      setFetching(false);
    }
  }, [dataMode, staticGraph]);
  React17.useEffect(() => {
    if (dataMode !== "dynamic" || !seed || !seedResolver) {
      if (dataMode === "dynamic") setFetching(false);
      return;
    }
    const controller = new AbortController();
    let active = true;
    setFetching(true);
    setFetchError(void 0);
    seedResolver(seed, { signal: controller.signal }).then((snap) => {
      if (!active) return;
      setNodes(snap.nodes ?? []);
      setEdges(snap.edges ?? []);
      setScene(snap.scene);
    }).catch((err) => {
      if (!active) return;
      setFetchError(err instanceof Error ? err.message : String(err));
    }).finally(() => {
      if (active) setFetching(false);
    });
    return () => {
      active = false;
      controller.abort();
    };
  }, [dataMode, seed, seedResolver]);
  const channel = React17.useMemo(
    () => dataMode === "dynamic" && live ? dynamicSeedToChannel(seed) : null,
    [dataMode, live, seed]
  );
  const resolveOverlay = React17.useMemo(
    () => catalog != null ? catalogResolverFrom(catalog) : viewerOverlay,
    [catalog, viewerOverlay]
  );
  const catalogRefs = React17.useMemo(() => graphCatalogRefs(scene ?? { nodes }), [scene, nodes]);
  React17.useEffect(() => {
    onCatalogRefsChange?.(catalogRefs);
  }, [catalogRefs, onCatalogRefsChange]);
  const drawnNodes = React17.useMemo(
    () => applyCatalogOverlay(nodes, resolveOverlay),
    [nodes, resolveOverlay]
  );
  const canvasContainerRef = React17.useRef(null);
  const onMerge = React17.useCallback((merged) => {
    setNodes(merged.nodes);
    setEdges(merged.edges);
  }, []);
  const initialViewMode = viewMode ?? view.viewMode ?? "hierarchical";
  const [elementViewMode, setElementViewMode] = React17.useState(initialViewMode);
  React17.useEffect(() => {
    setElementViewMode(initialViewMode);
  }, [initialViewMode]);
  if (fetching) {
    return /* @__PURE__ */ jsx(Fragment, { children: loadingSlot ?? null });
  }
  if (fetchError) {
    return /* @__PURE__ */ jsx(Fragment, { children: errorSlot ? errorSlot(fetchError) : null });
  }
  const unservable = describeUnservableShare({
    dataMode,
    hasSeed: Boolean(seed),
    hasResolver: Boolean(seedResolver),
    hasChannel: Boolean(channel)
  });
  if (unservable) {
    return /* @__PURE__ */ jsx(Fragment, { children: errorSlot ? errorSlot(unservable) : emptySlot ?? null });
  }
  const liveProps = channel ? {
    channel,
    nodesRef,
    edgesRef,
    parse: parseLiveMessage ?? defaultParseLive,
    onMerge
  } : null;
  const liveLayer = liveProps ? /* @__PURE__ */ jsx(React17.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(LiveGraphLayer2, { ...liveProps }) }) : null;
  if (scene) {
    return /* @__PURE__ */ jsx(
      SceneGraphView,
      {
        scene,
        resolveOverlay,
        defaultViewMode: viewMode ?? view.viewMode,
        defaultDetailTier: view.detailTier,
        defaultGrouping: view.grouping,
        defaultHiddenPanels: view.hiddenPanels ?? (compactScreen ? ["highlights", "legend", "stats", "minimap"] : void 0),
        defaultSearchQuery: view.search,
        ...showExport === void 0 ? {} : { showExport },
        ...height === void 0 ? {} : { height },
        className
      }
    );
  }
  if (!nodes.length && !edges.length) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      emptySlot ?? null,
      liveLayer
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      GraphCanvas,
      {
        containerRef: canvasContainerRef,
        header: /* @__PURE__ */ jsx(GraphViewContext, { value: view.viewContext }),
        nodes: drawnNodes,
        edges,
        chainGroups: view.groups,
        bundleParallelEdges: view.bundleParallelEdges,
        viewMode: elementViewMode,
        onViewModeChange: setElementViewMode,
        rankBy: elementViewMode === "temporal" ? "time" : void 0,
        engine: view.engine,
        showViewModeToggle: true,
        showFullscreen: true,
        showRelayout: true,
        searchQuery: view.search,
        fitView: true,
        className,
        extraToolbar: showExport === false ? void 0 : /* @__PURE__ */ jsx(
          GraphExportMenu,
          {
            graph: { nodes: drawnNodes, edges, ...view, viewMode: elementViewMode },
            containerRef: canvasContainerRef,
            filenameBase: "shared-graph"
          }
        )
      }
    ),
    liveLayer
  ] });
}
init_caseShare();
var CaseShareView2 = React17.lazy(() => Promise.resolve().then(() => (init_CaseShareView(), CaseShareView_exports)));
var ReportShareView = React17.lazy(
  () => import('@authe/reporting/preview').then((m) => ({ default: m.ReportSnapshotView }))
);
var LIVE_POLL_MS = 6e4;
var LIVE_FALLBACK_POLL_MS = 10 * 6e4;
var WAKE_COALESCE_MS = 1500;
function usePublicationEvents(config, ticket, onWake) {
  const [connected, setConnected] = React17.useState(false);
  const connection = React17.useRef(null);
  const latestTicket = React17.useRef(ticket);
  latestTicket.current = ticket;
  const wake = React17.useRef(onWake);
  wake.current = onWake;
  const endpoint3 = config?.endpoint;
  const region = config?.region;
  const active = Boolean(endpoint3 && region && ticket);
  React17.useEffect(() => {
    if (!active || !endpoint3 || !region) return;
    let cancelled = false;
    let timer;
    let opened = null;
    void Promise.resolve().then(() => (init_publicationEvents(), publicationEvents_exports)).then(({ connectPublicationEvents: connectPublicationEvents2 }) => {
      if (cancelled) return;
      opened = connectPublicationEvents2({ endpoint: endpoint3, region }, () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => wake.current(), WAKE_COALESCE_MS);
      }, void 0, (live) => {
        if (!cancelled) setConnected(live);
      });
      if (latestTicket.current) opened.setTicket(latestTicket.current);
      connection.current = opened;
    }).catch(() => {
    });
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      opened?.close();
      connection.current = null;
      setConnected(false);
    };
  }, [active, endpoint3, region]);
  React17.useEffect(() => {
    if (ticket) connection.current?.setTicket(ticket);
  }, [ticket]);
  return connected;
}
function ShareHeading({
  name,
  frozenAt
}) {
  if (!name && !frozenAt) return null;
  return /* @__PURE__ */ jsxs("div", { className: "mb-3 flex flex-wrap items-baseline gap-x-2 gap-y-1", children: [
    name ? /* @__PURE__ */ jsx("h2", { className: "text-base font-semibold", children: name }) : null,
    frozenAt ? /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
      "Snapshot frozen ",
      new Date(frozenAt).toLocaleString()
    ] }) : null
  ] });
}
function viewName(view) {
  const name = view?.name;
  return typeof name === "string" && name.trim() ? name.trim() : void 0;
}
function frozenAtOf(snapshot) {
  const raw = Number(snapshot?.frozenAt);
  return Number.isFinite(raw) && raw > 0 ? raw : void 0;
}
function PasswordGate({
  onSubmit,
  error,
  busy = false
}) {
  const [value, setValue] = React17.useState("");
  return /* @__PURE__ */ jsxs(
    "form",
    {
      className: "mx-auto flex w-full max-w-sm flex-col gap-3 py-10",
      onSubmit: (e) => {
        e.preventDefault();
        if (value && !busy) onSubmit(value);
      },
      children: [
        /* @__PURE__ */ jsx(Label, { htmlFor: "share-password", children: "This shared view is password-protected" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            id: "share-password",
            type: "password",
            name: "share-password",
            autoComplete: "current-password",
            required: true,
            disabled: busy,
            "aria-invalid": Boolean(error),
            "aria-describedby": error ? "share-password-error" : void 0,
            autoFocus: true,
            value,
            onChange: (e) => setValue(e.target.value),
            placeholder: "Enter password"
          }
        ),
        error ? /* @__PURE__ */ jsx("p", { id: "share-password-error", role: "alert", className: "text-sm text-destructive", children: error }) : null,
        /* @__PURE__ */ jsx(Button, { type: "submit", disabled: !value || busy, children: busy ? "Opening\u2026" : "Open shared view" })
      ]
    }
  );
}
function GraphShareViewer({
  source,
  token,
  seedResolver,
  parseLiveMessage,
  live = true,
  viewMode,
  className,
  onAuthRequired,
  showHeading = true,
  onResolved,
  onUnavailable,
  realtime,
  focusTrail,
  onNotifyTrail
}) {
  const {
    status,
    refreshing,
    resolved,
    snapshot,
    snapshotError,
    warnings,
    error,
    errorCode,
    errorCause,
    submitPassword,
    needsPassword,
    reload
  } = useResolveShare({ source, token });
  const onResolvedRef = React17.useRef(onResolved);
  onResolvedRef.current = onResolved;
  const onUnavailableRef = React17.useRef(onUnavailable);
  onUnavailableRef.current = onUnavailable;
  React17.useEffect(() => {
    if (status !== "ready" && status !== "loading") onUnavailableRef.current?.();
  }, [status]);
  const frozenAt = frozenAtOf(snapshot);
  const caseBundle = React17.useMemo(() => parseCaseShareBundle(snapshot), [snapshot]);
  const name = caseBundle?.title || viewName(resolved?.view);
  const reportSnapshot = React17.useMemo(() => parseReportSnapshot(snapshot), [snapshot]);
  const livePublication = status === "ready" && caseBundle?.publication?.mode === "live";
  const ticket = livePublication ? resolved?.realtime?.ticket : void 0;
  const subscribed = usePublicationEvents(realtime, ticket, reload);
  const pollable = livePublication && !refreshing && (Boolean(ticket) || !resolved?.link?.maxViews);
  React17.useEffect(() => {
    if (!pollable) return;
    const every = subscribed ? LIVE_FALLBACK_POLL_MS : LIVE_POLL_MS;
    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") reload();
    }, every);
    return () => window.clearInterval(timer);
  }, [pollable, subscribed, reload]);
  React17.useEffect(() => {
    if (status !== "ready" || !resolved) return;
    onResolvedRef.current?.({
      ...name ? { name } : {},
      ...frozenAt ? { frozenAt } : {},
      dataMode: resolved.dataMode,
      ...resolved.link?.target ? { target: resolved.link.target } : {},
      ...resolved.link?.viewCount !== void 0 ? { viewCount: resolved.link.viewCount } : {},
      kind: reportSnapshot ? "report" : caseBundle ? "case" : "graph",
      ...caseBundle ? { live: caseBundle.mode === "live", feedbackEnabled: caseBundle.publication?.feedbackEnabled === true, anonymousCatalogEnabled: caseBundle.publication?.anonymousCatalogEnabled === true, contributionsEnabled: caseBundle.publication?.contributionsEnabled === true, followable: caseBundle.publication?.followable === true, trailAlertsEnabled: caseBundle.publication?.trailAlertsEnabled === true } : {}
    });
  }, [status, resolved, name, frozenAt, caseBundle, reportSnapshot]);
  if (!token) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No share link",
        description: "Open the complete link you were sent. If it still doesn\u2019t work, ask the owner for a new link."
      }
    );
  }
  if (needsPassword) {
    return /* @__PURE__ */ jsx(PasswordGate, { onSubmit: submitPassword, error, busy: status === "loading" });
  }
  switch (status) {
    case "idle":
    case "loading":
      return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-16", children: /* @__PURE__ */ jsx(Spinner, { label: "Opening shared view" }) });
    case "password-required":
      return /* @__PURE__ */ jsx(PasswordGate, { onSubmit: submitPassword, error });
    case "auth-required":
      return /* @__PURE__ */ jsx(Fragment, { children: onAuthRequired ? onAuthRequired() : /* @__PURE__ */ jsx(
        EmptyState,
        {
          title: "Sign in to view",
          description: "This shared view is limited to specific people. Sign in to open it."
        }
      ) });
    case "forbidden":
      return /* @__PURE__ */ jsx(
        EmptyState,
        {
          title: "No access",
          description: "This account doesn\u2019t have access to this shared view. Use the account it was shared with, or ask the owner for access."
        }
      );
    case "not-found":
      return /* @__PURE__ */ jsx(
        EmptyState,
        {
          title: "Link not found",
          description: "This share link doesn't exist. Check you copied the whole URL, or ask whoever sent it for a new one."
        }
      );
    case "revoked":
      return /* @__PURE__ */ jsx(
        EmptyState,
        {
          title: "Link turned off",
          description: "The owner revoked this share link. Ask them for a new one if you still need access."
        }
      );
    case "expired":
      return /* @__PURE__ */ jsx(
        EmptyState,
        {
          title: "Link expired",
          description: "This share link has passed its expiry date or reached its limit on opens. Ask the owner to re-share the view."
        }
      );
    case "error":
      return /* @__PURE__ */ jsx(ErrorState, { error: errorCause ?? error ?? errorCode ?? "Failed to open the shared view", onRetry: () => reload() });
    case "ready":
    default:
      if (reportSnapshot) {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          warnings.length ? /* @__PURE__ */ jsx(AccessWarningBanner, { warnings, className: "mb-3" }) : null,
          /* @__PURE__ */ jsx(
            React17.Suspense,
            {
              fallback: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-16", children: /* @__PURE__ */ jsx(Spinner, { label: "Opening shared report" }) }),
              children: /* @__PURE__ */ jsx(ReportShareView, { snapshot: reportSnapshot })
            }
          )
        ] });
      }
      if (caseBundle) {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          warnings.length ? /* @__PURE__ */ jsx(AccessWarningBanner, { warnings, className: "mb-3" }) : null,
          /* @__PURE__ */ jsxs(
            React17.Suspense,
            {
              fallback: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-16", children: /* @__PURE__ */ jsx(Spinner, { label: "Opening shared investigation" }) }),
              children: [
                /* @__PURE__ */ jsxs("div", { className: "mb-3 flex items-center gap-3", children: [
                  /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outline", disabled: refreshing, onClick: () => reload(), children: refreshing ? "Refreshing publication\u2026" : "Refresh publication" }),
                  caseBundle.mode === "live" && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: resolved?.link?.maxViews ? "Each refresh uses one permitted view." : subscribed ? "Live: updates arrive as the case changes." : "Checks for updates every minute while this tab is visible." })
                ] }),
                /* @__PURE__ */ jsxs(Fragment, { children: [
                  resolved?.link ? /* @__PURE__ */ jsx("div", { className: "mb-3 flex flex-wrap gap-2", "aria-label": "Shared investigation access", children: /* @__PURE__ */ jsx(ShareAccessBadge, { target: resolved.link.target, hasPassword: resolved.link.hasPassword }) }) : null,
                  /* @__PURE__ */ jsx(CaseShareView2, { bundle: caseBundle, catalog: resolved?.catalog ?? null, focusTrail, onNotifyTrail })
                ] })
              ]
            }
          )
        ] });
      }
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        showHeading ? /* @__PURE__ */ jsx(ShareHeading, { name, frozenAt }) : null,
        warnings.length ? /* @__PURE__ */ jsx(AccessWarningBanner, { warnings, className: "mb-3" }) : null,
        /* @__PURE__ */ jsx(GraphFrame, { className, children: /* @__PURE__ */ jsx(
          SharedGraphView,
          {
            dataMode: resolved?.dataMode ?? "static",
            snapshot,
            dynamicSeed: resolved?.dynamicSeed ?? null,
            catalog: resolved?.catalog ?? null,
            seedResolver,
            parseLiveMessage,
            live,
            viewMode,
            loadingSlot: /* @__PURE__ */ jsx(GraphFrameMessage, { children: /* @__PURE__ */ jsx(Spinner, { label: "Loading live graph" }) }),
            emptySlot: (
              // A snapshot that could not be FETCHED is not an empty graph.
              // `snapshotError` names the difference (expired presign, 403,
              // never written); without it every one of those told the reader
              // the view had no data, which is the one thing it did not say.
              /* @__PURE__ */ jsx(
                EmptyState,
                {
                  title: snapshotError ? "Couldn't load this view" : "Empty graph",
                  description: snapshotError ?? "This shared view has no data.",
                  action: snapshotError ? /* @__PURE__ */ jsx(Button, { onClick: () => reload(), children: "Try again" }) : void 0
                }
              )
            ),
            errorSlot: (e) => /* @__PURE__ */ jsx(ErrorState, { error: e, onRetry: () => reload() })
          }
        ) })
      ] });
  }
}

// src/share/index.ts
init_caseShare();
init_CaseShareView();
init_caseShareReport();

// src/index.ts
init_live();
init_nodeKinds();
init_edgeKinds();

// src/transpose/index.ts
init_toScene();

// src/transpose/toGraph.ts
init_nodes();
init_edges();
init_nodeKinds();
init_edgeKinds();
init_filters();
function toNode2(view, options) {
  const short = view.address ? shortenAddress(view.address) : "";
  const subtitle = view.address && view.label !== short ? short : view.txCount > 0 ? `${view.txCount} tx` : void 0;
  const kind = (view.address ? options.resolveKind?.(view.address) : void 0) ?? domainKindForSceneKind(view.nodeType);
  return txNode(view.id, {
    label: view.label,
    subtitle,
    receiptProtocolIds: view.receiptProtocolIds,
    chain: view.chainId,
    kind,
    // The node's OWN address — empty for an off-chain actor (a bridge, a DON),
    // which is what `TxGraphNodeData.address` means.
    //
    // Everything that works on an element-level node keys off this and had
    // nothing to key on: the in-graph assignment menu (`canAssign`), the share
    // viewer's `applyCatalogOverlay`, and the element freeze that writes the
    // snapshot it reads. A scene node has carried its address all along, which
    // is why only the element surfaces were affected.
    ...view.address ? { address: view.address } : {},
    // Catalog overlay brand/attribution (from the host's resolveOverlay seam):
    // the winning logo, brand tags, and the primary entity id (which also seeds
    // the in-graph assignment menu's "currently mapped entity").
    icon: view.logo,
    // The rest of the catalog identity the avatar draws without a logo: the
    // brand colour, else the entity's initials (`AddressAvatar`).
    ...view.color ? { avatarColor: view.color } : {},
    ...view.primaryEntityName ? { avatarEntity: view.primaryEntityName } : {},
    tags: view.tags,
    entityId: view.primaryEntityId,
    // Distance from the seed, carried onto the node so the canvas can group,
    // colour and label by it. See `clusterByHop`.
    ...typeof view.hop === "number" ? { hop: view.hop } : {},
    // And its WEIGHT. `GraphNode` renders both the band and the score, so they
    // travel together: a badge reading "Severe" with a blank beside it looks
    // like a number that failed to load rather than one nobody claimed.
    riskLevel: view.riskLevel,
    riskScore: view.riskScore,
    // Named by what it imitates: "this is a lookalike" is not actionable on its
    // own, because the attack's whole premise is that the reader cannot tell the
    // two strings apart.
    ...view.address && options.impersonates?.(view.address) ? { impersonates: options.impersonates(view.address) } : {}
  });
}
function showsZeroTokenAmount(view) {
  return Boolean(view.tokenAddress) && isFlowEdgeKind(view.kind);
}
function amountLabel(view) {
  const amount = view.amountExact ?? view.amountDisplay;
  return amount == null || isZeroText(amount) && !showsZeroTokenAmount(view) ? void 0 : amount;
}
function toEdge2(view, options) {
  const demix = options.isDemix?.(view) ?? false;
  const amountless = view.kind === "order_account_link" || view.kind === "venue_link";
  const amount = amountless ? void 0 : amountLabel(view);
  const amountRaw = !amountless && view.amountExact == null && view.amountDisplay == null && view.rawAmountTotal != null && (!isZeroText(view.rawAmountTotal) || showsZeroTokenAmount(view)) ? view.rawAmountTotal : void 0;
  return txEdge(view.id, view.from, view.to, {
    variant: edgeVariantForKind(view.kind),
    kind: view.kind,
    label: amountless && view.kind ? `${FLOW_KIND_LABELS[view.kind]} \xB7 no amount` : void 0,
    fromChain: view.fromChain,
    toChain: view.toChain,
    assetChain: view.assetChain ?? view.fromChain,
    amount,
    amountRaw,
    movementCount: !amountless && view.interactionCount > 1 ? view.interactionCount : void 0,
    // The ticker rides with the amount. On its own it is a label saying which
    // asset did not move, which reads as if some had.
    ticker: amount != null || amountRaw != null ? view.symbol : void 0,
    tokenAddress: amountless ? void 0 : view.tokenAddress,
    tokenId: amountless ? void 0 : view.tokenId,
    valueUsd: amountless ? void 0 : view.valueUsd,
    demix
  });
}
function toGraph(graph, options = {}) {
  const view = toGraphView(graph, options);
  return {
    nodes: view.nodes.map((n) => toNode2(n, options)),
    edges: view.edges.map((e, index) => {
      const edge = toEdge2(e, options);
      const finality = graph.edges[index]?.finality;
      return finality ? { ...edge, data: { ...edge.data, finality } } : edge;
    })
  };
}

// src/transpose/preview.ts
init_nodes();
init_edges();
function previewGraph(rows, options = {}) {
  const nodeIds = /* @__PURE__ */ new Set();
  const nodes = [];
  const edges = [];
  const addNode = (address) => {
    if (!address || nodeIds.has(address)) return;
    nodeIds.add(address);
    nodes.push(
      txNode(address, {
        label: options.resolveLabel?.(address) ?? shortenAddress(address),
        subtitle: shortenAddress(address),
        chain: options.chainId
      })
    );
  };
  const seenEdges = /* @__PURE__ */ new Set();
  for (const row of rows) {
    addNode(row.from_address);
    addNode(row.to_address);
    if (!row.from_address || !row.to_address) continue;
    const id = `${row.from_address}->${row.to_address}`;
    if (seenEdges.has(id)) continue;
    seenEdges.add(id);
    edges.push(
      txEdge(id, row.from_address, row.to_address, {
        variant: "default",
        dashed: true,
        timestamp: row.block_timestamp
      })
    );
  }
  return { nodes, edges };
}
function graphNodeId(chainId, address) {
  if (!chainId) return normalizeAddress(address, null);
  return keys.chainAddressKey(chainId, address);
}
function text(value) {
  return value == null ? "" : String(value);
}
function endpoints(row) {
  const summary = row.participant_summary ?? {};
  return {
    from: text(summary.primary_from) || text(row.from),
    to: text(summary.primary_to) || text(row.to)
  };
}
function rowNodeIds(row) {
  const { from, to } = endpoints(row);
  if (!from || !to) return [];
  const chainId = text(row.chain_id);
  const fromId = graphNodeId(chainId, from);
  const toId = graphNodeId(chainId, to);
  return fromId === toId ? [fromId] : [fromId, toId];
}
function toBigInt(value) {
  if (value == null || value === "") return 0n;
  try {
    return BigInt(typeof value === "number" ? Math.trunc(value) : String(value).trim());
  } catch {
    return 0n;
  }
}
function interactionGraphFromRows(rows) {
  const nodes = /* @__PURE__ */ new Map();
  const edges = /* @__PURE__ */ new Map();
  const chains = /* @__PURE__ */ new Set();
  const touchNode = (address, chainId, txHash) => {
    const id = graphNodeId(chainId, address);
    let node = nodes.get(id);
    if (!node) {
      node = { id, address, chainId: chainId || null, degree: 0, txHashes: /* @__PURE__ */ new Set() };
      nodes.set(id, node);
    }
    node.degree += 1;
    if (txHash) node.txHashes.add(txHash);
    return id;
  };
  for (const row of rows) {
    const { from, to } = endpoints(row);
    if (!from || !to) continue;
    const chainId = text(row.chain_id);
    if (chainId) chains.add(chainId);
    const txHash = text(row.tx_hash) || text(row.canonical_tx_id);
    const fromId = touchNode(from, chainId, txHash);
    const toId = touchNode(to, chainId, txHash);
    const key = `${fromId}\0${toId}\0native`;
    let edge = edges.get(key);
    if (!edge) {
      edge = {
        fromAddress: from,
        toAddress: to,
        fromId,
        toId,
        chainId: chainId || null,
        interactionCount: 0,
        rawAmountTotal: 0n,
        txRefs: /* @__PURE__ */ new Map()
      };
      edges.set(key, edge);
    }
    edge.interactionCount += 1;
    edge.rawAmountTotal += toBigInt(row.total_value_raw);
    const ref = mergedTxRef({
      canonicalTxId: text(row.canonical_tx_id),
      txHash: text(row.tx_hash),
      chainId
    });
    if (ref) {
      const amount = toBigInt(row.total_value_raw);
      const existing = edge.txRefs.get(ref.id);
      if (existing) {
        existing.amount_raw = (BigInt(existing.amount_raw ?? "0") + amount).toString();
      } else if (edge.txRefs.size < MERGED_TXS_LIMIT) {
        edge.txRefs.set(ref.id, { ...ref, amount_raw: amount.toString() });
      }
    }
  }
  const nodeList = [...nodes.values()].sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0).map(
    (node) => ({
      id: node.id,
      node_type: "address",
      address: node.address,
      chain_id: node.chainId,
      label: null,
      degree: node.degree,
      tx_count: node.txHashes.size
    })
  );
  const edgeList = [...edges.values()].sort(
    (a, b) => a.fromId < b.fromId ? -1 : a.fromId > b.fromId ? 1 : a.toId < b.toId ? -1 : a.toId > b.toId ? 1 : 0
  ).map(
    (edge) => ({
      from_address: edge.fromAddress,
      to_address: edge.toAddress,
      from_id: edge.fromId,
      to_id: edge.toId,
      from_chain: edge.chainId,
      to_chain: edge.chainId,
      token_address: null,
      token_chain_id: null,
      kind: "native",
      interaction_count: edge.interactionCount,
      raw_amount_total: edge.rawAmountTotal.toString(),
      ...edge.txRefs.size > 0 ? { tx_refs: [...edge.txRefs.values()] } : {}
    })
  );
  const chainIds = [...chains].sort();
  return {
    nodes: nodeList,
    edges: edgeList,
    node_count: nodeList.length,
    edge_count: edgeList.length,
    chain_ids: chainIds,
    multi_chain: chainIds.length > 1
  };
}

// src/transpose/index.ts
init_mergeScenes();
init_interactionGraphToScene();

// src/transpose/chainGroups.ts
init_grouping();
init_mergeScenes();
init_grouping();
var BY_CHAIN = { dimensions: ["chain"] };
function groupNodesByChain(nodes) {
  const grouped = applyGrouping({ ...emptyScene(), nodes: [...nodes] }, BY_CHAIN);
  return { nodes: grouped.nodes, groups: grouped.groups };
}
function regroupSceneByChain(scene) {
  const grouped = applyGrouping(scene, BY_CHAIN);
  const preserved = scene.groups.filter((group) => group.group_type !== "chain");
  return preserved.length === 0 ? grouped : { ...grouped, groups: [...preserved, ...grouped.groups] };
}

// src/transpose/sagaGroups.ts
init_grouping();
var SAGA_GROUP_TYPE = "saga";
function sagaGroupId(key) {
  return `saga:${key}`;
}
function sagaGhostNodeId(key, role) {
  return `saga-ghost:${key}:${role.toLowerCase()}`;
}
function ghostNode(band, role) {
  return {
    id: sagaGhostNodeId(band.key, role),
    kind: "virtual",
    label: `${role} leg`,
    sublabel: band.confirmed ? "not observed yet" : "not in this view",
    chain_id: band.expectedChainId ?? null,
    address: null,
    group_id: null,
    off_chain: true,
    entity_id: null,
    icon: null,
    assets: [],
    value: null,
    badge: "expected",
    attributes: {
      [SAGA_KEY_ATTR]: band.key,
      [SAGA_LABEL_ATTR]: band.label,
      [SAGA_AWAITING_ATTR]: true,
      saga_role: role,
      saga_confirmed: Boolean(band.confirmed)
    },
    source_refs: [],
    // Not observed: an inference from the protocol's declared completion set, so
    // it must not read as evidence of a transaction.
    confidence: 0,
    // Only at the expanded tier: a compact view is the case's headline, and a leg
    // that doesn't exist yet isn't it.
    detail_tier: "standard",
    facts: [],
    origin: "synthesized"
  };
}
function ghostEdge(band, role, anchorNodeId) {
  return {
    id: `saga-ghost-edge:${band.key}:${role.toLowerCase()}`,
    source: anchorNodeId,
    target: sagaGhostNodeId(band.key, role),
    kind: "cross_chain",
    label: band.confirmed ? `awaiting ${role.toLowerCase()}` : `${role.toLowerCase()} not in view`,
    asset: null,
    direction: null,
    from_chain: null,
    to_chain: band.expectedChainId ?? null,
    cross_chain: true,
    virtual: true,
    icon: null,
    attributes: { saga_key: band.key, saga_role: role },
    detail_tier: "standard",
    facts: [],
    origin: "synthesized"
  };
}
function sagaAnchorNodeId(memberNodeIds, nodesById) {
  for (const id of memberNodeIds) {
    if (nodesById.get(id)?.off_chain) return id;
  }
  return memberNodeIds[0];
}
function applySagaBands(scene, bands) {
  if (bands.length === 0) return scene;
  const nodesById = new Map(scene.nodes.map((node) => [node.id, node]));
  const claimed = /* @__PURE__ */ new Map();
  const nodes = [];
  const edges = [];
  for (const band of bands) {
    const members = band.memberNodeIds.filter((id) => nodesById.has(id));
    if (members.length === 0) continue;
    for (const id of members) {
      if (!claimed.has(id)) claimed.set(id, band);
    }
    const missing = band.missingRoles ?? [];
    const anchor = band.anchorNodeId ?? sagaAnchorNodeId(members, nodesById);
    if (anchor) {
      for (const role of missing) {
        const ghost = ghostNode(band, role);
        if (nodesById.has(ghost.id)) continue;
        nodesById.set(ghost.id, ghost);
        nodes.push(ghost);
        edges.push(ghostEdge(band, role, anchor));
        claimed.set(ghost.id, band);
      }
    }
  }
  if (claimed.size === 0) return scene;
  const awaiting = new Set(
    bands.filter((band) => (band.missingRoles?.length ?? 0) > 0).map((band) => band.key)
  );
  const marked = [...scene.nodes, ...nodes].map((node) => {
    const band = claimed.get(node.id);
    if (!band) return node;
    return {
      ...node,
      attributes: {
        ...node.attributes,
        [SAGA_KEY_ATTR]: band.key,
        [SAGA_LABEL_ATTR]: band.label,
        [SAGA_AWAITING_ATTR]: awaiting.has(band.key)
      }
    };
  });
  return {
    ...scene,
    nodes: marked,
    edges: edges.length > 0 ? [...scene.edges, ...edges] : scene.edges
  };
}

// src/transpose/mergeElements.ts
function dedupeById(primary, secondary) {
  const out = [...primary];
  const seen = new Set(out.map((item) => item.id));
  for (const item of secondary) {
    if (seen.has(item.id)) continue;
    seen.add(item.id);
    out.push(item);
  }
  return out;
}
function mergeGraphElements(primary, secondary) {
  return {
    nodes: dedupeById(primary.nodes, secondary.nodes),
    edges: dedupeById(primary.edges, secondary.edges)
  };
}

// src/index.ts
init_grouping();
init_receiptProtocols();
init_search();

// src/cluster/index.ts
init_clustering();
init_useGraphClusters();
var FINALITY_FORWARD = [
  FinalityState.PENDING,
  FinalityState.CONFIRMED,
  FinalityState.FINALIZED
];
var FINALITY_STATES = [...FINALITY_FORWARD, FinalityState.REORGED];
var FINALITY_TRANSITIONS = [
  { from: FinalityState.PENDING, to: FinalityState.CONFIRMED, event: "included" },
  { from: FinalityState.CONFIRMED, to: FinalityState.FINALIZED, event: "depth-reached" },
  { from: FinalityState.CONFIRMED, to: FinalityState.REORGED, event: "reorg", reorg: true },
  { from: FinalityState.PENDING, to: FinalityState.REORGED, event: "dropped", reorg: true },
  { from: FinalityState.REORGED, to: FinalityState.PENDING, event: "replay" },
  { from: FinalityState.REORGED, to: FinalityState.CONFIRMED, event: "re-included" }
];
function transitionsFrom(state) {
  return FINALITY_TRANSITIONS.filter((t) => t.from === state);
}
function nextStates(state) {
  return transitionsFrom(state).map((t) => t.to);
}
function canTransition(from, to) {
  return FINALITY_TRANSITIONS.some((t) => t.from === from && t.to === to);
}
function isTerminal(state) {
  return state === FinalityState.FINALIZED;
}
function advanceFinality(state, event) {
  return FINALITY_TRANSITIONS.find((t) => t.from === state && t.event === event)?.to ?? null;
}
function finalityProgress(state) {
  switch (state) {
    case FinalityState.PENDING:
      return 0.1;
    case FinalityState.CONFIRMED:
      return 0.6;
    case FinalityState.FINALIZED:
      return 1;
    case FinalityState.REORGED:
      return 0;
    default:
      return 0;
  }
}
function buildFinalityHistory(steps) {
  const normalized = steps.map((s) => ({
    ...s,
    reorg: s.reorg ?? s.state === FinalityState.REORGED
  }));
  const current = normalized.length > 0 ? normalized[normalized.length - 1].state : FinalityState.PENDING;
  const visited = new Set(normalized.map((s) => s.state));
  const reorgCount = normalized.filter((s) => s.reorg).length;
  return { steps: normalized, current, visited, reorgCount, finalized: current === FinalityState.FINALIZED };
}
function historyTraversed(history, from, to) {
  for (let i = 1; i < history.steps.length; i++) {
    if (history.steps[i - 1].state === from && history.steps[i].state === to) return true;
  }
  return false;
}
var REORGED = FinalityState.REORGED;
function FinalityStateMachineView({
  state,
  history,
  confirmations,
  compact,
  className
}) {
  const current = history?.current ?? state ?? FinalityState.PENDING;
  const reorgCount = history?.reorgCount ?? (current === REORGED ? 1 : 0);
  const reached = React17.useMemo(() => {
    const set = new Set(history?.visited ?? []);
    const ci = FINALITY_FORWARD.indexOf(current);
    if (ci >= 0) for (let i = 0; i <= ci; i++) set.add(FINALITY_FORWARD[i]);
    if (current === REORGED) set.add(REORGED);
    return set;
  }, [history, current]);
  const reorgActive = reorgCount > 0 || current === REORGED;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col gap-3", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-4", children: [
      /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2", children: FINALITY_FORWARD.map((s, i) => /* @__PURE__ */ jsxs(React17.Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx(
          "span",
          {
            "aria-hidden": true,
            className: cn("shrink-0 text-sm", reached.has(s) ? "text-foreground" : "text-muted-foreground/40"),
            children: "\u2192"
          }
        ),
        /* @__PURE__ */ jsx(
          StateChip,
          {
            state: s,
            current: current === s,
            reached: reached.has(s),
            confirmations: s === FinalityState.CONFIRMED ? confirmations : void 0
          }
        )
      ] }, s)) }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            "aria-hidden": true,
            className: cn("shrink-0 text-sm", reorgActive ? "text-finality-reorged" : "text-muted-foreground/30"),
            children: "\u21BA"
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cn(
              "rounded-sm border border-dashed px-1 text-3xs",
              reorgActive ? "border-finality-reorged/40 text-finality-reorged" : "border-muted-foreground/20 text-muted-foreground/40"
            ),
            children: "reorg"
          }
        ),
        /* @__PURE__ */ jsx(StateChip, { state: REORGED, current: current === REORGED, reached: reached.has(REORGED) })
      ] })
    ] }),
    !compact && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Progress, { value: finalityProgress(current), reorged: current === REORGED }),
      history && history.steps.length > 0 && /* @__PURE__ */ jsx(Trail, { history })
    ] })
  ] });
}
function StateChip({
  state,
  current,
  reached,
  confirmations
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn(
        "inline-flex rounded-full",
        current && "ring-2 ring-ring ring-offset-1",
        !reached && "opacity-40"
      ),
      children: /* @__PURE__ */ jsx(FinalityPill, { state, confirmations })
    }
  );
}
function Progress({ value, reorged }) {
  return /* @__PURE__ */ jsx("div", { className: "h-1.5 w-full overflow-hidden rounded-full bg-muted", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("h-full rounded-full transition-all", reorged ? "bg-finality-reorged" : "bg-finality-finalized"),
      style: { width: `${Math.round(value * 100)}%` }
    }
  ) });
}
function Trail({ history }) {
  return /* @__PURE__ */ jsx("ol", { className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-2xs text-muted-foreground", children: history.steps.map((step, i) => /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-2", children: [
    i > 0 && /* @__PURE__ */ jsx("span", { className: "text-muted-foreground/40", children: "\u2192" }),
    /* @__PURE__ */ jsx("span", { className: cn("font-medium", step.reorg ? "text-finality-reorged" : "text-foreground"), children: step.event ?? step.state }),
    step.blockNumber != null && /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
      "#",
      step.blockNumber
    ] })
  ] }, i)) });
}
var NODE_ACCENT = {
  [FinalityState.MEMPOOL]: "border-finality-pending/70",
  [FinalityState.PENDING]: "border-finality-pending/70",
  [FinalityState.OBSERVED]: "border-finality-pending/70",
  [FinalityState.CONFIRMED]: "border-finality-confirmed/70",
  [FinalityState.FINALIZED]: "border-finality-finalized/70",
  [FinalityState.REORGED]: "border-risk-critical/70"
};
function isInFlight(state) {
  return state === FinalityState.MEMPOOL || state === FinalityState.PENDING || state === FinalityState.OBSERVED;
}
function decorateEdge(edge, state) {
  const data = edge.data ?? {};
  if (state === FinalityState.REORGED) {
    return { ...edge, data: { ...data, dashed: true, animated: false, failed: true, variant: "failed" } };
  }
  if (state === FinalityState.FINALIZED) {
    return { ...edge, data: { ...data, dashed: false, animated: false } };
  }
  return { ...edge, data: { ...data, dashed: isInFlight(state) } };
}
function decorateNode(node, state) {
  if (node.data?.failed) return node;
  const accentClassName = NODE_ACCENT[state];
  if (!accentClassName) return node;
  return { ...node, data: { ...node.data, accentClassName } };
}
function decorateFinality(elements, { nodeState, edgeState }) {
  return {
    ...elements,
    nodes: nodeState ? elements.nodes.map((node) => {
      const state = nodeState(node);
      return state ? decorateNode(node, state) : node;
    }) : elements.nodes,
    edges: edgeState ? elements.edges.map((edge) => {
      const state = edgeState(edge);
      return state ? decorateEdge(edge, state) : edge;
    }) : elements.edges
  };
}
function finalityLegendItems(group = "Finality") {
  return [
    { label: "In-flight (mempool / pending)", color: "hsl(var(--finality-pending))", shape: "dashed", group },
    { label: "Confirmed", color: "hsl(var(--finality-confirmed))", shape: "line", group },
    { label: "Finalized", color: "hsl(var(--finality-finalized))", shape: "line", group },
    { label: "Failed / reorged", color: "hsl(var(--risk-critical))", shape: "line", group }
  ];
}

// src/index.ts
init_edgeBundling();

// src/related-addresses/RelatedAddressesGraph.tsx
init_SceneGraphView();
init_canvasRoom();

// src/related-addresses/toRelatedAddressScene.ts
init_mergeScenes();
var RELATIONSHIP_GRAPH_STYLES = {
  manual: { variant: "flow", dashed: true },
  identity: { variant: "call", dashed: false },
  related: { variant: "default", dashed: false },
  coordination: { variant: "flow", dashed: true },
  candidate: { variant: "default", dashed: true },
  rejected: { variant: "failed", dashed: true },
  provisional: { variant: "default", dashed: true }
};
function relatedAddressLayout(scene, wide) {
  const neighbours = /* @__PURE__ */ new Map();
  for (const edge of scene.edges) {
    for (const [a, b] of [[edge.source, edge.target], [edge.target, edge.source]]) {
      if (!a || !b || a === b) continue;
      if (!neighbours.has(a)) neighbours.set(a, /* @__PURE__ */ new Set());
      neighbours.get(a).add(b);
    }
  }
  const branches = [...neighbours.values()].some((peers) => peers.size > 2);
  return {
    direction: wide || branches ? "LR" : "TB",
    nodeSep: 24,
    rankSep: wide ? 240 : 90
  };
}
function edgeLabel(row) {
  if (isMovementLink(row.link)) return row.link.kind === "economic_attribution" ? "Attributed output" : "Observed transfer";
  if (row.claim === "rejected" || row.link.kind !== "contract_state_reference") return `${RELATIONSHIP_CLAIM_LABELS[row.claim]} \xB7 ${evidenceLabel(row.link)}${row.pairAlsoAccepted ? " \xB7 also linked" : ""}`;
  const observation = contractObservations(row.link)[0];
  if (!observation) return "Contract reference";
  const predicate = contractPredicateLabel(observation.predicate);
  return `${predicate.length > 22 ? `${predicate.slice(0, 21)}\u2026` : predicate} \xB7 ${row.claim === "candidate" ? "candidate" : observation.assurance}`;
}
function toRelatedAddressScene(view) {
  const ids = /* @__PURE__ */ new Set();
  if (view.nodes.some((node) => node.id === view.seedId)) ids.add(view.seedId);
  const ranked = [...view.relationships].sort((a, b) => {
    const direct = (row) => Number(row.source === view.seedId || row.target === view.seedId);
    return direct(b) - direct(a) || (b.link.confidence ?? 0) - (a.link.confidence ?? 0) || a.id.localeCompare(b.id);
  });
  const edges = [];
  for (const row of ranked) {
    if (edges.length >= RELATED_ADDRESS_GRAPH_LIMITS.edges) break;
    const extra = new Set([row.source, row.target].filter((id) => !ids.has(id)));
    if (ids.size + extra.size > RELATED_ADDRESS_GRAPH_LIMITS.nodes) continue;
    ids.add(row.source);
    ids.add(row.target);
    edges.push(row);
  }
  for (const node of view.nodes) {
    if (ids.size >= RELATED_ADDRESS_GRAPH_LIMITS.nodes) break;
    ids.add(node.id);
  }
  const nodes = view.nodes.filter((node) => ids.has(node.id));
  const chainIds = [...new Set(nodes.map((node) => node.chainId))];
  const scene = {
    ...emptyScene({ kind: "knowledge" }),
    chain_ids: chainIds,
    multi_chain: chainIds.length > 1,
    nodes: nodes.map((node) => ({
      id: node.id,
      kind: "address",
      address: node.address,
      chain_id: node.chainId,
      label: shortenAddress(node.address),
      sublabel: chainDisplayName(node.chainId),
      badge: node.isSeed ? "Starting address" : node.manual ? "Manual member" : node.membership === "same-actor" ? "Identity member" : node.membership === "snapshot" ? "Snapshot member" : null,
      off_chain: false,
      assets: [],
      attributes: {},
      source_refs: [],
      confidence: 0,
      detail_tier: "compact",
      facts: [],
      origin: "decoded"
    })),
    edges: edges.map((row) => ({
      id: row.id,
      source: row.source,
      target: row.target,
      kind: "relationship",
      label: `${relationshipStrength(row.link).label} \xB7 ${edgeLabel(row)}`,
      from_chain: row.link.a_chain_id,
      to_chain: row.link.b_chain_id,
      cross_chain: row.link.a_chain_id !== row.link.b_chain_id,
      virtual: row.claim === "provisional",
      attributes: { claim: row.claim },
      detail_tier: "compact",
      facts: [],
      origin: "decoded"
    }))
  };
  return { scene, omittedNodes: view.nodes.length - nodes.length, omittedEdges: view.relationships.length - edges.length };
}
function decorateRelatedAddressElements(elements, directedIds = /* @__PURE__ */ new Set(), claims = /* @__PURE__ */ new Map()) {
  return {
    ...elements,
    nodes: elements.nodes.map((node) => ({ ...node, data: { ...node.data, confidence: void 0, origin: void 0 } })),
    edges: elements.edges.map((edge) => ({
      ...edge,
      markerEnd: directedIds.has(edge.id) ? edge.markerEnd : void 0,
      markerStart: void 0,
      data: {
        ...edge.data,
        ...RELATIONSHIP_GRAPH_STYLES[claims.get(edge.id) ?? "related"],
        animated: false,
        dashed: RELATIONSHIP_GRAPH_STYLES[claims.get(edge.id) ?? "related"].dashed || edge.data?.dashed === true,
        origin: void 0,
        fromChain: void 0,
        toChain: void 0
      }
    }))
  };
}
var defaultGrouping = { dimensions: ["chain"] };
function RelatedAddressesGraph({ view, onSelectNode, onSelectRelationship, selectedNodeId, selectedRelationshipId, onClearSelection, resolveOverlay, grouping, onGroupingChange }) {
  const frame = React17.useRef(null);
  const wide = useCanvasRoom(frame);
  const { scene, omittedNodes, omittedEdges } = React17.useMemo(() => toRelatedAddressScene(view), [view]);
  const layout = React17.useMemo(() => relatedAddressLayout(scene, wide), [scene, wide]);
  const directedIds = React17.useMemo(() => new Set(view.relationships.filter((row) => hasContractReferenceDirection(row.link) || isMovementLink(row.link)).map((row) => row.id)), [view.relationships]);
  const claims = React17.useMemo(() => new Map(view.relationships.map((row) => [row.id, row.claim])), [view.relationships]);
  const decorate = React17.useCallback((elements) => decorateRelatedAddressElements(elements, directedIds, claims), [directedIds, claims]);
  const legend = [...new Set(view.relationships.map((row) => row.claim))].map((claim) => ({
    label: RELATIONSHIP_CLAIM_LABELS[claim],
    color: GRAPH_EDGE_VARIANT_COLOR[RELATIONSHIP_GRAPH_STYLES[claim].variant],
    shape: RELATIONSHIP_GRAPH_STYLES[claim].dashed ? "dashed" : "line"
  }));
  return /* @__PURE__ */ jsxs("div", { ref: frame, className: "space-y-2", children: [
    /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Use Graph settings \u2192 Group by to nest blockchain and catalog bands. Options appear when matching catalog details are available. Grouping does not establish ownership. For multiple tags or groups, the first resolved membership is used." }),
    omittedNodes || omittedEdges ? /* @__PURE__ */ jsxs("p", { role: "status", className: "text-xs text-muted-foreground", children: [
      "Graph preview: ",
      scene.nodes.length,
      " of ",
      view.nodes.length,
      " addresses and ",
      scene.edges.length,
      " of ",
      view.relationships.length,
      " evidence links. Filter to narrow the graph or use Table to inspect every loaded link."
    ] }) : null,
    /* @__PURE__ */ jsx(GraphFrame, { className: "h-[520px] overflow-hidden rounded-md border", children: /* @__PURE__ */ jsx(
      SceneGraphView,
      {
        resolveOverlay,
        scene,
        viewMode: "hierarchical",
        layout,
        grouping,
        defaultGrouping,
        onGroupingChange,
        decorateElements: decorate,
        onNodeClick: onSelectNode,
        onEdgeClick: (edge) => onSelectRelationship(edge.id),
        focusNodeId: selectedNodeId,
        selectedEdgeId: selectedRelationshipId ?? null,
        onClearEdgeSelection: onClearSelection,
        showSummary: false,
        showStats: false,
        showSearch: false,
        showMiniMap: false,
        showDetailToggle: false,
        showGroupingControl: true,
        showViewsBar: false,
        showFlowToggle: false,
        showEdgeBundleToggle: false,
        bundleParallelEdges: false,
        showExport: false,
        flowParticles: false,
        legend: view.relationships.some((row) => isMovementLink(row.link)) ? [{ color: GRAPH_EDGE_VARIANT_COLOR.default, shape: "line", label: "Fund movement \xB7 not ownership" }] : legend
      }
    ) })
  ] });
}

// src/index.ts
init_filters();

// src/exploration/GraphFilterBar.tsx
init_filters();
var EMPTY_FILTERS = {};
var EMPTY2 = { nodes: [], edges: [] };
function useGraphFilters(graph, scopeKey, { connectSeeds = false } = {}) {
  const [state, setState] = React17.useState({ key: scopeKey, value: EMPTY_FILTERS });
  if (state.key !== scopeKey) setState({ key: scopeKey, value: EMPTY_FILTERS });
  const filters = state.key === scopeKey ? state.value : EMPTY_FILTERS;
  const setFilters = (value) => setState({ key: scopeKey, value });
  const elements = React17.useMemo(() => filterGraph(graph ?? EMPTY2, filters, { connectSeeds }), [graph, filters, connectSeeds]);
  const options = React17.useMemo(() => graphFilterOptions(graph ?? EMPTY2), [graph]);
  const active = hasGraphFilters(filters);
  const seedOnly = filters.maxHop === 0 && !filters.kind && !filters.assets?.length;
  return { filters, setFilters, elements, options, active, seedOnly, total: graph ?? EMPTY2 };
}
function GraphFilterBar({ controller }) {
  const { filters, setFilters, elements, options, total, active } = controller;
  const connecting = elements.edges.filter((e) => e.data?.context).length;
  const matching = elements.edges.length - connecting;
  const assets = new Map(options.assets);
  for (const key of filters.assets ?? []) if (!assets.has(key)) assets.set(key, `${key} (outside current view)`);
  const selectClass = "max-w-full rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground";
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2 rounded-md border bg-muted/20 p-2", "aria-label": "Graph filters", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      (options.hops.length > 0 || filters.maxHop != null) && /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs", children: [
        "Hops",
        /* @__PURE__ */ jsxs("select", { "aria-label": "Visible hops", className: selectClass, value: filters.maxHop ?? "", onChange: (e) => setFilters({ ...filters, maxHop: e.target.value === "" ? void 0 : Number(e.target.value) }), children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "All hops" }),
          filters.maxHop != null && !options.hops.includes(filters.maxHop) && /* @__PURE__ */ jsxs("option", { value: filters.maxHop, children: [
            "Through hop ",
            filters.maxHop,
            " (outside current view)"
          ] }),
          options.hops.map((h) => /* @__PURE__ */ jsx("option", { value: h, children: h === 0 ? "Seed only" : `Through hop ${h}` }, h))
        ] })
      ] }),
      (options.chains.length > 1 || filters.chain) && /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs", children: [
        "Chain",
        /* @__PURE__ */ jsxs("select", { "aria-label": "Graph chain", className: selectClass, value: filters.chain ?? "", onChange: (e) => setFilters({ ...filters, chain: e.target.value || void 0 }), children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "All chains" }),
          filters.chain && !options.chains.includes(filters.chain) && /* @__PURE__ */ jsxs("option", { value: filters.chain, children: [
            chainDisplayName(filters.chain),
            " (outside current view)"
          ] }),
          options.chains.map((c) => /* @__PURE__ */ jsx("option", { value: c, children: chainDisplayName(c) }, c))
        ] })
      ] }),
      (options.kinds.length > 1 || filters.kind) && /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs", children: [
        "Transfer",
        /* @__PURE__ */ jsxs("select", { "aria-label": "Graph transfer kind", className: selectClass, value: filters.kind ?? "", onChange: (e) => setFilters({ ...filters, kind: e.target.value || void 0 }), children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "All transfers" }),
          filters.kind && !options.kinds.includes(filters.kind) && /* @__PURE__ */ jsxs("option", { value: filters.kind, children: [
            FLOW_KIND_LABELS[filters.kind] ?? filters.kind,
            " (outside current view)"
          ] }),
          options.kinds.map((k) => /* @__PURE__ */ jsx("option", { value: k, children: FLOW_KIND_LABELS[k] ?? k }, k))
        ] })
      ] }),
      assets.size > 0 && /* @__PURE__ */ jsx(
        DataTableFacetedFilter,
        {
          title: "Assets",
          options: [...assets].map(([value, label]) => ({ value, label })),
          column: serverFacetColumn({ value: filters.assets, onChange: (assets2) => setFilters({ ...filters, assets: assets2 }) })
        }
      ),
      active && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: () => setFilters({}), children: "Reset filters" })
    ] }),
    /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", role: "status", children: [
      elements.nodes.length,
      " of ",
      total.nodes.length,
      " nodes \xB7 ",
      matching,
      " of ",
      total.edges.length,
      " edges",
      connecting ? ` (plus ${connecting} faint connecting edge${connecting === 1 ? "" : "s"} outside the filter)` : "",
      " \xB7 ",
      filters.assets?.length ? `${filters.assets.length} selected asset(s)` : "All loaded assets",
      " \xB7 Filters affect this view only."
    ] }),
    filters.chain && /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "Includes recorded crossings into or out of ",
      chainDisplayName(filters.chain),
      ". Other-chain endpoints and faint connecting paths preserve context; they do not prove common ownership or fund continuity."
    ] }),
    filters.maxHop != null && filters.maxHop > 0 && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Later hops are hidden by this view limit, including any connections through them. Funding receipts without a recorded hop may remain as faint context." }),
    active && matching === 0 && /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: filters.maxHop === 0 && elements.nodes.length ? "Seed-only view. Increase the hop limit to see movements." : "No loaded transfers match these filters. Clear filters to restore the trail." })
  ] });
}

// src/index.ts
init_clustering();
init_GraphGroupingMenu();
init_GraphSettingsMenu();
init_clusterGroups();
init_applyGrouping();
init_useClusterExploration();

// src/transpose/composeLayers.ts
function composeGraphLayers(layers) {
  if (layers.length === 0) return { nodes: [], edges: [] };
  const nodes = /* @__PURE__ */ new Map();
  const edges = [];
  const seen = /* @__PURE__ */ new Set();
  for (const [index, layer] of layers.entries()) {
    if (seen.has(layer.id)) continue;
    seen.add(layer.id);
    for (const node of layer.graph.nodes) {
      const prior = nodes.get(node.id);
      const membership = { id: layer.id, label: layer.label, hop: node.data.hop };
      const memberships = [...prior?.data.sourceLayers ?? [], membership];
      nodes.set(node.id, prior ? { ...prior, data: { ...prior.data, sourceLayers: memberships } } : {
        ...node,
        data: {
          ...node.data,
          sourceLayers: memberships,
          inPrimaryLayer: index === 0 || layer.sharesHopOrigin === true,
          ...index > 0 && !layer.sharesHopOrigin ? { hop: void 0, subtitle: `${layer.label} \xB7 ${node.data.subtitle ?? ""}` } : {}
        }
      });
    }
    for (const edge of layer.graph.edges) edges.push({
      ...edge,
      id: layerEdgeId(layer.id, edge.id),
      data: {
        ...edge.data,
        sourceEdgeId: edge.data?.sourceEdgeId ?? edge.id,
        sourceLayerId: layer.id,
        sourceLayerLabel: layer.label,
        sourceLayerHref: layer.href,
        sourceLayerDescription: layer.description
      }
    });
  }
  return { nodes: [...nodes.values()], edges };
}
function layerEdgeId(layerId, edgeId) {
  return `layer:${JSON.stringify([layerId, edgeId])}`;
}

// src/exploration/routes.ts
var ROUTE_COUNT_CAP = 99;
function distances(starts, adjacent) {
  const found = new Map(starts.map((id) => [id, 0]));
  const queue = [...found.keys()];
  for (let i = 0; i < queue.length; i++) {
    const id = queue[i];
    for (const step of adjacent.get(id) ?? []) if (!found.has(step.to)) {
      found.set(step.to, found.get(id) + 1);
      queue.push(step.to);
    }
  }
  return found;
}
function graphConnectionScope(graph, targets, options) {
  const present = new Set(graph.nodes.map((n) => n.id));
  const seeds = options.seeds.filter((id) => present.has(id));
  const wanted = [...new Set(targets)].filter((id) => present.has(id));
  const edges = graph.edges.filter((e) => present.has(e.source) && present.has(e.target));
  const out = /* @__PURE__ */ new Map(), into = /* @__PURE__ */ new Map();
  for (const e of edges) {
    (out.get(e.source) ?? out.set(e.source, []).get(e.source)).push({ to: e.target, id: e.id });
    (into.get(e.target) ?? into.set(e.target, []).get(e.target)).push({ to: e.source, id: e.id });
  }
  const nodeIds = /* @__PURE__ */ new Set(), edgeIds = /* @__PURE__ */ new Set();
  for (const direction of options.direction === "both" ? ["outbound", "inbound"] : [options.direction]) {
    const forward = distances(seeds, direction === "outbound" ? out : into);
    const back = distances(wanted, direction === "outbound" ? into : out);
    for (const id of forward.keys()) if (back.has(id)) nodeIds.add(id);
    for (const e of edges) {
      const from = direction === "outbound" ? e.source : e.target;
      const to = direction === "outbound" ? e.target : e.source;
      if (forward.has(from) && back.has(to)) edgeIds.add(e.id);
    }
  }
  return { nodeIds, edgeIds, unreachedTargets: [...new Set(targets)].filter((id) => !nodeIds.has(id)) };
}
function findGraphRoutes(graph, targets, options) {
  const present = new Set(graph.nodes.map((n) => n.id));
  const seeds = [...new Set(options.seeds)].filter((id) => present.has(id)).sort();
  const wanted = new Set(targets);
  const paths = [];
  const result = { nodeIds: /* @__PURE__ */ new Set(), edgeIds: /* @__PURE__ */ new Set(), paths, hops: 0, maxHops: 0, routes: 0, truncated: false, unreachedTargets: [] };
  const limit = (n, fallback, cap) => Math.min(cap, Math.max(1, Math.floor(Number.isFinite(n) ? n : fallback)));
  const maxHops = limit(options.maxHops, 8, 64);
  const maxRoutes = limit(options.maxRoutes, ROUTE_COUNT_CAP, 1e3);
  const maxExpansions = limit(options.maxExpansions, 2e4, 1e5);
  const through = options.through;
  if (through && !graph.edges.some((e) => e.id === through.id && e.source === through.source && e.target === through.target && present.has(e.source) && present.has(e.target))) {
    return { ...result, unreachedTargets: [...wanted] };
  }
  const out = /* @__PURE__ */ new Map();
  const endings = /* @__PURE__ */ new Map();
  const add = (from, to, id) => {
    if (id === through?.id) endings.set(from, to);
    else {
      const far = through && options.direction !== "both" ? options.direction === "inbound" ? through.source : through.target : null;
      if (far && (from === far || to === far)) return;
      (out.get(from) ?? out.set(from, []).get(from)).push({ to, id });
    }
  };
  for (const e of graph.edges) {
    if (!present.has(e.source) || !present.has(e.target)) continue;
    if (options.direction !== "inbound") add(e.source, e.target, e.id);
    if (options.direction !== "outbound") add(e.target, e.source, e.id);
  }
  for (const steps of out.values()) steps.sort((a, b) => a.id.localeCompare(b.id) || a.to.localeCompare(b.to));
  const dist = distances(seeds, out);
  const shortestEnd = through ? Math.min(...[...endings.keys()].map((id) => (dist.get(id) ?? Infinity) + 1)) : null;
  const into = /* @__PURE__ */ new Map();
  for (const [from, steps] of out) for (const { to } of steps) (into.get(to) ?? into.set(to, []).get(to)).push(from);
  const remaining = /* @__PURE__ */ new Map();
  const back = [...through ? endings.keys() : wanted].filter((id) => present.has(id));
  for (const id of back) remaining.set(id, through ? 1 : 0);
  for (let i = 0; i < back.length; i++) for (const from of into.get(back[i]) ?? []) if (!remaining.has(from)) {
    remaining.set(from, remaining.get(back[i]) + 1);
    back.push(from);
  }
  const reached = /* @__PURE__ */ new Set();
  let expansions = 0;
  const record = (nodes, edges) => {
    if (paths.length >= maxRoutes) {
      result.truncated = true;
      return;
    }
    paths.push({ nodeIds: [...nodes], edgeIds: [...edges] });
    reached.add(nodes[nodes.length - 1]);
    for (const id of nodes) result.nodeIds.add(id);
    for (const id of edges) result.edgeIds.add(id);
  };
  const visit = (nodes, edges, seen) => {
    if (result.truncated) return;
    const node = nodes[nodes.length - 1];
    if (edges.length + (remaining.get(node) ?? Infinity) > maxHops) return;
    if (++expansions > maxExpansions) {
      result.truncated = true;
      return;
    }
    const far = endings.get(node);
    if (through && far && !seen.has(far) && (options.mode === "all" || edges.length + 1 === shortestEnd)) {
      record([...nodes, far], [...edges, through.id]);
    } else if (!through && wanted.has(node) && (options.mode === "all" || edges.length === dist.get(node))) record(nodes, edges);
    if (edges.length >= maxHops) return;
    for (const step of out.get(node) ?? []) {
      if (result.truncated) break;
      if (seen.has(step.to) || options.mode !== "all" && dist.get(step.to) !== edges.length + 1) continue;
      seen.add(step.to);
      nodes.push(step.to);
      edges.push(step.id);
      visit(nodes, edges, seen);
      edges.pop();
      nodes.pop();
      seen.delete(step.to);
    }
  };
  for (const seed of seeds) visit([seed], [], /* @__PURE__ */ new Set([seed]));
  result.routes = paths.length;
  result.hops = paths.length ? Math.min(...paths.map((p) => p.edgeIds.length)) : 0;
  result.maxHops = paths.length ? Math.max(...paths.map((p) => p.edgeIds.length)) : 0;
  result.unreachedTargets = through ? [] : [...wanted].filter((id) => !reached.has(id));
  return result;
}
function routeEmphasis(result, selected) {
  const paths = selected === null ? result.paths : selected.flatMap((i) => result.paths[i] ? [result.paths[i]] : []);
  return { nodeIds: new Set(paths.flatMap((p) => p.nodeIds)), edgeIds: new Set(paths.flatMap((p) => p.edgeIds)) };
}
function routeComparisonAction(nodeId2, targets, onChange) {
  const included = targets.includes(nodeId2);
  return {
    id: "compare-route",
    label: included ? "Remove from route comparison" : "Add to route comparison",
    hint: "Compare connections from the seeds to several addresses in this snapshot.",
    onSelect: () => onChange(included ? targets.filter((id) => id !== nodeId2) : [...targets, nodeId2])
  };
}
function GraphSelectionNotice({ children, detail, onClear, clearLabel = "Clear highlight", active = true }) {
  return /* @__PURE__ */ jsxs("section", { "aria-label": "Selected trail", className: "flex flex-wrap items-center justify-between gap-2 border-b border-primary/30 bg-primary/5 px-3 py-2 text-xs", children: [
    /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1 space-y-1", children: [
      /* @__PURE__ */ jsxs("p", { role: "status", "aria-live": "polite", className: "break-words", children: [
        /* @__PURE__ */ jsx("strong", { children: active ? "Highlighted trail" : "Highlight paused" }),
        " \xB7 ",
        children
      ] }),
      detail && /* @__PURE__ */ jsx("p", { className: "text-muted-foreground", children: detail })
    ] }),
    onClear && /* @__PURE__ */ jsx("button", { type: "button", className: "shrink-0 rounded border bg-background px-2 py-1", onClick: onClear, children: clearLabel })
  ] });
}
function GraphRouteControls({ result, mode, maxHops, direction, onModeChange, selected, onSelectionChange, label, flowLabel, active = true, onClear }) {
  const [expanded, setExpanded] = React17.useState(false);
  const shown = expanded ? result.paths : result.paths.slice(0, 6);
  const chosen = selected === null ? result.paths : result.paths.filter((_, i) => selected.includes(i));
  const arrow = direction === "inbound" ? " \u2190 " : direction === "both" ? " \u2014 " : " \u2192 ";
  const describe = (ids) => {
    const names = ids.map((id) => label?.(id) ?? id);
    return names.length > 5 ? [names[0], `\u2026 ${names.length - 2} intermediate addresses \u2026`, names.at(-1)].join(arrow) : names.join(arrow);
  };
  const endpoints2 = (ids) => {
    const unique = [...new Set(ids)];
    return unique.slice(0, 3).map((id) => label?.(id) ?? id).join(", ") + (unique.length > 3 ? ` and ${unique.length - 3} more` : "");
  };
  return /* @__PURE__ */ jsxs("section", { "aria-label": "Recorded routes", className: "space-y-2 rounded border p-2 text-xs", children: [
    /* @__PURE__ */ jsx(GraphSelectionNotice, { active: active && chosen.length > 0, onClear, clearLabel: active ? "Clear highlight" : "Show highlight", detail: !active ? "The graph is showing all connections." : chosen.length ? "Other connections are faded. This selection changes the view, not which funds the tracer follows." : "Choose a route below to highlight its connections.", children: chosen.length === 1 ? describe(chosen[0].nodeIds) : chosen.length > 1 ? `${chosen.length} routes selected \xB7 ${endpoints2(chosen.map((path) => path.nodeIds[0]))}${arrow}${endpoints2(chosen.map((path) => path.nodeIds.at(-1)))}` : "No route selected" }),
    result.truncated || result.unreachedTargets.length > 0 ? /* @__PURE__ */ jsxs("p", { role: "status", className: "text-warning", children: [
      result.truncated ? "Search limit reached; more routes may exist. " : "",
      result.unreachedTargets.length ? `${result.unreachedTargets.length} selected address(es) ${result.truncated ? "were not reached before the search limit" : "have no route within this view and hop limit"}.` : ""
    ] }) : null,
    /* @__PURE__ */ jsxs("details", { children: [
      /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer font-medium", children: [
        "Choose routes and inspect steps (",
        result.routes,
        ")"
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "mt-2 space-y-2", children: [
        /* @__PURE__ */ jsxs("label", { children: [
          "Route scope ",
          /* @__PURE__ */ jsxs("select", { "aria-label": "Route scope", className: "rounded border bg-background p-1", value: mode, onChange: (e) => onModeChange(e.target.value), children: [
            /* @__PURE__ */ jsx("option", { value: "shortest", children: "Shortest connections" }),
            /* @__PURE__ */ jsxs("option", { value: "all", children: [
              "All simple connections within ",
              maxHops,
              " hops"
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("p", { children: [
          result.routes,
          " route",
          result.routes === 1 ? "" : "s",
          " found \xB7 ",
          active ? chosen.length : 0,
          " highlighted."
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-muted-foreground", children: "Connections in this snapshot only. Time order, asset changes and ownership require receipt review; amounts are never added across routes." }),
        /* @__PURE__ */ jsx("p", { className: "text-muted-foreground", children: direction === "inbound" ? "Reading upstream from the seed. Arrows still show sender \u2192 receiver." : direction === "both" ? "Connections may go upstream or downstream. Check the flow arrows for payment direction." : "Reading downstream from the seed, in payment direction." }),
        result.paths.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("button", { type: "button", className: "underline", onClick: () => onSelectionChange(null), children: "Select all found routes" }),
          /* @__PURE__ */ jsx("div", { className: "max-h-44 space-y-2 overflow-auto", children: shown.map((path, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2", children: [
            /* @__PURE__ */ jsxs("label", { className: "flex min-w-0 flex-1 items-start gap-2", children: [
              /* @__PURE__ */ jsx("input", { type: "checkbox", "aria-label": `Highlight route ${i + 1}`, checked: selected === null || selected.includes(i), onChange: (e) => {
                const current = selected ?? result.paths.map((_, index) => index);
                onSelectionChange(e.target.checked ? [...current, i] : current.filter((index) => index !== i));
              } }),
              /* @__PURE__ */ jsxs("span", { className: "min-w-0 break-words", children: [
                "Route ",
                i + 1,
                " \xB7 ",
                path.edgeIds.length,
                " hop",
                path.edgeIds.length === 1 ? "" : "s",
                label ? ` \xB7 ${path.nodeIds.map(label).join(direction === "inbound" ? " \u2190 " : direction === "both" ? " \u2014 " : " \u2192 ")}` : "",
                flowLabel && /* @__PURE__ */ jsxs("span", { className: "block text-muted-foreground", children: [
                  "Flow sequence: ",
                  path.edgeIds.map(flowLabel).join("; ")
                ] })
              ] })
            ] }),
            /* @__PURE__ */ jsx("button", { type: "button", "aria-label": `Focus only route ${i + 1}`, className: "shrink-0 underline", onClick: () => onSelectionChange([i]), children: "Only this" })
          ] }, i)) }),
          result.paths.length > 6 && /* @__PURE__ */ jsx("button", { type: "button", className: "underline", onClick: () => setExpanded(!expanded), children: expanded ? "Show fewer routes" : `Show all ${result.paths.length} routes` })
        ] })
      ] })
    ] })
  ] });
}
function GraphFocusControl({ options, value, onChange, hiddenNodes, hiddenEdges, unreached = 0, hiddenHops = [], folded = false, quick = [] }) {
  const id = React17.useId();
  const selected = options.find((option) => option.id === value);
  const sections = [...new Set(options.map((option) => option.section))];
  const chips = quick.flatMap((chip2) => {
    const option = options.find((o) => o.id === chip2.id);
    return option ? [{ ...chip2, option }] : [];
  });
  const chip = "h-7 rounded-full px-3 text-xs";
  return /* @__PURE__ */ jsxs("section", { "aria-label": "Graph focus", className: "flex flex-wrap items-center gap-x-2 gap-y-1 border-b px-3 py-2 text-xs", children: [
    chips.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: "font-medium", id: `${id}-quick`, children: "Show" }),
      /* @__PURE__ */ jsxs("div", { role: "group", "aria-labelledby": `${id}-quick`, className: "flex flex-wrap items-center gap-1", children: [
        /* @__PURE__ */ jsx(Button, { type: "button", size: "sm", variant: value ? "outline" : "default", className: chip, "aria-pressed": !value, onClick: () => onChange(null), children: "Everything" }),
        chips.map(({ id: chipId, label, count = true, option }) => {
          const on = value === chipId;
          return /* @__PURE__ */ jsxs(
            Button,
            {
              type: "button",
              size: "sm",
              variant: on ? "default" : "outline",
              className: chip,
              "aria-pressed": on,
              title: option.description,
              onClick: () => onChange(on ? null : chipId),
              children: [
                label,
                count ? /* @__PURE__ */ jsx("span", { className: "ml-1 tabular-nums opacity-70", children: option.nodeIds.length }) : null
              ]
            },
            chipId
          );
        })
      ] }),
      /* @__PURE__ */ jsx("label", { htmlFor: id, className: "ml-1 text-muted-foreground", children: "More" })
    ] }) : /* @__PURE__ */ jsx("label", { htmlFor: id, className: "font-medium", children: "Show" }),
    /* @__PURE__ */ jsxs(
      "select",
      {
        id,
        "aria-label": "Graph focus",
        "aria-describedby": `${id}-description`,
        value: value ?? "",
        className: "max-w-full rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground",
        onChange: (event) => onChange(event.target.value || null),
        children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "All loaded paths" }),
          value && !selected && /* @__PURE__ */ jsx("option", { value, children: "Selected focus unavailable" }),
          sections.map((section) => /* @__PURE__ */ jsx("optgroup", { label: section, children: options.filter((option) => option.section === section).map((option) => /* @__PURE__ */ jsxs("option", { value: option.id, children: [
            option.label,
            " \xB7 ",
            option.nodeIds.length,
            " address",
            option.nodeIds.length === 1 ? "" : "es"
          ] }, option.id)) }, section))
        ]
      }
    ),
    value ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("span", { role: "status", children: [
        hiddenNodes,
        " address",
        hiddenNodes === 1 ? "" : "es",
        " and ",
        hiddenEdges,
        " flow",
        hiddenEdges === 1 ? "" : "s",
        " ",
        folded ? "folded by this view" : "hidden by focus",
        "."
      ] }),
      chips.length > 0 ? null : /* @__PURE__ */ jsx(Button, { type: "button", variant: "ghost", size: "sm", className: "h-6", onClick: () => onChange(null), children: "Clear focus" })
    ] }) : chips.length > 0 ? null : /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "Focus on a destination or group; keep its connecting paths." }),
    /* @__PURE__ */ jsxs("span", { id: `${id}-description`, className: value ? "basis-full text-muted-foreground" : "sr-only", children: [
      selected?.description ?? (value ? "This selection is no longer available. Clear focus or choose another view." : "View only. The trace and its evidence are unchanged."),
      hiddenHops.length > 0 && ` Hop${hiddenHops.length === 1 ? "" : "s"} ${hiddenHops.join(", ")} ${folded ? "folded" : "hidden"} by this focus. Hop numbers keep their original distance from the start; they are not renumbered.`,
      unreached > 0 && ` ${unreached} selected address${unreached === 1 ? " has" : "es have"} no connection to a starting address in this view. Check the other filters or clear focus.`
    ] })
  ] });
}

// src/index.ts
init_filters();

// src/exploration/follow.ts
init_edgeKinds();
var DEFAULT_MAX_HOPS = 12;
function depart(step, arrival) {
  let at = Infinity;
  const used = [];
  for (const m of step.movements) {
    if (m.at === null) {
      used.push(m.id);
      at = Math.min(at, arrival);
    } else if (m.at >= arrival) {
      used.push(m.id);
      at = Math.min(at, m.at);
    }
  }
  return used.length > 0 ? { at, used } : null;
}
function followFunds(graph, options) {
  const present = new Set(graph.nodes.map((n) => n.id));
  const seeds = [...new Set(options.seeds)].filter((id) => present.has(id));
  const maxHops = Math.min(64, Math.max(1, Math.floor(options.maxHops ?? DEFAULT_MAX_HOPS)));
  const carries = options.carries ?? ((edge) => isFlowEdgeKind(edge.kind ?? void 0));
  const sign = options.direction === "outbound" ? 1 : -1;
  let timeOrdered = false;
  const steps = [];
  const signed = (list) => list.map((m) => ({ id: m.id, at: typeof m.at === "number" && Number.isFinite(m.at) ? sign * m.at : null })).sort((a, b) => (a.at ?? -Infinity) - (b.at ?? -Infinity));
  for (const edge of graph.edges) {
    if (edge.source === edge.target || !present.has(edge.source) || !present.has(edge.target) || !carries(edge)) continue;
    const listed = options.movementsOf?.(edge);
    const movements = signed(listed && listed.length > 0 ? listed : [{ id: edge.id, at: null }]);
    if (movements.some((m) => m.at !== null)) timeOrdered = true;
    const [from, to] = sign > 0 ? [edge.source, edge.target] : [edge.target, edge.source];
    steps.push({ id: edge.id, from, to, link: false, movements });
  }
  for (const link of options.links ?? []) {
    if (!present.has(link.source) || !present.has(link.target) || link.source === link.target) continue;
    const [from, to] = sign > 0 ? [link.source, link.target] : [link.target, link.source];
    steps.push({ id: link.id, from, to, link: true, movements: signed([{ id: link.id, at: link.at ?? null }]) });
  }
  const arrival = new Map(seeds.map((id) => [id, -Infinity]));
  const hops = new Map(seeds.map((id) => [id, 0]));
  let changed = seeds.length > 0;
  for (let round = 1; round <= maxHops && changed; round += 1) {
    changed = false;
    const before = new Map(arrival);
    for (const step of steps) {
      const at = before.get(step.from);
      if (at === void 0) continue;
      const leave = depart(step, at);
      if (!leave) continue;
      const known = arrival.get(step.to);
      if (known === void 0 || leave.at < known) {
        arrival.set(step.to, leave.at);
        if (!hops.has(step.to)) hops.set(step.to, round);
        changed = true;
      }
    }
  }
  const result = {
    nodeIds: new Set(arrival.keys()),
    edgeIds: /* @__PURE__ */ new Set(),
    linkIds: /* @__PURE__ */ new Set(),
    movements: /* @__PURE__ */ new Map(),
    hops,
    ends: [],
    truncated: false,
    timeOrdered
  };
  const onward = /* @__PURE__ */ new Set();
  for (const step of steps) {
    const at = arrival.get(step.from);
    if (at === void 0) continue;
    const leave = depart(step, at);
    if (!leave) continue;
    const fromHop = hops.get(step.from) ?? 0;
    if (fromHop >= maxHops) {
      if (!arrival.has(step.to) || leave.at < arrival.get(step.to)) result.truncated = true;
      continue;
    }
    if (!arrival.has(step.to)) continue;
    onward.add(step.from);
    if (step.link) {
      result.linkIds.add(step.id);
      continue;
    }
    result.edgeIds.add(step.id);
    if (leave.used.length < step.movements.length) result.movements.set(step.id, new Set(leave.used));
  }
  const seedSet = new Set(seeds);
  result.ends = [...arrival.keys()].filter((id) => !seedSet.has(id) && !onward.has(id));
  return result;
}
function followEmphasis(followed) {
  return { nodeIds: followed.nodeIds, edgeIds: followed.edgeIds, movements: followed.movements };
}

// src/index.ts
init_live();
init_assetColors();

// src/exploration/displayNames.ts
init_mergeScenes();
function graphNameId(kind, id) {
  return JSON.stringify([kind, id]);
}
function graphNameTargets(graph, groups = []) {
  const labels = new Map(graph.nodes.map((n) => [n.id, n.data.label]));
  const targets = [
    ...groups.map((g) => ({ id: graphNameId("group", g.id), kind: "group", label: g.label, detail: `${g.memberNodeIds.length} ${g.memberNodeIds.length === 1 ? "address" : "addresses"} \xB7 display group, not ownership` })),
    ...graph.nodes.map((n) => ({ id: graphNameId("node", n.id), kind: "node", label: n.data.label, detail: [n.data.chain, n.data.address ?? n.id].filter(Boolean).join(" \xB7 ") })),
    ...graph.edges.map((e) => ({ id: graphNameId("edge", e.data?.sourceEdgeId ?? e.id), kind: "edge", label: e.data?.displayName ?? e.data?.label ?? ([e.data?.amount, e.data?.ticker].filter(Boolean).join(" ") || "Connection"), detail: `${labels.get(e.source) ?? e.source} \u2192 ${labels.get(e.target) ?? e.target} \xB7 ${e.data?.assetLabel ?? e.data?.ticker ?? e.data?.kind ?? "link"}` }))
  ];
  return [...new Map(targets.map((t) => [t.id, t])).values()];
}
function graphNamesScene(targets) {
  return parseGraphScene({ ...emptyScene(), nodes: targets.map((t) => ({ id: t.id, kind: "annotation", label: t.label })) });
}
function applyGraphNames(graph, groups, base, named) {
  const originals = new Map(base.nodes.map((n) => [n.id, n.label]));
  const names = new Map(named.nodes.flatMap((n) => n.label && n.label !== originals.get(n.id) ? [[n.id, n.label]] : []));
  return {
    nodes: graph.nodes.map((n) => {
      const name = names.get(graphNameId("node", n.id));
      return name ? { ...n, data: { ...n.data, label: `${name} \xB7 note`, subtitle: [n.data.label, n.data.subtitle].filter(Boolean).join(" \xB7 ") } } : n;
    }),
    edges: graph.edges.map((e) => {
      const name = names.get(graphNameId("edge", e.data?.sourceEdgeId ?? e.id));
      return name ? { ...e, data: { ...e.data, displayName: name } } : e;
    }),
    groups: groups.map((g) => {
      const name = names.get(graphNameId("group", g.id));
      return name ? { ...g, label: `${name} \xB7 note (${g.label})` } : g;
    })
  };
}

// src/exploration/GraphNamesPanel.tsx
init_GraphAuthoring();
function GraphNamesPanel({ targets, api, disabled = false, selectedId, open }) {
  const [query, setQuery] = React17.useState("");
  const [id, setId] = React17.useState(selectedId ?? "");
  const [describing, setDescribing] = React17.useState();
  React17.useEffect(() => {
    if (selectedId) {
      setId(selectedId);
      setDescribing(void 0);
    }
  }, [selectedId]);
  const selected = targets.find((t) => t.id === id);
  const matches = targets.filter((t) => `${t.kind} ${t.label} ${t.detail}`.toLowerCase().includes(query.toLowerCase()));
  return /* @__PURE__ */ jsxs("details", { open: open || void 0, className: "border-b px-3 py-2 text-xs", children: [
    /* @__PURE__ */ jsx("summary", { className: "cursor-pointer font-medium", children: "Name addresses, connections and groups" }),
    /* @__PURE__ */ jsx("p", { className: "my-2 text-muted-foreground", children: "Your private display notes for this tracer. Original addresses, assets and amounts remain visible. Grouping does not establish shared ownership." }),
    /* @__PURE__ */ jsx(Input, { "aria-label": "Find an item to name", placeholder: "Find an address, connection or group", value: query, onChange: (e) => setQuery(e.target.value), className: "h-8" }),
    /* @__PURE__ */ jsxs("select", { "aria-label": "Item to name", disabled, value: selected?.id ?? "", onChange: (e) => {
      setId(e.target.value);
      setDescribing(void 0);
    }, className: "my-2 w-full rounded border bg-background p-2", children: [
      /* @__PURE__ */ jsx("option", { value: "", children: "Choose an item\u2026" }),
      selected && !matches.slice(0, 100).includes(selected) && /* @__PURE__ */ jsxs("option", { value: selected.id, children: [
        selected.kind,
        ": ",
        selected.label
      ] }),
      matches.slice(0, 100).map((t) => /* @__PURE__ */ jsxs("option", { value: t.id, children: [
        t.kind,
        ": ",
        t.label,
        " \u2014 ",
        t.detail
      ] }, t.id))
    ] }),
    matches.length > 100 && /* @__PURE__ */ jsxs("p", { children: [
      "Showing 100 of ",
      matches.length,
      " items. Search to narrow the list."
    ] }),
    selected && !disabled && /* @__PURE__ */ jsx(GraphAuthoringBar, { api, selection: { kind: selected.kind === "edge" ? "edge" : "node", id: selected.id, label: selected.label }, linking: false, onToggleLinking: () => {
    }, describing, onAuthored: setDescribing, onDescribed: (reason) => {
      if (reason !== null && describing) api.onExplain?.(describing, reason);
      setDescribing(void 0);
    } }, selected.id)
  ] });
}
init_SceneGraphView();
init_mergeScenes();
function tokenHolderScene(holders, chain, cohorts) {
  const scene = { ...emptyScene({ kind: "knowledge" }), chain_ids: [chain], nodes: holders.slice(0, HOLDER_VIEW_POLICY.graphNodes).map((holder) => ({
    id: nodeId(chain, holder.address),
    kind: "address",
    address: holder.address,
    chain_id: chain,
    label: holder.label ?? shortenAddress(holder.address),
    sublabel: holder.balance_formatted ?? (holder.balance != null ? `${holder.balance} raw units` : "Balance unknown"),
    badge: holder.percentage_of_supply != null ? `${formatPercentCell(holder.percentage_of_supply)} of supply` : "Share unknown",
    attributes: { holder_share_band: HOLDER_BAND_LABELS[holderBand(holder)] },
    off_chain: false,
    assets: [],
    source_refs: [],
    confidence: 0,
    detail_tier: "compact",
    facts: [],
    origin: "decoded"
  })) };
  const ids = new Set(scene.nodes.map((n) => n.id));
  const seen = /* @__PURE__ */ new Set();
  scene.edges = (cohorts?.groups ?? []).flatMap((group) => group.edges).flatMap((edge) => {
    const id = `${edge.chain_id}:${edge.block_hash}:${edge.tx_hash}:${edge.log_index}`;
    const source = nodeId(edge.chain_id, edge.source), target = nodeId(edge.chain_id, edge.target);
    if (seen.has(id) || !ids.has(source) || !ids.has(target)) return [];
    seen.add(id);
    return [{
      id,
      source,
      target,
      kind: "relationship",
      label: "Observed token transfer",
      from_chain: edge.chain_id,
      to_chain: edge.chain_id,
      cross_chain: false,
      virtual: false,
      attributes: { claim: "observed", tx_hash: edge.tx_hash, block_number: edge.block_number, raw_amount: edge.raw_amount },
      detail_tier: "compact",
      facts: [],
      origin: "decoded"
    }];
  });
  return scene;
}
function holderGroupContext(cohorts, chain) {
  const entries = /* @__PURE__ */ new Map();
  const overlaps2 = /* @__PURE__ */ new Set();
  for (const [i, group] of (cohorts?.groups ?? []).entries()) for (const address of group.members) {
    const id = nodeId(chain, address);
    if (entries.has(id)) overlaps2.add(id);
    entries.set(id, { key: group.id, label: `Candidate group ${i + 1} \xB7 ownership unproven` });
  }
  for (const id of overlaps2) entries.delete(id);
  return { relatedAddresses: entries };
}
function TokenHolderGraph({ holders, chain, cohorts, resolveOverlay }) {
  const scene = React17.useMemo(() => tokenHolderScene(holders, chain, cohorts), [holders, chain, cohorts]);
  const groupingContext = React17.useMemo(() => holderGroupContext(cohorts, chain), [cohorts, chain]);
  const visibleIds = React17.useMemo(() => new Set(scene.nodes.map((n) => n.id)), [scene]);
  const directed = React17.useMemo(() => new Set(scene.edges.map((e) => e.id)), [scene]);
  const decorate = React17.useCallback((elements) => decorateRelatedAddressElements(elements, directed), [directed]);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    cohorts && /* @__PURE__ */ jsxs("section", { "aria-label": "Coordinated holder groups", className: "rounded border p-3 text-sm space-y-1", children: [
      /* @__PURE__ */ jsxs("p", { children: [
        "Candidate holder groups \xB7 blocks ",
        cohorts.from_block,
        "\u2013",
        cohorts.through_block
      ] }),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Shared distributions and reciprocal material transfers suggest coordination. They do not prove one owner or pre-launch manipulation. Group shares exclude assets held in staking, lending and vault contracts." }),
      cohorts.groups.map((group, i) => /* @__PURE__ */ jsxs("details", { children: [
        /* @__PURE__ */ jsxs("summary", { children: [
          "Candidate group ",
          i + 1,
          ": ",
          group.members.length,
          " wallets (",
          group.members.filter((a) => visibleIds.has(nodeId(chain, a))).length,
          " shown) \xB7 ",
          group.percentage_of_supply != null ? `${formatPercentCell(group.percentage_of_supply)} of total supply` : "Supply share unknown"
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-xs", children: "Full snapshot group; filtering or hiding a node does not change this statistic. Groups may overlap; do not add their percentages." }),
        /* @__PURE__ */ jsxs("p", { className: "text-xs", children: [
          "Distributor: ",
          group.distributor,
          " \xB7 ",
          group.supporting_transactions.length,
          " supporting transactions"
        ] }),
        /* @__PURE__ */ jsx("ul", { className: "text-xs font-mono", children: group.supporting_transactions.map((tx) => /* @__PURE__ */ jsx("li", { children: tx }, tx)) })
      ] }, group.id)),
      cohorts.groups.length === 0 && /* @__PURE__ */ jsx("p", { children: "No candidate groups found in the retained window. This does not establish independent ownership." }),
      Object.keys(cohorts.omissions).length > 0 && /* @__PURE__ */ jsxs("p", { role: "status", children: [
        "Coordination coverage is incomplete: ",
        Object.keys(cohorts.omissions).map((x) => x.replaceAll("_", " ")).join(", "),
        "."
      ] }),
      cohorts.status === "disabled" && /* @__PURE__ */ jsx("p", { children: "Coordination detection is disabled." })
    ] }),
    /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Holding bands are visual groups, not ownership clusters. Graph settings can group by blockchain or available catalog details." }),
    holders.length > scene.nodes.length && /* @__PURE__ */ jsxs("p", { role: "status", children: [
      "Graph shows ",
      scene.nodes.length,
      " of ",
      holders.length,
      " loaded addresses. Use Table to inspect the rest."
    ] }),
    /* @__PURE__ */ jsx(GraphFrame, { className: "h-[520px] overflow-hidden rounded-md border", children: scene.nodes.length === 0 ? /* @__PURE__ */ jsx("p", { role: "status", className: "p-6 text-sm", children: "No loaded addresses match this view. Reset the filters or restore hidden addresses to show them." }) : /* @__PURE__ */ jsx(
      SceneGraphView,
      {
        scene,
        decorateElements: decorate,
        groupingContext,
        resolveOverlay,
        defaultGrouping: { dimensions: ["chain", "related"] },
        showGroupingControl: true,
        showStats: false,
        showSummary: false,
        showMiniMap: false,
        showDetailToggle: false,
        showViewsBar: false,
        showFlowToggle: false,
        showEdgeBundleToggle: false,
        showExport: false,
        flowParticles: false
      }
    ) })
  ] });
}

export { ALL_SEARCH_FIELDS, ASSET_PALETTE, AUTO_CLUSTER_THRESHOLD, CASE_SHARE_KIND, CASE_SHARE_VERSION, CHAIN_LABEL_ATTR, CaseShareView, DEFAULT_EDGE_LEGEND, DEFAULT_SEARCH_FIELDS, EDGE_STROKE, EXPAND_TRANSFERS_LIMIT, FINALITY_FORWARD, FINALITY_STATES, FINALITY_TRANSITIONS, FLOW_EDGE_KINDS, FLOW_KIND_LABELS, FinalityStateMachineView, ForceGraph, GRAPH_DYNAMIC_SEED_KIND, GRAPH_SEARCH_FIELDS, GRAPH_SEARCH_MODES, GROUPING_DIMENSION_LIST, GraphAuthoringBar, GraphCanvas, GraphContextOpenerContext, GraphDefaultsProvider, GraphExportMenu, GraphFilterBar, GraphFocusControl, GraphGroupingMenu, GraphLegend, GraphNamesPanel, GraphRouteControls, GraphSearchBox, GraphSelectionNotice, GraphSettingsMenu, GraphShareViewer, GraphStatsPanel, GraphTimeline, GraphViewContext, GraphViewModeToggle, GroupGraphView, LINK_EDGE_KINDS, LIVE_GRAPH_DEFAULTS, MAX_EXPLORED_NODES, NODE_KIND_REGISTRY, NODE_KIND_VARIANT, NodeDrilldownPanel, ROUTE_COUNT_CAP, RelatedAddressesGraph, ReplayControls, SAGA_AWAITING_ATTR, SAGA_GROUP_TYPE, SAGA_KEY_ATTR, SAGA_LABEL_ATTR, SceneGraphView, SharedGraphView, TimeRangeSlider, TokenHolderGraph, TransactionGraph, advanceFinality, allNodesMatch, annotatableEdgeId, applicableDimensions, applyCatalogOverlay, applyClusters, applyGraphNames, applyGrouping, applySagaBands, assetColor, assetColorLegend, autoClusteredGraph, buildCaseShareBundle, buildChainGroupNodes, buildClusters, buildFinalityHistory, buildGraphViewServing, bundleParallelEdges, canTransition, caseShareRefresh, catalogResolverFrom, chainGroupNode, clusterByChain, clusterByEntity, clusterByHop, clusterByHopAndChain, clusterByHopOrUnknown, clusterByKind, clusterIdFromNodeId, clusterNodeId, clusterWithinGroups, compactGraphState, composeClusterKeys, composeGraphLayers, computeGraphStats, connectedGraph, decorateFinality, decorateRelatedAddressElements, diffGraphEvidence, dynamicSeedToChannel, edgeTypes, edgeVariantForKind, emphasisLightsEdge, emptyScene, engineForView, expandFoldedEdges, exportGraphData, exportGraphEdges, exportGraphNodes, exportGraphPng, filterGraph, filterGraphByTimeRange, finalityLegendItems, finalityProgress, findGraphRoutes, fingerprintOf, followEmphasis, followFunds, freezeCatalogSnapshot, freezeCatalogSnapshotFromNodes, graphAssetKey, graphCatalogRefs, graphConnectionScope, graphEvidenceKey, graphExpansionReducer, graphFilterOptions, graphFlowLabel, graphNameId, graphNameTargets, graphNamesScene, graphNodeId, graphRouteNodeLabel, graphShareStateHasContent, graphTimeDomain, groupNodesByChain, groupingDimension, groupingDimensionLabel, groupsForVisibleNodes, groupsWithinBands, hasGraphAsset, historyTraversed, hopRingLabel, interactionGraphFromRows, interactionGraphToScene, isCaseShareBundle, isFlowEdgeKind, isLinkEdgeKind, isPlainGraphClick, isTerminal, layerEdgeId, layoutDirectionForView, layoutForView, layoutWithDagre, layoutWithElk, matchGraphNodes, mergeGraphElements, mergeNeighborhood, mergeScenes, nextStates, nodeTypes, normalizeDynamicSeed, originalEdgeIds, parseCaseShareBundle, parseCaseShareFinding, parseCaseShareTrails, parseGraphSnapshot, previewGraph, readGraphViewContext, receiptProtocolNames, regroupSceneByChain, resolveAutoCluster, routeComparisonAction, routeEmphasis, rowNodeIds, sagaAnchorNodeId, sagaGhostNodeId, sagaGroupId, sceneEdgeForClick, sceneViewToElements, stampTx, toGraph, toRelatedAddressScene, toScene, trailsSections, transitionsFrom, txEdge, txNode, useGraphChangeHistory, useGraphClusters, useGraphDefaults, useGraphDetailTier, useGraphFilters, useGraphLiveUpdates, useGraphReducer, useGraphSearch, useGraphTimeRange, useReplay, variantForKind, withAssetColors, withGraphFrom };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map